import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  OCBase64Cursor: { input: any; output: any };
  OCCountryCode2: { input: any; output: any };
  OCDate: { input: any; output: any };
  OCDateTime: { input: any; output: any };
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  OCEmailAddress: { input: any; output: any };
  OCJSON: { input: any; output: any };
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  OCPhoneNumber: { input: any; output: any };
  OCPromocode: { input: any; output: any };
  OCReferralCode: { input: any; output: any };
  OCTime: { input: any; output: any };
  OCTimeZone: { input: any; output: any };
  OCURL: { input: any; output: any };
  OCUUID: { input: string; output: string };
};

export enum AchEnrollmentStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Hold = 'HOLD',
  PendingEnrollment = 'PENDING_ENROLLMENT',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
  WaitingApproval = 'WAITING_APPROVAL',
}

export enum AchStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Hold = 'HOLD',
  PendingEnrollment = 'PENDING_ENROLLMENT',
  Rejected = 'REJECTED',
  Suspended = 'SUSPENDED',
  WaitingApproval = 'WAITING_APPROVAL',
}

export enum ActivatePaymentMethod {
  MobileApp = 'MOBILE_APP',
}

export enum ActivateTransactionSortBy {
  CreatedAt = 'CREATED_AT',
}

export enum ActivateTransactionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Redeemed = 'REDEEMED',
}

export enum AwardPerCountingStrategy {
  IndividualPurchase = 'INDIVIDUAL_PURCHASE',
  SellingUnitPurchase = 'SELLING_UNIT_PURCHASE',
  TotalPurchase = 'TOTAL_PURCHASE',
}

export enum AwardPointsRoundingStrategy {
  Down = 'DOWN',
  HalfUp = 'HALF_UP',
}

export type AccessTokenByRefreshTokenInput = {
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type ActivateLineItemPromotion = {
  offer: Maybe<Offer>;
  promotionAmount: Scalars['Float']['output'];
  promotionReason: Scalars['String']['output'];
  promotionTitle: Scalars['String']['output'];
};

export type ActivateLocation = {
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['OCCountryCode2']['output']>;
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  lat: Maybe<Scalars['Float']['output']>;
  lon: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['OCPhoneNumber']['output']>;
  state: Maybe<Scalars['String']['output']>;
  zipcode: Maybe<Scalars['String']['output']>;
};

export type ActivatePaymentInfo = {
  amountCharged: Maybe<Scalars['Float']['output']>;
  isoPrefix: Maybe<Scalars['String']['output']>;
  tenderSubtype: Maybe<Scalars['String']['output']>;
  tenderType: Maybe<Scalars['String']['output']>;
};

export type ActivateTransaction = {
  createdAt: Scalars['OCDateTime']['output'];
  customData: Maybe<Scalars['OCJSON']['output']>;
  fulfilledOffers: Array<Maybe<Offer>>;
  id: Scalars['ID']['output'];
  lineItems: Array<Maybe<ActivateTransactionLineItem>>;
  location: Maybe<ActivateLocation>;
  offerFulfillments: Maybe<Array<RuleFulfillment>>;
  paymentInfos: Maybe<Array<ActivatePaymentInfo>>;
  status: Maybe<ActivateTransactionStatus>;
  subtotalAmount: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountWithoutDiscounts: Maybe<Scalars['Float']['output']>;
  totalDiscountAmount: Maybe<Scalars['Float']['output']>;
  totalPointsEarned: Scalars['Int']['output'];
  totalPointsRefunded: Scalars['Int']['output'];
  totalPointsSpent: Scalars['Int']['output'];
  totalTax: Maybe<Scalars['Float']['output']>;
  transactionTimeAt: Maybe<Scalars['OCDateTime']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type ActivateTransactionConnection = {
  edges: Array<Maybe<ActivateTransactionEdge>>;
  pageInfo: PageInfo;
};

export type ActivateTransactionEdge = {
  cursor: Scalars['ID']['output'];
  node: ActivateTransaction;
};

export type ActivateTransactionFilter = {
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  transactionStatusEquals?: InputMaybe<ActivateTransactionStatus>;
};

export type ActivateTransactionLineItem = {
  externalLineItemPromotions: Maybe<Array<ExternalLineItemPromotion>>;
  fuelGradeId: Maybe<Scalars['String']['output']>;
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItemNumber: Maybe<Scalars['Int']['output']>;
  moneyAmount: Maybe<Scalars['Float']['output']>;
  productGroups: Array<Maybe<ProductGroup>>;
  promotions: Maybe<Array<ActivateLineItemPromotion>>;
  quantity: Maybe<Scalars['Float']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  transaction: ActivateTransaction;
  upc: Maybe<Scalars['String']['output']>;
};

export type ActivateUser = {
  email: Scalars['OCEmailAddress']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type ActivePaymentProviderConfiguration = FiservConfiguration | ParPayConfiguration | WorldpayConfiguration;

export type ActivityFeedConnection = {
  edges: Array<ActivityFeedEdge>;
  pageInfo: PageInfo;
};

export type ActivityFeedEdge = {
  cursor: Scalars['OCBase64Cursor']['output'];
  node: ActivityFeedEvent;
};

export type ActivityFeedEvent = {
  event: ActivityType;
  id: Scalars['ID']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type ActivityFeedFilter = {
  customerUuid: Scalars['OCUUID']['input'];
  includeLoyaltyTransactions: Scalars['Boolean']['input'];
  includeMobileTransactions: Scalars['Boolean']['input'];
  includePointChanges: Scalars['Boolean']['input'];
};

export type ActivityType = ActivateTransaction | CombinedTransaction | PointChange | Transaction;

export type Address = {
  alias: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  countryCode: Scalars['OCCountryCode2']['output'];
  geoLocation: Maybe<GeoLocation>;
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
  street2: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type AppConfig = {
  appRating: AppRatingConfiguration;
  applePay: Maybe<ApplePayConfiguration>;
  appsFlyer: Maybe<AppsFlyerConfiguration>;
  auth: AuthConfiguration;
  /** @deprecated Brand UUID is a legacy value that supposed to be removed */
  brandUuid: Scalars['OCUUID']['output'];
  chainId: Scalars['OCUUID']['output'];
  communicationPreference: CommunicationPreferenceConfiguration;
  cookieConsent: Maybe<CookieConsentConfiguration>;
  deleteAccount: DeleteAccountConfiguration;
  eaivAgeVerification: EaivAgeVerificationConfiguration;
  eaivIdentityVerification: EaivIdentityVerificationConfiguration;
  externalIdentityVerification: Maybe<ExternalIdentityVerification>;
  /** @deprecated Use support.widget */
  freshdeskSupportWidget: FreshdeskSupportWidgetConfiguration;
  googlePay: Maybe<GooglePayConfiguration>;
  kount: Maybe<KountConfiguration>;
  localOffers: Maybe<LocalOffersConfiguration>;
  loyaltyIdBarcode: Maybe<LoyaltyIdBarcodeConfiguration>;
  /** @deprecated Use loyaltyIdBarcode instead */
  loyaltyIdQRCode: Maybe<LoyaltyIdQrCodeConfiguration>;
  loyaltyProgram: LoyaltyProgramConfiguration;
  mobilePaymentsReceiptsView: MobilePaymentsReceiptsViewConfiguration;
  orderAhead: Maybe<OrderAheadConfiguration>;
  payAtPump: PayAtPump;
  payInside: PayInside;
  paymentProvider: Maybe<ActivePaymentProviderConfiguration>;
  paymentWallet: PaymentWalletConfiguration;
  personalDataShareOptOut: Maybe<PersonalDataShareOptOutConfiguration>;
  pinCode: PinCodeConfiguration;
  /** @deprecated Use totalAvailableRollback instead. This one will be removed after all envs will use TotalAvailableRollbackConfiguration */
  preferredFuelGrade: PreferredFuelGradeConfiguration;
  privacyPolicy: BrandAgreement;
  productInterests: ProductInterestsConfiguration;
  rudderStack: RudderStackConfiguration;
  smsOptIn: SmsOptInConfiguration;
  smsOptedOutWarning: SmsOptedOutWarning;
  spireEnrollment: Maybe<SpireEnrollmentConfiguration>;
  storeLocator: StoreLocatorConfiguration;
  support: SupportConfiguration;
  /** @deprecated Use support.phoneNumber */
  supportPhoneNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Use support.email */
  supportTeamEmail: Scalars['String']['output'];
  termsConditions: BrandAgreement;
  totalAvailableRollback: TotalAvailableRollbackConfiguration;
  totalPointsEarned: Maybe<TotalPointsEarnedConfiguration>;
  userExperience: UserExperienceConfig;
  wallet: WalletConfiguration;
};

export type AppRatingConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  promptIntervalDays: Scalars['Int']['output'];
  transactionHistoryLookupDays: Scalars['Int']['output'];
};

export enum ApplePayCardNetwork {
  Amex = 'AMEX',
  CartesBancaires = 'CARTES_BANCAIRES',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Mada = 'MADA',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  MasterCard = 'MASTER_CARD',
  PrivateLabel = 'PRIVATE_LABEL',
  Visa = 'VISA',
  VPay = 'V_PAY',
}

export type ApplePayConfiguration = {
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  isBillingZipCodeCollectionEnabled: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName: Maybe<Scalars['String']['output']>;
  supportedNetworks: Array<ApplePayCardNetwork>;
};

export type ApplePayConfigurationCreateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
  supportedNetworks: Array<ParPayApplePayCardNetwork>;
};

export type ApplePayConfigurationUpdateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
  supportedNetworks: Array<ParPayApplePayCardNetwork>;
};

export type ApplePaySession = {
  data: Maybe<Scalars['OCJSON']['output']>;
};

export type AppsFlyerConfiguration = FeatureConfiguration & {
  appId: Scalars['String']['output'];
  devKey: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  webDevKey: Maybe<Scalars['String']['output']>;
};

export type AuthConfiguration = {
  otp: AuthOtpConfiguration;
  primaryMethod: AuthMethod;
};

export enum AuthMethod {
  MagicLink = 'MAGIC_LINK',
  Otp = 'OTP',
}

export type AuthOtpConfiguration = FeatureConfiguration & {
  channels: Array<OtpChannel>;
  enabled: Scalars['Boolean']['output'];
};

export type AuthPayload = {
  customer: Maybe<Customer>;
  tokens: Maybe<Tokens>;
};

export type AuthTokens = {
  tokens: Maybe<Tokens>;
};

export enum AutoDecision {
  Approve = 'APPROVE',
  Decline = 'DECLINE',
  Escalate = 'ESCALATE',
  Review = 'REVIEW',
}

export type AwardBuyAndGet = {
  discountThreshold: Scalars['Int']['output'];
  percentDiscount: Scalars['Int']['output'];
};

export type AwardExternal = {
  provider: ExternalAwardProvider;
};

export type AwardExternalInput = {
  provider: ExternalAwardProvider;
};

export type AwardExternalPoints = {
  maximum: Maybe<Scalars['Int']['output']>;
};

export type AwardExternalPointsOrPointsOrVouchers = AwardExternalPoints | AwardPoints | AwardVouchers;

export type AwardMoneyDiscount = {
  awardPer: AwardPerCountingStrategy;
  moneyAmount: Scalars['Int']['output'];
  partialDiscount: Scalars['Boolean']['output'];
};

export type AwardMoneyDiscountOrPriceOverrideOrBuyAndGet = AwardBuyAndGet | AwardMoneyDiscount | AwardPriceOverride;

export type AwardPoints = {
  points: Scalars['Int']['output'];
};

export type AwardPointsOrVouchers = AwardPoints | AwardVouchers;

export type AwardPointsOrVouchersOrExternal = AwardExternal | AwardPoints | AwardVouchers;

export type AwardPointsPer = {
  points: Scalars['Int']['output'];
  rounding: AwardPointsRoundingStrategy;
};

export type AwardPriceOverride = {
  maximumCost: Scalars['Int']['output'];
};

export type AwardProductDiscount = {
  eligibleProductGroups: Array<ProductGroup>;
  percentDiscount: Scalars['Int']['output'];
  purchaseThreshold: Scalars['Int']['output'];
};

export type AwardTransactionMoneyDiscount = {
  moneyDiscount: Scalars['Int']['output'];
};

export type AwardTransactionPercentDiscount = {
  percentDiscount: Scalars['Int']['output'];
};

export type AwardVouchers = {
  voucherCount: Scalars['Int']['output'];
  voucherExpirationDays: Maybe<Scalars['Int']['output']>;
  voucheredOffer: Offer;
};

export enum BannerConfigurationProvider {
  Altria = 'ALTRIA',
}

export enum BannerConfigurationType {
  ExternalAd = 'EXTERNAL_AD',
}

export enum BreakagePointRounding {
  RoundDown = 'ROUND_DOWN',
  RoundUp = 'ROUND_UP',
}

export type Banner = {
  bannerConfigurationUuid: Scalars['OCUUID']['output'];
  content: BannerContent;
  externalCampaignId: Maybe<Scalars['String']['output']>;
  trackingId: Scalars['ID']['output'];
};

export type BannerContent = {
  imageUrl: Maybe<Scalars['OCURL']['output']>;
  surgeonGeneralWarning: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title2: Maybe<Scalars['String']['output']>;
  titleMiddle: Maybe<Scalars['String']['output']>;
};

export type BannerFilter = {
  bannerConfigurationUuidIncludes: Array<Scalars['OCUUID']['input']>;
};

export type BillingAddress = {
  alias: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['OCCountryCode2']['output']>;
  geoLocation: Maybe<GeoLocation>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type Brand = {
  agreements: Maybe<Array<Maybe<BrandAgreement>>>;
  name: Scalars['String']['output'];
  preferences: Maybe<Array<Maybe<BrandCustomerPreference>>>;
  supportedPaymentTypes: Maybe<Array<Maybe<PaymentInstrumentType>>>;
  tenant: Tenant;
};

export type BrandAgreement = {
  activeAt: Maybe<Scalars['OCDateTime']['output']>;
  name: Scalars['String']['output'];
  url: Maybe<Scalars['OCURL']['output']>;
  uuid: Scalars['ID']['output'];
};

export type BrandCustomerPreference = {
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type BrandFilter = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  tenantContains?: InputMaybe<Scalars['String']['input']>;
  tenantEquals?: InputMaybe<Scalars['String']['input']>;
};

export enum CategoryRestrictions {
  Age = 'AGE',
  Eaiv = 'EAIV',
}

export enum ChangeSource {
  CommandCenter = 'COMMAND_CENTER',
  EtlImport = 'ETL_IMPORT',
  Experience = 'EXPERIENCE',
  RetailerConnect = 'RETAILER_CONNECT',
  SqlUpdate = 'SQL_UPDATE',
}

export enum ConexxusPriceTier {
  Cash = 'cash',
  Credit = 'credit',
  Debit = 'debit',
  Fleet = 'fleet',
  Loyalty = 'loyalty',
  Proprietary = 'proprietary',
  StoredValue = 'storedValue',
}

export enum ConstraintPurchaseThresholdCountingAttribute {
  MoneyAmount = 'MONEY_AMOUNT',
  Quantity = 'QUANTITY',
  UnitsCount = 'UNITS_COUNT',
}

export enum CustomerRequestType {
  Complaint = 'COMPLAINT',
  Compliment = 'COMPLIMENT',
  Question = 'QUESTION',
}

export enum CustomerStatus {
  Active = 'ACTIVE',
  Blacklisted = 'BLACKLISTED',
  FlaggedForReview = 'FLAGGED_FOR_REVIEW',
  Inactive = 'INACTIVE',
  SignedUp = 'SIGNED_UP',
  SignupNotCompleted = 'SIGNUP_NOT_COMPLETED',
  WaitingForVerification = 'WAITING_FOR_VERIFICATION',
  Whitelisted = 'WHITELISTED',
}

export enum CustomDataMode {
  Merge = 'MERGE',
  Replace = 'REPLACE',
}

export type CarWashInput = {
  amount: Scalars['Float']['input'];
  posCode: Scalars['String']['input'];
  posCodeModifier: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};

export type CarWashItem = {
  additionalAttributes: Maybe<Scalars['OCJSON']['output']>;
  description: Maybe<Scalars['String']['output']>;
  itemType: Maybe<ResourceItemType>;
  merchandiseCode: Maybe<Scalars['String']['output']>;
  posCode: Maybe<Scalars['String']['output']>;
  posCodeFormat: Maybe<Scalars['String']['output']>;
  posCodeModifier: Maybe<Scalars['String']['output']>;
  receiptDescription: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  taxCode: Maybe<Scalars['String']['output']>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<ItemPrice>;
  uuid: Scalars['ID']['output'];
};

export type CarWashItemConnection = {
  edges: Maybe<Array<Maybe<CarWashItemEdge>>>;
  pageInfo: PageInfo;
};

export type CarWashItemEdge = {
  cursor: Scalars['ID']['output'];
  node: Maybe<CarWashItem>;
};

export type Chain = {
  configuration: ChainConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subBrandConfigurations: Maybe<Array<SubBrandConfiguration>>;
};

export type ChainConfiguration = {
  allowMultipleTransactionDiscounts: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  pointsStrategy: PointsStrategy;
};

export type ClientToken = {
  token: Maybe<Scalars['String']['output']>;
};

export type CombinedTransaction = {
  loyalty: Maybe<ActivateTransaction>;
  mobile: Maybe<Transaction>;
  pointChange: Maybe<PointChange>;
  startedAt: Scalars['OCDateTime']['output'];
};

export type CommandCenterUser = {
  email: Scalars['OCEmailAddress']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type CommunicationPreference = {
  emailOptIn: Scalars['Boolean']['output'];
  emailOptInAt: Maybe<Scalars['OCDateTime']['output']>;
  emailOptOutAt: Maybe<Scalars['OCDateTime']['output']>;
  pushOptIn: Scalars['Boolean']['output'];
  pushOptInAt: Maybe<Scalars['OCDateTime']['output']>;
  pushOptOutAt: Maybe<Scalars['OCDateTime']['output']>;
  smsOptIn: Scalars['Boolean']['output'];
  smsOptInAt: Maybe<Scalars['OCDateTime']['output']>;
  smsOptOutAt: Maybe<Scalars['OCDateTime']['output']>;
  smsOptOutReason: Maybe<SmsOptOutReason>;
  subBrandUuid: Maybe<Scalars['ID']['output']>;
};

export type CommunicationPreferenceConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  isPushOptInConfigurable: Scalars['Boolean']['output'];
  isSmsOptInConfigurable: Scalars['Boolean']['output'];
};

export type CommunicationPreferenceUpdateInput = {
  emailOptInAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  emailOptOutAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  pushOptInAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  pushOptOutAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  smsOptInAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  smsOptOutAt?: InputMaybe<Scalars['OCDateTime']['input']>;
  subBrandUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type Constraint =
  | ConstraintDaysOfWeek
  | ConstraintEmailRequired
  | ConstraintInAudience
  | ConstraintLocationInState
  | ConstraintOrderAheadOnly
  | ConstraintPaymentInstrument
  | ConstraintPaymentMethod
  | ConstraintPreAuth
  | ConstraintPurchasableEligibility
  | ConstraintPurchaseThreshold
  | ConstraintRequiresActivation
  | ConstraintRequiresTransactionVoucher
  | ConstraintRequiresVoucher
  | ConstraintRequiresVoucherAvailableForDiscount
  | ConstraintStoreLocation
  | ConstraintStoreLocationGroup
  | ConstraintSubBrand
  | ConstraintTimeOfDay;

export type ConstraintDaysOfWeek = {
  availableWeeklyOnDays: Array<Weekday>;
  id: Scalars['ID']['output'];
  startOfDayTimezone: Scalars['String']['output'];
};

export type ConstraintEmailRequired = {
  id: Scalars['ID']['output'];
};

export type ConstraintInAudience = {
  audienceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ConstraintLocationInState = {
  id: Scalars['ID']['output'];
  states: Array<Scalars['String']['output']>;
};

export type ConstraintOrderAheadOnly = {
  id: Scalars['ID']['output'];
};

export type ConstraintPaymentInstrument = {
  evaluationMethod: PaymentInstrumentEvaluationMethod;
  id: Scalars['ID']['output'];
  paymentInstruments: Array<PaymentInstrumentType>;
};

export type ConstraintPaymentMethod = {
  evaluationMethod: PaymentMethodEvaluationMethod;
  id: Scalars['ID']['output'];
  paymentMethods: Array<ActivatePaymentMethod>;
};

export type ConstraintPreAuth = {
  id: Scalars['ID']['output'];
};

export type ConstraintPurchasableEligibility = {
  id: Scalars['ID']['output'];
  ownershipCondition: OwnershipCondition;
  voucheredOffers: Array<Offer>;
};

export type ConstraintPurchaseThreshold = {
  countProductsBy: ConstraintPurchaseThresholdCountingAttribute;
  eligibleProductGroupIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  threshold: Scalars['Int']['output'];
};

export type ConstraintRequiresActivation = {
  allowMultipleFulfillmentsOnActivation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mustFulfillWithinDays: Maybe<Scalars['Int']['output']>;
};

export type ConstraintRequiresTransactionVoucher = {
  allowSingleOfferVoucherStacking: Maybe<Scalars['Boolean']['output']>;
  breakagePointRounding: Maybe<BreakagePointRounding>;
  breakageRefund: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ConstraintRequiresVoucher = {
  id: Scalars['ID']['output'];
};

export type ConstraintRequiresVoucherAvailableForDiscount = {
  id: Scalars['ID']['output'];
};

export type ConstraintStoreLocation = {
  evaluationMethod: StoreLocationEvaluationMethod;
  id: Scalars['ID']['output'];
  locations: Array<ActivateLocation>;
};

export type ConstraintStoreLocationGroup = {
  id: Scalars['ID']['output'];
  locationGroups: Array<LocationGroup>;
};

export type ConstraintSubBrand = {
  id: Scalars['ID']['output'];
  subBrandUuids: Array<Scalars['ID']['output']>;
};

export type ConstraintTimeOfDay = {
  availableDailyEndingAtTime: Scalars['OCTime']['output'];
  availableDailyStartingAtTime: Scalars['OCTime']['output'];
  id: Scalars['ID']['output'];
  timezone: Scalars['String']['output'];
};

export type ContactPhoneNumber = {
  alias: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['OCPhoneNumber']['output'];
  phoneType: PhoneType;
  uuid: Scalars['ID']['output'];
};

export type CookieConsentConfiguration = CookiebotCookieConsentConfiguration;

export type CookiebotCookieConsentConfiguration = FeatureConfiguration & {
  consentEditingEnabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  sdkUrl: Scalars['String']['output'];
};

export type CreateOtpSessionInput = {
  otpChannel?: InputMaybe<OtpChannel>;
  otpPlatform: OtpPlatform;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type Currency = {
  code: Maybe<Scalars['String']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
};

export type CustomDataInput = {
  data: Scalars['OCJSON']['input'];
  mode?: InputMaybe<CustomDataMode>;
};

export type Customer = {
  addresses: Maybe<Array<Maybe<Address>>>;
  agreements: Maybe<Array<Maybe<CustomerAgreement>>>;
  brands: Maybe<Array<Maybe<Brand>>>;
  communicationPreference: CommunicationPreference;
  defaultLocation: Maybe<Location>;
  demographics: Maybe<Demographics>;
  devices: Maybe<Array<Maybe<CustomerDevice>>>;
  email: Maybe<Scalars['OCEmailAddress']['output']>;
  hasPasscode: Maybe<Scalars['Boolean']['output']>;
  hasPasswordSet: Maybe<Scalars['Boolean']['output']>;
  isNewCustomer: Scalars['Boolean']['output'];
  loginHistory: Maybe<CustomerLoginAttemptConnection>;
  loyaltyAccounts: Maybe<Array<Maybe<LoyaltyAccount>>>;
  loyaltyWallet: Maybe<Array<Maybe<LoyaltyInstrument>>>;
  membership: Maybe<Membership>;
  name: Maybe<PersonName>;
  paymentWallet: Maybe<Array<Maybe<PaymentInstrument>>>;
  phoneNumbers: Maybe<Array<Maybe<ContactPhoneNumber>>>;
  preferences: Maybe<Array<Maybe<CustomerPreference>>>;
  privacyGovernance: Maybe<Scalars['String']['output']>;
  signUpOrigin: Maybe<SignUpOrigin>;
  status: CustomerStatus;
  transactions: Maybe<TransactionConnection>;
  username: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CustomerLoginHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerLoginAttemptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerAddressCreate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationCreate>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerAddressUpdate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationUpdate>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerAgreement = {
  agreedAt: Maybe<Scalars['OCDateTime']['output']>;
  brandAgreement: Maybe<BrandAgreement>;
  name: Scalars['String']['output'];
  url: Maybe<Scalars['OCURL']['output']>;
};

export type CustomerAgreementCreate = {
  uuid: Scalars['ID']['input'];
};

export type CustomerContact = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['OCCountryCode2']['input']>;
  customerRequestType: CustomerRequestType;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stationId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreate = {
  addresses?: InputMaybe<Array<InputMaybe<CustomerAddressCreate>>>;
  agreements?: InputMaybe<Array<InputMaybe<CustomerAgreementCreate>>>;
  brandUuid: Scalars['ID']['input'];
  chainId?: InputMaybe<Scalars['ID']['input']>;
  demographics?: InputMaybe<CustomerDemographicsCreate>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  loyaltyAccounts?: InputMaybe<Array<InputMaybe<LoyaltyAccountCreate>>>;
  name?: InputMaybe<CustomerPersonNameCreate>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<CustomerPhoneNumberCreate>>>;
  preferences?: InputMaybe<Array<InputMaybe<CustomerPreferenceCreate>>>;
  signUpOrigin?: InputMaybe<SignUpOrigin>;
  username: Scalars['String']['input'];
};

export type CustomerCreateVerify = {
  otp: Otp;
};

export type CustomerDemographicsCreate = {
  birthday?: InputMaybe<Scalars['OCDate']['input']>;
  customDemographics?: InputMaybe<Scalars['OCJSON']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDemographicsUpdate = {
  birthday?: InputMaybe<Scalars['OCDate']['input']>;
  customDemographics?: InputMaybe<Scalars['OCJSON']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDevice = {
  additionalInfo: Maybe<Scalars['OCJSON']['output']>;
  alias: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceType: DeviceType;
  osType: Maybe<Scalars['String']['output']>;
  osVersion: Maybe<Scalars['String']['output']>;
  signature: Maybe<Scalars['String']['output']>;
};

export type CustomerDeviceFilter = {
  aliasEquals?: InputMaybe<Scalars['String']['input']>;
  deviceIDEquals?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDeviceInput = {
  additionalInfo?: InputMaybe<Scalars['OCJSON']['input']>;
  alias: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  deviceType: DeviceType;
  osType?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerFeedback = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export type CustomerLoginAttempt = {
  device: Maybe<CustomerDevice>;
  loginAt: Scalars['OCDateTime']['output'];
  loginLocation: Maybe<GeoLocation>;
  wasSuccessful: Scalars['Boolean']['output'];
};

export type CustomerLoginAttemptConnection = {
  edges: Maybe<Array<Maybe<CustomerLoginAttemptEdge>>>;
  pageInfo: PageInfo;
};

export type CustomerLoginAttemptEdge = {
  cursor: Scalars['ID']['output'];
  node: Maybe<CustomerLoginAttempt>;
};

export type CustomerLoginAttemptFilter = {
  device?: InputMaybe<CustomerDeviceFilter>;
  loginAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  loginAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  loginLocation?: InputMaybe<GeoLocationFilter>;
  wasSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerLoyaltyInstrumentCreate = {
  accountNumber: Scalars['String']['input'];
  alias: Scalars['String']['input'];
};

export type CustomerLoyaltyInstrumentUpdate = {
  alias: Scalars['String']['input'];
};

export type CustomerOtpPayload = {
  session: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomerOtpPayloadOrAuthPayload = AuthPayload | CustomerOtpPayload;

export type CustomerOtpRequest = {
  brandUuid: Scalars['ID']['input'];
  chainId?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<OtpChannel>;
  identifier: Scalars['String']['input'];
  mode?: InputMaybe<OtpMode>;
};

export type CustomerOtpVerify = {
  otp: Otp;
};

export type CustomerPassword = {
  password: Scalars['String']['input'];
};

export type CustomerPasswordChange = {
  newPassword: CustomerPassword;
  oldPassword: CustomerPassword;
};

export type CustomerPasswordCredentials = {
  password: CustomerPassword;
  username: CustomerUsername;
};

export type CustomerPasswordReset = {
  newPassword: CustomerPassword;
};

export type CustomerPasswordResetByOtpVerify = {
  otp: Otp;
};

export type CustomerPasswordResetPaymentInstrumentVerify = {
  expiration: CustomerPaymentInstrumentExpirationInput;
};

export type CustomerPasswordSet = {
  newPassword: CustomerPassword;
};

export type CustomerPaymentInstrumentCreate = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<PaymentAccountType>;
  address?: InputMaybe<CustomerAddressCreate>;
  alias?: InputMaybe<Scalars['String']['input']>;
  binRange?: InputMaybe<Scalars['String']['input']>;
  encryptedPaymentInstrumentDetails?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<CustomerPaymentInstrumentExpirationInput>;
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  fiservOAuthToken?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<CustomerPersonNameCreate>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentInstrumentType>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  tokenizationSessionId?: InputMaybe<Scalars['String']['input']>;
  transactionUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerPaymentInstrumentExpirationInput = {
  expirationMonth?: InputMaybe<Scalars['String']['input']>;
  expirationYear?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPaymentInstrumentUpdate = {
  address?: InputMaybe<CustomerAddressUpdate>;
  alias?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<CustomerPaymentInstrumentExpirationInput>;
  paymentType?: InputMaybe<PaymentInstrumentType>;
  uuid: Scalars['ID']['input'];
};

export type CustomerPaymentInstrumentVerify = {
  otp: Otp;
};

export type CustomerPersonNameCreate = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
  middle?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPersonNameUpdate = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
  middle?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPhoneNumberCreate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  phoneType: PhoneType;
};

export type CustomerPhoneNumberUpdate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  phoneType: PhoneType;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerPinCode = {
  pinCode: Scalars['String']['input'];
};

export type CustomerPinCodeChange = {
  newPinCode: CustomerPinCode;
  oldPinCode: CustomerPinCode;
};

export type CustomerPinCodeCredentials = {
  pinCode: CustomerPinCode;
  username: CustomerUsername;
};

export type CustomerPinCodeSet = {
  pinCode: CustomerPinCode;
};

export type CustomerPinCodeVerify = {
  pinCode: CustomerPinCode;
};

export type CustomerPreference = {
  preference: Maybe<BrandCustomerPreference>;
  uuid: Scalars['ID']['output'];
  value: Maybe<PreferenceValue>;
};

export type CustomerPreferenceCreate = {
  uuid: Scalars['ID']['input'];
  value?: InputMaybe<PreferenceValueCreate>;
};

export type CustomerPreferenceUpdate = {
  uuid?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<PreferenceValueUpdate>;
};

export type CustomerRegistrationComplete = {
  acceptAgreement?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  defaultLocationId: Scalars['Int']['input'];
  demographics?: InputMaybe<CustomerDemographicsCreate>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  name?: InputMaybe<CustomerPersonNameCreate>;
  preferences?: InputMaybe<Array<InputMaybe<CustomerPreferenceCreate>>>;
};

export type CustomerUpdate = {
  addresses?: InputMaybe<Array<InputMaybe<CustomerAddressUpdate>>>;
  defaultLocationId?: InputMaybe<Scalars['Int']['input']>;
  demographics?: InputMaybe<CustomerDemographicsUpdate>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  loyaltyAccounts?: InputMaybe<Array<InputMaybe<LoyaltyAccountUpdate>>>;
  membership?: InputMaybe<MembershipUpdate>;
  name?: InputMaybe<CustomerPersonNameUpdate>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<CustomerPhoneNumberUpdate>>>;
  preferences?: InputMaybe<Array<InputMaybe<CustomerPreferenceUpdate>>>;
  signUpOrigin?: InputMaybe<SignUpOrigin>;
};

export type CustomerUpdateStateInput = {
  ageVerifyAndEaivReset?: InputMaybe<Scalars['Boolean']['input']>;
  payResetThrottle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerUsername = {
  username: Scalars['String']['input'];
};

export enum DeviceType {
  AlexaSkill = 'ALEXA_SKILL',
  Android = 'ANDROID',
  AndroidTablet = 'ANDROID_TABLET',
  AppServer = 'APP_SERVER',
  ConnectedCar = 'CONNECTED_CAR',
  Desktop = 'DESKTOP',
  Ipad = 'IPAD',
  Iphone = 'IPHONE',
  Pos = 'POS',
  Web = 'WEB',
}

export type DateRangeInput = {
  endDate: Scalars['OCDateTime']['input'];
  startDate: Scalars['OCDateTime']['input'];
};

export type DeleteAccountConfiguration = FeatureConfiguration & {
  deleteAccountMutation: DeleteAccountMutation;
  enabled: Scalars['Boolean']['output'];
};

export enum DeleteAccountMutation {
  DeleteMembership = 'DELETE_MEMBERSHIP',
  ScrubData = 'SCRUB_DATA',
}

export type DeletionRequestSourceInput = {
  membershipUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type Demographics = {
  birthday: Maybe<Scalars['OCDate']['output']>;
  customDemographics: Maybe<Scalars['OCJSON']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type DevRevSupportWidgetConfiguration = FeatureConfiguration & {
  appId: Scalars['ID']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type DeviceTokenRegisterInput = {
  deviceId: Scalars['ID']['input'];
  deviceType: DeviceType;
  token: Scalars['String']['input'];
};

export type DisplayCategory = {
  /** @deprecated Replaced by categoryRestrictions. */
  ageRestricted: Maybe<Scalars['Boolean']['output']>;
  bannerIds: Maybe<Array<Scalars['ID']['output']>>;
  categoryRestrictions: Maybe<CategoryRestrictions>;
  chainId: Scalars['ID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  offers: OfferConnection;
  rank: Scalars['Int']['output'];
};

export type DisplayCategoryOffersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DisplayCategoryConnection = {
  edges: Array<DisplayCategoryEdge>;
  pageInfo: PageInfo;
};

export type DisplayCategoryEdge = {
  cursor: Scalars['ID']['output'];
  node: DisplayCategory;
};

export type DisplayCategoryFilter = {
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum EaivAdditionalPromptFields {
  EaivPromptForAdditionalAddress = 'EAIV_PROMPT_FOR_ADDITIONAL_ADDRESS',
  EaivPromptForSsn4 = 'EAIV_PROMPT_FOR_SSN4',
  EaivPromptForSsn4OrAdditionalAddress = 'EAIV_PROMPT_FOR_SSN4_OR_ADDITIONAL_ADDRESS',
}

export enum EaivAgeVerificationFailed {
  LimitReached = 'LIMIT_REACHED',
  VerificationFailed = 'VERIFICATION_FAILED',
}

export enum EaivIdentityVerificationFailed {
  LimitReached = 'LIMIT_REACHED',
  VerificationFailed = 'VERIFICATION_FAILED',
}

export enum EarningMechanismProductCountingAttribute {
  MoneyAmount = 'MONEY_AMOUNT',
  Quantity = 'QUANTITY',
  UnitsCount = 'UNITS_COUNT',
}

export enum EarningMechanismProductCountingRoundingStrategy {
  Down = 'DOWN',
  HalfUp = 'HALF_UP',
  Raw = 'RAW',
}

export enum EarningMechanismTypename {
  EarningMechanismExternalFulfillment = 'EarningMechanismExternalFulfillment',
  EarningMechanismLoyaltyEvent = 'EarningMechanismLoyaltyEvent',
  EarningMechanismMembershipEvent = 'EarningMechanismMembershipEvent',
  EarningMechanismPointSpend = 'EarningMechanismPointSpend',
  EarningMechanismProductDiscount = 'EarningMechanismProductDiscount',
  EarningMechanismProductPurchase = 'EarningMechanismProductPurchase',
  EarningMechanismPromocodes = 'EarningMechanismPromocodes',
  EarningMechanismSpinWheelGame = 'EarningMechanismSpinWheelGame',
  EarningMechanismTotalEligiblePurchase = 'EarningMechanismTotalEligiblePurchase',
  EarningMechanismTotalEligiblePurchaseOverTime = 'EarningMechanismTotalEligiblePurchaseOverTime',
  EarningMechanismTotalSpendOnTransaction = 'EarningMechanismTotalSpendOnTransaction',
  EarningMechanismTotalSpendOverTime = 'EarningMechanismTotalSpendOverTime',
  EarningMechanismTransactionDiscount = 'EarningMechanismTransactionDiscount',
  EarningMechanismVarietyDiscount = 'EarningMechanismVarietyDiscount',
  EarningMechanismVarietyPurchase = 'EarningMechanismVarietyPurchase',
  EarningMechanismVarietyPurchaseOverTime = 'EarningMechanismVarietyPurchaseOverTime',
  EarningMechanismVisits = 'EarningMechanismVisits',
}

export type EaivAgeVerification = {
  isAvailable: Scalars['Boolean']['output'];
};

export type EaivAgeVerificationAddress = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type EaivAgeVerificationConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export enum EaivAgeVerificationRequestStatusType {
  Success = 'Success',
}

export type EaivAgeVerificationRequireAdditionalPrompt = {
  prompt: EaivAdditionalPromptFields;
};

export type EaivAgeVerificationResultFailed = {
  reason: Maybe<EaivAgeVerificationFailed>;
};

export type EaivAgeVerificationStartInput = {
  /** @deprecated Use addresses object instead */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  address2?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<EaivAgeVerificationAddress>>>;
  birthdate: Scalars['OCDate']['input'];
  /** @deprecated Use addresses object instead */
  city?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  ssn4?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  state?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type EaivAgeVerificationStartResult =
  | EaivAgeVerificationRequireAdditionalPrompt
  | EaivAgeVerificationResultFailed
  | EaivAgeVerificationStartResultSuccess;

export type EaivAgeVerificationStartResultSuccess = {
  status: EaivAgeVerificationRequestStatusType;
};

export type EaivIdentityVerification = {
  isAvailable: Scalars['Boolean']['output'];
};

export type EaivIdentityVerificationAddress = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type EaivIdentityVerificationAnswerInput = {
  answerValue: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export type EaivIdentityVerificationAnswerSetInput = {
  answers: Array<EaivIdentityVerificationAnswerInput>;
  questionSetId: Scalars['String']['input'];
};

export type EaivIdentityVerificationChoiceQuestion = {
  choices: Array<EaivIdentityVerificationChoiceQuestionOption>;
  helpText: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type EaivIdentityVerificationChoiceQuestionOption = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type EaivIdentityVerificationConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type EaivIdentityVerificationQuestion = EaivIdentityVerificationChoiceQuestion;

export type EaivIdentityVerificationQuestionSet = {
  id: Scalars['String']['output'];
  questions: Array<EaivIdentityVerificationQuestion>;
};

export enum EaivIdentityVerificationRequestStatusType {
  Success = 'Success',
}

export type EaivIdentityVerificationRequireAdditionalPrompt = {
  prompt: EaivAdditionalPromptFields;
};

export type EaivIdentityVerificationResultFailed = {
  reason: Maybe<EaivIdentityVerificationFailed>;
};

export type EaivIdentityVerificationStartInput = {
  /** @deprecated Use addresses object instead */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  address2?: InputMaybe<Scalars['String']['input']>;
  addresses?: InputMaybe<Array<InputMaybe<EaivIdentityVerificationAddress>>>;
  birthdate: Scalars['OCDate']['input'];
  /** @deprecated Use addresses object instead */
  city?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  ssn4?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  state?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use addresses object instead */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type EaivIdentityVerificationStartResult =
  | EaivIdentityVerificationRequireAdditionalPrompt
  | EaivIdentityVerificationResultFailed
  | EaivIdentityVerificationStartResultSuccess;

export type EaivIdentityVerificationStartResultSuccess = {
  conversationId: Scalars['String']['output'];
  questionSet: EaivIdentityVerificationQuestionSet;
};

export type EaivIdentityVerificationSubmitInput = {
  answerSet: EaivIdentityVerificationAnswerSetInput;
  conversationId: Scalars['String']['input'];
};

export type EaivIdentityVerificationSubmitResult =
  | EaivIdentityVerificationResultFailed
  | EaivIdentityVerificationSubmitResultContinue
  | EaivIdentityVerificationSubmitResultSuccess;

export type EaivIdentityVerificationSubmitResultContinue = {
  conversationId: Scalars['String']['output'];
  questionSet: EaivIdentityVerificationQuestionSet;
};

export type EaivIdentityVerificationSubmitResultSuccess = {
  status: EaivIdentityVerificationRequestStatusType;
};

export type EarningMechanism =
  | EarningMechanismExternalFulfillment
  | EarningMechanismLoyaltyEvent
  | EarningMechanismMembershipEvent
  | EarningMechanismPointSpend
  | EarningMechanismProductDiscount
  | EarningMechanismProductPurchase
  | EarningMechanismPromocodes
  | EarningMechanismSpinWheelGame
  | EarningMechanismTotalEligiblePurchase
  | EarningMechanismTotalEligiblePurchaseOverTime
  | EarningMechanismTotalSpendOnTransaction
  | EarningMechanismTotalSpendOverTime
  | EarningMechanismTransactionDiscount
  | EarningMechanismVarietyDiscount
  | EarningMechanismVarietyPurchase
  | EarningMechanismVarietyPurchaseOverTime
  | EarningMechanismVisits;

export type EarningMechanismExternalFulfillment = {
  award: Maybe<AwardPointsOrVouchers>;
  id: Scalars['ID']['output'];
};

export type EarningMechanismLoyaltyEvent = {
  award: Maybe<AwardExternalPointsOrPointsOrVouchers>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EarningMechanismMembershipEvent = {
  award: AwardPointsOrVouchers;
  eventType: MembershipEventType;
  id: Scalars['ID']['output'];
};

export type EarningMechanismPointSpend = {
  award: AwardVouchers;
  id: Scalars['ID']['output'];
  pointCost: Scalars['Int']['output'];
};

export type EarningMechanismProductCriteria = {
  countProductsBy: EarningMechanismProductCountingAttribute;
  eligibleProductGroups: Array<ProductGroup>;
  id: Maybe<Scalars['ID']['output']>;
  purchaseThreshold: Scalars['Float']['output'];
};

export type EarningMechanismProductDiscount = {
  award: AwardMoneyDiscountOrPriceOverrideOrBuyAndGet;
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  purchaseThreshold: Scalars['Int']['output'];
};

export type EarningMechanismProductPurchase = {
  award: AwardPointsOrVouchersOrExternal;
  countProductsBy: EarningMechanismProductCountingAttribute;
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  purchaseThreshold: Scalars['Float']['output'];
};

export type EarningMechanismPromocodes = {
  award: Maybe<AwardPointsOrVouchers>;
  id: Scalars['ID']['output'];
};

export type EarningMechanismSpinWheelGame = {
  awards: Array<RandomAwardConfig>;
  id: Scalars['ID']['output'];
  purchasableOffer: Maybe<Offer>;
};

export type EarningMechanismTotalEligiblePurchase = {
  award: AwardPointsPer;
  countProductsBy: EarningMechanismProductCountingAttribute;
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  roundCountedProducts: EarningMechanismProductCountingRoundingStrategy;
};

export type EarningMechanismTotalEligiblePurchaseOverTime = {
  accumulationThreshold: Scalars['Float']['output'];
  award: AwardPointsOrVouchers;
  countProductsBy: EarningMechanismProductCountingAttribute;
  eligibleProductGroups: Array<ProductGroup>;
  hiddenUntilProgress: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  purchaseMemberProgress: Maybe<PurchaseProgress>;
};

export type EarningMechanismTotalSpendOnTransaction = {
  award: AwardPointsPer;
  id: Scalars['ID']['output'];
  ineligibleProductGroups: Array<ProductGroup>;
  roundMoneyAmount: EarningMechanismProductCountingRoundingStrategy;
};

export type EarningMechanismTotalSpendOverTime = {
  accumulationThreshold: Scalars['Float']['output'];
  award: AwardPointsOrVouchers;
  id: Scalars['ID']['output'];
  ineligibleProductGroups: Array<ProductGroup>;
  purchaseMemberProgress: Maybe<PurchaseProgress>;
};

export type EarningMechanismTransactionDiscount = {
  allowMultipleFulfillmentsPerProductGroupThreshold: Scalars['Boolean']['output'];
  award: TransactionDiscountAwards;
  /** @deprecated Replaced by ineligibleProductGroups. */
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  ineligibleProductGroups: Array<ProductGroup>;
  purchaseAmountThreshold: Scalars['Int']['output'];
};

export type EarningMechanismVarietyDiscount = {
  award: VarietyDiscountAwards;
  id: Scalars['ID']['output'];
  purchases: Array<EarningVarietyDiscountCriteria>;
};

export type EarningMechanismVarietyPurchase = {
  award: AwardPointsOrVouchers;
  id: Scalars['ID']['output'];
  products: Array<EarningMechanismProductCriteria>;
};

export type EarningMechanismVarietyPurchaseOverTime = {
  award: AwardPointsOrVouchers;
  hiddenUntilProgress: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  products: Array<EarningMechanismProductCriteria>;
  varietyMemberProgress: Array<VarietyProgress>;
};

export type EarningMechanismVisits = {
  award: AwardPointsOrVouchers;
  id: Scalars['ID']['output'];
  visitThreshold: Scalars['Int']['output'];
  visitsMemberProgress: Maybe<VisitsProgress>;
};

export type EarningVarietyDiscountCriteria = {
  eligibleProductGroups: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  purchaseThreshold: Scalars['Int']['output'];
};

export type ExchangeSessionAndOtpToAuthTokenResult = {
  success: Scalars['Boolean']['output'];
};

export type ExchangeSessionAndOtpToAuthTokenResultFailedIncorrectOtp = ExchangeSessionAndOtpToAuthTokenResult & {
  success: Scalars['Boolean']['output'];
};

export type ExchangeSessionAndOtpToAuthTokenResultSuccess = ExchangeSessionAndOtpToAuthTokenResult & {
  success: Scalars['Boolean']['output'];
  tokens: Tokens;
};

export type ExchangeSessionAndOtpToAuthTokenResultUnion =
  | ExchangeSessionAndOtpToAuthTokenResultFailedIncorrectOtp
  | ExchangeSessionAndOtpToAuthTokenResultSuccess;

export enum ExternalAwardProvider {
  Bybe = 'BYBE',
  Unknown = 'UNKNOWN',
}

export type ExternalIdentityAppConfig = {
  externalIdentityVerification: Maybe<ExternalIdentityVerification>;
};

export type ExternalIdentityVerification = {
  enabled: Scalars['Boolean']['output'];
  provider: ExternalIdentityVerificationProvider;
};

export type ExternalIdentityVerificationAttribute = {
  handle: Scalars['String']['output'];
  isCoreAttribute: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ExternalIdentityVerificationAttributeFilter = {
  isCoreAttributeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalIdentityVerificationAuthorizationUrlInput = {
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalIdentityVerificationAuthorizationUrlPayload = {
  authorizationUrl: Scalars['OCURL']['output'];
  clientId: Scalars['String']['output'];
  grantType: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type ExternalIdentityVerificationProfile = {
  attributes: Maybe<Array<ExternalIdentityVerificationAttribute>>;
  completedAt: Scalars['OCDateTime']['output'];
  provider: ExternalIdentityVerificationProvider;
};

export type ExternalIdentityVerificationProfileAttributesArgs = {
  filter?: InputMaybe<ExternalIdentityVerificationAttributeFilter>;
};

export enum ExternalIdentityVerificationProvider {
  Idme = 'IDME',
}

export type ExternalLineItemPromotion = {
  discountAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  promotionReason: Scalars['String']['output'];
};

export enum FuelPricesMode {
  Both = 'BOTH',
  CashOnly = 'CASH_ONLY',
  CreditOnly = 'CREDIT_ONLY',
}

export enum FuelPumpStatus {
  FuelCanceled = 'FUEL_CANCELED',
  FuelEnd = 'FUEL_END',
  FuelPreAuthSubmitted = 'FUEL_PRE_AUTH_SUBMITTED',
  FuelPumpActivated = 'FUEL_PUMP_ACTIVATED',
  FuelPumpDeactivated = 'FUEL_PUMP_DEACTIVATED',
  FuelReceiptReceived = 'FUEL_RECEIPT_RECEIVED',
  FuelSecondaryIdReceived = 'FUEL_SECONDARY_ID_RECEIVED',
  FuelStart = 'FUEL_START',
  Unknown = 'UNKNOWN',
}

export enum FuelType {
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Gasoline = 'GASOLINE',
  NaturalGas = 'NATURAL_GAS',
  OffroadDiesel = 'OFFROAD_DIESEL',
  Propane = 'PROPANE',
}

export type FeatureConfiguration = {
  enabled: Scalars['Boolean']['output'];
};

export type FiservClientToken = {
  algorithm: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  expiresInSeconds: Scalars['Int']['output'];
  fdCustomerId: Scalars['ID']['output'];
  issuedOn: Scalars['OCDateTime']['output'];
  oAuthToken: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
};

export type FiservConfiguration = PaymentProviderConfiguration & {
  customData: Maybe<Scalars['OCJSON']['output']>;
};

export enum FraudCheckStatus {
  Fraudulent = 'FRAUDULENT',
  NotChecked = 'NOT_CHECKED',
  NotFraudulent = 'NOT_FRAUDULENT',
}

export type FreshdeskSupportWidgetConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  host: Maybe<Scalars['String']['output']>;
  sdkUrl: Maybe<Scalars['String']['output']>;
  token: Maybe<Scalars['String']['output']>;
  widgetId: Maybe<Scalars['String']['output']>;
};

export type FuelAndConvenienceProfile = {
  achEnrollmentStatus: Maybe<AchEnrollmentStatus>;
  acquisitionChannel: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by restrictionVerification. */
  alcoholVerified: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by restrictionVerification. */
  altriaVerified: Maybe<Scalars['Boolean']['output']>;
  externalAuthSource: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberDataShare: Maybe<Scalars['Boolean']['output']>;
  pendingVerification: Maybe<CategoryRestrictions>;
  preferredFuelProductGroup: Maybe<FuelProductGroup>;
  restrictionVerification: Maybe<CategoryRestrictions>;
  /** @deprecated Replaced by restrictionVerification. */
  rjrVerified: Maybe<Scalars['Boolean']['output']>;
};

export type FuelAndConvenienceProfileCreateOrUpdateInput = {
  achEnrollmentStatus?: InputMaybe<AchEnrollmentStatus>;
  memberDataShare?: InputMaybe<Scalars['Boolean']['input']>;
  preferredFuelProductGroupUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type FuelGradePrice = {
  description: Scalars['String']['output'];
  unitPrice: Maybe<FuelItemPrice>;
};

export type FuelItem = {
  additionalAttributes: Maybe<Scalars['OCJSON']['output']>;
  description: Maybe<Scalars['String']['output']>;
  fuelGrade: Maybe<Scalars['Float']['output']>;
  fuelType: Maybe<FuelType>;
  itemType: Maybe<ResourceItemType>;
  merchandiseCode: Maybe<Scalars['String']['output']>;
  posCode: Maybe<Scalars['String']['output']>;
  posCodeFormat: Maybe<Scalars['String']['output']>;
  posCodeModifier: Maybe<Scalars['String']['output']>;
  receiptDescription: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  taxCode: Maybe<Scalars['String']['output']>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<FuelItemPrice>;
  uuid: Scalars['ID']['output'];
};

export type FuelItemConnection = {
  edges: Maybe<Array<Maybe<FuelItemEdge>>>;
  pageInfo: PageInfo;
};

export type FuelItemEdge = {
  cursor: Scalars['ID']['output'];
  node: Maybe<FuelItem>;
};

export type FuelItemPrice = {
  cashPrice: Scalars['Float']['output'];
  creditPrice: Scalars['Float']['output'];
  displayCashPrice: Scalars['String']['output'];
  displayCreditPrice: Scalars['String']['output'];
};

export enum FuelPriceState {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
}

export type FuelProductGroup = {
  id: Scalars['ID']['output'];
  productGroup: ProductGroup;
};

export type FuelProductGroupFilter = {
  userSelectable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FuelReceipt = {
  carWashCode: Maybe<Scalars['String']['output']>;
  carWashName: Maybe<Scalars['String']['output']>;
  carWashPrice: Maybe<Scalars['String']['output']>;
  fuelSale: Scalars['String']['output'];
  gallons: Scalars['String']['output'];
  priceG: Scalars['String']['output'];
  product: Scalars['String']['output'];
  tax: Scalars['String']['output'];
};

export enum GlobalOffersFilter {
  All = 'ALL',
  PerLocation = 'PER_LOCATION',
}

export enum GooglePayEnvironment {
  Production = 'PRODUCTION',
  Test = 'TEST',
}

export type GameSession = {
  awardData: Maybe<Scalars['OCJSON']['output']>;
  id: Scalars['ID']['output'];
  membership: Membership;
  offer: Offer;
};

export type GeneralSurvey = Survey & {
  audienceUuid: Scalars['OCUUID']['output'];
  award: Maybe<AwardPointsOrVouchers>;
  chainId: Scalars['OCUUID']['output'];
  configuration: GeneralSurveyConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  deletedAt: Maybe<Scalars['OCDateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  questions: Array<SurveyQuestion>;
  status: SurveyStatus;
  type: SurveyType;
  uuid: Scalars['OCUUID']['output'];
};

export type GeneralSurveyConfiguration = {
  endDate: Maybe<Scalars['OCDateTime']['output']>;
  startDate: Scalars['OCDateTime']['output'];
};

export type GeneralSurveyConfigurationInput = {
  endDate?: InputMaybe<Scalars['OCDateTime']['input']>;
  startDate: Scalars['OCDateTime']['input'];
};

export type GeneralSurveyCreateInput = {
  audienceUuid: Scalars['OCUUID']['input'];
  chainId: Scalars['String']['input'];
  configuration: GeneralSurveyConfigurationInput;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  questions: Array<GeneralSurveyQuestionInput>;
};

export type GeneralSurveyQuestionInput = {
  configuration: SurveyQuestionConfigurationInput;
  text: Scalars['String']['input'];
};

export type GeneralSurveyQuestionUpdateInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['OCUUID']['input'];
};

export type GeneralSurveyStatusUpdateInput = {
  status: SurveyStatus;
  uuid: Scalars['OCUUID']['input'];
};

export type GeneralSurveyUpdateInput = {
  audienceUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  chainId?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<GeneralSurveyConfigurationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<GeneralSurveyQuestionInput>>;
  updatedQuestions?: InputMaybe<Array<GeneralSurveyQuestionUpdateInput>>;
  uuid: Scalars['OCUUID']['input'];
};

export type GeoLocation = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeoLocationCreate = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GeoLocationFilter = {
  epicenter: GeoLocationCreate;
  radiusInMeters: Scalars['Float']['input'];
};

export type GeoLocationUpdate = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export enum GooglePayCardNetwork {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  EloDebit = 'ELO_DEBIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA',
}

export type GooglePayConfiguration = {
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  allowedCardNetworks: Array<GooglePayCardNetwork>;
  environment: GooglePayEnvironment;
  gateway: Scalars['String']['output'];
  gatewayMerchantId: Scalars['ID']['output'];
  isBillingZipCodeCollectionEnabled: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName: Maybe<Scalars['String']['output']>;
};

export type GooglePayConfigurationCreateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  allowedCardNetworks: Array<ParPayGooglePayCardNetwork>;
  environment: GooglePayEnvironment;
  gateway: Scalars['String']['input'];
  gatewayMerchantId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
};

export type GooglePayConfigurationUpdateInput = {
  allowCreditCards: Scalars['Boolean']['input'];
  allowPrepaidCards: Scalars['Boolean']['input'];
  allowedCardNetworks: Array<ParPayGooglePayCardNetwork>;
  environment: GooglePayEnvironment;
  gateway: Scalars['String']['input'];
  gatewayMerchantId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  merchantName?: InputMaybe<Scalars['String']['input']>;
};

export type Guest = {
  uuid: Scalars['ID']['output'];
};

export type GuestLocationFilter = {
  siteSystemConfiguration?: InputMaybe<SiteSystemConfigurationFilter>;
};

export type GuestSurveyAnswerSendInput = {
  fields: Array<SurveyFieldInput>;
  guestSurveyId: Scalars['String']['input'];
  questionUuid: Scalars['OCUUID']['input'];
};

export type GuestSurveyAnswerSubmitInput = {
  fields: Array<SurveyFieldInput>;
  guestSurveyId: Scalars['String']['input'];
  questionUuid: Scalars['OCUUID']['input'];
};

export type GuestSurveyAnswersSubmitInput = {
  answers: Array<SurveyQuestionAnswerInput>;
  guestSurveyId: Scalars['String']['input'];
};

export type GuestTransaction = {
  fuelReceipt: Maybe<FuelReceipt>;
  primaryStatus: PrimaryTransactionStatus;
  receiptLines: Maybe<Array<ReceiptLine>>;
  secondaryStatus: SecondaryTransactionStatus;
  stac: Maybe<Stac>;
  uuid: Scalars['ID']['output'];
};

export type GuestTransactionStartInput = {
  billingZipCode?: InputMaybe<Scalars['String']['input']>;
  fuelingPosition?: InputMaybe<Scalars['String']['input']>;
  locationUuid: Scalars['ID']['input'];
  loyaltyId?: InputMaybe<Scalars['String']['input']>;
  nonce: Scalars['String']['input'];
  paymentInstrumentType: PaymentInstrumentType;
  preAuthAmount: Scalars['Float']['input'];
  siteId: Scalars['String']['input'];
  transactionType: TransactionType;
};

export enum HardwareVendor {
  Comdata = 'COMDATA',
  Gilbarco = 'GILBARCO',
  Mashgin = 'MASHGIN',
  Ncr = 'NCR',
  Stuzo = 'STUZO',
  Verifone = 'VERIFONE',
}

export type HomeStore = {
  locationUuid: Scalars['ID']['output'];
};

export type HoursOfOperation = {
  closeTime: Scalars['OCTime']['output'];
  dayOfWeek: Weekday;
  genericHoursString: Maybe<Scalars['String']['output']>;
  openTime: Scalars['OCTime']['output'];
};

export type HoursOfOperationGroup = {
  /** @deprecated Removing alias */
  alias: Maybe<Scalars['String']['output']>;
  hours: Array<HoursOfOperation>;
};

export enum IneligibilityReason {
  CompleteProfileRequired = 'COMPLETE_PROFILE_REQUIRED',
  EmailRequired = 'EMAIL_REQUIRED',
  NotEnoughPoints = 'NOT_ENOUGH_POINTS',
  PurchasableEligibilityConstraintFailed = 'PURCHASABLE_ELIGIBILITY_CONSTRAINT_FAILED',
  RequiresActivation = 'REQUIRES_ACTIVATION',
}

export type IncomingReferral = {
  status: ReceiverStatus;
};

export type ItemPrice = {
  displayPrice: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export enum KountEnvironment {
  Production = 'PRODUCTION',
  Test = 'TEST',
}

export enum KountCheckStatus {
  Fraudulent = 'FRAUDULENT',
  NotFraudulent = 'NOT_FRAUDULENT',
}

export type KountConfiguration = {
  collectorHostname: Scalars['String']['output'];
  environment: KountEnvironment;
  merchantId: Scalars['Int']['output'];
};

export type KountFraudCheckResult = {
  amount: Scalars['Float']['output'];
  autoDecision: AutoDecision;
  binRange: Maybe<Scalars['String']['output']>;
  creditCardBrand: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4: Maybe<Scalars['String']['output']>;
  omniScore: Scalars['Float']['output'];
  reasonCode: Maybe<Scalars['String']['output']>;
  ruleDescriptions: Maybe<Array<RuleDescription>>;
  sessionId: Scalars['String']['output'];
  status: KountCheckStatus;
  transactionDate: Scalars['OCDateTime']['output'];
  transactionUuid: Scalars['OCUUID']['output'];
  triggeredRules: Maybe<Array<RuleDescription>>;
};

export enum LimitTimePeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
}

export enum LocationOpenStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Unknown = 'UNKNOWN',
}

export enum LocationResourceStatus {
  Available = 'AVAILABLE',
  Inuse = 'INUSE',
  Offline = 'OFFLINE',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN',
}

export enum LocationResourceType {
  CarWash = 'CAR_WASH',
  FuelPump = 'FUEL_PUMP',
  Store = 'STORE',
}

export enum LoyaltyEventOrigin {
  ActivateInternalProcess = 'ACTIVATE_INTERNAL_PROCESS',
  CommandApi = 'COMMAND_API',
  ExperienceApi = 'EXPERIENCE_API',
  Rabbitmq = 'RABBITMQ',
}

export enum LoyaltyInstrumentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum LoyaltyLevel {
  AboveSite = 'ABOVE_SITE',
  SiteLevel = 'SITE_LEVEL',
}

export enum LoyaltyProviderTypeEnum {
  Albertsons = 'ALBERTSONS',
  OpenCommerce = 'OPEN_COMMERCE',
}

export type Limit =
  | LimitGlobalActivation
  | LimitGlobalActivationInTime
  | LimitGlobalAwardCount
  | LimitGlobalAwardCountInTime
  | LimitInTransactionAwardCount
  | LimitInTransactionProgress
  | LimitMembershipActivation
  | LimitMembershipActivationInTime
  | LimitMembershipAwardCount
  | LimitMembershipAwardCountInTime
  | LimitMembershipProgressInTime
  | LimitMembershipTransactionCount
  | LimitMembershipTransactionCountInTime;

export type LimitGlobalActivation = {
  globalQuantityFulfilled: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitGlobalActivationInTime = {
  globalQuantityFulfilled: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  timePeriod: LimitTimePeriod;
};

export type LimitGlobalAwardCount = {
  globalQuantityFulfilled: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitGlobalAwardCountInTime = {
  globalQuantityFulfilled: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  timePeriod: LimitTimePeriod;
};

export type LimitInTransactionAwardCount = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitInTransactionProgress = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitMembershipActivation = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityFulfilled: Maybe<Scalars['Int']['output']>;
};

export type LimitMembershipActivationInTime = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityFulfilled: Maybe<Scalars['Int']['output']>;
  timePeriod: LimitTimePeriod;
};

export type LimitMembershipAwardCount = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityAvailable: Maybe<Scalars['Int']['output']>;
  membershipQuantityFulfilled: Maybe<Scalars['Int']['output']>;
};

export type LimitMembershipAwardCountInTime = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityAvailable: Maybe<Scalars['Int']['output']>;
  membershipQuantityFulfilled: Maybe<Scalars['Int']['output']>;
  timePeriod: LimitTimePeriod;
};

export type LimitMembershipProgressInTime = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  membershipQuantityAvailable: Maybe<Scalars['Int']['output']>;
  membershipQuantityFulfilled: Maybe<Scalars['Int']['output']>;
  timePeriod: LimitTimePeriod;
};

export type LimitMembershipTransactionCount = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type LimitMembershipTransactionCountInTime = {
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  timePeriod: LimitTimePeriod;
};

export type LocalOffersConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  radiusInMeters: Scalars['Int']['output'];
};

export type Location = {
  address: Maybe<Address>;
  attributes: Array<LocationAttribute>;
  brand: Maybe<Brand>;
  brandSpecificLocationId: Maybe<Scalars['String']['output']>;
  customerId: Maybe<Scalars['String']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  distance: Maybe<Scalars['Float']['output']>;
  fuelGradePrices: Array<FuelGradePrice>;
  fuelPriceState: Maybe<FuelPriceState>;
  hoursOfOperationGroup: Maybe<HoursOfOperationGroup>;
  lastChangeSource: Maybe<ChangeSource>;
  manuallyUpdated: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  openCommerceFeatures: Array<OpenCommerceFeature>;
  openStatus: LocationOpenStatus;
  payAtPumpEnabled: Scalars['Boolean']['output'];
  paymentProviderMerchantId: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<ContactPhoneNumber>;
  siteSystemConfiguration: Array<SiteSystemConfiguration>;
  specialHours: Maybe<Scalars['String']['output']>;
  subBrandName: Maybe<Scalars['String']['output']>;
  subBrandUuid: Maybe<Scalars['OCUUID']['output']>;
  utcOffset: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type LocationAttribute = {
  /** @deprecated Removed description, only using value and string */
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LocationAttributeFilter = {
  /** @deprecated Not implemented */
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not implemented */
  descriptionEquals?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not implemented */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not implemented */
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueEquals?: InputMaybe<Scalars['String']['input']>;
};

export type LocationCheckIn = {
  geoLocation?: InputMaybe<GeoLocationCreate>;
};

export type LocationConnection = {
  edges: Maybe<Array<LocationEdge>>;
  pageInfo: PageInfo;
};

export type LocationDowntimeMetric = {
  downtimeInSeconds: TimeSeriesMetric;
  locationUuid: Scalars['OCUUID']['output'];
};

export type LocationEdge = {
  cursor: Scalars['ID']['output'];
  node: Location;
};

export type LocationFilter = {
  attributes?: InputMaybe<LocationAttributeFilter>;
  brand?: InputMaybe<BrandFilter>;
  customerIdEquals?: InputMaybe<Scalars['String']['input']>;
  customerNameEquals?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationFilter>;
  geoLocationEquals?: InputMaybe<GeoLocationCreate>;
  isAltriaParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isPayAtPumpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  openCommerceFeatures?: InputMaybe<OpenCommerceFeatureFilter>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  resources?: InputMaybe<LocationResourceFilter>;
  siteSystemConfiguration?: InputMaybe<SiteSystemConfigurationFilter>;
  subBrandNameEquals?: InputMaybe<Scalars['String']['input']>;
  subBrandUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  uuidContains?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type LocationGroup = {
  countOfLocations: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type LocationProfile = {
  city: Maybe<Scalars['String']['output']>;
  locationId: Maybe<Scalars['ID']['output']>;
  state: Maybe<Scalars['String']['output']>;
  zipcode: Maybe<Scalars['String']['output']>;
};

export type LocationProfileCreateOrUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type LocationResource = {
  carWashItems: Maybe<CarWashItemConnection>;
  fuelItems: Maybe<FuelItemConnection>;
  position: Maybe<Scalars['String']['output']>;
  resourceType: LocationResourceType;
  status: Maybe<LocationResourceStatus>;
  storeItems: Maybe<StoreItemConnection>;
  uuid: Scalars['ID']['output'];
};

export type LocationResourceCarWashItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResourceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationResourceFuelItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResourceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationResourceStoreItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResourceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationResourceFilter = {
  items?: InputMaybe<ResourceItemFilter>;
  statusContains?: InputMaybe<Array<InputMaybe<LocationResourceStatus>>>;
  statusEquals?: InputMaybe<LocationResourceStatus>;
  typeContains?: InputMaybe<Array<InputMaybe<LocationResourceType>>>;
  typeEquals?: InputMaybe<LocationResourceType>;
};

export type LocationsFilterInput = {
  globalOffersIncluded?: InputMaybe<GlobalOffersFilter>;
  locationGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LocationsGeoFilterInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusInMeters: Scalars['Float']['input'];
  restrictGeoFiltering?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltyAccount = {
  accountNumber: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  rewardProgram: RewardProgram;
  uuid: Scalars['ID']['output'];
};

export type LoyaltyAccountCreate = {
  accountNumber: Scalars['String']['input'];
  rewardProgramUuid: Scalars['ID']['input'];
};

export type LoyaltyAccountUpdate = {
  accountNumber: Scalars['String']['input'];
  rewardProgramUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type LoyaltyEvent = {
  chain: Chain;
  createdAt: Scalars['OCDateTime']['output'];
  eventData: Maybe<Scalars['OCJSON']['output']>;
  eventType: Scalars['String']['output'];
  origin: Maybe<LoyaltyEventOrigin>;
};

export type LoyaltyEventCreate = {
  chainId: Scalars['ID']['input'];
  eventData?: InputMaybe<Scalars['OCJSON']['input']>;
  eventType: Scalars['String']['input'];
  origin?: InputMaybe<LoyaltyEventOrigin>;
};

export type LoyaltyIdBarcodeConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type LoyaltyIdQrCodeConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type LoyaltyInstrument = {
  accountNumber: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  status: LoyaltyInstrumentStatus;
  uuid: Scalars['ID']['output'];
};

export type LoyaltyInstrumentFilter = {
  accountNumberEquals?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasEquals?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltyProgramConfiguration = {
  homePageOffersLimit: Scalars['Int']['output'];
  isExplicitSmsPromotionAcceptanceEnabled: Scalars['Boolean']['output'];
  isExplicitTermsAcceptanceRequired: Scalars['Boolean']['output'];
  isPromocodesEnabled: Scalars['Boolean']['output'];
  isReturnRewardEnabled: Scalars['Boolean']['output'];
  membershipMinAge: Scalars['Int']['output'];
  pointExpiration: PointExpiration;
  /** @deprecated Functionality extended. Whether it is points based or not is now handled with pointsStrategy property. */
  pointsBased: Scalars['Boolean']['output'];
  pointsStrategy: PointsStrategy;
  redeemOfferWithCompletedProfileOnly: Scalars['Boolean']['output'];
  referralProgramConfiguration: Maybe<ReferralProgramConfiguration>;
};

export type LulaOrderAheadCreateSessionPayload = {
  iframeUrl: Scalars['OCURL']['output'];
};

export enum MembershipEventType {
  Active = 'ACTIVE',
  Birthday = 'BIRTHDAY',
  Created = 'CREATED',
}

export enum MEMBERSHIP_STATE {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  DeletionPlaceholder = 'DELETION_PLACEHOLDER',
  NewMember = 'NEW_MEMBER',
  Paused = 'PAUSED',
  Suspended = 'SUSPENDED',
}

export enum MembershipType {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  RcUser = 'RC_USER',
  Standard = 'STANDARD',
}

export type MagicLinkExchangePayload = {
  tokens: Tokens;
};

export type MagicLinkExchangeSessionIdToAuthTokenInput = {
  brandUuid: Scalars['String']['input'];
  chainId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  subBrandName?: InputMaybe<Scalars['String']['input']>;
};

export type MagicLinkRequestInput = {
  brandUuid: Scalars['ID']['input'];
  chainId?: InputMaybe<Scalars['ID']['input']>;
  identifier: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type MarketingContent = {
  customData: Maybe<Scalars['OCJSON']['output']>;
  disclaimer: Maybe<Scalars['String']['output']>;
  disclaimerUrl: Maybe<Scalars['OCURL']['output']>;
  discontinued: Scalars['Boolean']['output'];
  externalUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['OCURL']['output']>;
  locale: Scalars['String']['output'];
  longDescription: Maybe<Scalars['String']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  surgeonGeneralsWarning: Maybe<Scalars['String']['output']>;
  terms: Maybe<Scalars['String']['output']>;
  termsUrl: Maybe<Scalars['OCURL']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type Membership = {
  barcodeIdentifier: Scalars['String']['output'];
  birthdate: Maybe<Scalars['OCDate']['output']>;
  chain: Chain;
  createdAt: Scalars['OCDateTime']['output'];
  customData: Maybe<Scalars['OCJSON']['output']>;
  customerUuid: Maybe<Scalars['ID']['output']>;
  displayBrand: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['OCEmailAddress']['output']>;
  externalIdentityVerificationProfiles: Maybe<Array<ExternalIdentityVerificationProfile>>;
  firstName: Maybe<Scalars['String']['output']>;
  fuelAndConvenienceProfile: Maybe<FuelAndConvenienceProfile>;
  homeStores: Maybe<Array<HomeStore>>;
  id: Scalars['ID']['output'];
  incomingReferral: Maybe<IncomingReferral>;
  isCompleted: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSubBrandOffersQueriesUuid: Maybe<Scalars['ID']['output']>;
  lifetimeMetrics: MembershipLifetimeMetrics;
  locationProfile: Maybe<LocationProfile>;
  offers: Maybe<OfferConnection>;
  phone: Maybe<Scalars['OCPhoneNumber']['output']>;
  pointChanges: Maybe<PointChangeConnection>;
  pointExpirationSchedule: PointExpirationScheduleConnection;
  points: Scalars['Int']['output'];
  primaryAddress: Maybe<MembershipAddress>;
  productInterests: Array<ProductCategory>;
  /** @deprecated Replaced by productInterests. */
  productPreferences: Array<DisplayCategory>;
  programTermsAcceptanceAt: Maybe<Scalars['OCDateTime']['output']>;
  /** @deprecated QR codes are no longer used. Use barcodeIdentifier instead */
  qrIdentifier: Scalars['String']['output'];
  referralCode: Scalars['OCReferralCode']['output'];
  referralUrl: Scalars['OCURL']['output'];
  state: MEMBERSHIP_STATE;
  stateChanges: Array<MembershipState>;
  totalAvailableRollback: Maybe<TotalAvailableRollback>;
  transactions: Maybe<ActivateTransactionConnection>;
  vouchers: VoucherConnection;
};

export type MembershipOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferSort>;
};

export type MembershipPointChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PointChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipPointExpirationScheduleArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipTotalAvailableRollbackArgs = {
  filter?: InputMaybe<TotalAvailableRollbackFilter>;
};

export type MembershipTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivateTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipVouchersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<VoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VoucherSort>;
};

export enum MembershipActivitySortBy {
  CreatedAt = 'CREATED_AT',
}

export enum MembershipActivityTypename {
  PointChange = 'POINT_CHANGE',
  Transaction = 'TRANSACTION',
}

export type MembershipAddress = {
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  state: Maybe<Scalars['String']['output']>;
  zipcode: Maybe<Scalars['String']['output']>;
};

export type MembershipDeleteInput = {
  deletionRequestSource?: InputMaybe<DeletionRequestSourceInput>;
  membershipUuid: Scalars['ID']['input'];
};

export type MembershipHomeStoresCreateOrUpdateInput = {
  locationUuids: Array<Scalars['ID']['input']>;
};

export type MembershipLifetimeMetrics = {
  pointsEarned: Scalars['Int']['output'];
};

export type MembershipPrimaryAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipState = {
  effectiveAt: Maybe<Scalars['OCDateTime']['output']>;
  state: MEMBERSHIP_STATE;
};

export type MembershipStateTransition = {
  state: MEMBERSHIP_STATE;
};

export type MembershipUpdate = {
  birthdate?: InputMaybe<Scalars['OCDate']['input']>;
  customData?: InputMaybe<CustomDataInput>;
  displayBrand?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['OCEmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  primaryAddress?: InputMaybe<MembershipPrimaryAddressInput>;
  programTermsAcceptanceAt?: InputMaybe<Scalars['OCDateTime']['input']>;
};

export type MobilePaymentsReceiptsViewConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type MobileTransactionFraudCheck = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  provider: MobileTransactionFraudCheckProvider;
};

export enum MobileTransactionFraudCheckProvider {
  Kount = 'KOUNT',
}

export type Mutation = {
  applePaySessionCreate: ApplePaySession;
  createExternalIdentityVerificationAuthorizationUrl: ExternalIdentityVerificationAuthorizationUrlPayload;
  /** @deprecated Deprecated because of createOTPSessionByPlatform. */
  createOTPSession: CreateOtpSessionResult;
  createOTPSessionByPlatform: CreateOtpSessionResult;
  createOrderAheadSession: OrderAheadCreateSessionPayload;
  customerDelete: Scalars['Boolean']['output'];
  customerInitiateTokenizationSession: ParPayTokenizationSession;
  customerLoginByOTP: Maybe<CustomerOtpPayloadOrAuthPayload>;
  customerOTPRequest: Maybe<CustomerOtpPayload>;
  customerPaymentInstrumentCreate: PaymentInstrument;
  customerPaymentInstrumentDelete: Array<Maybe<PaymentInstrument>>;
  customerPinCodeReset: Maybe<Scalars['Boolean']['output']>;
  customerPinCodeSet: Maybe<Scalars['Boolean']['output']>;
  customerPinCodeVerify: Maybe<Scalars['Boolean']['output']>;
  customerRegistrationComplete: Maybe<Customer>;
  customerUpdate: Maybe<Customer>;
  customerUpdateState: Maybe<Scalars['Boolean']['output']>;
  customerUsernamePasswordSignIn: AuthTokens;
  customerUsernamePasswordSignUp: AuthTokens;
  deviceTokenRegister: Scalars['Boolean']['output'];
  eaivAgeVerificationStart: EaivAgeVerificationStartResult;
  eaivIdentityVerificationStart: EaivIdentityVerificationStartResult;
  eaivIdentityVerificationSubmit: EaivIdentityVerificationSubmitResult;
  exchangeSessionAndOTPToAuthToken: ExchangeSessionAndOtpToAuthTokenResultUnion;
  fuelAndConvenienceProfileCreateOrUpdate: FuelAndConvenienceProfile;
  getAccessTokenByRefreshToken: Maybe<Tokens>;
  guestAccountCreate: Guest;
  /** @deprecated Used for WS Surveys only. Mutation will be removed after BE refactor. */
  guestSurveyAnswerSend: Scalars['Boolean']['output'];
  guestSurveyAnswersSubmit: Scalars['Boolean']['output'];
  guestTransactionCancel: Scalars['Boolean']['output'];
  guestTransactionStart: GuestTransaction;
  locationProfileCreateOrUpdate: Maybe<LocationProfile>;
  logout: Maybe<Scalars['Boolean']['output']>;
  loyaltyEventCreate: Maybe<LoyaltyEvent>;
  magicLinkExchangeSessionIdToAuthToken: MagicLinkExchangePayload;
  membershipDelete: Scalars['Boolean']['output'];
  membershipHomeStoresCreateOrUpdate: Membership;
  membershipStateTransition: Maybe<Membership>;
  offerActivate: Maybe<Offer>;
  offerActivityLog: Scalars['Boolean']['output'];
  offerActivityLogBatch: Scalars['Boolean']['output'];
  offerDeactivate: Maybe<Offer>;
  offerPurchaseCreate: Maybe<Array<Maybe<OfferPurchase>>>;
  offerPurchaseReturn: Maybe<OfferPurchase>;
  paymentInstrumentSetDefault: Scalars['Boolean']['output'];
  productInterestCreate: ProductInterest;
  productInterestDelete: Scalars['Boolean']['output'];
  productInterestsReplace: Membership;
  productPreferenceCreate: ProductPreference;
  productPreferenceDelete: Scalars['Boolean']['output'];
  productPreferenceReplace: Membership;
  redeemPromocode: RedeemPromocodeResult;
  refreshCustomerAccessToken: AuthTokens;
  requestMagicLink: Scalars['Boolean']['output'];
  scrubData: Scalars['Boolean']['output'];
  spinWheelGameExecute: Maybe<RandomAwardConfig>;
  submitReferralCodeSharedEvent: ReferralCodeSharedEvent;
  /** @deprecated Used for WS Surveys only. Mutation will be removed after BE refactor. */
  surveyAnswerSend: Scalars['Boolean']['output'];
  /** @deprecated Will be removed. */
  surveyAnswerSubmit: Scalars['Boolean']['output'];
  surveyAnswersSubmit: Scalars['Boolean']['output'];
  surveyDismiss: Scalars['Boolean']['output'];
  surveyViewsCreate: Scalars['Boolean']['output'];
  transactionCancel: Scalars['Boolean']['output'];
  transactionStart: Maybe<Transaction>;
  updateCommunicationPreference: CommunicationPreference;
  validateAndResetCustomerPassword: AuthTokens;
};

export type MutationApplePaySessionCreateArgs = {
  input: PaymentApplePaySessionCreateInput;
};

export type MutationCreateExternalIdentityVerificationAuthorizationUrlArgs = {
  input: ExternalIdentityVerificationAuthorizationUrlInput;
};

export type MutationCreateOtpSessionArgs = {
  phoneNumber: Scalars['OCPhoneNumber']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOtpSessionByPlatformArgs = {
  input: CreateOtpSessionInput;
};

export type MutationCreateOrderAheadSessionArgs = {
  input: OrderAheadCreateSessionInput;
};

export type MutationCustomerLoginByOtpArgs = {
  input: Otp;
};

export type MutationCustomerOtpRequestArgs = {
  input: CustomerOtpRequest;
};

export type MutationCustomerPaymentInstrumentCreateArgs = {
  input: CustomerPaymentInstrumentCreate;
};

export type MutationCustomerPaymentInstrumentDeleteArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationCustomerPinCodeSetArgs = {
  input: CustomerPinCodeSet;
};

export type MutationCustomerPinCodeVerifyArgs = {
  input: CustomerPinCodeVerify;
};

export type MutationCustomerRegistrationCompleteArgs = {
  input: CustomerRegistrationComplete;
};

export type MutationCustomerUpdateArgs = {
  input: CustomerUpdate;
};

export type MutationCustomerUpdateStateArgs = {
  input: CustomerUpdateStateInput;
};

export type MutationCustomerUsernamePasswordSignInArgs = {
  input: SignInUsernamePasswordUserInput;
};

export type MutationCustomerUsernamePasswordSignUpArgs = {
  input: SignUpUsernamePasswordUserInput;
};

export type MutationDeviceTokenRegisterArgs = {
  input: DeviceTokenRegisterInput;
};

export type MutationEaivAgeVerificationStartArgs = {
  input: EaivAgeVerificationStartInput;
};

export type MutationEaivIdentityVerificationStartArgs = {
  input: EaivIdentityVerificationStartInput;
};

export type MutationEaivIdentityVerificationSubmitArgs = {
  input: EaivIdentityVerificationSubmitInput;
};

export type MutationExchangeSessionAndOtpToAuthTokenArgs = {
  input: Otp;
};

export type MutationFuelAndConvenienceProfileCreateOrUpdateArgs = {
  input: FuelAndConvenienceProfileCreateOrUpdateInput;
};

export type MutationGetAccessTokenByRefreshTokenArgs = {
  input: AccessTokenByRefreshTokenInput;
};

export type MutationGuestSurveyAnswerSendArgs = {
  input: GuestSurveyAnswerSendInput;
};

export type MutationGuestSurveyAnswersSubmitArgs = {
  input: GuestSurveyAnswersSubmitInput;
};

export type MutationGuestTransactionCancelArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationGuestTransactionStartArgs = {
  input: GuestTransactionStartInput;
};

export type MutationLocationProfileCreateOrUpdateArgs = {
  input: LocationProfileCreateOrUpdateInput;
};

export type MutationLoyaltyEventCreateArgs = {
  input: LoyaltyEventCreate;
};

export type MutationMagicLinkExchangeSessionIdToAuthTokenArgs = {
  input: MagicLinkExchangeSessionIdToAuthTokenInput;
};

export type MutationMembershipHomeStoresCreateOrUpdateArgs = {
  input: MembershipHomeStoresCreateOrUpdateInput;
};

export type MutationMembershipStateTransitionArgs = {
  input: MembershipStateTransition;
};

export type MutationOfferActivateArgs = {
  input: OfferActivate;
};

export type MutationOfferActivityLogArgs = {
  input: OfferActivityLogInput;
};

export type MutationOfferActivityLogBatchArgs = {
  input: Array<OfferActivityLogInput>;
};

export type MutationOfferDeactivateArgs = {
  input: OfferDeactivate;
};

export type MutationOfferPurchaseCreateArgs = {
  input: OfferPurchaseCreate;
};

export type MutationOfferPurchaseReturnArgs = {
  input: OfferPurchaseReturn;
};

export type MutationPaymentInstrumentSetDefaultArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationProductInterestCreateArgs = {
  input: ProductInterestInput;
};

export type MutationProductInterestDeleteArgs = {
  input: ProductInterestInput;
};

export type MutationProductInterestsReplaceArgs = {
  input: ProductInterestsReplaceInput;
};

export type MutationProductPreferenceCreateArgs = {
  input: ProductPreferenceInput;
};

export type MutationProductPreferenceDeleteArgs = {
  input: ProductPreferenceInput;
};

export type MutationProductPreferenceReplaceArgs = {
  input: ProductPreferenceReplaceInput;
};

export type MutationRedeemPromocodeArgs = {
  promocode: Scalars['String']['input'];
};

export type MutationRefreshCustomerAccessTokenArgs = {
  refreshToken: Scalars['String']['input'];
};

export type MutationRequestMagicLinkArgs = {
  input: MagicLinkRequestInput;
};

export type MutationSpinWheelGameExecuteArgs = {
  input: SpinWheelGameExecuteInput;
};

export type MutationSurveyAnswerSendArgs = {
  input: SurveyAnswerSendInput;
};

export type MutationSurveyAnswerSubmitArgs = {
  input: SurveyAnswerSubmitInput;
};

export type MutationSurveyAnswersSubmitArgs = {
  input: SurveyAnswersSubmitInput;
};

export type MutationSurveyDismissArgs = {
  input: SurveyDismissInput;
};

export type MutationSurveyViewsCreateArgs = {
  input: SurveyViewsCreateInput;
};

export type MutationTransactionCancelArgs = {
  uuid: Scalars['ID']['input'];
};

export type MutationTransactionStartArgs = {
  input: TransactionStart;
};

export type MutationUpdateCommunicationPreferenceArgs = {
  input: CommunicationPreferenceUpdateInput;
};

export type MutationValidateAndResetCustomerPasswordArgs = {
  input: ValidateAndResetCustomerPasswordInput;
};

export enum NotificationReceiverType {
  AndroidApp = 'ANDROID_APP',
  Email = 'EMAIL',
  IosApp = 'IOS_APP',
  IosWallet = 'IOS_WALLET',
}

export enum OfferActivationStatus {
  Activated = 'ACTIVATED',
  DoesNotRequireActivation = 'DOES_NOT_REQUIRE_ACTIVATION',
  RequiresActivation = 'REQUIRES_ACTIVATION',
}

export enum OfferActivityLogChannelType {
  App = 'APP',
  Email = 'EMAIL',
  Sms = 'SMS',
}

export enum OfferActivityLogType {
  Click = 'CLICK',
  Delivered = 'DELIVERED',
  Impression = 'IMPRESSION',
  Ltc = 'LTC',
  OptedOut = 'OPTED_OUT',
  Sent = 'SENT',
}

export enum OfferEngagementType {
  Base = 'BASE',
  Behavioral = 'BEHAVIORAL',
  Billboard = 'BILLBOARD',
  ExternallyFulfillable = 'EXTERNALLY_FULFILLABLE',
  FuelRollback = 'FUEL_ROLLBACK',
  Game = 'GAME',
  GameVoucher = 'GAME_VOUCHER',
  Promocode = 'PROMOCODE',
  Promotional = 'PROMOTIONAL',
  PunchcardChallenge = 'PUNCHCARD_CHALLENGE',
  Purchaseable = 'PURCHASEABLE',
  SurveyBehavioral = 'SURVEY_BEHAVIORAL',
  SweepstakesEntry = 'SWEEPSTAKES_ENTRY',
  SweepstakesPurchasable = 'SWEEPSTAKES_PURCHASABLE',
  SweepstakesTransactional = 'SWEEPSTAKES_TRANSACTIONAL',
  Transactional = 'TRANSACTIONAL',
  Vouchered = 'VOUCHERED',
}

export enum OfferFundingSource {
  Brand = 'BRAND',
  Other = 'OTHER',
  Partner = 'PARTNER',
  Retailer = 'RETAILER',
}

export enum OfferPresentationPriority {
  Default = 'DEFAULT',
  Featured = 'FEATURED',
}

export enum OfferPresentationType {
  Banner = 'BANNER',
  Default = 'DEFAULT',
  Hidden = 'HIDDEN',
}

export enum OfferPurchaseOrigin {
  ApiCall = 'API_CALL',
  OptionalOffer = 'OPTIONAL_OFFER',
}

export enum OfferSortBy {
  FulfillmentPriorityLevel = 'FULFILLMENT_PRIORITY_LEVEL',
}

export enum OfferVisibleStatus {
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  AgeRestricted = 'AGE_RESTRICTED',
  Discontinued = 'DISCONTINUED',
  Expired = 'EXPIRED',
  GlobalLimit = 'GLOBAL_LIMIT',
  HiddenUntilProgress = 'HIDDEN_UNTIL_PROGRESS',
  MemberLimit = 'MEMBER_LIMIT',
  /** @deprecated Do not support differences in visibility between new members and active members. */
  MemberNotActive = 'MEMBER_NOT_ACTIVE',
  MemberSuspended = 'MEMBER_SUSPENDED',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  MissingRequiredSegments = 'MISSING_REQUIRED_SEGMENTS',
  NotInRequiredAudiences = 'NOT_IN_REQUIRED_AUDIENCES',
  NoVoucher = 'NO_VOUCHER',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  PurchaseLimitExceeded = 'PURCHASE_LIMIT_EXCEEDED',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  PurchaseLimitNotReached = 'PURCHASE_LIMIT_NOT_REACHED',
  Unpublished = 'UNPUBLISHED',
  /** @deprecated All audience related visibility reasons will use NOT_IN_REQUIRED_AUDIENCES going forward. */
  UnsatisfiedMembershipProfileAttribute = 'UNSATISFIED_MEMBERSHIP_PROFILE_ATTRIBUTE',
  Visible = 'VISIBLE',
}

export type Otp = {
  chainId?: InputMaybe<Scalars['String']['input']>;
  otp: Scalars['String']['input'];
  session: Scalars['String']['input'];
  subBrandName?: InputMaybe<Scalars['String']['input']>;
};

export enum OtpChannel {
  Email = 'EMAIL',
  PhoneCall = 'PHONE_CALL',
  Sms = 'SMS',
}

export enum OtpMode {
  PasswordReset = 'PASSWORD_RESET',
  Signin = 'SIGNIN',
  Signup = 'SIGNUP',
  UpdateIdentifier = 'UPDATE_IDENTIFIER',
}

export enum OtpPlatform {
  Android = 'ANDROID',
  Iphone = 'IPHONE',
  Web = 'WEB',
}

export enum OwnershipCondition {
  DoesNotOwnAll = 'DOES_NOT_OWN_ALL',
  OwnsAll = 'OWNS_ALL',
  OwnsAny = 'OWNS_ANY',
  OwnsNone = 'OWNS_NONE',
}

export type Offer = {
  activationStatus: OfferActivationStatus;
  ageRestricted: Scalars['Boolean']['output'];
  availableAtLocations: Maybe<Array<Location>>;
  category: Maybe<Scalars['String']['output']>;
  constraints: Array<Constraint>;
  createdAt: Scalars['OCDateTime']['output'];
  customData: Maybe<Scalars['OCJSON']['output']>;
  deleted: Scalars['Boolean']['output'];
  deletedAt: Maybe<Scalars['OCDateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayCategories: Array<DisplayCategory>;
  earningMechanism: Maybe<EarningMechanism>;
  eligible: Scalars['Boolean']['output'];
  engagementType: Maybe<OfferEngagementType>;
  expireAt: Maybe<Scalars['OCDateTime']['output']>;
  id: Scalars['ID']['output'];
  ineligibilityReason: Maybe<IneligibilityReason>;
  limits: Array<Limit>;
  longDescription: Maybe<Scalars['String']['output']>;
  marketingContents: Array<Maybe<MarketingContent>>;
  name: Scalars['String']['output'];
  optionalAtPos: Maybe<Scalars['Boolean']['output']>;
  presentationPriority: OfferPresentationPriority;
  presentationType: OfferPresentationType;
  publicationStatus: PublicationStatusType;
  publishAt: Maybe<Scalars['OCDateTime']['output']>;
  shortDescription: Maybe<Scalars['String']['output']>;
  stackable: Scalars['Boolean']['output'];
  trackingConfig: Maybe<TrackingConfig>;
  triggerPreferences: TriggerPreferences;
  visibleForCommandCenterFulfillment: Maybe<Scalars['Boolean']['output']>;
  visibleStatus: OfferVisibleStatus;
  voucherCount: Scalars['Int']['output'];
  vouchers: VoucherConnection;
};

export type OfferVouchersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<VoucherFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferActivate = {
  offerId: Scalars['ID']['input'];
};

export type OfferActivityLogInput = {
  activateOfferId?: InputMaybe<Scalars['OCUUID']['input']>;
  activityAt: Scalars['OCDateTime']['input'];
  activityState?: InputMaybe<Scalars['String']['input']>;
  activityType: OfferActivityLogType;
  bannerConfigurationUuid?: InputMaybe<Scalars['ID']['input']>;
  channelType: OfferActivityLogChannelType;
  externalCampaignId?: InputMaybe<Scalars['String']['input']>;
  isActivityLogIncludedInAltriaDDM?: InputMaybe<Scalars['Boolean']['input']>;
  marketingTransactionLogId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  trackingId?: InputMaybe<Scalars['ID']['input']>;
};

export type OfferConnection = {
  edges: Array<Maybe<OfferEdge>>;
  pageInfo: PageInfo;
};

export type OfferDeactivate = {
  offerId: Scalars['ID']['input'];
};

export type OfferDisplayCategoryInput = {
  displayCategoryId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
};

export type OfferEdge = {
  cursor: Scalars['ID']['output'];
  node: Offer;
};

export type OfferFilter = {
  activationStatusEquals?: InputMaybe<OfferActivationStatus>;
  campaignIdEquals?: InputMaybe<Scalars['ID']['input']>;
  categoryEquals?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  engagementTypeEquals?: InputMaybe<OfferEngagementType>;
  engagementTypeExcludes?: InputMaybe<Array<OfferEngagementType>>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  locationsFilter?: InputMaybe<LocationsFilterInput>;
  locationsGeoFilter?: InputMaybe<LocationsGeoFilterInput>;
  loyaltyEventEquals?: InputMaybe<Scalars['String']['input']>;
  presentationPriorityIncludes?: InputMaybe<Array<OfferPresentationPriority>>;
  presentationTypeIncludes?: InputMaybe<Array<OfferPresentationType>>;
  publicationStatusEquals?: InputMaybe<PublicationStatusType>;
  visibleForCommandCenterFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  visibleStatusEquals?: InputMaybe<OfferVisibleStatus>;
};

export type OfferPurchase = {
  createdAt: Scalars['OCDateTime']['output'];
  discontinued: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pointCost: Scalars['Int']['output'];
  purchasedWith: Offer;
  reservedUntil: Maybe<Scalars['OCDateTime']['output']>;
  returnable: Scalars['Boolean']['output'];
  voucherGrantFor: Offer;
};

export type OfferPurchaseCreate = {
  count?: InputMaybe<Scalars['Int']['input']>;
  offerId: Scalars['ID']['input'];
};

export type OfferPurchaseReturn = {
  offerId: Scalars['ID']['input'];
};

export type OfferSort = {
  direction: SortOrder;
  field: OfferSortBy;
};

export enum OffersGridLocation {
  Home = 'HOME',
  Tab = 'TAB',
}

export enum OffersTabNavbarIcon {
  Gift = 'GIFT',
  Percent = 'PERCENT',
  Star = 'STAR',
  Tag = 'TAG',
}

export type OloOrderAheadCreateSessionPayload = {
  iframeUrl: Scalars['OCURL']['output'];
};

export type OpenCommerceFeature = {
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type OpenCommerceFeatureFilter = {
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionEquals?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueEquals?: InputMaybe<Scalars['String']['input']>;
};

export type OptionSelectionCount = {
  count: Scalars['Int']['output'];
  optionLabel: Scalars['String']['output'];
  optionUuid: Scalars['OCUUID']['output'];
};

export type OrderAheadConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  navbar: OrderAheadConfigurationNavbar;
  provider: OrderAheadConfigurationProvider;
};

export type OrderAheadConfigurationNavbar = {
  icon: OrderAheadConfigurationNavbarIcon;
  text: Scalars['String']['output'];
};

export enum OrderAheadConfigurationNavbarIcon {
  Delivery = 'DELIVERY',
  Food = 'FOOD',
  Merch = 'MERCH',
}

export type OrderAheadConfigurationProvider =
  | OrderAheadConfigurationProviderLula
  | OrderAheadConfigurationProviderOlo
  | OrderAheadConfigurationProviderVroom;

export type OrderAheadConfigurationProviderLula = {
  _empty: Maybe<Scalars['String']['output']>;
};

export type OrderAheadConfigurationProviderOlo = {
  _empty: Maybe<Scalars['String']['output']>;
};

export type OrderAheadConfigurationProviderVroom = {
  urlTemplate: Scalars['String']['output'];
};

export type OrderAheadCreateSessionInput = {
  provider: OrderAheadProvider;
};

export type OrderAheadCreateSessionPayload = LulaOrderAheadCreateSessionPayload | OloOrderAheadCreateSessionPayload;

export enum OrderAheadProvider {
  Lula = 'lula',
  Olo = 'olo',
}

export enum ParPayApplePayCardNetwork {
  Amex = 'AMEX',
  CartesBancaires = 'CARTES_BANCAIRES',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Mada = 'MADA',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  MasterCard = 'MASTER_CARD',
  PrivateLabel = 'PRIVATE_LABEL',
  Visa = 'VISA',
  VPay = 'V_PAY',
}

export enum ParPayGooglePayCardNetwork {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  EloDebit = 'ELO_DEBIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA',
}

export enum ParPayPaymentAccountType {
  ApplePay = 'APPLE_PAY',
  Credit = 'CREDIT',
  GooglePay = 'GOOGLE_PAY',
  Prepaid = 'PREPAID',
  Unknown = 'UNKNOWN',
}

export enum ParPayPaymentInstrumentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

export enum ParPayPaymentInstrumentType {
  AmazonPay = 'AMAZON_PAY',
  AmericanExpress = 'AMERICAN_EXPRESS',
  ApplePay = 'APPLE_PAY',
  ApplePayAmericanExpress = 'APPLE_PAY_AMERICAN_EXPRESS',
  ApplePayDiscover = 'APPLE_PAY_DISCOVER',
  ApplePayMastercard = 'APPLE_PAY_MASTERCARD',
  ApplePayVisa = 'APPLE_PAY_VISA',
  CartesBancaires = 'CARTES_BANCAIRES',
  CarteBlanche = 'CARTE_BLANCHE',
  ChasePay = 'CHASE_PAY',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  CitiPay = 'CITI_PAY',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Elo = 'ELO',
  Gift = 'GIFT',
  GooglePay = 'GOOGLE_PAY',
  GooglePayAmericanExpress = 'GOOGLE_PAY_AMERICAN_EXPRESS',
  GooglePayDiscover = 'GOOGLE_PAY_DISCOVER',
  GooglePayMastercard = 'GOOGLE_PAY_MASTERCARD',
  GooglePayVisa = 'GOOGLE_PAY_VISA',
  GoogleWallet = 'GOOGLE_WALLET',
  IdCredit = 'ID_CREDIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Masterpass = 'MASTERPASS',
  Paypal = 'PAYPAL',
  Prepaid = 'PREPAID',
  PrivateLabel = 'PRIVATE_LABEL',
  QuicPay = 'QUIC_PAY',
  Solo = 'SOLO',
  Suica = 'SUICA',
  Switch = 'SWITCH',
  Unknown = 'UNKNOWN',
  Venmo = 'VENMO',
  Visa = 'VISA',
  VisaCheckout = 'VISA_CHECKOUT',
  VisaVpay = 'VISA_VPAY',
}

export enum ParPayTransactionType {
  BalanceInquiry = 'BALANCE_INQUIRY',
  CiOttBasedSaleCopy = 'CI_OTT_BASED_SALE_COPY',
  GiftCardActivate = 'GIFT_CARD_ACTIVATE',
  GiftCardIssue = 'GIFT_CARD_ISSUE',
  GiftCardRedeem = 'GIFT_CARD_REDEEM',
  GiftCardReload = 'GIFT_CARD_RELOAD',
  Preauthorization = 'PREAUTHORIZATION',
  PtrRequest = 'PTR_REQUEST',
  Refund = 'REFUND',
  Sale = 'SALE',
  Settlement = 'SETTLEMENT',
  Void = 'VOID',
}

export enum PaymentAccountType {
  ApplePay = 'APPLE_PAY',
  Credit = 'CREDIT',
  GooglePay = 'GOOGLE_PAY',
  Prepaid = 'PREPAID',
  Unknown = 'UNKNOWN',
}

export enum PaymentInstrumentEvaluationMethod {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

export enum PaymentInstrumentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
}

export enum PaymentInstrumentType {
  AmazonPay = 'AMAZON_PAY',
  AmericanExpress = 'AMERICAN_EXPRESS',
  ApplePay = 'APPLE_PAY',
  ApplePayAmericanExpress = 'APPLE_PAY_AMERICAN_EXPRESS',
  ApplePayDiscover = 'APPLE_PAY_DISCOVER',
  ApplePayMastercard = 'APPLE_PAY_MASTERCARD',
  ApplePayVisa = 'APPLE_PAY_VISA',
  CartesBancaires = 'CARTES_BANCAIRES',
  CarteBlanche = 'CARTE_BLANCHE',
  ChasePay = 'CHASE_PAY',
  ChinaUnionPay = 'CHINA_UNION_PAY',
  CitiPay = 'CITI_PAY',
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Eftpos = 'EFTPOS',
  Elo = 'ELO',
  Gift = 'GIFT',
  GooglePay = 'GOOGLE_PAY',
  GooglePayAmericanExpress = 'GOOGLE_PAY_AMERICAN_EXPRESS',
  GooglePayDiscover = 'GOOGLE_PAY_DISCOVER',
  GooglePayMastercard = 'GOOGLE_PAY_MASTERCARD',
  GooglePayVisa = 'GOOGLE_PAY_VISA',
  GoogleWallet = 'GOOGLE_WALLET',
  IdCredit = 'ID_CREDIT',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Laser = 'LASER',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  Masterpass = 'MASTERPASS',
  Paypal = 'PAYPAL',
  Prepaid = 'PREPAID',
  PrivateLabel = 'PRIVATE_LABEL',
  QuicPay = 'QUIC_PAY',
  Solo = 'SOLO',
  Suica = 'SUICA',
  Switch = 'SWITCH',
  Unknown = 'UNKNOWN',
  Venmo = 'VENMO',
  Visa = 'VISA',
  VisaCheckout = 'VISA_CHECKOUT',
  VisaVpay = 'VISA_VPAY',
}

export enum PaymentLevel {
  AboveSite = 'ABOVE_SITE',
  SiteLevel = 'SITE_LEVEL',
}

export enum PaymentMethod {
  Activation = 'Activation',
  Cash = 'Cash',
  CashChange = 'CashChange',
  Cheque = 'Cheque',
  Credit = 'Credit',
  Debit = 'Debit',
  Ebt = 'EBT',
  EbtFs = 'EBT_FS',
  Loyalty = 'Loyalty',
  Na = 'NA',
  Other = 'Other',
  PrePaid = 'PrePaid',
  Recharge = 'Recharge',
}

export enum PaymentMethodEvaluationMethod {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

export enum PhoneType {
  Home = 'HOME',
  Location = 'LOCATION',
  Mobile = 'MOBILE',
  Work = 'WORK',
}

export enum PointChangeSortBy {
  CreatedAt = 'CREATED_AT',
}

export enum PointChangeSourceType {
  CommandCenterUser = 'COMMAND_CENTER_USER',
  Expiration = 'EXPIRATION',
  GameSession = 'GAME_SESSION',
  LoyaltyEvent = 'LOYALTY_EVENT',
  OfferPurchase = 'OFFER_PURCHASE',
  PointChange = 'POINT_CHANGE',
  PromocodeUseRequest = 'PROMOCODE_USE_REQUEST',
  Transaction = 'TRANSACTION',
  User = 'USER',
}

export enum PointChangeType {
  ApiPointAdjustment = 'API_POINT_ADJUSTMENT',
  BreakageReturn = 'BREAKAGE_RETURN',
  CancelRedemption = 'CANCEL_REDEMPTION',
  CancelTransaction = 'CANCEL_TRANSACTION',
  Migration = 'MIGRATION',
  OfferPurchase = 'OFFER_PURCHASE',
  OfferPurchaseReturn = 'OFFER_PURCHASE_RETURN',
  OptVoucherPurchase = 'OPT_VOUCHER_PURCHASE',
  PointAward = 'POINT_AWARD',
  PointExpiration = 'POINT_EXPIRATION',
  ReferralPointAward = 'REFERRAL_POINT_AWARD',
  ScrubData = 'SCRUB_DATA',
  SweepstakeEntryPurchase = 'SWEEPSTAKE_ENTRY_PURCHASE',
  VoucherExpiration = 'VOUCHER_EXPIRATION',
}

export enum PointExpirationStrategy {
  ActivityBased = 'ACTIVITY_BASED',
  FirstInFirstOut = 'FIRST_IN_FIRST_OUT',
  None = 'NONE',
}

export enum PrimaryTransactionStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Refunding = 'REFUNDING',
  Voiding = 'VOIDING',
}

export enum ProductGroupKey {
  FuelGradeId = 'FUEL_GRADE_ID',
  Group = 'GROUP',
  Sku = 'SKU',
  Upc = 'UPC',
}

export enum PublicationStatusType {
  All = 'ALL',
  Expired = 'EXPIRED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED',
}

export type PageInfo = {
  endCursor: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['ID']['output']>;
};

export type ParPayAppConfigurationCreateInput = {
  applePay?: InputMaybe<ApplePayConfigurationCreateInput>;
  corpId: Scalars['String']['input'];
  googlePay?: InputMaybe<GooglePayConfigurationCreateInput>;
  payAtPumpEnabled: Scalars['Boolean']['input'];
  payInsideEnabled: Scalars['Boolean']['input'];
  paymentWallet: WalletConfigurationCreateInput;
};

export type ParPayAppConfigurationUpdateInput = {
  applePay?: InputMaybe<ApplePayConfigurationUpdateInput>;
  corpId: Scalars['String']['input'];
  googlePay?: InputMaybe<GooglePayConfigurationUpdateInput>;
  payAtPumpEnabled: Scalars['Boolean']['input'];
  payInsideEnabled: Scalars['Boolean']['input'];
  paymentWallet: WalletConfigurationUpdateInput;
};

export type ParPayApplePayConfiguration = {
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName: Maybe<Scalars['String']['output']>;
  supportedNetworks: Array<ParPayApplePayCardNetwork>;
};

export type ParPayApplePaySession = {
  data: Maybe<Scalars['OCJSON']['output']>;
};

export type ParPayApplePaySessionCreateInput = {
  displayName: Scalars['String']['input'];
  initiative: Scalars['String']['input'];
  initiativeContext: Scalars['String']['input'];
  merchantIdentifier: Scalars['String']['input'];
};

export type ParPayBillingAddress = {
  alias: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['OCCountryCode2']['output']>;
  geoLocation: Maybe<GeoLocation>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
  zipCode: Scalars['String']['output'];
};

export type ParPayConfiguration = PaymentProviderConfiguration & {
  customData: Maybe<Scalars['OCJSON']['output']>;
};

export type ParPayCorporateAccount = {
  corpId: Scalars['String']['output'];
  createdAt: Maybe<Scalars['OCDateTime']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['OCDateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ParPayCorporateAccountCreateInput = {
  corpId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParPayCorporateAccountUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ParPayCorporateAccountsGetFilter = {
  corpIdEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type ParPayEcommInfoResponse = {
  avsResult: Maybe<Scalars['String']['output']>;
  cvvResult: Maybe<Scalars['String']['output']>;
  merchantIdentifier: Maybe<Scalars['String']['output']>;
  oneOrderToken: Maybe<Scalars['String']['output']>;
  oneTimeToken: Maybe<Scalars['String']['output']>;
  storeId: Maybe<Scalars['String']['output']>;
  terminalId: Maybe<Scalars['String']['output']>;
};

export type ParPayFeatureConfiguration = {
  enabled: Scalars['Boolean']['output'];
};

export type ParPayFraudScoreInfo = {
  decision: Maybe<Scalars['String']['output']>;
  ecomToken: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstAndLastName: Maybe<Scalars['String']['output']>;
  origDecision: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  processorDecision: Maybe<Scalars['String']['output']>;
  reasonCode: Maybe<Scalars['String']['output']>;
  remarks: Maybe<Scalars['String']['output']>;
  reqTypeIndicator: Maybe<Scalars['String']['output']>;
  requestId: Maybe<Scalars['String']['output']>;
  requestToken: Maybe<Scalars['String']['output']>;
  rulesTripped: Maybe<Scalars['String']['output']>;
  score: Maybe<Scalars['String']['output']>;
  serviceIdentifier: Maybe<Scalars['String']['output']>;
  streetAddr: Maybe<Scalars['String']['output']>;
};

export type ParPayGooglePayConfiguration = {
  allowCreditCards: Scalars['Boolean']['output'];
  allowPrepaidCards: Scalars['Boolean']['output'];
  allowedCardNetworks: Array<ParPayGooglePayCardNetwork>;
  environment: GooglePayEnvironment;
  gateway: Scalars['String']['output'];
  gatewayMerchantId: Scalars['ID']['output'];
  merchantId: Scalars['ID']['output'];
  merchantName: Maybe<Scalars['String']['output']>;
};

export type ParPayInitiateTokenizationSessionInput = {
  corpId: Scalars['String']['input'];
  customerUuid: Scalars['ID']['input'];
};

export type ParPayInside = ParPayFeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type ParPayMerchantAccount = {
  corpId: Scalars['String']['output'];
  createdAt: Maybe<Scalars['OCDateTime']['output']>;
  defaultForTokenization: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  locationUuid: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  terminalId: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['OCDateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ParPayMerchantAccountCreateInput = {
  corpId: Scalars['String']['input'];
  defaultForTokenization?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationUuid: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
  terminalId: Scalars['String']['input'];
};

export type ParPayMerchantAccountUpdateInput = {
  corpId?: InputMaybe<Scalars['String']['input']>;
  defaultForTokenization?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  terminalId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ParPayMerchantAccountsGetFilter = {
  corpIdEquals?: InputMaybe<Scalars['String']['input']>;
  defaultForTokenizationEquals?: InputMaybe<Scalars['Boolean']['input']>;
  locationUuidEquals?: InputMaybe<Scalars['ID']['input']>;
  merchantIdEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type ParPayPayAtPump = ParPayFeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type ParPayPaymentAppConfig = {
  applePay: Maybe<ParPayApplePayConfiguration>;
  googlePay: Maybe<ParPayGooglePayConfiguration>;
  payAtPump: ParPayPayAtPump;
  payInside: ParPayInside;
  paymentWallet: ParPayPaymentWalletConfiguration;
};

export type ParPayPaymentInstrument = {
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: ParPayPaymentAccountType;
  additionalDetails: Maybe<Scalars['OCJSON']['output']>;
  address: Maybe<ParPayBillingAddress>;
  alias: Maybe<Scalars['String']['output']>;
  balance: Maybe<Scalars['Float']['output']>;
  binRange: Maybe<Scalars['String']['output']>;
  corpId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['OCDateTime']['output']>;
  createdByDevice: Maybe<CustomerDevice>;
  customerUuid: Scalars['ID']['output'];
  displayNumber: Maybe<Scalars['String']['output']>;
  expiration: Maybe<ParPayPaymentInstrumentExpiration>;
  isDefault: Maybe<Scalars['Boolean']['output']>;
  last4: Maybe<Scalars['String']['output']>;
  maskedCardNumber: Maybe<Scalars['String']['output']>;
  paymentType: Maybe<ParPayPaymentInstrumentType>;
  providerNickName: Maybe<Scalars['String']['output']>;
  status: ParPayPaymentInstrumentStatus;
  updatedAt: Maybe<Scalars['OCDateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ParPayPaymentInstrumentCreateInput = {
  accountType: ParPayPaymentAccountType;
  customerUuid: Scalars['ID']['input'];
  expiration?: InputMaybe<Scalars['String']['input']>;
  maskedCardNumber?: InputMaybe<Scalars['String']['input']>;
  oneTimeToken: Scalars['String']['input'];
  paymentType?: InputMaybe<ParPayPaymentInstrumentType>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  tokenizationSessionId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentInstrumentExpiration = {
  expirationMonth: Maybe<Scalars['String']['output']>;
  expirationYear: Maybe<Scalars['String']['output']>;
};

export type ParPayPaymentInstrumentExpirationInput = {
  expirationMonth?: InputMaybe<Scalars['String']['input']>;
  expirationYear?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentInstrumentSetDefaultInput = {
  customerUuid: Scalars['ID']['input'];
  paymentInstrumentUuid: Scalars['ID']['input'];
};

export type ParPayPaymentInstrumentUpdateInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ParPayPaymentPreAuthorizeInput = {
  amountAsCents: Scalars['Int']['input'];
  customerUuid: Scalars['ID']['input'];
  fuelingPosition?: InputMaybe<Scalars['String']['input']>;
  locationUuid: Scalars['ID']['input'];
  oneTimePaymentToken?: InputMaybe<ParPayPaymentTokenInput>;
  paymentInstrumentUuid?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<TransactionType>;
};

export type ParPayPaymentRefundInput = {
  amountAsCents: Scalars['Int']['input'];
  parPayTransactionId: Scalars['String']['input'];
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentSettleInput = {
  amountAsCents: Scalars['Int']['input'];
  parPayTransactionId: Scalars['String']['input'];
};

export type ParPayPaymentTokenInput = {
  applePay?: InputMaybe<Scalars['String']['input']>;
  googlePay?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentVoidInput = {
  parPayTransactionId: Scalars['String']['input'];
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ParPayPaymentWalletConfiguration = {
  allowedAccountTypes: Array<ParPayPaymentAccountType>;
  maxInstruments: Scalars['Int']['output'];
};

export type ParPayResponse = {
  approvalCode: Maybe<Scalars['String']['output']>;
  batchNumber: Maybe<Scalars['String']['output']>;
  ecommInfoResponse: Maybe<ParPayEcommInfoResponse>;
  fraudScoreInfo: Maybe<ParPayFraudScoreInfo>;
  maskedCardNumber: Maybe<Scalars['String']['output']>;
  paymentInstrumentUuid: Maybe<Scalars['ID']['output']>;
  processorId: Maybe<Scalars['String']['output']>;
  processorResponseText: Maybe<Scalars['String']['output']>;
  rawResponse: Maybe<Scalars['OCJSON']['output']>;
  receiptToken: Maybe<Scalars['String']['output']>;
  referenceNumber: Maybe<Scalars['String']['output']>;
  referralNum: Maybe<Scalars['String']['output']>;
  responseCode: Maybe<Scalars['String']['output']>;
  responseText: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
  ticketNumber: Maybe<Scalars['String']['output']>;
  transactionId: Maybe<Scalars['String']['output']>;
  transactionSequenceNumber: Maybe<Scalars['String']['output']>;
  transactionToken: Maybe<Scalars['String']['output']>;
  transactionType: Maybe<ParPayTransactionType>;
  transactionTypeCode: Maybe<Scalars['String']['output']>;
};

export type ParPayTokenizationSession = {
  iframeUrl: Scalars['String']['output'];
  rawResponse: Scalars['OCJSON']['output'];
  responseCode: Scalars['String']['output'];
  responseText: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type PayAtPump = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type PayInside = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type PaymentApplePaySessionCreateInput = {
  displayName: Scalars['String']['input'];
  initiative: Scalars['String']['input'];
  initiativeContext: Scalars['String']['input'];
  merchantIdentifier: Scalars['String']['input'];
};

export type PaymentInstrument = {
  accountNumber: Maybe<Scalars['String']['output']>;
  accountType: PaymentAccountType;
  address: Maybe<BillingAddress>;
  alias: Maybe<Scalars['String']['output']>;
  balance: Maybe<Scalars['Float']['output']>;
  binRange: Maybe<Scalars['String']['output']>;
  createdByDevice: Maybe<CustomerDevice>;
  displayNumber: Maybe<Scalars['String']['output']>;
  expiration: Maybe<PaymentInstrumentExpiration>;
  isDefault: Maybe<Scalars['Boolean']['output']>;
  last4: Maybe<Scalars['String']['output']>;
  paymentProvider: Maybe<PaymentProvider>;
  paymentType: Maybe<PaymentInstrumentType>;
  providerNickName: Maybe<Scalars['String']['output']>;
  status: PaymentInstrumentStatus;
  uuid: Scalars['ID']['output'];
};

export type PaymentInstrumentExpiration = {
  expirationMonth: Maybe<Scalars['String']['output']>;
  expirationYear: Maybe<Scalars['String']['output']>;
};

export type PaymentProvider = {
  name: Scalars['String']['output'];
};

export type PaymentProviderConfiguration = {
  customData: Maybe<Scalars['OCJSON']['output']>;
};

export type PaymentTokenInput = {
  applePay?: InputMaybe<Scalars['String']['input']>;
  googlePay?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentWalletConfiguration = {
  allowedAccountTypes: Array<PaymentAccountType>;
  maxInstruments: Scalars['Int']['output'];
};

export type PersonName = {
  first: Maybe<Scalars['String']['output']>;
  last: Maybe<Scalars['String']['output']>;
  middle: Maybe<Scalars['String']['output']>;
  suffix: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type PersonalDataShareOptOutConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  optOutUrl: Scalars['String']['output'];
};

export type PinCodeConfiguration = {
  attemptThrottle: Scalars['Int']['output'];
  blockingDuration: Scalars['Int']['output'];
  maxAttempts: Scalars['Int']['output'];
  verifyMaxAttempts: Scalars['Int']['output'];
  verifyThrottling: Scalars['Boolean']['output'];
};

export type PointChange = {
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  notes: Maybe<Scalars['String']['output']>;
  offer: Maybe<Offer>;
  quantity: Scalars['Int']['output'];
  source: Maybe<PointChangeSource>;
  sourceType: Maybe<PointChangeSourceType>;
  type: Maybe<PointChangeType>;
};

export type PointChangeConnection = {
  edges: Array<Maybe<PointChangeEdge>>;
  pageInfo: PageInfo;
};

export type PointChangeEdge = {
  cursor: Scalars['ID']['output'];
  node: PointChange;
};

export type PointChangeFilter = {
  idEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type PointChangeSource =
  | ActivateTransaction
  | ActivateUser
  | Chain
  | CommandCenterUser
  | GameSession
  | LoyaltyEvent
  | OfferPurchase
  | PointChange
  | PromocodeUseRequest;

export type PointExpiration = {
  notificationDays: Maybe<Scalars['Int']['output']>;
  strategy: PointExpirationStrategy;
};

export type PointExpirationSchedule = {
  date: Scalars['OCDate']['output'];
  points: Scalars['Int']['output'];
};

export type PointExpirationScheduleConnection = {
  edges: Array<PointExpirationScheduleEdge>;
  pageInfo: PageInfo;
};

export type PointExpirationScheduleEdge = {
  cursor: Scalars['ID']['output'];
  node: PointExpirationSchedule;
};

export enum PointsStrategy {
  Cents = 'CENTS',
  NotUsed = 'NOT_USED',
  Points = 'POINTS',
}

export type PreferenceValue = {
  booleanType: Maybe<Scalars['Boolean']['output']>;
  floatType: Maybe<Scalars['Float']['output']>;
  intType: Maybe<Scalars['Int']['output']>;
  stringType: Maybe<Scalars['String']['output']>;
};

export type PreferenceValueCreate = {
  booleanType?: InputMaybe<Scalars['Boolean']['input']>;
  floatType?: InputMaybe<Scalars['Float']['input']>;
  intType?: InputMaybe<Scalars['Int']['input']>;
  stringType?: InputMaybe<Scalars['String']['input']>;
};

export type PreferenceValueUpdate = {
  booleanType?: InputMaybe<Scalars['Boolean']['input']>;
  floatType?: InputMaybe<Scalars['Float']['input']>;
  intType?: InputMaybe<Scalars['Int']['input']>;
  stringType?: InputMaybe<Scalars['String']['input']>;
};

export type PreferredFuelGradeConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type ProductCategory = {
  categoryRestriction: Maybe<CategoryRestrictions>;
  chainId: Scalars['ID']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type ProductCategoryConnection = {
  edges: Array<ProductCategoryEdge>;
  pageInfo: PageInfo;
};

export type ProductCategoryEdge = {
  cursor: Scalars['ID']['output'];
  node: ProductCategory;
};

export type ProductCategoryFilter = {
  categoryRestrictionEquals?: InputMaybe<CategoryRestrictions>;
  chainIdEquals?: InputMaybe<Scalars['ID']['input']>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductGroup = {
  createdAt: Scalars['OCDateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  discontinued: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: ProductGroupKey;
  name: Scalars['String']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type ProductInterest = {
  membershipId: Scalars['ID']['output'];
  productCategoryId: Scalars['ID']['output'];
};

export type ProductInterestInput = {
  productCategoryId: Scalars['ID']['input'];
};

export type ProductInterestsConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  isEAIVPromotionOnProfileCompletedEnabled: Scalars['Boolean']['output'];
};

export type ProductInterestsReplaceInput = {
  productCategoryIds: Array<Scalars['ID']['input']>;
};

export type ProductPreference = {
  displayCategoryId: Scalars['ID']['output'];
  membershipId: Scalars['ID']['output'];
};

export type ProductPreferenceInput = {
  displayCategoryId: Scalars['ID']['input'];
};

export type ProductPreferenceReplaceInput = {
  displayCategoryIds: Array<Scalars['ID']['input']>;
};

export enum PromocodePublicationStatus {
  Expired = 'EXPIRED',
  NotPublished = 'NOT_PUBLISHED',
  Published = 'PUBLISHED',
}

export enum PromocodeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export type PromocodeUseRequest = {
  id: Scalars['ID']['output'];
  membership: Membership;
  offer: Offer;
};

export type PurchaseProgress = {
  quantityPurchased: Scalars['Float']['output'];
  quantityRequired: Scalars['Float']['output'];
};

export type Query = {
  activityFeed: ActivityFeedConnection;
  appConfig: AppConfig;
  banners: Array<Banner>;
  currentCustomer: Maybe<Customer>;
  displayCategories: DisplayCategoryConnection;
  eaivAgeVerification: EaivAgeVerification;
  eaivIdentityVerification: EaivIdentityVerification;
  fuelProductGroups: Maybe<Array<FuelProductGroup>>;
  getBraintreeClientToken: Maybe<ClientToken>;
  getFiservClientAccessToken: FiservClientToken;
  guestGetBraintreeClientToken: ClientToken;
  guestLocations: LocationConnection;
  guestSurvey: Maybe<Survey>;
  guestTransaction: GuestTransaction;
  locations: Maybe<LocationConnection>;
  productCategories: ProductCategoryConnection;
  rudderstack: Rudderstack;
  subBrands: SubBrandConnection;
  survey: Survey;
  surveys: SurveyConnection;
  transaction: Maybe<Transaction>;
};

export type QueryActivityFeedArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter: ActivityFeedFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryBannersArgs = {
  filter: BannerFilter;
};

export type QueryDisplayCategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<DisplayCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFuelProductGroupsArgs = {
  filter?: InputMaybe<FuelProductGroupFilter>;
};

export type QueryGuestLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GuestLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGuestSurveyArgs = {
  guestSurveyId: Scalars['String']['input'];
};

export type QueryGuestTransactionArgs = {
  uuid: Scalars['ID']['input'];
};

export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ProductCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySubBrandsArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySurveyArgs = {
  uuid: Scalars['OCUUID']['input'];
};

export type QuerySurveysArgs = {
  after?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  before?: InputMaybe<Scalars['OCBase64Cursor']['input']>;
  filter?: InputMaybe<SurveyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTransactionArgs = {
  uuid: Scalars['ID']['input'];
};

export enum RandomAwardType {
  NoAward = 'NO_AWARD',
  Points = 'POINTS',
  TryAgain = 'TRY_AGAIN',
  Vouchers = 'VOUCHERS',
}

export enum ResourceItemType {
  CarWash = 'CAR_WASH',
  Fuel = 'FUEL',
  Lottery = 'LOTTERY',
  MiscConvenience = 'MISC_CONVENIENCE',
  Snack = 'SNACK',
  Tax = 'TAX',
  Tobacco = 'TOBACCO',
}

export enum RestrictionVerificationSource {
  AvtTransaction = 'AVT_TRANSACTION',
  LexisNexis = 'LEXIS_NEXIS',
  TobaccoTransaction = 'TOBACCO_TRANSACTION',
}

export type RandomAwardConfig = {
  award: Maybe<AwardPointsOrVouchers>;
  awardType: RandomAwardType;
  limit: Scalars['Int']['output'];
  sequenceNumber: Scalars['Int']['output'];
};

export type ReceiptLine = {
  lineNumber: Maybe<Scalars['Int']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type ReceiverConfiguration = {
  instructions: Scalars['String']['output'];
};

export enum ReceiverStatus {
  CodeNotRecognized = 'CODE_NOT_RECOGNIZED',
  Completed = 'COMPLETED',
  PendingQualifiedEvent = 'PENDING_QUALIFIED_EVENT',
}

export type RedeemPromocodeResult = RedeemPromocodeResultFail | RedeemPromocodeResultSuccess;

export type RedeemPromocodeResultFail = {
  reason: Maybe<Scalars['String']['output']>;
};

export type RedeemPromocodeResultSuccess = {
  award: Maybe<AwardPointsOrVouchers>;
};

export type ReferralCodeSharedEvent = {
  createdAt: Scalars['OCDateTime']['output'];
  id: Scalars['ID']['output'];
};

export type ReferralProgramConfiguration = {
  receiverConfiguration: ReceiverConfiguration;
  referralCodeManualEntryEnabled: Scalars['Boolean']['output'];
  referralProgramEnabled: Scalars['Boolean']['output'];
  senderConfiguration: SenderConfiguration;
};

export type ResourceItem = CarWashItem | FuelItem | StoreItem;

export type ResourceItemFilter = {
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionEquals?: InputMaybe<Scalars['String']['input']>;
  itemTypeContains?: InputMaybe<Array<InputMaybe<ResourceItemType>>>;
  itemTypeEquals?: InputMaybe<ResourceItemType>;
  merchandiseCodeContains?: InputMaybe<Scalars['String']['input']>;
  merchandiseCodeEquals?: InputMaybe<Scalars['String']['input']>;
  posCodeContains?: InputMaybe<Scalars['String']['input']>;
  posCodeEquals?: InputMaybe<Scalars['String']['input']>;
  posCodeFormatContains?: InputMaybe<Scalars['String']['input']>;
  posCodeFormatEquals?: InputMaybe<Scalars['String']['input']>;
  posCodeModifierContains?: InputMaybe<Scalars['String']['input']>;
  posCodeModifierEquals?: InputMaybe<Scalars['String']['input']>;
  receiptDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  receiptDescriptionEquals?: InputMaybe<Scalars['String']['input']>;
  skuContains?: InputMaybe<Scalars['String']['input']>;
  skuEquals?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureContains?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureEquals?: InputMaybe<Scalars['String']['input']>;
  unitPriceEquals?: InputMaybe<Scalars['Float']['input']>;
  unitPriceMax?: InputMaybe<Scalars['Float']['input']>;
  unitPriceMin?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export enum ReturnableOffersConfig {
  Off = 'OFF',
  On = 'ON',
  PerOffer = 'PER_OFFER',
}

export type RewardProgram = {
  createdAt: Scalars['OCDateTime']['output'];
  longDescription: Scalars['String']['output'];
  programId: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  type: LoyaltyProviderTypeEnum;
  updatedAt: Scalars['OCDateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type RudderStackConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type Rudderstack = {
  audienceUuids: Array<Scalars['ID']['output']>;
};

export type RuleDescription = {
  description: Scalars['String']['output'];
  ruleId: Scalars['String']['output'];
};

export type RuleFulfillment = {
  fulfilledOffer: Maybe<Offer>;
  fulfillmentCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export enum SecondaryTransactionStatus {
  Authorized = 'AUTHORIZED',
  Authorizing = 'AUTHORIZING',
  Cancelled = 'CANCELLED',
  CancellingAuthorized = 'CANCELLING_AUTHORIZED',
  CancellingAuthorizing = 'CANCELLING_AUTHORIZING',
  CancellingPumpEnabled = 'CANCELLING_PUMP_ENABLED',
  CancellingPumpEnabling = 'CANCELLING_PUMP_ENABLING',
  CancellingPumpReserved = 'CANCELLING_PUMP_RESERVED',
  CancellingReservingPump = 'CANCELLING_RESERVING_PUMP',
  Closed = 'CLOSED',
  Fueling = 'FUELING',
  GettingReceipt = 'GETTING_RECEIPT',
  PumpEnabled = 'PUMP_ENABLED',
  PumpEnabling = 'PUMP_ENABLING',
  PumpReserved = 'PUMP_RESERVED',
  ReservingPump = 'RESERVING_PUMP',
  Settled = 'SETTLED',
  Settling = 'SETTLING',
  SiteUnavailable = 'SITE_UNAVAILABLE',
  Started = 'STARTED',
  UnableToGetReceipt = 'UNABLE_TO_GET_RECEIPT',
  WaitingForStacScan = 'WAITING_FOR_STAC_SCAN',
}

export enum SignUpOrigin {
  Android = 'ANDROID',
  /** @deprecated ANDROID and IOS should be used */
  App = 'APP',
  ExternalAuth = 'EXTERNAL_AUTH',
  Imported = 'IMPORTED',
  Ios = 'IOS',
  Pos = 'POS',
  Pump = 'PUMP',
  /** @deprecated PUMP and POS should be used */
  PumpPos = 'PUMP_POS',
  RetailerConnect = 'RETAILER_CONNECT',
  Sms = 'SMS',
  Touchpoint = 'TOUCHPOINT',
  Unknown = 'UNKNOWN',
  Web = 'WEB',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Stac = {
  expiration: Maybe<Scalars['OCDateTime']['output']>;
  id: Scalars['String']['output'];
};

export enum StoreLocationEvaluationMethod {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

export enum SurveyType {
  General = 'GENERAL',
  Wallet = 'WALLET',
}

export type SenderConfiguration = {
  instructions: Scalars['String']['output'];
  smsTemplate: Scalars['String']['output'];
};

export type SignInUsernamePasswordUserInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  subBrandName?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpUsernamePasswordUserInput = {
  birthdate?: InputMaybe<Scalars['OCDate']['input']>;
  brandUuid: Scalars['ID']['input'];
  chainId?: InputMaybe<Scalars['ID']['input']>;
  customData: Scalars['OCJSON']['input'];
  email: Scalars['OCEmailAddress']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type SiteSystemCarWashItem = {
  description: Maybe<Scalars['String']['output']>;
  merchandiseCode: Maybe<Scalars['String']['output']>;
  posCode: Scalars['String']['output'];
  posCodeFormat: Maybe<Scalars['String']['output']>;
  posCodeModifier: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type SiteSystemConfiguration = {
  details: Maybe<SiteSystemDetails>;
  hardwareVendor: HardwareVendor;
  identifier: Scalars['String']['output'];
  loyaltyEnabled: Scalars['Boolean']['output'];
  mobileEnabled: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export type SiteSystemConfigurationCreate = {
  hardwareVendor: HardwareVendor;
  identifier: Scalars['String']['input'];
  loyaltyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteSystemConfigurationFilter = {
  hardwareVendorEquals?: InputMaybe<HardwareVendor>;
  identifierContains?: InputMaybe<Scalars['String']['input']>;
  identifierEquals?: InputMaybe<Scalars['String']['input']>;
  isLoyaltyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineEquals?: InputMaybe<Scalars['Boolean']['input']>;
  siteConfigurationIdContains?: InputMaybe<Scalars['String']['input']>;
  siteConfigurationIdEquals?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSystemConfigurationUpdate = {
  hardwareVendor?: InputMaybe<HardwareVendor>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  loyaltyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

export type SiteSystemDetails = {
  carWashDetails: Array<SiteSystemCarWashItem>;
  fuelConfigDetails: Array<SiteSystemFuelPumpProduct>;
  mobileActive: Maybe<Scalars['Boolean']['output']>;
  mobileVersion: Maybe<Scalars['String']['output']>;
  partialAuthAllowed: Maybe<Scalars['Boolean']['output']>;
  pumpTimeout: Maybe<Scalars['Int']['output']>;
  siteAddress: Maybe<Scalars['String']['output']>;
  siteName: Maybe<Scalars['String']['output']>;
};

export type SiteSystemFuelPumpProduct = {
  description: Maybe<Scalars['String']['output']>;
  merchandiseCode: Maybe<Scalars['String']['output']>;
  outdoorPosition: Maybe<Scalars['String']['output']>;
  posCode: Scalars['String']['output'];
  posCodeFormat: Maybe<Scalars['String']['output']>;
  posCodeModifier: Scalars['String']['output'];
  priceTier: Maybe<ConexxusPriceTier>;
  productCode: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type SitesSummary = {
  online: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SliderResponseRange = {
  count: Scalars['Int']['output'];
  rangeEnd: Scalars['Int']['output'];
  rangeStart: Scalars['Int']['output'];
};

export type SmsOptInConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  modalAppearanceDelaySeconds: Scalars['Int']['output'];
  modalOfferLoyaltyEventName: Scalars['String']['output'];
  optInAcceptedLoyaltyEventName: Scalars['String']['output'];
  optInRejectedLoyaltyEventName: Scalars['String']['output'];
};

export enum SmsOptOutReason {
  BlockedByProvider = 'BLOCKED_BY_PROVIDER',
  ManualOptOut = 'MANUAL_OPT_OUT',
  PhoneNumberInactive = 'PHONE_NUMBER_INACTIVE',
}

export type SmsOptedOutWarning = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  smsOptInKeyword: Scalars['String']['output'];
  smsOptInPhoneNumber: Scalars['String']['output'];
};

export type SpinWheelGameExecuteInput = {
  offerId: Scalars['ID']['input'];
};

export type SpireEnrollmentConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
  iframeUrl: Scalars['String']['output'];
  partnerId: Maybe<Scalars['String']['output']>;
};

export type SteeringWallet = {
  archivedAt: Maybe<Scalars['OCDateTime']['output']>;
  chainId: Scalars['OCUUID']['output'];
  configuration: SteeringWalletConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  name: Scalars['String']['output'];
  statistics: WalletSteeringDailySnapshot;
  status: SteeringWalletStatus;
  uuid: Scalars['OCUUID']['output'];
};

export enum SteeringWalletBasis {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type SteeringWalletConfiguration = {
  basis: Maybe<SteeringWalletBasis>;
  productGroupId: Maybe<Scalars['OCUUID']['output']>;
  reportingPeriod: Maybe<SteeringWalletReportingPeriod>;
  unitOfMeasure: Maybe<UnitOfMeasure>;
  uuid: Scalars['OCUUID']['output'];
};

export type SteeringWalletConfigurationCreateInput = {
  basis: SteeringWalletBasis;
  productGroupId: Scalars['OCUUID']['input'];
  reportingPeriod: SteeringWalletReportingPeriod;
  unitOfMeasure: UnitOfMeasure;
};

export type SteeringWalletConnection = {
  edges: Array<SteeringWalletEdge>;
  pageInfo: PageInfo;
};

export type SteeringWalletCreateInput = {
  chainId: Scalars['OCUUID']['input'];
  configuration: SteeringWalletConfigurationCreateInput;
  name: Scalars['String']['input'];
};

export type SteeringWalletEdge = {
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SteeringWallet;
};

export type SteeringWalletFilter = {
  chainIdEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusEquals?: InputMaybe<SteeringWalletStatus>;
  uuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
};

export enum SteeringWalletReportingPeriod {
  NinetyDays = 'NINETY_DAYS',
  ThirtyDays = 'THIRTY_DAYS',
}

export enum SteeringWalletStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export type SteeringWalletUpdateInput = {
  name: Scalars['String']['input'];
  uuid: Scalars['OCUUID']['input'];
};

export type StoreItem = {
  additionalAttributes: Maybe<Scalars['OCJSON']['output']>;
  description: Maybe<Scalars['String']['output']>;
  isAgeRestricted: Maybe<Scalars['Boolean']['output']>;
  itemType: Maybe<ResourceItemType>;
  merchandiseCode: Maybe<Scalars['String']['output']>;
  posCode: Maybe<Scalars['String']['output']>;
  posCodeFormat: Maybe<Scalars['String']['output']>;
  posCodeModifier: Maybe<Scalars['String']['output']>;
  receiptDescription: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  taxCode: Maybe<Scalars['String']['output']>;
  unitOfMeasure: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<ItemPrice>;
  uuid: Scalars['ID']['output'];
};

export type StoreItemConnection = {
  edges: Maybe<Array<Maybe<StoreItemEdge>>>;
  pageInfo: PageInfo;
};

export type StoreItemEdge = {
  cursor: Scalars['ID']['output'];
  node: Maybe<StoreItem>;
};

export type StoreLocatorConfiguration = {
  defaultLocation: GeoLocation;
  fuelPricesMode: FuelPricesMode;
  googleMapsApiKey: Scalars['String']['output'];
};

export type SubBrand = {
  codeName: Scalars['String']['output'];
  createdAt: Scalars['OCDateTime']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SubBrandConfiguration = {
  referralProgramEnabled: Scalars['Boolean']['output'];
  subBrandUuid: Scalars['ID']['output'];
};

export type SubBrandConnection = {
  edges: Array<SubBrandEdge>;
  pageInfo: PageInfo;
};

export type SubBrandEdge = {
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SubBrand;
};

export type SubBrandFilter = {
  codeNameEquals?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
};

export type SubBrandFilterInput = {
  subBrandUuids: Array<Scalars['String']['input']>;
};

export type SupportConfiguration = {
  email: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  widget: Maybe<SupportWidgetConfiguration>;
};

export type SupportWidgetConfiguration = DevRevSupportWidgetConfiguration | FreshdeskSupportWidgetConfiguration;

export type Survey = {
  award: Maybe<AwardPointsOrVouchers>;
  questions: Array<SurveyQuestion>;
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyAnswerInput = {
  multipleChoice?: InputMaybe<SurveyAnswerMultipleChoiceInput>;
  singleChoice?: InputMaybe<SurveyAnswerSingleChoiceInput>;
  slider?: InputMaybe<SurveyAnswerIntSliderInput>;
};

export type SurveyAnswerIntSliderInput = {
  value: Scalars['Int']['input'];
};

export type SurveyAnswerMultipleChoiceInput = {
  optionUuids: Array<Scalars['OCUUID']['input']>;
};

export type SurveyAnswerSendInput = {
  fields: Array<SurveyFieldInput>;
  questionUuid: Scalars['OCUUID']['input'];
};

export type SurveyAnswerSingleChoiceInput = {
  optionUuid: Scalars['OCUUID']['input'];
};

export type SurveyAnswerSubmitInput = {
  fields: Array<SurveyFieldInput>;
  memberUuid: Scalars['OCUUID']['input'];
  questionUuid: Scalars['OCUUID']['input'];
};

export type SurveyAnswersSubmitInput = {
  answers: Array<SurveyQuestionAnswerInput>;
};

export type SurveyConnection = {
  edges: Array<SurveyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SurveyDeployInput = {
  audienceUuid: Scalars['OCUUID']['input'];
  channel: SurveyDeploymentChannel;
  rolloutType: SurveyDeploymentRolloutType;
  surveyUuid: Scalars['OCUUID']['input'];
};

export type SurveyDeployment = {
  configuration: SurveyDeploymentConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  status: SurveyDeploymentStatus;
  uuid: Scalars['OCUUID']['output'];
};

export enum SurveyDeploymentChannel {
  Experience = 'EXPERIENCE',
}

export type SurveyDeploymentConfiguration = {
  channel: Maybe<SurveyDeploymentChannel>;
  rolloutType: Maybe<SurveyDeploymentRolloutType>;
};

export type SurveyDeploymentConnection = {
  edges: Array<SurveyDeploymentEdge>;
  pageInfo: PageInfo;
};

export type SurveyDeploymentEdge = {
  cursor: Scalars['OCBase64Cursor']['output'];
  node: SurveyDeployment;
};

export enum SurveyDeploymentRolloutType {
  AtDeployment = 'AT_DEPLOYMENT',
  OpenEnded = 'OPEN_ENDED',
}

export enum SurveyDeploymentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Creating = 'CREATING',
  Deployed = 'DEPLOYED',
  Publishing = 'PUBLISHING',
}

export type SurveyDismissInput = {
  surveyUuid: Scalars['OCUUID']['input'];
};

export type SurveyEdge = {
  cursor: Scalars['OCBase64Cursor']['output'];
  node: Survey;
};

export type SurveyField = {
  label: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyFieldInput = {
  answer: Scalars['String']['input'];
  uuid: Scalars['OCUUID']['input'];
};

export type SurveyFieldIntSlider = SurveyField & {
  configuration: SurveyFieldIntSliderConfiguration;
  label: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyFieldIntSliderConfiguration = {
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type SurveyFilter = {
  chainIdEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  includeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer supported */
  memberUuidEquals?: InputMaybe<Scalars['OCUUID']['input']>;
  statusEquals?: InputMaybe<SurveyStatus>;
  typeEquals?: InputMaybe<SurveyType>;
  uuidContains?: InputMaybe<Array<Scalars['OCUUID']['input']>>;
};

export type SurveyQuestion = {
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionAnswerInput = {
  answer: SurveyAnswerInput;
  uuid: Scalars['OCUUID']['input'];
};

export type SurveyQuestionConfigurationInput = {
  multipleChoice?: InputMaybe<SurveyQuestionMultipleChoiceConfigurationInput>;
  singleChoice?: InputMaybe<SurveyQuestionSingleChoiceConfigurationInput>;
  slider?: InputMaybe<SurveyQuestionSliderConfigurationInput>;
};

export type SurveyQuestionIntSlider = SurveyQuestion & {
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionMultipleChoice = SurveyQuestion & {
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  options: Array<SurveyQuestionOption>;
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionMultipleChoiceConfigurationInput = {
  options: Array<Scalars['String']['input']>;
};

export type SurveyQuestionOption = {
  index: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionResponseStatistics = {
  locationUuid: Maybe<Scalars['OCUUID']['output']>;
  optionSelectionCounters: Array<OptionSelectionCount>;
  sliderResponseRanges: Array<SliderResponseRange>;
};

export type SurveyQuestionSingleChoice = SurveyQuestion & {
  /** @deprecated Use the options field instead. This field will be removed in the future. */
  fields: Array<SurveyField>;
  index: Scalars['Int']['output'];
  options: Array<SurveyQuestionOption>;
  questionText: Scalars['String']['output'];
  uuid: Scalars['OCUUID']['output'];
};

export type SurveyQuestionSingleChoiceConfigurationInput = {
  options: Array<Scalars['String']['input']>;
};

export type SurveyQuestionSliderConfigurationInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export enum SurveyStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
}

export type SurveyViewsCreateInput = {
  surveyUuids: Array<Scalars['OCUUID']['input']>;
};

export enum TransactionStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  CompletedFailedAuthorization = 'COMPLETED_FAILED_AUTHORIZATION',
  CompletedFailedOnReceipt = 'COMPLETED_FAILED_ON_RECEIPT',
  CompletedFailedSettlement = 'COMPLETED_FAILED_SETTLEMENT',
  CompletedFailedToEnablePump = 'COMPLETED_FAILED_TO_ENABLE_PUMP',
  CompletedFailedToReservePump = 'COMPLETED_FAILED_TO_RESERVE_PUMP',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  FullReversal = 'FULL_REVERSAL',
  FullReversalPending = 'FULL_REVERSAL_PENDING',
  Open = 'OPEN',
  PartialPayment = 'PARTIAL_PAYMENT',
  PartialRefundTransaction = 'PARTIAL_REFUND_TRANSACTION',
  Pending = 'PENDING',
  PendingRefundReceipt = 'PENDING_REFUND_RECEIPT',
  Processing = 'PROCESSING',
  ReceiptPending = 'RECEIPT_PENDING',
  RefundPending = 'REFUND_PENDING',
  RefundTransaction = 'REFUND_TRANSACTION',
  Start = 'START',
  Unclaimed = 'UNCLAIMED',
  Unknown = 'UNKNOWN',
  VoidPending = 'VOID_PENDING',
  VoidTransaction = 'VOID_TRANSACTION',
}

export enum TransactionType {
  AtPump = 'AT_PUMP',
  InStore = 'IN_STORE',
  KioskInStore = 'KIOSK_IN_STORE',
}

export type Tenant = {
  name: Scalars['String']['output'];
};

export type TimeSeriesMetric = {
  date: Scalars['OCDateTime']['output'];
  value: Scalars['Int']['output'];
};

export type Tokens = {
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type TotalAvailableRollback = {
  fuelProductGroup: Maybe<FuelProductGroup>;
  locationName: Maybe<Scalars['String']['output']>;
  locationUuid: Maybe<Scalars['ID']['output']>;
  moneyAmount: Scalars['Int']['output'];
  offers: Maybe<Array<Offer>>;
};

export type TotalAvailableRollbackConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type TotalAvailableRollbackFilter = {
  subBrandId?: InputMaybe<Scalars['String']['input']>;
};

export type TotalPointsEarnedConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type TrackingConfig = {
  isActivityLogIncludedInAltriaDDM: Scalars['Boolean']['output'];
  trackingId: Scalars['ID']['output'];
};

export type Transaction = {
  additionalReceiptData: Maybe<Scalars['OCJSON']['output']>;
  amount: Maybe<ItemPrice>;
  authCode: Maybe<Scalars['String']['output']>;
  brandSpecificLocationId: Maybe<Scalars['String']['output']>;
  completedAt: Maybe<Scalars['OCDateTime']['output']>;
  currency: Currency;
  customerUuid: Maybe<Scalars['ID']['output']>;
  fuelPumpStatus: Maybe<FuelPumpStatus>;
  fuelReceipt: Maybe<FuelReceipt>;
  fuelingPosition: Maybe<Scalars['String']['output']>;
  hardwareVendor: Maybe<HardwareVendor>;
  initiationResource: Maybe<LocationResourceType>;
  items: Maybe<Array<Maybe<TransactionItem>>>;
  lastUpdatedAt: Scalars['OCDateTime']['output'];
  location: Maybe<Location>;
  loyaltyInstruments: Maybe<Array<Maybe<LoyaltyInstrument>>>;
  loyaltyLevel: Maybe<LoyaltyLevel>;
  paymentInfo: Maybe<Array<Maybe<TransactionPaymentInfo>>>;
  paymentInstrument: Maybe<PaymentInstrument>;
  paymentInstrumentType: Maybe<PaymentInstrumentType>;
  paymentLevel: Maybe<PaymentLevel>;
  primaryStatus: PrimaryTransactionStatus;
  rawReceipt: Maybe<Scalars['String']['output']>;
  receiptLines: Maybe<Array<Maybe<ReceiptLine>>>;
  secondaryStatus: SecondaryTransactionStatus;
  sourceId: Maybe<Scalars['ID']['output']>;
  stac: Maybe<Stac>;
  startedAt: Scalars['OCDateTime']['output'];
  /** @deprecated Use primaryStatus and secondaryStatus */
  status: Maybe<TransactionStatus>;
  tax: Maybe<ItemPrice>;
  transactionType: TransactionType;
  umti: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TransactionAppConfig = {
  mobileTransactionFraudCheck: Maybe<MobileTransactionFraudCheck>;
};

export type TransactionConnection = {
  edges: Maybe<Array<Maybe<TransactionEdge>>>;
  pageInfo: PageInfo;
};

export type TransactionCustomer = {
  phoneNumber: Scalars['OCPhoneNumber']['output'];
  uuid: Scalars['ID']['output'];
};

export type TransactionDiscountAwards = AwardTransactionMoneyDiscount | AwardTransactionPercentDiscount;

export type TransactionEdge = {
  cursor: Scalars['ID']['output'];
  node: Maybe<Transaction>;
};

export type TransactionFilter = {
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  authCodeContains?: InputMaybe<Scalars['String']['input']>;
  authCodeEquals?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandFilter>;
  completedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  completedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  fuelPumpStatusContains?: InputMaybe<Array<InputMaybe<FuelPumpStatus>>>;
  fuelPumpStatusEquals?: InputMaybe<FuelPumpStatus>;
  fuelingPositionEquals?: InputMaybe<Scalars['String']['input']>;
  hardwareVendorContains?: InputMaybe<Array<InputMaybe<HardwareVendor>>>;
  hardwareVendorEquals?: InputMaybe<HardwareVendor>;
  initiationResourceContains?: InputMaybe<Array<InputMaybe<LocationResourceType>>>;
  initiationResourceEquals?: InputMaybe<LocationResourceType>;
  items?: InputMaybe<ResourceItemFilter>;
  lastUpdatedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  lastUpdatedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  location?: InputMaybe<LocationFilter>;
  loyaltyInstrument?: InputMaybe<LoyaltyInstrumentFilter>;
  loyaltyLevelContains?: InputMaybe<Array<InputMaybe<LoyaltyLevel>>>;
  loyaltyLevelEquals?: InputMaybe<LoyaltyLevel>;
  paymentInfo?: InputMaybe<TransactionPaymentInfoFilter>;
  paymentLevelContains?: InputMaybe<Array<InputMaybe<PaymentLevel>>>;
  paymentLevelEquals?: InputMaybe<PaymentLevel>;
  primaryStatusContains?: InputMaybe<Array<InputMaybe<PrimaryTransactionStatus>>>;
  primaryStatusEquals?: InputMaybe<PrimaryTransactionStatus>;
  secondaryStatusContains?: InputMaybe<Array<InputMaybe<SecondaryTransactionStatus>>>;
  secondaryStatusEquals?: InputMaybe<SecondaryTransactionStatus>;
  stacEquals?: InputMaybe<Scalars['String']['input']>;
  startedAtMax?: InputMaybe<Scalars['OCDateTime']['input']>;
  startedAtMin?: InputMaybe<Scalars['OCDateTime']['input']>;
  taxMax?: InputMaybe<Scalars['Float']['input']>;
  taxMin?: InputMaybe<Scalars['Float']['input']>;
  typeContains?: InputMaybe<Array<InputMaybe<TransactionType>>>;
  typeEquals?: InputMaybe<TransactionType>;
  umtiContains?: InputMaybe<Scalars['String']['input']>;
  umtiEquals?: InputMaybe<Scalars['String']['input']>;
  uuidEquals?: InputMaybe<Scalars['ID']['input']>;
};

export type TransactionFraudCheckResult = KountFraudCheckResult;

export type TransactionItem = {
  amount: Maybe<ItemPrice>;
  discountApplied: Maybe<ItemPrice>;
  discountDescription: Maybe<Scalars['String']['output']>;
  itemDescription: Maybe<Scalars['String']['output']>;
  qty: Maybe<Scalars['Float']['output']>;
  refundedAmount: Maybe<ItemPrice>;
  resourceItem: Maybe<ResourceItem>;
  tax: Maybe<ItemPrice>;
};

export type TransactionPaymentInfo = {
  cardCircuit: Maybe<Scalars['String']['output']>;
  cardPANPrint: Maybe<Scalars['String']['output']>;
  cardType: Maybe<Scalars['String']['output']>;
  hostAuthNumber: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<PaymentMethod>;
  preAuthAmount: Maybe<Scalars['Float']['output']>;
};

export type TransactionPaymentInfoFilter = {
  cardCircuitEquals?: InputMaybe<Scalars['String']['input']>;
  cardPANPrintEquals?: InputMaybe<Scalars['String']['input']>;
  cardTypeEquals?: InputMaybe<Scalars['String']['input']>;
  hostAuthNumberEquals?: InputMaybe<Scalars['String']['input']>;
  paymentMethodEquals?: InputMaybe<PaymentMethod>;
  preAuthAmountMax?: InputMaybe<Scalars['Float']['input']>;
  preAuthAmountMin?: InputMaybe<Scalars['Float']['input']>;
};

export type TransactionPaymentTokenInput = {
  /** @deprecated Replaced by applePayPayment but remains for the older clients backward compatibility. */
  applePay?: InputMaybe<Scalars['String']['input']>;
  applePayPayment?: InputMaybe<Scalars['String']['input']>;
  googlePay?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionStart = {
  billingZipCode?: InputMaybe<Scalars['String']['input']>;
  carWash?: InputMaybe<CarWashInput>;
  externalRequestData?: InputMaybe<Scalars['OCJSON']['input']>;
  fuelingPosition?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationCreate>;
  initiationResource?: InputMaybe<LocationResourceType>;
  items?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  kountSessionId?: InputMaybe<Scalars['String']['input']>;
  locationUuid?: InputMaybe<Scalars['ID']['input']>;
  loyaltyIdentifier?: InputMaybe<Scalars['String']['input']>;
  loyaltyInstruments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  paymentInstrumentType?: InputMaybe<PaymentInstrumentType>;
  paymentInstruments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paymentToken?: InputMaybe<TransactionPaymentTokenInput>;
  pinCode?: InputMaybe<CustomerPinCode>;
  printReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  promptForCarWash?: InputMaybe<Scalars['Boolean']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stac?: InputMaybe<Scalars['String']['input']>;
  transactionType: TransactionType;
};

export type TriggerPreferences = {
  triggerOnFulfillment: Scalars['Boolean']['output'];
  triggerOnProgress: Scalars['Boolean']['output'];
  triggerOnVisibility: Scalars['Boolean']['output'];
};

export type TriggerPreferencesInput = {
  triggerOnFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  triggerOnProgress?: InputMaybe<Scalars['Boolean']['input']>;
  triggerOnVisibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UnitOfMeasure {
  Amount = 'AMOUNT',
  Gallon = 'GALLON',
  Unit = 'UNIT',
}

export type UserExperienceConfig = {
  offers: UserExperienceOffersConfig;
};

export type UserExperienceOffersConfig = {
  gridLocation: OffersGridLocation;
  tabNavbarIcon: Maybe<OffersTabNavbarIcon>;
};

export enum VouchersSortBy {
  CreatedAt = 'CREATED_AT',
}

export enum VoucherSourceType {
  GameSession = 'GAME_SESSION',
  LoyaltyEvent = 'LOYALTY_EVENT',
  Offer = 'OFFER',
  OfferPurchase = 'OFFER_PURCHASE',
  PromocodeUseRequest = 'PROMOCODE_USE_REQUEST',
  Transaction = 'TRANSACTION',
}

export enum VoucherState {
  Abandoned = 'ABANDONED',
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  Unfulfilled = 'UNFULFILLED',
}

export type ValidateAndResetCustomerPasswordInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
  subBrandName?: InputMaybe<Scalars['String']['input']>;
};

export type VarietyDiscountAwards = AwardPriceOverride | AwardProductDiscount | AwardTransactionMoneyDiscount;

export type VarietyProgress = {
  productGroups: Array<ProductGroup>;
  quantityPurchased: Scalars['Float']['output'];
  quantityRequired: Scalars['Float']['output'];
};

export type VisitsProgress = {
  visits: Scalars['Int']['output'];
  visitsRequired: Scalars['Int']['output'];
};

export type Voucher = {
  createdAt: Scalars['OCDateTime']['output'];
  deletedAt: Maybe<Scalars['OCDateTime']['output']>;
  expireAt: Maybe<Scalars['OCDateTime']['output']>;
  fulfilledBy: Maybe<VoucherFulfilledBy>;
  fulfilledById: Maybe<Scalars['String']['output']>;
  fulfilledByType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  membership: Membership;
  offer: Maybe<Offer>;
  reservedKey: Maybe<Scalars['String']['output']>;
  reservedUntil: Maybe<Scalars['OCDateTime']['output']>;
  source: Maybe<VoucherSource>;
  sourceId: Maybe<Scalars['String']['output']>;
  sourceType: Maybe<Scalars['String']['output']>;
  state: VoucherState;
  updatedAt: Scalars['OCDateTime']['output'];
};

export type VoucherConnection = {
  edges: Array<VoucherEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VoucherEdge = {
  cursor: Scalars['ID']['output'];
  node: Voucher;
};

export type VoucherFilter = {
  engagementTypeContains?: InputMaybe<Array<OfferEngagementType>>;
  membershipUuid?: InputMaybe<Scalars['OCUUID']['input']>;
  presentationTypeContains?: InputMaybe<Array<OfferPresentationType>>;
  returnable?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<VoucherSourceType>;
  state?: InputMaybe<VoucherState>;
  visibleStatusEquals?: InputMaybe<OfferVisibleStatus>;
};

export type VoucherFulfilledBy = ActivateTransaction | GameSession | LoyaltyEvent;

export type VoucherSort = {
  direction: SortOrder;
  field: VouchersSortBy;
};

export type VoucherSource =
  | ActivateTransaction
  | GameSession
  | LoyaltyEvent
  | Offer
  | OfferPurchase
  | PromocodeUseRequest;

export enum Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type WalletConfiguration = FeatureConfiguration & {
  enabled: Scalars['Boolean']['output'];
};

export type WalletConfigurationCreateInput = {
  allowedAccountTypes: Array<ParPayPaymentAccountType>;
  maxInstruments: Scalars['Int']['input'];
};

export type WalletConfigurationUpdateInput = {
  allowedAccountTypes: Array<ParPayPaymentAccountType>;
  maxInstruments: Scalars['Int']['input'];
};

export type WalletSteeringDailySnapshot = {
  date: Scalars['OCDate']['output'];
  membershipCount: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['OCUUID']['output'];
  walletCapacity: Scalars['Float']['output'];
  walletOpportunity: Maybe<Scalars['Float']['output']>;
  walletShare: Maybe<Scalars['Float']['output']>;
  walletUuid: Scalars['OCUUID']['output'];
};

export type WalletSteeringStatisticsFilter = {
  endDate: Scalars['OCDate']['input'];
  startDate: Scalars['OCDate']['input'];
  walletUuid: Scalars['OCUUID']['input'];
};

export type WalletSteeringSurvey = Survey & {
  audienceUuid: Scalars['OCUUID']['output'];
  award: Maybe<AwardPointsOrVouchers>;
  chainId: Scalars['OCUUID']['output'];
  configuration: WalletSteeringSurveyConfiguration;
  createdAt: Scalars['OCDateTime']['output'];
  deletedAt: Maybe<Scalars['OCDateTime']['output']>;
  questions: Array<SurveyQuestion>;
  status: SurveyStatus;
  type: SurveyType;
  uuid: Scalars['OCUUID']['output'];
};

export type WalletSteeringSurveyConfiguration = {
  maxUnits: Maybe<Scalars['Int']['output']>;
  minUnits: Maybe<Scalars['Int']['output']>;
  questionText: Maybe<Scalars['String']['output']>;
  steeringWalletUnitOfMeasure: Maybe<UnitOfMeasure>;
  steeringWalletUuid: Maybe<Scalars['OCUUID']['output']>;
};

export type WalletSteeringSurveyCreateInput = {
  maxUnits: Scalars['Int']['input'];
  minUnits: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  steeringWalletUuid: Scalars['OCUUID']['input'];
};

export type WalletSteeringSurveyUpdateInput = {
  maxUnits: Scalars['Int']['input'];
  minUnits: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  uuid: Scalars['OCUUID']['input'];
};

export type WorldpayConfiguration = PaymentProviderConfiguration & {
  customData: Maybe<Scalars['OCJSON']['output']>;
  eProtectGooglePayPageId: Scalars['String']['output'];
  eProtectPayPageId: Scalars['String']['output'];
  eProtectWebSdkApiUrl: Scalars['String']['output'];
  eProtectWebSdkUrl: Scalars['String']['output'];
};

export type CreateOtpSessionResult = {
  session: Scalars['String']['output'];
};

export type CustomerMakeActiveMutationVariables = Exact<{ [key: string]: never }>;

export type CustomerMakeActiveMutation = {
  membershipStateTransition: {
    __typename: 'Membership';
    id: string;
    customerUuid: string | null;
    state: MEMBERSHIP_STATE;
  } | null;
};

export type CustomerResetPinCodeMutationVariables = Exact<{ [key: string]: never }>;

export type CustomerResetPinCodeMutation = { success: boolean | null };

export type CustomerSetPinCodeMutationVariables = Exact<{
  pinCode: Scalars['String']['input'];
}>;

export type CustomerSetPinCodeMutation = { success: boolean | null };

export type CustomerVerifyPinCodeMutationVariables = Exact<{
  pinCode: Scalars['String']['input'];
}>;

export type CustomerVerifyPinCodeMutation = { success: boolean | null };

export type GetAtTheStoreWithPumpsQueryVariables = Exact<{
  geoLocation?: InputMaybe<GeoLocationFilter>;
}>;

export type GetAtTheStoreWithPumpsQuery = {
  store: {
    edges: Array<{
      node: {
        uuid: string;
        siteSystemConfiguration: Array<{
          uuid: string;
          mobileEnabled: boolean;
          details: { fuelConfigDetails: Array<{ outdoorPosition: string | null }> } | null;
        }>;
      };
    }> | null;
  } | null;
};

export type OfferByLoyaltyEventFragment = {
  id: string;
  customData: any | null;
  trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
  marketingContents: Array<{
    id: string;
    title: string | null;
    shortDescription: string | null;
    imageUrl: any | null;
    terms: string | null;
    disclaimer: string | null;
    disclaimerUrl: any | null;
  } | null>;
};

export type GetOffersByLoyaltyEventQueryVariables = Exact<{
  loyaltyEventEquals: Scalars['String']['input'];
  publicationStatusEquals: PublicationStatusType;
  visibleStatusEquals: OfferVisibleStatus;
}>;

export type GetOffersByLoyaltyEventQuery = {
  currentCustomer: {
    uuid: string;
    membership: {
      id: string;
      offers: {
        edges: Array<{
          node: {
            id: string;
            customData: any | null;
            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
            marketingContents: Array<{
              id: string;
              title: string | null;
              shortDescription: string | null;
              imageUrl: any | null;
              terms: string | null;
              disclaimer: string | null;
              disclaimerUrl: any | null;
            } | null>;
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type LoyaltyEventCreateMutationVariables = Exact<{
  input: LoyaltyEventCreate;
}>;

export type LoyaltyEventCreateMutation = { event: { eventData: any | null; eventType: string; createdAt: any } | null };

export type OfferPurchaseMutationVariables = Exact<{
  input: OfferPurchaseCreate;
}>;

export type OfferPurchaseMutation = { offers: Array<{ pointCost: number } | null> | null };

export type PointChangeFragment = {
  id: string;
  createdAt: any;
  quantity: number;
  type: PointChangeType | null;
  notes: string | null;
  source:
    | { __typename: 'ActivateTransaction'; id: string }
    | { __typename: 'ActivateUser'; id: string }
    | { __typename: 'Chain'; id: string }
    | { __typename: 'CommandCenterUser' }
    | { __typename: 'GameSession' }
    | { __typename: 'LoyaltyEvent'; eventType: string; createdAt: any }
    | {
        __typename: 'OfferPurchase';
        purchasedWith: {
          id: string;
          name: string;
          marketingContents: Array<{ id: string; title: string | null } | null>;
        };
      }
    | {
        __typename: 'PointChange';
        id: string;
        offer: {
          id: string;
          name: string;
          marketingContents: Array<{ id: string; title: string | null } | null>;
        } | null;
      }
    | { __typename: 'PromocodeUseRequest' }
    | null;
  offer: { id: string; name: string; marketingContents: Array<{ id: string; title: string | null } | null> } | null;
};

export type GetPointsChangeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPointsChangeQuery = {
  transactionHistory: {
    uuid: string;
    membership: {
      id: string;
      pointChanges: {
        edges: Array<{
          cursor: string;
          node: {
            id: string;
            createdAt: any;
            quantity: number;
            type: PointChangeType | null;
            notes: string | null;
            source:
              | { __typename: 'ActivateTransaction'; id: string }
              | { __typename: 'ActivateUser'; id: string }
              | { __typename: 'Chain'; id: string }
              | { __typename: 'CommandCenterUser' }
              | { __typename: 'GameSession' }
              | { __typename: 'LoyaltyEvent'; eventType: string; createdAt: any }
              | {
                  __typename: 'OfferPurchase';
                  purchasedWith: {
                    id: string;
                    name: string;
                    marketingContents: Array<{ id: string; title: string | null } | null>;
                  };
                }
              | {
                  __typename: 'PointChange';
                  id: string;
                  offer: {
                    id: string;
                    name: string;
                    marketingContents: Array<{ id: string; title: string | null } | null>;
                  } | null;
                }
              | { __typename: 'PromocodeUseRequest' }
              | null;
            offer: {
              id: string;
              name: string;
              marketingContents: Array<{ id: string; title: string | null } | null>;
            } | null;
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type ActivateTransactionFragment = {
  id: string;
  totalTax: number | null;
  totalAmount: number | null;
  subtotalAmount: number | null;
  totalDiscountAmount: number | null;
  totalAmountWithoutDiscounts: number | null;
  totalPointsEarned: number;
  totalPointsRefunded: number;
  totalPointsSpent: number;
  status: ActivateTransactionStatus | null;
  vendorName: string | null;
  createdAt: any;
  lineItems: Array<{
    id: string;
    group: string | null;
    moneyAmount: number | null;
    quantity: number | null;
    sku: string | null;
    upc: string | null;
    fuelGradeId: string | null;
    promotions: Array<{
      promotionAmount: number;
      promotionReason: string;
      promotionTitle: string;
      offer: {
        id: string;
        marketingContents: Array<{ id: string; title: string | null; shortDescription: string | null } | null>;
      } | null;
    }> | null;
    externalLineItemPromotions: Array<{ id: string; discountAmount: number; promotionReason: string }> | null;
  } | null>;
  location: {
    id: string;
    address1: string | null;
    address2: string | null;
    state: string | null;
    city: string | null;
    name: string | null;
    zipcode: string | null;
  } | null;
  paymentInfos: Array<{ tenderType: string | null; tenderSubtype: string | null }> | null;
};

export type ActivateLineItemPromotionFragment = {
  promotionAmount: number;
  promotionReason: string;
  promotionTitle: string;
  offer: {
    id: string;
    marketingContents: Array<{ id: string; title: string | null; shortDescription: string | null } | null>;
  } | null;
};

export type GetActivateTransactionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetActivateTransactionQuery = {
  transactionHistory: {
    uuid: string;
    membership: {
      id: string;
      transactions: {
        edges: Array<{
          cursor: string;
          node: {
            id: string;
            totalTax: number | null;
            totalAmount: number | null;
            subtotalAmount: number | null;
            totalDiscountAmount: number | null;
            totalAmountWithoutDiscounts: number | null;
            totalPointsEarned: number;
            totalPointsRefunded: number;
            totalPointsSpent: number;
            status: ActivateTransactionStatus | null;
            vendorName: string | null;
            createdAt: any;
            lineItems: Array<{
              id: string;
              group: string | null;
              moneyAmount: number | null;
              quantity: number | null;
              sku: string | null;
              upc: string | null;
              fuelGradeId: string | null;
              promotions: Array<{
                promotionAmount: number;
                promotionReason: string;
                promotionTitle: string;
                offer: {
                  id: string;
                  marketingContents: Array<{
                    id: string;
                    title: string | null;
                    shortDescription: string | null;
                  } | null>;
                } | null;
              }> | null;
              externalLineItemPromotions: Array<{ id: string; discountAmount: number; promotionReason: string }> | null;
            } | null>;
            location: {
              id: string;
              address1: string | null;
              address2: string | null;
              state: string | null;
              city: string | null;
              name: string | null;
              zipcode: string | null;
            } | null;
            paymentInfos: Array<{ tenderType: string | null; tenderSubtype: string | null }> | null;
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type CreateSurveyViewsMutationVariables = Exact<{
  input: SurveyViewsCreateInput;
}>;

export type CreateSurveyViewsMutation = { createSurveyViews: boolean };

export type DismissSurveyMutationVariables = Exact<{
  input: SurveyDismissInput;
}>;

export type DismissSurveyMutation = { surveyDismiss: boolean };

export type GetGuestSurveyQueryVariables = Exact<{
  guestSurveyId: Scalars['String']['input'];
}>;

export type GetGuestSurveyQuery = {
  guestSurvey:
    | {
        __typename: 'GeneralSurvey';
        uuid: string;
        questions: Array<
          | {
              __typename: 'SurveyQuestionIntSlider';
              min: number;
              max: number;
              uuid: string;
              index: number;
              questionText: string;
            }
          | {
              __typename: 'SurveyQuestionMultipleChoice';
              uuid: string;
              index: number;
              questionText: string;
              options: Array<{ uuid: string; index: number; label: string }>;
            }
          | {
              __typename: 'SurveyQuestionSingleChoice';
              uuid: string;
              index: number;
              questionText: string;
              options: Array<{ uuid: string; index: number; label: string }>;
            }
        >;
        configuration: { startDate: any; endDate: any | null };
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucheredOffer: {
                id: string;
                marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
              };
            }
          | null;
      }
    | {
        __typename: 'WalletSteeringSurvey';
        uuid: string;
        questions: Array<
          | {
              __typename: 'SurveyQuestionIntSlider';
              uuid: string;
              index: number;
              questionText: string;
              fields: Array<{ uuid: string }>;
            }
          | {
              __typename: 'SurveyQuestionMultipleChoice';
              uuid: string;
              index: number;
              questionText: string;
              fields: Array<{ uuid: string }>;
            }
          | {
              __typename: 'SurveyQuestionSingleChoice';
              uuid: string;
              index: number;
              questionText: string;
              fields: Array<{ uuid: string }>;
            }
        >;
        configuration: {
          steeringWalletUuid: string | null;
          questionText: string | null;
          steeringWalletUnitOfMeasure: UnitOfMeasure | null;
          maxUnits: number | null;
          minUnits: number | null;
        };
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucheredOffer: {
                id: string;
                marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
              };
            }
          | null;
      }
    | null;
};

export type GetSurveyQueryVariables = Exact<{
  uuid: Scalars['OCUUID']['input'];
}>;

export type GetSurveyQuery = {
  survey:
    | {
        __typename: 'GeneralSurvey';
        uuid: string;
        questions: Array<
          | {
              __typename: 'SurveyQuestionIntSlider';
              min: number;
              max: number;
              uuid: string;
              index: number;
              questionText: string;
            }
          | {
              __typename: 'SurveyQuestionMultipleChoice';
              uuid: string;
              index: number;
              questionText: string;
              options: Array<{ uuid: string; index: number; label: string }>;
            }
          | {
              __typename: 'SurveyQuestionSingleChoice';
              uuid: string;
              index: number;
              questionText: string;
              options: Array<{ uuid: string; index: number; label: string }>;
            }
        >;
        configuration: { startDate: any; endDate: any | null };
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucheredOffer: {
                id: string;
                marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
              };
            }
          | null;
      }
    | {
        __typename: 'WalletSteeringSurvey';
        uuid: string;
        questions: Array<
          | {
              __typename: 'SurveyQuestionIntSlider';
              uuid: string;
              index: number;
              questionText: string;
              fields: Array<{ uuid: string }>;
            }
          | {
              __typename: 'SurveyQuestionMultipleChoice';
              uuid: string;
              index: number;
              questionText: string;
              fields: Array<{ uuid: string }>;
            }
          | {
              __typename: 'SurveyQuestionSingleChoice';
              uuid: string;
              index: number;
              questionText: string;
              fields: Array<{ uuid: string }>;
            }
        >;
        configuration: {
          steeringWalletUuid: string | null;
          questionText: string | null;
          steeringWalletUnitOfMeasure: UnitOfMeasure | null;
          maxUnits: number | null;
          minUnits: number | null;
        };
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucheredOffer: {
                id: string;
                marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
              };
            }
          | null;
      };
};

export type GetSurveysQueryVariables = Exact<{
  filter?: InputMaybe<SurveyFilter>;
}>;

export type GetSurveysQuery = {
  surveys: {
    edges: Array<{
      cursor: any;
      node:
        | {
            __typename: 'GeneralSurvey';
            uuid: string;
            questions: Array<
              | {
                  __typename: 'SurveyQuestionIntSlider';
                  min: number;
                  max: number;
                  uuid: string;
                  index: number;
                  questionText: string;
                }
              | {
                  __typename: 'SurveyQuestionMultipleChoice';
                  uuid: string;
                  index: number;
                  questionText: string;
                  options: Array<{ uuid: string; index: number; label: string }>;
                }
              | {
                  __typename: 'SurveyQuestionSingleChoice';
                  uuid: string;
                  index: number;
                  questionText: string;
                  options: Array<{ uuid: string; index: number; label: string }>;
                }
            >;
            configuration: { startDate: any; endDate: any | null };
            award:
              | { __typename: 'AwardPoints'; points: number }
              | {
                  __typename: 'AwardVouchers';
                  voucheredOffer: {
                    id: string;
                    marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
                  };
                }
              | null;
          }
        | {
            __typename: 'WalletSteeringSurvey';
            uuid: string;
            questions: Array<
              | {
                  __typename: 'SurveyQuestionIntSlider';
                  uuid: string;
                  index: number;
                  questionText: string;
                  fields: Array<{ uuid: string }>;
                }
              | {
                  __typename: 'SurveyQuestionMultipleChoice';
                  uuid: string;
                  index: number;
                  questionText: string;
                  fields: Array<{ uuid: string }>;
                }
              | {
                  __typename: 'SurveyQuestionSingleChoice';
                  uuid: string;
                  index: number;
                  questionText: string;
                  fields: Array<{ uuid: string }>;
                }
            >;
            configuration: {
              steeringWalletUuid: string | null;
              questionText: string | null;
              steeringWalletUnitOfMeasure: UnitOfMeasure | null;
              maxUnits: number | null;
              minUnits: number | null;
            };
            award:
              | { __typename: 'AwardPoints'; points: number }
              | {
                  __typename: 'AwardVouchers';
                  voucheredOffer: {
                    id: string;
                    marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
                  };
                }
              | null;
          };
    }>;
  };
};

export type GetSurveysTotalCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetSurveysTotalCountQuery = { surveys: { totalCount: number } };

export type SubmitGuestSurveyAnswerMutationVariables = Exact<{
  input: GuestSurveyAnswerSendInput;
}>;

export type SubmitGuestSurveyAnswerMutation = { submitGuestSurveyAnswer: boolean };

export type SubmitGuestSurveyAnswersMutationVariables = Exact<{
  input: GuestSurveyAnswersSubmitInput;
}>;

export type SubmitGuestSurveyAnswersMutation = { submitGuestSurveyAnswers: boolean };

export type SubmitSurveyAnswerMutationVariables = Exact<{
  input: SurveyAnswerSendInput;
}>;

export type SubmitSurveyAnswerMutation = { submitSurveyAnswer: boolean };

export type SubmitSurveyAnswersMutationVariables = Exact<{
  input: SurveyAnswersSubmitInput;
}>;

export type SubmitSurveyAnswersMutation = { submitSurveyAnswers: boolean };

type BaseSurveyGeneralSurveyFragment = {
  __typename: 'GeneralSurvey';
  uuid: string;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucheredOffer: {
          id: string;
          marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
        };
      }
    | null;
};

type BaseSurveyWalletSteeringSurveyFragment = {
  __typename: 'WalletSteeringSurvey';
  uuid: string;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucheredOffer: {
          id: string;
          marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
        };
      }
    | null;
};

export type BaseSurveyFragment = BaseSurveyGeneralSurveyFragment | BaseSurveyWalletSteeringSurveyFragment;

type SurveyQuestionSurveyQuestionIntSliderFragment = {
  __typename: 'SurveyQuestionIntSlider';
  uuid: string;
  index: number;
  questionText: string;
};

type SurveyQuestionSurveyQuestionMultipleChoiceFragment = {
  __typename: 'SurveyQuestionMultipleChoice';
  uuid: string;
  index: number;
  questionText: string;
};

type SurveyQuestionSurveyQuestionSingleChoiceFragment = {
  __typename: 'SurveyQuestionSingleChoice';
  uuid: string;
  index: number;
  questionText: string;
};

export type SurveyQuestionFragment =
  | SurveyQuestionSurveyQuestionIntSliderFragment
  | SurveyQuestionSurveyQuestionMultipleChoiceFragment
  | SurveyQuestionSurveyQuestionSingleChoiceFragment;

type SurveyGeneralSurveyFragment = {
  __typename: 'GeneralSurvey';
  uuid: string;
  questions: Array<
    | {
        __typename: 'SurveyQuestionIntSlider';
        min: number;
        max: number;
        uuid: string;
        index: number;
        questionText: string;
      }
    | {
        __typename: 'SurveyQuestionMultipleChoice';
        uuid: string;
        index: number;
        questionText: string;
        options: Array<{ uuid: string; index: number; label: string }>;
      }
    | {
        __typename: 'SurveyQuestionSingleChoice';
        uuid: string;
        index: number;
        questionText: string;
        options: Array<{ uuid: string; index: number; label: string }>;
      }
  >;
  configuration: { startDate: any; endDate: any | null };
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucheredOffer: {
          id: string;
          marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
        };
      }
    | null;
};

type SurveyWalletSteeringSurveyFragment = {
  __typename: 'WalletSteeringSurvey';
  uuid: string;
  questions: Array<
    | {
        __typename: 'SurveyQuestionIntSlider';
        uuid: string;
        index: number;
        questionText: string;
        fields: Array<{ uuid: string }>;
      }
    | {
        __typename: 'SurveyQuestionMultipleChoice';
        uuid: string;
        index: number;
        questionText: string;
        fields: Array<{ uuid: string }>;
      }
    | {
        __typename: 'SurveyQuestionSingleChoice';
        uuid: string;
        index: number;
        questionText: string;
        fields: Array<{ uuid: string }>;
      }
  >;
  configuration: {
    steeringWalletUuid: string | null;
    questionText: string | null;
    steeringWalletUnitOfMeasure: UnitOfMeasure | null;
    maxUnits: number | null;
    minUnits: number | null;
  };
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucheredOffer: {
          id: string;
          marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
        };
      }
    | null;
};

export type SurveyFragment = SurveyGeneralSurveyFragment | SurveyWalletSteeringSurveyFragment;

export type WalletSteeringSurveyFragment = {
  __typename: 'WalletSteeringSurvey';
  uuid: string;
  questions: Array<
    | {
        __typename: 'SurveyQuestionIntSlider';
        uuid: string;
        index: number;
        questionText: string;
        fields: Array<{ uuid: string }>;
      }
    | {
        __typename: 'SurveyQuestionMultipleChoice';
        uuid: string;
        index: number;
        questionText: string;
        fields: Array<{ uuid: string }>;
      }
    | {
        __typename: 'SurveyQuestionSingleChoice';
        uuid: string;
        index: number;
        questionText: string;
        fields: Array<{ uuid: string }>;
      }
  >;
  configuration: {
    steeringWalletUuid: string | null;
    questionText: string | null;
    steeringWalletUnitOfMeasure: UnitOfMeasure | null;
    maxUnits: number | null;
    minUnits: number | null;
  };
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucheredOffer: {
          id: string;
          marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
        };
      }
    | null;
};

export type GeneralSurveyFragment = {
  __typename: 'GeneralSurvey';
  uuid: string;
  questions: Array<
    | {
        __typename: 'SurveyQuestionIntSlider';
        min: number;
        max: number;
        uuid: string;
        index: number;
        questionText: string;
      }
    | {
        __typename: 'SurveyQuestionMultipleChoice';
        uuid: string;
        index: number;
        questionText: string;
        options: Array<{ uuid: string; index: number; label: string }>;
      }
    | {
        __typename: 'SurveyQuestionSingleChoice';
        uuid: string;
        index: number;
        questionText: string;
        options: Array<{ uuid: string; index: number; label: string }>;
      }
  >;
  configuration: { startDate: any; endDate: any | null };
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucheredOffer: {
          id: string;
          marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
        };
      }
    | null;
};

export type AwardVouchersSurveyFragment = {
  __typename: 'AwardVouchers';
  voucheredOffer: {
    id: string;
    marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
  };
};

export type TransactionsWithOfferFulfillmentQueryVariables = Exact<{
  size: Scalars['Int']['input'];
}>;

export type TransactionsWithOfferFulfillmentQuery = {
  customer: {
    uuid: string;
    membership: {
      id: string;
      transactions: {
        edges: Array<{
          node: {
            id: string;
            createdAt: any;
            offerFulfillments: Array<{
              id: string;
              fulfillmentCount: number;
              fulfilledOffer: {
                id: string;
                earningMechanism:
                  | { __typename: 'EarningMechanismExternalFulfillment'; id: string }
                  | { __typename: 'EarningMechanismLoyaltyEvent'; id: string }
                  | { __typename: 'EarningMechanismMembershipEvent'; id: string }
                  | { __typename: 'EarningMechanismPointSpend'; id: string }
                  | { __typename: 'EarningMechanismProductDiscount'; id: string }
                  | { __typename: 'EarningMechanismProductPurchase'; id: string }
                  | { __typename: 'EarningMechanismPromocodes' }
                  | { __typename: 'EarningMechanismSpinWheelGame' }
                  | { __typename: 'EarningMechanismTotalEligiblePurchase'; id: string }
                  | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime'; id: string }
                  | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
                  | { __typename: 'EarningMechanismTotalSpendOverTime'; id: string }
                  | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
                  | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
                  | { __typename: 'EarningMechanismVarietyPurchase'; id: string }
                  | { __typename: 'EarningMechanismVarietyPurchaseOverTime'; id: string }
                  | { __typename: 'EarningMechanismVisits'; id: string }
                  | null;
              } | null;
            }> | null;
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type TransactionWithOfferFulfillmentFragment = {
  id: string;
  createdAt: any;
  offerFulfillments: Array<{
    id: string;
    fulfillmentCount: number;
    fulfilledOffer: {
      id: string;
      earningMechanism:
        | { __typename: 'EarningMechanismExternalFulfillment'; id: string }
        | { __typename: 'EarningMechanismLoyaltyEvent'; id: string }
        | { __typename: 'EarningMechanismMembershipEvent'; id: string }
        | { __typename: 'EarningMechanismPointSpend'; id: string }
        | { __typename: 'EarningMechanismProductDiscount'; id: string }
        | { __typename: 'EarningMechanismProductPurchase'; id: string }
        | { __typename: 'EarningMechanismPromocodes' }
        | { __typename: 'EarningMechanismSpinWheelGame' }
        | { __typename: 'EarningMechanismTotalEligiblePurchase'; id: string }
        | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime'; id: string }
        | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
        | { __typename: 'EarningMechanismTotalSpendOverTime'; id: string }
        | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
        | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
        | { __typename: 'EarningMechanismVarietyPurchase'; id: string }
        | { __typename: 'EarningMechanismVarietyPurchaseOverTime'; id: string }
        | { __typename: 'EarningMechanismVisits'; id: string }
        | null;
    } | null;
  }> | null;
};

export type OfferFulfillmentFragment = {
  id: string;
  fulfillmentCount: number;
  fulfilledOffer: {
    id: string;
    earningMechanism:
      | { __typename: 'EarningMechanismExternalFulfillment'; id: string }
      | { __typename: 'EarningMechanismLoyaltyEvent'; id: string }
      | { __typename: 'EarningMechanismMembershipEvent'; id: string }
      | { __typename: 'EarningMechanismPointSpend'; id: string }
      | { __typename: 'EarningMechanismProductDiscount'; id: string }
      | { __typename: 'EarningMechanismProductPurchase'; id: string }
      | { __typename: 'EarningMechanismPromocodes' }
      | { __typename: 'EarningMechanismSpinWheelGame' }
      | { __typename: 'EarningMechanismTotalEligiblePurchase'; id: string }
      | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime'; id: string }
      | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
      | { __typename: 'EarningMechanismTotalSpendOverTime'; id: string }
      | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
      | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
      | { __typename: 'EarningMechanismVarietyPurchase'; id: string }
      | { __typename: 'EarningMechanismVarietyPurchaseOverTime'; id: string }
      | { __typename: 'EarningMechanismVisits'; id: string }
      | null;
  } | null;
};

export type FulfilledOfferFragment = {
  id: string;
  earningMechanism:
    | { __typename: 'EarningMechanismExternalFulfillment'; id: string }
    | { __typename: 'EarningMechanismLoyaltyEvent'; id: string }
    | { __typename: 'EarningMechanismMembershipEvent'; id: string }
    | { __typename: 'EarningMechanismPointSpend'; id: string }
    | { __typename: 'EarningMechanismProductDiscount'; id: string }
    | { __typename: 'EarningMechanismProductPurchase'; id: string }
    | { __typename: 'EarningMechanismPromocodes' }
    | { __typename: 'EarningMechanismSpinWheelGame' }
    | { __typename: 'EarningMechanismTotalEligiblePurchase'; id: string }
    | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime'; id: string }
    | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
    | { __typename: 'EarningMechanismTotalSpendOverTime'; id: string }
    | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
    | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
    | { __typename: 'EarningMechanismVarietyPurchase'; id: string }
    | { __typename: 'EarningMechanismVarietyPurchaseOverTime'; id: string }
    | { __typename: 'EarningMechanismVisits'; id: string }
    | null;
};

export type AuthPayloadFragment = {
  __typename: 'AuthPayload';
  tokens: { accessToken: string; refreshToken: string } | null;
};

export type CustomerOtpPayloadFragment = { __typename: 'CustomerOTPPayload'; session: string | null; success: boolean };

export type CreateOtpSessionByPlatformMutationVariables = Exact<{
  input: CreateOtpSessionInput;
}>;

export type CreateOtpSessionByPlatformMutation = { createOTPSessionByPlatform: { session: string } };

export type GetAccessTokenByRefreshTokenMutationVariables = Exact<{
  input: AccessTokenByRefreshTokenInput;
}>;

export type GetAccessTokenByRefreshTokenMutation = {
  getAccessTokenByRefreshToken: { accessToken: string; refreshToken: string } | null;
};

export type RequestMagicLinkMutationVariables = Exact<{
  input: MagicLinkRequestInput;
}>;

export type RequestMagicLinkMutation = { requestMagicLink: boolean };

export type SignupWithOtpMutationVariables = Exact<{
  input: Otp;
}>;

export type SignupWithOtpMutation = {
  exchangeSessionAndOTPToAuthToken:
    | { __typename: 'ExchangeSessionAndOTPToAuthTokenResultFailedIncorrectOTP'; success: boolean }
    | {
        __typename: 'ExchangeSessionAndOTPToAuthTokenResultSuccess';
        success: boolean;
        tokens: { accessToken: string; refreshToken: string };
      };
};

export type SignupWithOtpSuccessFragment = { success: boolean; tokens: { accessToken: string; refreshToken: string } };

export type SignupWithOtpIncorrectOtpFragment = { success: boolean };

export type SignupWithTokenMutationVariables = Exact<{
  input: MagicLinkExchangeSessionIdToAuthTokenInput;
}>;

export type SignupWithTokenMutation = { signupWithToken: { tokens: { accessToken: string; refreshToken: string } } };

export type CommunicationPreferenceUpdateMutationVariables = Exact<{
  input: CommunicationPreferenceUpdateInput;
}>;

export type CommunicationPreferenceUpdateMutation = {
  preference: { smsOptIn: boolean; pushOptIn: boolean; smsOptOutReason: SmsOptOutReason | null };
};

export type CommunicationPreferenceFragment = {
  smsOptIn: boolean;
  pushOptIn: boolean;
  smsOptOutReason: SmsOptOutReason | null;
};

export type GetAppConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetAppConfigQuery = {
  appConfig: {
    brandUuid: string;
    chainId: string;
    userExperience: { offers: { gridLocation: OffersGridLocation; tabNavbarIcon: OffersTabNavbarIcon | null } };
    termsConditions: { activeAt: any | null; name: string; url: any | null; uuid: string };
    privacyPolicy: { activeAt: any | null; name: string; url: any | null; uuid: string };
    support: {
      email: string;
      phoneNumber: string | null;
      widget:
        | { __typename: 'DevRevSupportWidgetConfiguration'; enabled: boolean; appId: string }
        | {
            __typename: 'FreshdeskSupportWidgetConfiguration';
            enabled: boolean;
            widgetId: string | null;
            token: string | null;
            host: string | null;
            sdkUrl: string | null;
          }
        | null;
    };
    loyaltyProgram: {
      pointsStrategy: PointsStrategy;
      homePageOffersLimit: number;
      redeemOfferWithCompletedProfileOnly: boolean;
      membershipMinAge: number;
      isExplicitTermsAcceptanceRequired: boolean;
      isExplicitSmsPromotionAcceptanceEnabled: boolean;
      isPromocodesEnabled: boolean;
      pointExpiration: { strategy: PointExpirationStrategy; notificationDays: number | null };
      referralProgramConfig: {
        __typename: 'ReferralProgramConfiguration';
        referralProgramEnabled: boolean;
        referralCodeManualEntryEnabled: boolean;
        receiverConfiguration: { instructions: string };
      } | null;
    };
    payAtPump: { enabled: boolean };
    payInside: { enabled: boolean };
    applePay: {
      merchantId: string;
      supportedNetworks: Array<ApplePayCardNetwork>;
      allowCreditCards: boolean;
      merchantName: string | null;
      allowPrepaidCards: boolean;
      isBillingZipCodeCollectionEnabled: boolean;
    } | null;
    googlePay: {
      environment: GooglePayEnvironment;
      gateway: string;
      merchantId: string;
      merchantName: string | null;
      allowedCardNetworks: Array<GooglePayCardNetwork>;
      allowPrepaidCards: boolean;
      allowCreditCards: boolean;
      gatewayMerchantId: string;
      isBillingZipCodeCollectionEnabled: boolean;
    } | null;
    kount: { merchantId: number; collectorHostname: string; environment: KountEnvironment } | null;
    pinCode: { blockingDuration: number; attemptThrottle: number; maxAttempts: number };
    wallet: { enabled: boolean };
    deleteAccount: { enabled: boolean; deleteAccountMutation: DeleteAccountMutation };
    paymentProvider:
      | { __typename: 'FiservConfiguration'; customData: any | null }
      | { __typename: 'ParPayConfiguration'; customData: any | null }
      | {
          __typename: 'WorldpayConfiguration';
          customData: any | null;
          eProtectPayPageId: string;
          eProtectGooglePayPageId: string;
          eProtectWebSdkApiUrl: string;
          eProtectWebSdkUrl: string;
        }
      | null;
    paymentWallet: { maxInstruments: number; allowedAccountTypes: Array<PaymentAccountType> };
    communicationPreference: { enabled: boolean; isSmsOptInConfigurable: boolean; isPushOptInConfigurable: boolean };
    eaivAgeVerification: { enabled: boolean };
    eaivIdentityVerification: { enabled: boolean };
    productInterests: { enabled: boolean; isEAIVPromotionOnProfileCompletedEnabled: boolean };
    appRating: { enabled: boolean; promptIntervalDays: number; transactionHistoryLookupDays: number };
    auth: { primaryMethod: AuthMethod; otp: { enabled: boolean; channels: Array<OtpChannel> } };
    rudderStack: { enabled: boolean };
    totalAvailableRollback: { enabled: boolean };
    totalPointsEarned: { enabled: boolean } | null;
    smsOptIn: {
      enabled: boolean;
      modalAppearanceDelaySeconds: number;
      modalOfferLoyaltyEventName: string;
      optInAcceptedLoyaltyEventName: string;
      optInRejectedLoyaltyEventName: string;
    };
    mobilePaymentsReceiptsView: { enabled: boolean };
    storeLocator: {
      fuelPricesMode: FuelPricesMode;
      googleMapsApiKey: string;
      defaultLocation: { latitude: number; longitude: number };
    };
    smsOptedOutWarning: { enabled: boolean; smsOptInPhoneNumber: string; smsOptInKeyword: string };
    orderAhead: {
      enabled: boolean;
      navbar: { icon: OrderAheadConfigurationNavbarIcon; text: string };
      provider:
        | { __typename: 'OrderAheadConfigurationProviderOlo' }
        | { __typename: 'OrderAheadConfigurationProviderVroom'; urlTemplate: string };
    } | null;
    externalIdentityVerification: { enabled: boolean; provider: ExternalIdentityVerificationProvider } | null;
    personalDataShareOptOut: { enabled: boolean; optOutUrl: string } | null;
    appsFlyer: { enabled: boolean; appId: string; devKey: string; webDevKey: string | null } | null;
    localOffers: { enabled: boolean; radiusInMeters: number } | null;
    spireEnrollment: { enabled: boolean; iframeUrl: string; partnerId: string | null } | null;
    cookieConsent: {
      __typename: 'CookiebotCookieConsentConfiguration';
      enabled: boolean;
      consentEditingEnabled: boolean;
      sdkUrl: string;
    } | null;
    loyaltyIdBarcode: { enabled: boolean } | null;
  };
};

export type OrderAheadConfigurationProviderVroomFragment = {
  __typename: 'OrderAheadConfigurationProviderVroom';
  urlTemplate: string;
};

export type OrderAheadConfigurationProviderOloFragment = { __typename: 'OrderAheadConfigurationProviderOlo' };

export type EaivAgeVerificationStartMutationVariables = Exact<{
  input: EaivAgeVerificationStartInput;
}>;

export type EaivAgeVerificationStartMutation = {
  result:
    | { __typename: 'EaivAgeVerificationRequireAdditionalPrompt'; prompt: EaivAdditionalPromptFields }
    | { __typename: 'EaivAgeVerificationResultFailed'; reason: EaivAgeVerificationFailed | null }
    | { __typename: 'EaivAgeVerificationStartResultSuccess'; status: EaivAgeVerificationRequestStatusType };
};

export type AgeVerificationRequireAdditionalPromptFragment = { prompt: EaivAdditionalPromptFields };

export type EaivIdentityVerificationStartMutationVariables = Exact<{
  input: EaivIdentityVerificationStartInput;
}>;

export type EaivIdentityVerificationStartMutation = {
  result:
    | { __typename: 'EaivIdentityVerificationRequireAdditionalPrompt'; prompt: EaivAdditionalPromptFields }
    | { __typename: 'EaivIdentityVerificationResultFailed'; reason: EaivIdentityVerificationFailed | null }
    | {
        __typename: 'EaivIdentityVerificationStartResultSuccess';
        conversationId: string;
        questionSet: {
          id: string;
          questions: Array<{
            __typename: 'EaivIdentityVerificationChoiceQuestion';
            id: string;
            text: string;
            helpText: string | null;
            choices: Array<{ id: string; text: string }>;
          }>;
        };
      };
};

export type IdentityVerificationStartResultSuccessFragment = {
  conversationId: string;
  questionSet: {
    id: string;
    questions: Array<{
      __typename: 'EaivIdentityVerificationChoiceQuestion';
      id: string;
      text: string;
      helpText: string | null;
      choices: Array<{ id: string; text: string }>;
    }>;
  };
};

export type IdentityVerificationQuestionSetFragment = {
  id: string;
  questions: Array<{
    __typename: 'EaivIdentityVerificationChoiceQuestion';
    id: string;
    text: string;
    helpText: string | null;
    choices: Array<{ id: string; text: string }>;
  }>;
};

export type IdentityVerificationChoiceQuestionFragment = {
  id: string;
  text: string;
  helpText: string | null;
  choices: Array<{ id: string; text: string }>;
};

export type IdentityVerificationChoiceQuestionOptionFragment = { id: string; text: string };

export type IdentityVerificationRequireAdditionalPromptFragment = { prompt: EaivAdditionalPromptFields };

export type EaivIdentityVerificationSubmitMutationVariables = Exact<{
  input: EaivIdentityVerificationSubmitInput;
}>;

export type EaivIdentityVerificationSubmitMutation = {
  result:
    | { __typename: 'EaivIdentityVerificationResultFailed'; reason: EaivIdentityVerificationFailed | null }
    | {
        __typename: 'EaivIdentityVerificationSubmitResultContinue';
        conversationId: string;
        questionSet: {
          id: string;
          questions: Array<{
            __typename: 'EaivIdentityVerificationChoiceQuestion';
            id: string;
            text: string;
            helpText: string | null;
            choices: Array<{ id: string; text: string }>;
          }>;
        };
      }
    | { __typename: 'EaivIdentityVerificationSubmitResultSuccess'; status: EaivIdentityVerificationRequestStatusType };
};

export type IdentityVerificationStartResultContinueFragment = {
  conversationId: string;
  questionSet: {
    id: string;
    questions: Array<{
      __typename: 'EaivIdentityVerificationChoiceQuestion';
      id: string;
      text: string;
      helpText: string | null;
      choices: Array<{ id: string; text: string }>;
    }>;
  };
};

export type FuelProductGroupFragment = { id: string; productGroup: { id: string; name: string } };

export type FuelProductGroupsQueryVariables = Exact<{
  filter?: InputMaybe<FuelProductGroupFilter>;
}>;

export type FuelProductGroupsQuery = {
  fuelProductGroups: Array<{ id: string; productGroup: { id: string; name: string } }> | null;
};

export type ExecuteSpinWheelGameMutationVariables = Exact<{
  offerId: Scalars['ID']['input'];
}>;

export type ExecuteSpinWheelGameMutation = {
  result: {
    sequenceNumber: number;
    awardType: RandomAwardType;
    award:
      | { __typename: 'AwardPoints'; points: number }
      | {
          __typename: 'AwardVouchers';
          voucherExpirationDays: number | null;
          voucheredOffer: {
            __typename: 'Offer';
            id: string;
            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
            marketingContents: Array<{
              id: string;
              imageUrl: any | null;
              title: string | null;
              shortDescription: string | null;
              longDescription: string | null;
              disclaimer: string | null;
              disclaimerUrl: any | null;
              terms: string | null;
              termsUrl: any | null;
              surgeonGeneralsWarning: string | null;
              externalUrl: string | null;
            } | null>;
          };
        }
      | null;
  } | null;
};

export type GetDisplayCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<DisplayCategoryFilter>;
}>;

export type GetDisplayCategoriesQuery = {
  displayCategories: {
    edges: Array<{
      node: {
        id: string;
        name: string;
        rank: number;
        categoryRestrictions: CategoryRestrictions | null;
        bannerIds: Array<string> | null;
      };
    }>;
  };
};

export type DisplayCategoryFragment = {
  id: string;
  name: string;
  rank: number;
  categoryRestrictions: CategoryRestrictions | null;
  bannerIds: Array<string> | null;
};

export type ProductCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<ProductCategoryFilter>;
}>;

export type ProductCategoriesQuery = {
  productCategories: {
    edges: Array<{
      node: { id: string; name: string; rank: number; categoryRestriction: CategoryRestrictions | null };
    }>;
  };
};

export type ProductCategoryFragment = {
  id: string;
  name: string;
  rank: number;
  categoryRestriction: CategoryRestrictions | null;
};

export type DeviceTokenRegisterMutationVariables = Exact<{
  input: DeviceTokenRegisterInput;
}>;

export type DeviceTokenRegisterMutation = { deviceTokenRegister: boolean };

export type StoreDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type StoreDetailsQuery = {
  stores: {
    edges: Array<{
      node: {
        uuid: string;
        utcOffset: number | null;
        openStatus: LocationOpenStatus;
        fuelPriceState: FuelPriceState | null;
        address: {
          city: string;
          street1: string;
          street2: string | null;
          state: string;
          zipCode: string;
          geoLocation: { latitude: number; longitude: number } | null;
        } | null;
        fuelGradePrices: Array<{ description: string; unitPrice: { cashPrice: number; creditPrice: number } | null }>;
        hoursOfOperationGroup: { hours: Array<{ dayOfWeek: Weekday; openTime: any; closeTime: any }> } | null;
        phoneNumbers: Array<{ alias: string | null; phoneNumber: any; phoneType: PhoneType; uuid: string }>;
        attributes: Array<{ description: string | null; name: string; value: string }>;
      };
    }> | null;
  } | null;
};

export type StoreLocationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type StoreLocationsQuery = {
  stores: {
    pageInfo: { endCursor: string | null; hasNextPage: boolean; hasPreviousPage: boolean; startCursor: string | null };
    edges: Array<{
      node: {
        uuid: string;
        fuelPriceState: FuelPriceState | null;
        address: {
          city: string;
          street1: string;
          street2: string | null;
          state: string;
          zipCode: string;
          geoLocation: { latitude: number; longitude: number } | null;
        } | null;
        fuelGradePrices: Array<{ description: string; unitPrice: { cashPrice: number; creditPrice: number } | null }>;
      };
    }> | null;
  } | null;
};

export type StorePumpInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type StorePumpInfoQuery = {
  stores: {
    edges: Array<{
      node: {
        uuid: string;
        address: {
          city: string;
          street1: string;
          street2: string | null;
          state: string;
          zipCode: string;
          geoLocation: { latitude: number; longitude: number } | null;
        } | null;
        siteSystemConfiguration: Array<{
          uuid: string;
          identifier: string;
          details: {
            carWashDetails: Array<{
              description: string | null;
              posCode: string;
              posCodeModifier: string;
              productCode: string;
              unitPrice: number;
            }>;
            fuelConfigDetails: Array<{
              outdoorPosition: string | null;
              description: string | null;
              posCode: string;
              posCodeFormat: string | null;
              productCode: string;
            }>;
          } | null;
        }>;
      };
    }> | null;
  } | null;
};

export type StoreAddressFragment = {
  city: string;
  street1: string;
  street2: string | null;
  state: string;
  zipCode: string;
  geoLocation: { latitude: number; longitude: number } | null;
};

export type StoreFuelGradeFragment = {
  description: string;
  unitPrice: { cashPrice: number; creditPrice: number } | null;
};

export type StoreWorkingHoursFragment = { hours: Array<{ dayOfWeek: Weekday; openTime: any; closeTime: any }> };

export type StorePhoneNumberFragment = { alias: string | null; phoneNumber: any; phoneType: PhoneType; uuid: string };

export type StoreAttributeFragment = { description: string | null; name: string; value: string };

export type StorePumpConfigFragment = {
  outdoorPosition: string | null;
  description: string | null;
  posCode: string;
  posCodeFormat: string | null;
  productCode: string;
};

export type StoreCarWashItemFragment = {
  description: string | null;
  posCode: string;
  posCodeModifier: string;
  productCode: string;
  unitPrice: number;
};

export type StoreConfigurationFragment = {
  uuid: string;
  identifier: string;
  details: {
    carWashDetails: Array<{
      description: string | null;
      posCode: string;
      posCodeModifier: string;
      productCode: string;
      unitPrice: number;
    }>;
    fuelConfigDetails: Array<{
      outdoorPosition: string | null;
      description: string | null;
      posCode: string;
      posCodeFormat: string | null;
      productCode: string;
    }>;
  } | null;
};

export type StorePumpInfoFragment = {
  uuid: string;
  address: {
    city: string;
    street1: string;
    street2: string | null;
    state: string;
    zipCode: string;
    geoLocation: { latitude: number; longitude: number } | null;
  } | null;
  siteSystemConfiguration: Array<{
    uuid: string;
    identifier: string;
    details: {
      carWashDetails: Array<{
        description: string | null;
        posCode: string;
        posCodeModifier: string;
        productCode: string;
        unitPrice: number;
      }>;
      fuelConfigDetails: Array<{
        outdoorPosition: string | null;
        description: string | null;
        posCode: string;
        posCodeFormat: string | null;
        productCode: string;
      }>;
    } | null;
  }>;
};

export type GetTotalAvailableRollbackMoneyAmountQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalAvailableRollbackMoneyAmountQuery = {
  customer: {
    uuid: string;
    membership: {
      id: string;
      totalAvailableRollback: {
        locationUuid: string | null;
        moneyAmount: number;
        fuelProductGroup: { id: string } | null;
      } | null;
    } | null;
  } | null;
};

export type GetTotalAvailableRollbackQueryVariables = Exact<{
  offerLimitsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  offerVouchersIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  availableAtLocationsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  constraintsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetTotalAvailableRollbackQuery = {
  customer: {
    uuid: string;
    membership: {
      id: string;
      totalAvailableRollback: {
        locationUuid: string | null;
        locationName: string | null;
        moneyAmount: number;
        fuelProductGroup: { id: string; productGroup: { id: string; name: string } } | null;
        offers: Array<{
          __typename: 'Offer';
          id: string;
          expireAt: any | null;
          engagementType: OfferEngagementType | null;
          activationStatus: OfferActivationStatus;
          visibleStatus: OfferVisibleStatus;
          ineligibilityReason: IneligibilityReason | null;
          customData: any | null;
          voucherCount: number;
          presentationPriority: OfferPresentationPriority;
          presentationType: OfferPresentationType;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
          marketingContents: Array<{
            id: string;
            imageUrl: any | null;
            title: string | null;
            shortDescription: string | null;
            longDescription: string | null;
            disclaimer: string | null;
            disclaimerUrl: any | null;
            terms: string | null;
            termsUrl: any | null;
            surgeonGeneralsWarning: string | null;
            externalUrl: string | null;
          } | null>;
          earningMechanism:
            | {
                __typename: 'EarningMechanismExternalFulfillment';
                id: string;
                optionalAward:
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    }
                  | null;
              }
            | {
                __typename: 'EarningMechanismLoyaltyEvent';
                id: string;
                optionalAward:
                  | { __typename: 'AwardExternalPoints' }
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    }
                  | null;
              }
            | {
                __typename: 'EarningMechanismMembershipEvent';
                id: string;
                award:
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    };
              }
            | {
                __typename: 'EarningMechanismPointSpend';
                id: string;
                pointCost: number;
                award: {
                  __typename: 'AwardVouchers';
                  voucherExpirationDays: number | null;
                  voucherCount: number;
                  voucheredOffer: {
                    id: string;
                    voucherCount: number;
                    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                  };
                };
              }
            | { __typename: 'EarningMechanismProductDiscount'; id: string }
            | {
                __typename: 'EarningMechanismProductPurchase';
                id: string;
                award:
                  | { __typename: 'AwardExternal' }
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    };
              }
            | { __typename: 'EarningMechanismPromocodes' }
            | {
                __typename: 'EarningMechanismSpinWheelGame';
                id: string;
                awards: Array<{
                  awardType: RandomAwardType;
                  limit: number;
                  sequenceNumber: number;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucheredOffer: {
                          __typename: 'Offer';
                          id: string;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                          marketingContents: Array<{
                            id: string;
                            imageUrl: any | null;
                            title: string | null;
                            shortDescription: string | null;
                            longDescription: string | null;
                            disclaimer: string | null;
                            disclaimerUrl: any | null;
                            terms: string | null;
                            termsUrl: any | null;
                            surgeonGeneralsWarning: string | null;
                            externalUrl: string | null;
                          } | null>;
                        };
                      }
                    | null;
                }>;
                purchasableOffer: {
                  __typename: 'Offer';
                  id: string;
                  trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                  earningMechanism:
                    | { __typename: 'EarningMechanismExternalFulfillment' }
                    | { __typename: 'EarningMechanismLoyaltyEvent' }
                    | { __typename: 'EarningMechanismMembershipEvent' }
                    | { __typename: 'EarningMechanismPointSpend'; id: string; pointCost: number }
                    | { __typename: 'EarningMechanismProductDiscount' }
                    | { __typename: 'EarningMechanismProductPurchase' }
                    | { __typename: 'EarningMechanismPromocodes' }
                    | { __typename: 'EarningMechanismSpinWheelGame' }
                    | { __typename: 'EarningMechanismTotalEligiblePurchase' }
                    | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' }
                    | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
                    | { __typename: 'EarningMechanismTotalSpendOverTime' }
                    | { __typename: 'EarningMechanismTransactionDiscount' }
                    | { __typename: 'EarningMechanismVarietyDiscount' }
                    | { __typename: 'EarningMechanismVarietyPurchase' }
                    | { __typename: 'EarningMechanismVarietyPurchaseOverTime' }
                    | { __typename: 'EarningMechanismVisits' }
                    | null;
                } | null;
              }
            | {
                __typename: 'EarningMechanismTotalEligiblePurchase';
                id: string;
                award: { __typename: 'AwardPointsPer'; points: number; rounding: AwardPointsRoundingStrategy };
              }
            | {
                __typename: 'EarningMechanismTotalEligiblePurchaseOverTime';
                id: string;
                purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
                award:
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    };
              }
            | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
            | {
                __typename: 'EarningMechanismTotalSpendOverTime';
                id: string;
                purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
                award:
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    };
              }
            | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
            | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
            | {
                __typename: 'EarningMechanismVarietyPurchase';
                id: string;
                award:
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    };
              }
            | {
                __typename: 'EarningMechanismVarietyPurchaseOverTime';
                id: string;
                varietyMemberProgress: Array<{ quantityPurchased: number; quantityRequired: number }>;
                award:
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    };
                products: Array<{
                  __typename: 'EarningMechanismProductCriteria';
                  countProductsBy: EarningMechanismProductCountingAttribute;
                }>;
              }
            | {
                __typename: 'EarningMechanismVisits';
                id: string;
                visitsMemberProgress: { visits: number; visitsRequired: number } | null;
                award:
                  | { __typename: 'AwardPoints'; points: number }
                  | {
                      __typename: 'AwardVouchers';
                      voucherExpirationDays: number | null;
                      voucherCount: number;
                      voucheredOffer: {
                        id: string;
                        voucherCount: number;
                        trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                      };
                    };
              }
            | null;
          vouchers?: {
            edges: Array<{ node: { id: string; expireAt: any | null; createdAt: any; state: VoucherState } }>;
          };
          displayCategories: Array<{
            id: string;
            name: string;
            rank: number;
            categoryRestrictions: CategoryRestrictions | null;
            bannerIds: Array<string> | null;
          }>;
          limits?: Array<
            | { __typename: 'LimitGlobalActivation'; id: string }
            | { __typename: 'LimitGlobalActivationInTime'; id: string }
            | { __typename: 'LimitGlobalAwardCount'; id: string }
            | { __typename: 'LimitGlobalAwardCountInTime'; id: string }
            | { __typename: 'LimitInTransactionAwardCount'; id: string }
            | { __typename: 'LimitInTransactionProgress'; id: string }
            | { __typename: 'LimitMembershipActivation'; id: string }
            | { __typename: 'LimitMembershipActivationInTime'; id: string }
            | {
                __typename: 'LimitMembershipAwardCount';
                id: string;
                limit: number;
                membershipQuantityAvailable: number | null;
              }
            | {
                __typename: 'LimitMembershipAwardCountInTime';
                id: string;
                limit: number;
                membershipQuantityAvailable: number | null;
              }
            | { __typename: 'LimitMembershipProgressInTime'; id: string }
            | { __typename: 'LimitMembershipTransactionCount'; id: string }
            | { __typename: 'LimitMembershipTransactionCountInTime'; id: string }
          >;
          availableAtLocations: Array<{
            uuid: string;
            name?: string | null;
            address?: {
              city: string;
              street1: string;
              street2: string | null;
              state: string;
              zipCode: string;
              geoLocation: { latitude: number; longitude: number } | null;
            } | null;
          }> | null;
          constraints?: Array<
            | { __typename: 'ConstraintDaysOfWeek' }
            | { __typename: 'ConstraintEmailRequired' }
            | { __typename: 'ConstraintInAudience' }
            | { __typename: 'ConstraintLocationInState' }
            | { __typename: 'ConstraintOrderAheadOnly' }
            | { __typename: 'ConstraintPaymentInstrument' }
            | { __typename: 'ConstraintPaymentMethod' }
            | { __typename: 'ConstraintPreAuth' }
            | { __typename: 'ConstraintPurchasableEligibility' }
            | { __typename: 'ConstraintPurchaseThreshold' }
            | { __typename: 'ConstraintRequiresActivation' }
            | { __typename: 'ConstraintRequiresTransactionVoucher' }
            | { __typename: 'ConstraintRequiresVoucher' }
            | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount' }
            | { __typename: 'ConstraintStoreLocation'; id: string }
            | { __typename: 'ConstraintStoreLocationGroup'; id: string }
            | { __typename: 'ConstraintSubBrand' }
            | { __typename: 'ConstraintTimeOfDay' }
          >;
        }> | null;
      } | null;
    } | null;
  } | null;
};

export type LoyaltyActivateTransactionItemFragment = {
  id: string;
  createdAt: any;
  totalAmount: number | null;
  totalAmountWithoutDiscounts: number | null;
  vendorName: string | null;
  status: ActivateTransactionStatus | null;
};

export type LoyaltyPointChangeItemFragment = {
  id: string;
  type: PointChangeType | null;
  createdAt: any;
  quantity: number;
  notes: string | null;
  offer: { id: string; name: string } | null;
  source:
    | { __typename: 'ActivateTransaction'; id: string }
    | { __typename: 'ActivateUser'; id: string }
    | { __typename: 'Chain'; id: string }
    | { __typename: 'CommandCenterUser' }
    | { __typename: 'GameSession' }
    | { __typename: 'LoyaltyEvent'; eventType: string; createdAt: any }
    | {
        __typename: 'OfferPurchase';
        purchasedWith: {
          id: string;
          name: string;
          marketingContents: Array<{ id: string; title: string | null } | null>;
        };
      }
    | {
        __typename: 'PointChange';
        id: string;
        offer: {
          id: string;
          name: string;
          marketingContents: Array<{ id: string; title: string | null } | null>;
        } | null;
      }
    | { __typename: 'PromocodeUseRequest' }
    | null;
};

export type LoyaltyActivitySourceChainFragment = { id: string };

export type LoyaltyActivitySourceActivateUserFragment = { id: string };

export type LoyaltyActivitySourceLoyaltyEventFragment = { eventType: string; createdAt: any };

export type LoyaltyActivitySourceActivateTransactionFragment = { id: string };

export type LoyaltyActivitySourceOfferPurchaseFragment = {
  purchasedWith: { id: string; name: string; marketingContents: Array<{ id: string; title: string | null } | null> };
};

export type LoyaltyActivitySourcePointChangeFragment = {
  id: string;
  offer: { id: string; name: string; marketingContents: Array<{ id: string; title: string | null } | null> } | null;
};

export type LoyaltyActionHistoryQueryVariables = Exact<{
  size: Scalars['Int']['input'];
  transactionCursor?: InputMaybe<Scalars['String']['input']>;
  pointChangeCursor?: InputMaybe<Scalars['String']['input']>;
  skipPointChanges?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LoyaltyActionHistoryQuery = {
  customer: {
    uuid: string;
    membership: {
      id: string;
      transactions: {
        edges: Array<{
          cursor: string;
          node: {
            id: string;
            createdAt: any;
            totalAmount: number | null;
            totalAmountWithoutDiscounts: number | null;
            vendorName: string | null;
            status: ActivateTransactionStatus | null;
          };
        } | null>;
      } | null;
      pointChanges?: {
        edges: Array<{
          cursor: string;
          node: {
            id: string;
            type: PointChangeType | null;
            createdAt: any;
            quantity: number;
            notes: string | null;
            offer: { id: string; name: string } | null;
            source:
              | { __typename: 'ActivateTransaction'; id: string }
              | { __typename: 'ActivateUser'; id: string }
              | { __typename: 'Chain'; id: string }
              | { __typename: 'CommandCenterUser' }
              | { __typename: 'GameSession' }
              | { __typename: 'LoyaltyEvent'; eventType: string; createdAt: any }
              | {
                  __typename: 'OfferPurchase';
                  purchasedWith: {
                    id: string;
                    name: string;
                    marketingContents: Array<{ id: string; title: string | null } | null>;
                  };
                }
              | {
                  __typename: 'PointChange';
                  id: string;
                  offer: {
                    id: string;
                    name: string;
                    marketingContents: Array<{ id: string; title: string | null } | null>;
                  } | null;
                }
              | { __typename: 'PromocodeUseRequest' }
              | null;
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type TransactionHistoryItemFragment = {
  uuid: string;
  completedAt: any | null;
  primaryStatus: PrimaryTransactionStatus;
  secondaryStatus: SecondaryTransactionStatus;
  amount: { displayPrice: string; price: number } | null;
};

export type TransactionHistoryQueryVariables = Exact<{
  size: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  primaryTransactionStatus?: InputMaybe<PrimaryTransactionStatus>;
  secondaryTransactionStatus?: InputMaybe<SecondaryTransactionStatus>;
}>;

export type TransactionHistoryQuery = {
  customer: {
    uuid: string;
    transactions: {
      edges: Array<{
        cursor: string;
        node: {
          uuid: string;
          completedAt: any | null;
          primaryStatus: PrimaryTransactionStatus;
          secondaryStatus: SecondaryTransactionStatus;
          amount: { displayPrice: string; price: number } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CurrentCustomerQueryVariables = Exact<{
  isLoggedIn: Scalars['Boolean']['input'];
}>;

export type CurrentCustomerQuery = {
  customer?: {
    __typename: 'Customer';
    uuid: string;
    hasPasscode: boolean | null;
    membership: {
      __typename: 'Membership';
      points: number;
      customData: any | null;
      id: string;
      customerUuid: string | null;
      createdAt: any;
      state: MEMBERSHIP_STATE;
      isCompleted: boolean;
      firstName: string | null;
      lastName: string | null;
      birthdate: any | null;
      phone: any | null;
      email: any | null;
      programTermsAcceptanceAt: any | null;
      barcodeIdentifier: string;
      incomingReferral: { status: ReceiverStatus } | null;
      homeStores: Array<{ locationUuid: string }> | null;
      externalIdentityVerificationProfiles: Array<{
        completedAt: any;
        provider: ExternalIdentityVerificationProvider;
        attributes: Array<{ handle: string; name: string }> | null;
      }> | null;
      primaryAddress: {
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        zipcode: string | null;
      } | null;
      fuelAndConvenienceProfile: {
        restrictionVerification: CategoryRestrictions | null;
        pendingVerification: CategoryRestrictions | null;
        memberDataShare: boolean | null;
        achEnrollmentStatus: AchEnrollmentStatus | null;
        preferredFuelProductGroup: { id: string; productGroup: { id: string; name: string } } | null;
      } | null;
    } | null;
    communicationPreference: { smsOptIn: boolean; pushOptIn: boolean; smsOptOutReason: SmsOptOutReason | null };
  } | null;
};

export type CustomerLogoutMutationVariables = Exact<{ [key: string]: never }>;

export type CustomerLogoutMutation = { logout: boolean | null };

export type CustomerUpdateMutationVariables = Exact<{
  customer: CustomerUpdate;
}>;

export type CustomerUpdateMutation = {
  customer: {
    uuid: string;
    membership: {
      __typename: 'Membership';
      points: number;
      customData: any | null;
      id: string;
      customerUuid: string | null;
      createdAt: any;
      state: MEMBERSHIP_STATE;
      isCompleted: boolean;
      firstName: string | null;
      lastName: string | null;
      birthdate: any | null;
      phone: any | null;
      email: any | null;
      programTermsAcceptanceAt: any | null;
      barcodeIdentifier: string;
      incomingReferral: { status: ReceiverStatus } | null;
      homeStores: Array<{ locationUuid: string }> | null;
      externalIdentityVerificationProfiles: Array<{
        completedAt: any;
        provider: ExternalIdentityVerificationProvider;
        attributes: Array<{ handle: string; name: string }> | null;
      }> | null;
      primaryAddress: {
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        zipcode: string | null;
      } | null;
      fuelAndConvenienceProfile: {
        restrictionVerification: CategoryRestrictions | null;
        pendingVerification: CategoryRestrictions | null;
        memberDataShare: boolean | null;
        achEnrollmentStatus: AchEnrollmentStatus | null;
        preferredFuelProductGroup: { id: string; productGroup: { id: string; name: string } } | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteMembershipScrubDataMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMembershipScrubDataMutation = { deleteAccount: boolean };

export type DeleteMembershipMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteMembershipMutation = { deleteAccount: boolean };

export type ExternalIdentityVerificationProfileFragment = {
  completedAt: any;
  provider: ExternalIdentityVerificationProvider;
  attributes: Array<{ handle: string; name: string }> | null;
};

export type ExternalIdentityVerificationAttributeFragment = { handle: string; name: string };

export type FuelAndConvenienceProfileFragment = {
  restrictionVerification: CategoryRestrictions | null;
  pendingVerification: CategoryRestrictions | null;
  memberDataShare: boolean | null;
  achEnrollmentStatus: AchEnrollmentStatus | null;
  preferredFuelProductGroup: { id: string; productGroup: { id: string; name: string } } | null;
};

export type FuelAndConvenienceProfileCreateOrUpdateMutationVariables = Exact<{
  input: FuelAndConvenienceProfileCreateOrUpdateInput;
}>;

export type FuelAndConvenienceProfileCreateOrUpdateMutation = {
  fuelAndConvenienceProfile: {
    memberDataShare: boolean | null;
    achEnrollmentStatus: AchEnrollmentStatus | null;
    preferredFuelProductGroup: { id: string } | null;
  };
};

export type MembershipAddressFragment = {
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
};

export type MembershipProductInterestsQueryVariables = Exact<{ [key: string]: never }>;

export type MembershipProductInterestsQuery = {
  customer: {
    __typename: 'Customer';
    uuid: string;
    membership: {
      id: string;
      productInterests: Array<{
        id: string;
        name: string;
        rank: number;
        categoryRestriction: CategoryRestrictions | null;
      }>;
    } | null;
  } | null;
};

export type CustomerProfileFragment = {
  __typename: 'Membership';
  id: string;
  customerUuid: string | null;
  createdAt: any;
  state: MEMBERSHIP_STATE;
  isCompleted: boolean;
  firstName: string | null;
  lastName: string | null;
  birthdate: any | null;
  phone: any | null;
  email: any | null;
  programTermsAcceptanceAt: any | null;
  barcodeIdentifier: string;
  primaryAddress: {
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipcode: string | null;
  } | null;
  fuelAndConvenienceProfile: {
    restrictionVerification: CategoryRestrictions | null;
    pendingVerification: CategoryRestrictions | null;
    memberDataShare: boolean | null;
    achEnrollmentStatus: AchEnrollmentStatus | null;
    preferredFuelProductGroup: { id: string; productGroup: { id: string; name: string } } | null;
  } | null;
};

export type MembershipFragment = {
  __typename: 'Membership';
  points: number;
  customData: any | null;
  id: string;
  customerUuid: string | null;
  createdAt: any;
  state: MEMBERSHIP_STATE;
  isCompleted: boolean;
  firstName: string | null;
  lastName: string | null;
  birthdate: any | null;
  phone: any | null;
  email: any | null;
  programTermsAcceptanceAt: any | null;
  barcodeIdentifier: string;
  incomingReferral: { status: ReceiverStatus } | null;
  homeStores: Array<{ locationUuid: string }> | null;
  externalIdentityVerificationProfiles: Array<{
    completedAt: any;
    provider: ExternalIdentityVerificationProvider;
    attributes: Array<{ handle: string; name: string }> | null;
  }> | null;
  primaryAddress: {
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    zipcode: string | null;
  } | null;
  fuelAndConvenienceProfile: {
    restrictionVerification: CategoryRestrictions | null;
    pendingVerification: CategoryRestrictions | null;
    memberDataShare: boolean | null;
    achEnrollmentStatus: AchEnrollmentStatus | null;
    preferredFuelProductGroup: { id: string; productGroup: { id: string; name: string } } | null;
  } | null;
};

export type ProductInterestsReplaceMutationVariables = Exact<{
  input: ProductInterestsReplaceInput;
}>;

export type ProductInterestsReplaceMutation = {
  membership: {
    id: string;
    productInterests: Array<{
      id: string;
      name: string;
      rank: number;
      categoryRestriction: CategoryRestrictions | null;
    }>;
    fuelAndConvenienceProfile: { pendingVerification: CategoryRestrictions | null } | null;
  };
};

export type ActivateOfferMutationVariables = Exact<{
  input: OfferActivate;
}>;

export type ActivateOfferMutation = { offerActivate: { id: string; activationStatus: OfferActivationStatus } | null };

export type AwardPointsFragment = { __typename: 'AwardPoints'; points: number };

export type AwardPointsPerFragment = {
  __typename: 'AwardPointsPer';
  points: number;
  rounding: AwardPointsRoundingStrategy;
};

export type AwardVouchersFragment = {
  __typename: 'AwardVouchers';
  voucherExpirationDays: number | null;
  voucherCount: number;
  voucheredOffer: {
    id: string;
    voucherCount: number;
    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
  };
};

type AwardPointsOrVouchersAwardPointsFragment = { __typename: 'AwardPoints'; points: number };

type AwardPointsOrVouchersAwardVouchersFragment = {
  __typename: 'AwardVouchers';
  voucherExpirationDays: number | null;
  voucherCount: number;
  voucheredOffer: {
    id: string;
    voucherCount: number;
    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
  };
};

export type AwardPointsOrVouchersFragment =
  | AwardPointsOrVouchersAwardPointsFragment
  | AwardPointsOrVouchersAwardVouchersFragment;

export type GameAwardVouchersFragment = {
  __typename: 'AwardVouchers';
  voucherExpirationDays: number | null;
  voucheredOffer: {
    __typename: 'Offer';
    id: string;
    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
    marketingContents: Array<{
      id: string;
      imageUrl: any | null;
      title: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      disclaimer: string | null;
      disclaimerUrl: any | null;
      terms: string | null;
      termsUrl: any | null;
      surgeonGeneralsWarning: string | null;
      externalUrl: string | null;
    } | null>;
  };
};

type GameAwardPointsOrVouchersAwardPointsFragment = { __typename: 'AwardPoints'; points: number };

type GameAwardPointsOrVouchersAwardVouchersFragment = {
  __typename: 'AwardVouchers';
  voucherExpirationDays: number | null;
  voucheredOffer: {
    __typename: 'Offer';
    id: string;
    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
    marketingContents: Array<{
      id: string;
      imageUrl: any | null;
      title: string | null;
      shortDescription: string | null;
      longDescription: string | null;
      disclaimer: string | null;
      disclaimerUrl: any | null;
      terms: string | null;
      termsUrl: any | null;
      surgeonGeneralsWarning: string | null;
      externalUrl: string | null;
    } | null>;
  };
};

export type GameAwardPointsOrVouchersFragment =
  | GameAwardPointsOrVouchersAwardPointsFragment
  | GameAwardPointsOrVouchersAwardVouchersFragment;

export type BaseOffersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  deleted: Scalars['Boolean']['input'];
  publicationStatusEquals?: InputMaybe<PublicationStatusType>;
  visibleStatusEquals?: InputMaybe<OfferVisibleStatus>;
  presentationTypeIncludes?: InputMaybe<Array<OfferPresentationType> | OfferPresentationType>;
  engagementTypeEquals: OfferEngagementType;
  offerLimitsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  offerVouchersIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  availableAtLocationsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  constraintsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type BaseOffersQuery = {
  customer: {
    uuid: string;
    membership: {
      id: string;
      offers: {
        edges: Array<{
          node: {
            __typename: 'Offer';
            id: string;
            expireAt: any | null;
            engagementType: OfferEngagementType | null;
            activationStatus: OfferActivationStatus;
            visibleStatus: OfferVisibleStatus;
            ineligibilityReason: IneligibilityReason | null;
            customData: any | null;
            voucherCount: number;
            presentationPriority: OfferPresentationPriority;
            presentationType: OfferPresentationType;
            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
            marketingContents: Array<{
              id: string;
              imageUrl: any | null;
              title: string | null;
              shortDescription: string | null;
              longDescription: string | null;
              disclaimer: string | null;
              disclaimerUrl: any | null;
              terms: string | null;
              termsUrl: any | null;
              surgeonGeneralsWarning: string | null;
              externalUrl: string | null;
            } | null>;
            earningMechanism:
              | {
                  __typename: 'EarningMechanismExternalFulfillment';
                  id: string;
                  optionalAward:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      }
                    | null;
                }
              | {
                  __typename: 'EarningMechanismLoyaltyEvent';
                  id: string;
                  optionalAward:
                    | { __typename: 'AwardExternalPoints' }
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      }
                    | null;
                }
              | {
                  __typename: 'EarningMechanismMembershipEvent';
                  id: string;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | {
                  __typename: 'EarningMechanismPointSpend';
                  id: string;
                  pointCost: number;
                  award: {
                    __typename: 'AwardVouchers';
                    voucherExpirationDays: number | null;
                    voucherCount: number;
                    voucheredOffer: {
                      id: string;
                      voucherCount: number;
                      trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                    };
                  };
                }
              | { __typename: 'EarningMechanismProductDiscount'; id: string }
              | {
                  __typename: 'EarningMechanismProductPurchase';
                  id: string;
                  award:
                    | { __typename: 'AwardExternal' }
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | { __typename: 'EarningMechanismPromocodes' }
              | {
                  __typename: 'EarningMechanismSpinWheelGame';
                  id: string;
                  awards: Array<{
                    awardType: RandomAwardType;
                    limit: number;
                    sequenceNumber: number;
                    award:
                      | { __typename: 'AwardPoints'; points: number }
                      | {
                          __typename: 'AwardVouchers';
                          voucherExpirationDays: number | null;
                          voucheredOffer: {
                            __typename: 'Offer';
                            id: string;
                            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                            marketingContents: Array<{
                              id: string;
                              imageUrl: any | null;
                              title: string | null;
                              shortDescription: string | null;
                              longDescription: string | null;
                              disclaimer: string | null;
                              disclaimerUrl: any | null;
                              terms: string | null;
                              termsUrl: any | null;
                              surgeonGeneralsWarning: string | null;
                              externalUrl: string | null;
                            } | null>;
                          };
                        }
                      | null;
                  }>;
                  purchasableOffer: {
                    __typename: 'Offer';
                    id: string;
                    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                    earningMechanism:
                      | { __typename: 'EarningMechanismExternalFulfillment' }
                      | { __typename: 'EarningMechanismLoyaltyEvent' }
                      | { __typename: 'EarningMechanismMembershipEvent' }
                      | { __typename: 'EarningMechanismPointSpend'; id: string; pointCost: number }
                      | { __typename: 'EarningMechanismProductDiscount' }
                      | { __typename: 'EarningMechanismProductPurchase' }
                      | { __typename: 'EarningMechanismPromocodes' }
                      | { __typename: 'EarningMechanismSpinWheelGame' }
                      | { __typename: 'EarningMechanismTotalEligiblePurchase' }
                      | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' }
                      | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
                      | { __typename: 'EarningMechanismTotalSpendOverTime' }
                      | { __typename: 'EarningMechanismTransactionDiscount' }
                      | { __typename: 'EarningMechanismVarietyDiscount' }
                      | { __typename: 'EarningMechanismVarietyPurchase' }
                      | { __typename: 'EarningMechanismVarietyPurchaseOverTime' }
                      | { __typename: 'EarningMechanismVisits' }
                      | null;
                  } | null;
                }
              | {
                  __typename: 'EarningMechanismTotalEligiblePurchase';
                  id: string;
                  award: { __typename: 'AwardPointsPer'; points: number; rounding: AwardPointsRoundingStrategy };
                }
              | {
                  __typename: 'EarningMechanismTotalEligiblePurchaseOverTime';
                  id: string;
                  purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
              | {
                  __typename: 'EarningMechanismTotalSpendOverTime';
                  id: string;
                  purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
              | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
              | {
                  __typename: 'EarningMechanismVarietyPurchase';
                  id: string;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | {
                  __typename: 'EarningMechanismVarietyPurchaseOverTime';
                  id: string;
                  varietyMemberProgress: Array<{ quantityPurchased: number; quantityRequired: number }>;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                  products: Array<{
                    __typename: 'EarningMechanismProductCriteria';
                    countProductsBy: EarningMechanismProductCountingAttribute;
                  }>;
                }
              | {
                  __typename: 'EarningMechanismVisits';
                  id: string;
                  visitsMemberProgress: { visits: number; visitsRequired: number } | null;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | null;
            vouchers?: {
              edges: Array<{ node: { id: string; expireAt: any | null; createdAt: any; state: VoucherState } }>;
            };
            displayCategories: Array<{
              id: string;
              name: string;
              rank: number;
              categoryRestrictions: CategoryRestrictions | null;
              bannerIds: Array<string> | null;
            }>;
            limits?: Array<
              | { __typename: 'LimitGlobalActivation'; id: string }
              | { __typename: 'LimitGlobalActivationInTime'; id: string }
              | { __typename: 'LimitGlobalAwardCount'; id: string }
              | { __typename: 'LimitGlobalAwardCountInTime'; id: string }
              | { __typename: 'LimitInTransactionAwardCount'; id: string }
              | { __typename: 'LimitInTransactionProgress'; id: string }
              | { __typename: 'LimitMembershipActivation'; id: string }
              | { __typename: 'LimitMembershipActivationInTime'; id: string }
              | {
                  __typename: 'LimitMembershipAwardCount';
                  id: string;
                  limit: number;
                  membershipQuantityAvailable: number | null;
                }
              | {
                  __typename: 'LimitMembershipAwardCountInTime';
                  id: string;
                  limit: number;
                  membershipQuantityAvailable: number | null;
                }
              | { __typename: 'LimitMembershipProgressInTime'; id: string }
              | { __typename: 'LimitMembershipTransactionCount'; id: string }
              | { __typename: 'LimitMembershipTransactionCountInTime'; id: string }
            >;
            availableAtLocations: Array<{
              uuid: string;
              name?: string | null;
              address?: {
                city: string;
                street1: string;
                street2: string | null;
                state: string;
                zipCode: string;
                geoLocation: { latitude: number; longitude: number } | null;
              } | null;
            }> | null;
            constraints?: Array<
              | { __typename: 'ConstraintDaysOfWeek' }
              | { __typename: 'ConstraintEmailRequired' }
              | { __typename: 'ConstraintInAudience' }
              | { __typename: 'ConstraintLocationInState' }
              | { __typename: 'ConstraintOrderAheadOnly' }
              | { __typename: 'ConstraintPaymentInstrument' }
              | { __typename: 'ConstraintPaymentMethod' }
              | { __typename: 'ConstraintPreAuth' }
              | { __typename: 'ConstraintPurchasableEligibility' }
              | { __typename: 'ConstraintPurchaseThreshold' }
              | { __typename: 'ConstraintRequiresActivation' }
              | { __typename: 'ConstraintRequiresTransactionVoucher' }
              | { __typename: 'ConstraintRequiresVoucher' }
              | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount' }
              | { __typename: 'ConstraintStoreLocation'; id: string }
              | { __typename: 'ConstraintStoreLocationGroup'; id: string }
              | { __typename: 'ConstraintSubBrand' }
              | { __typename: 'ConstraintTimeOfDay' }
            >;
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type EarningMechanismProductPurchaseFragment = {
  id: string;
  award:
    | { __typename: 'AwardExternal' }
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      };
};

export type EarningMechanismPointSpendFragment = {
  __typename: 'EarningMechanismPointSpend';
  id: string;
  pointCost: number;
  award: {
    __typename: 'AwardVouchers';
    voucherExpirationDays: number | null;
    voucherCount: number;
    voucheredOffer: {
      id: string;
      voucherCount: number;
      trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
    };
  };
};

export type EarningMechanismExternalFulfillmentFragment = {
  id: string;
  optionalAward:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      }
    | null;
};

export type EarningMechanismLoyaltyEventFragment = {
  id: string;
  optionalAward:
    | { __typename: 'AwardExternalPoints' }
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      }
    | null;
};

export type EarningMechanismMembershipEventFragment = {
  id: string;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      };
};

export type EarningMechanismVarietyPurchaseFragment = {
  id: string;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      };
};

export type EarningMechanismTotalEligiblePurchaseFragment = {
  id: string;
  award: { __typename: 'AwardPointsPer'; points: number; rounding: AwardPointsRoundingStrategy };
};

export type EarningMechanismTotalEligiblePurchaseOverTimeFragment = {
  id: string;
  purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      };
};

export type EarningMechanismTotalSpendOverTimeFragment = {
  id: string;
  purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      };
};

export type EarningMechanismVisitsFragment = {
  id: string;
  visitsMemberProgress: { visits: number; visitsRequired: number } | null;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      };
};

export type EarningMechanismVarietyPurchaseOverTimeFragment = {
  id: string;
  varietyMemberProgress: Array<{ quantityPurchased: number; quantityRequired: number }>;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      };
  products: Array<{
    __typename: 'EarningMechanismProductCriteria';
    countProductsBy: EarningMechanismProductCountingAttribute;
  }>;
};

export type EarningMechanismProductDiscountFragment = { __typename: 'EarningMechanismProductDiscount'; id: string };

export type EarningMechanismTransactionDiscountFragment = {
  __typename: 'EarningMechanismTransactionDiscount';
  id: string;
};

export type EarningMechanismVarietyDiscountFragment = { __typename: 'EarningMechanismVarietyDiscount'; id: string };

export type SpinWheelGameVoucherPurchaseFragment = {
  __typename: 'Offer';
  id: string;
  trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
  earningMechanism:
    | { __typename: 'EarningMechanismExternalFulfillment' }
    | { __typename: 'EarningMechanismLoyaltyEvent' }
    | { __typename: 'EarningMechanismMembershipEvent' }
    | { __typename: 'EarningMechanismPointSpend'; id: string; pointCost: number }
    | { __typename: 'EarningMechanismProductDiscount' }
    | { __typename: 'EarningMechanismProductPurchase' }
    | { __typename: 'EarningMechanismPromocodes' }
    | { __typename: 'EarningMechanismSpinWheelGame' }
    | { __typename: 'EarningMechanismTotalEligiblePurchase' }
    | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' }
    | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
    | { __typename: 'EarningMechanismTotalSpendOverTime' }
    | { __typename: 'EarningMechanismTransactionDiscount' }
    | { __typename: 'EarningMechanismVarietyDiscount' }
    | { __typename: 'EarningMechanismVarietyPurchase' }
    | { __typename: 'EarningMechanismVarietyPurchaseOverTime' }
    | { __typename: 'EarningMechanismVisits' }
    | null;
};

export type SpinWheelGamePrizeFragment = {
  awardType: RandomAwardType;
  limit: number;
  sequenceNumber: number;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucheredOffer: {
          __typename: 'Offer';
          id: string;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
          marketingContents: Array<{
            id: string;
            imageUrl: any | null;
            title: string | null;
            shortDescription: string | null;
            longDescription: string | null;
            disclaimer: string | null;
            disclaimerUrl: any | null;
            terms: string | null;
            termsUrl: any | null;
            surgeonGeneralsWarning: string | null;
            externalUrl: string | null;
          } | null>;
        };
      }
    | null;
};

export type EarningMechanismSpinWheelGameFragment = {
  __typename: 'EarningMechanismSpinWheelGame';
  id: string;
  awards: Array<{
    awardType: RandomAwardType;
    limit: number;
    sequenceNumber: number;
    award:
      | { __typename: 'AwardPoints'; points: number }
      | {
          __typename: 'AwardVouchers';
          voucherExpirationDays: number | null;
          voucheredOffer: {
            __typename: 'Offer';
            id: string;
            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
            marketingContents: Array<{
              id: string;
              imageUrl: any | null;
              title: string | null;
              shortDescription: string | null;
              longDescription: string | null;
              disclaimer: string | null;
              disclaimerUrl: any | null;
              terms: string | null;
              termsUrl: any | null;
              surgeonGeneralsWarning: string | null;
              externalUrl: string | null;
            } | null>;
          };
        }
      | null;
  }>;
  purchasableOffer: {
    __typename: 'Offer';
    id: string;
    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
    earningMechanism:
      | { __typename: 'EarningMechanismExternalFulfillment' }
      | { __typename: 'EarningMechanismLoyaltyEvent' }
      | { __typename: 'EarningMechanismMembershipEvent' }
      | { __typename: 'EarningMechanismPointSpend'; id: string; pointCost: number }
      | { __typename: 'EarningMechanismProductDiscount' }
      | { __typename: 'EarningMechanismProductPurchase' }
      | { __typename: 'EarningMechanismPromocodes' }
      | { __typename: 'EarningMechanismSpinWheelGame' }
      | { __typename: 'EarningMechanismTotalEligiblePurchase' }
      | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' }
      | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
      | { __typename: 'EarningMechanismTotalSpendOverTime' }
      | { __typename: 'EarningMechanismTransactionDiscount' }
      | { __typename: 'EarningMechanismVarietyDiscount' }
      | { __typename: 'EarningMechanismVarietyPurchase' }
      | { __typename: 'EarningMechanismVarietyPurchaseOverTime' }
      | { __typename: 'EarningMechanismVisits' }
      | null;
  } | null;
};

export type EarningMechanismPromocodesFragment = {
  id: string;
  award:
    | { __typename: 'AwardPoints'; points: number }
    | {
        __typename: 'AwardVouchers';
        voucherExpirationDays: number | null;
        voucherCount: number;
        voucheredOffer: {
          id: string;
          voucherCount: number;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
        };
      }
    | null;
};

export type ExternalOfferFragment = {
  trackingId: string;
  bannerConfigurationUuid: string;
  externalCampaignId: string | null;
  content: {
    title: string;
    title2: string | null;
    titleMiddle: string | null;
    imageUrl: any | null;
    surgeonGeneralWarning: string | null;
  };
};

export type GetExternalOffersQueryVariables = Exact<{
  filter: BannerFilter;
}>;

export type GetExternalOffersQuery = {
  banners: Array<{
    trackingId: string;
    bannerConfigurationUuid: string;
    externalCampaignId: string | null;
    content: {
      title: string;
      title2: string | null;
      titleMiddle: string | null;
      imageUrl: any | null;
      surgeonGeneralWarning: string | null;
    };
  }>;
};

export type GetOfferVoucherQueryVariables = Exact<{
  offerId: Scalars['ID']['input'];
  voucherFilter: VoucherFilter;
}>;

export type GetOfferVoucherQuery = {
  customer: {
    uuid: string;
    membership: {
      id: string;
      offers: {
        edges: Array<{
          node: {
            id: string;
            vouchers: {
              edges: Array<{
                node: {
                  id: string;
                  source:
                    | { __typename: 'ActivateTransaction' }
                    | { __typename: 'GameSession' }
                    | { __typename: 'LoyaltyEvent' }
                    | { __typename: 'Offer' }
                    | { __typename: 'OfferPurchase'; purchasedWith: { id: string } }
                    | { __typename: 'PromocodeUseRequest' }
                    | null;
                };
              }>;
            };
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

type LimitLimitGlobalActivationFragment = { __typename: 'LimitGlobalActivation'; id: string };

type LimitLimitGlobalActivationInTimeFragment = { __typename: 'LimitGlobalActivationInTime'; id: string };

type LimitLimitGlobalAwardCountFragment = { __typename: 'LimitGlobalAwardCount'; id: string };

type LimitLimitGlobalAwardCountInTimeFragment = { __typename: 'LimitGlobalAwardCountInTime'; id: string };

type LimitLimitInTransactionAwardCountFragment = { __typename: 'LimitInTransactionAwardCount'; id: string };

type LimitLimitInTransactionProgressFragment = { __typename: 'LimitInTransactionProgress'; id: string };

type LimitLimitMembershipActivationFragment = { __typename: 'LimitMembershipActivation'; id: string };

type LimitLimitMembershipActivationInTimeFragment = { __typename: 'LimitMembershipActivationInTime'; id: string };

type LimitLimitMembershipAwardCountFragment = {
  __typename: 'LimitMembershipAwardCount';
  id: string;
  limit: number;
  membershipQuantityAvailable: number | null;
};

type LimitLimitMembershipAwardCountInTimeFragment = {
  __typename: 'LimitMembershipAwardCountInTime';
  id: string;
  limit: number;
  membershipQuantityAvailable: number | null;
};

type LimitLimitMembershipProgressInTimeFragment = { __typename: 'LimitMembershipProgressInTime'; id: string };

type LimitLimitMembershipTransactionCountFragment = { __typename: 'LimitMembershipTransactionCount'; id: string };

type LimitLimitMembershipTransactionCountInTimeFragment = {
  __typename: 'LimitMembershipTransactionCountInTime';
  id: string;
};

export type LimitFragment =
  | LimitLimitGlobalActivationFragment
  | LimitLimitGlobalActivationInTimeFragment
  | LimitLimitGlobalAwardCountFragment
  | LimitLimitGlobalAwardCountInTimeFragment
  | LimitLimitInTransactionAwardCountFragment
  | LimitLimitInTransactionProgressFragment
  | LimitLimitMembershipActivationFragment
  | LimitLimitMembershipActivationInTimeFragment
  | LimitLimitMembershipAwardCountFragment
  | LimitLimitMembershipAwardCountInTimeFragment
  | LimitLimitMembershipProgressInTimeFragment
  | LimitLimitMembershipTransactionCountFragment
  | LimitLimitMembershipTransactionCountInTimeFragment;

export type LimitMembershipAwardCountFragment = {
  __typename: 'LimitMembershipAwardCount';
  id: string;
  limit: number;
  membershipQuantityAvailable: number | null;
};

export type LimitMembershipAwardCountInTimeFragment = {
  __typename: 'LimitMembershipAwardCountInTime';
  id: string;
  limit: number;
  membershipQuantityAvailable: number | null;
};

export type LimitGlobalActivationFragment = { __typename: 'LimitGlobalActivation'; id: string };

export type LimitGlobalActivationInTimeFragment = { __typename: 'LimitGlobalActivationInTime'; id: string };

export type LimitGlobalAwardCountFragment = { __typename: 'LimitGlobalAwardCount'; id: string };

export type LimitGlobalAwardCountInTimeFragment = { __typename: 'LimitGlobalAwardCountInTime'; id: string };

export type LimitMembershipActivationFragment = { __typename: 'LimitMembershipActivation'; id: string };

export type LimitMembershipActivationInTimeFragment = { __typename: 'LimitMembershipActivationInTime'; id: string };

export type LimitInTransactionAwardCountFragment = { __typename: 'LimitInTransactionAwardCount'; id: string };

export type LimitInTransactionProgressFragment = { __typename: 'LimitInTransactionProgress'; id: string };

export type LimitMembershipProgressInTimeFragment = { __typename: 'LimitMembershipProgressInTime'; id: string };

export type LimitMembershipTransactionCountFragment = { __typename: 'LimitMembershipTransactionCount'; id: string };

export type LimitMembershipTransactionCountInTimeFragment = {
  __typename: 'LimitMembershipTransactionCountInTime';
  id: string;
};

export type LogOfferActivityBatchMutationVariables = Exact<{
  input: Array<OfferActivityLogInput> | OfferActivityLogInput;
}>;

export type LogOfferActivityBatchMutation = { offerActivityLogBatch: boolean };

export type LogOfferActivityMutationVariables = Exact<{
  input: OfferActivityLogInput;
}>;

export type LogOfferActivityMutation = { offerActivityLog: boolean };

export type MarketingContentFragment = {
  id: string;
  imageUrl: any | null;
  title: string | null;
  shortDescription: string | null;
  longDescription: string | null;
  disclaimer: string | null;
  disclaimerUrl: any | null;
  terms: string | null;
  termsUrl: any | null;
  surgeonGeneralsWarning: string | null;
  externalUrl: string | null;
};

export type OfferAvailableAtLocationFragment = {
  name?: string | null;
  address?: {
    city: string;
    street1: string;
    street2: string | null;
    state: string;
    zipCode: string;
    geoLocation: { latitude: number; longitude: number } | null;
  } | null;
};

export type OfferFragment = {
  __typename: 'Offer';
  id: string;
  expireAt: any | null;
  engagementType: OfferEngagementType | null;
  activationStatus: OfferActivationStatus;
  visibleStatus: OfferVisibleStatus;
  ineligibilityReason: IneligibilityReason | null;
  customData: any | null;
  voucherCount: number;
  presentationPriority: OfferPresentationPriority;
  presentationType: OfferPresentationType;
  trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
  marketingContents: Array<{
    id: string;
    imageUrl: any | null;
    title: string | null;
    shortDescription: string | null;
    longDescription: string | null;
    disclaimer: string | null;
    disclaimerUrl: any | null;
    terms: string | null;
    termsUrl: any | null;
    surgeonGeneralsWarning: string | null;
    externalUrl: string | null;
  } | null>;
  earningMechanism:
    | {
        __typename: 'EarningMechanismExternalFulfillment';
        id: string;
        optionalAward:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            }
          | null;
      }
    | {
        __typename: 'EarningMechanismLoyaltyEvent';
        id: string;
        optionalAward:
          | { __typename: 'AwardExternalPoints' }
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            }
          | null;
      }
    | {
        __typename: 'EarningMechanismMembershipEvent';
        id: string;
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            };
      }
    | {
        __typename: 'EarningMechanismPointSpend';
        id: string;
        pointCost: number;
        award: {
          __typename: 'AwardVouchers';
          voucherExpirationDays: number | null;
          voucherCount: number;
          voucheredOffer: {
            id: string;
            voucherCount: number;
            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
          };
        };
      }
    | { __typename: 'EarningMechanismProductDiscount'; id: string }
    | {
        __typename: 'EarningMechanismProductPurchase';
        id: string;
        award:
          | { __typename: 'AwardExternal' }
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            };
      }
    | { __typename: 'EarningMechanismPromocodes' }
    | {
        __typename: 'EarningMechanismSpinWheelGame';
        id: string;
        awards: Array<{
          awardType: RandomAwardType;
          limit: number;
          sequenceNumber: number;
          award:
            | { __typename: 'AwardPoints'; points: number }
            | {
                __typename: 'AwardVouchers';
                voucherExpirationDays: number | null;
                voucheredOffer: {
                  __typename: 'Offer';
                  id: string;
                  trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                  marketingContents: Array<{
                    id: string;
                    imageUrl: any | null;
                    title: string | null;
                    shortDescription: string | null;
                    longDescription: string | null;
                    disclaimer: string | null;
                    disclaimerUrl: any | null;
                    terms: string | null;
                    termsUrl: any | null;
                    surgeonGeneralsWarning: string | null;
                    externalUrl: string | null;
                  } | null>;
                };
              }
            | null;
        }>;
        purchasableOffer: {
          __typename: 'Offer';
          id: string;
          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
          earningMechanism:
            | { __typename: 'EarningMechanismExternalFulfillment' }
            | { __typename: 'EarningMechanismLoyaltyEvent' }
            | { __typename: 'EarningMechanismMembershipEvent' }
            | { __typename: 'EarningMechanismPointSpend'; id: string; pointCost: number }
            | { __typename: 'EarningMechanismProductDiscount' }
            | { __typename: 'EarningMechanismProductPurchase' }
            | { __typename: 'EarningMechanismPromocodes' }
            | { __typename: 'EarningMechanismSpinWheelGame' }
            | { __typename: 'EarningMechanismTotalEligiblePurchase' }
            | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' }
            | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
            | { __typename: 'EarningMechanismTotalSpendOverTime' }
            | { __typename: 'EarningMechanismTransactionDiscount' }
            | { __typename: 'EarningMechanismVarietyDiscount' }
            | { __typename: 'EarningMechanismVarietyPurchase' }
            | { __typename: 'EarningMechanismVarietyPurchaseOverTime' }
            | { __typename: 'EarningMechanismVisits' }
            | null;
        } | null;
      }
    | {
        __typename: 'EarningMechanismTotalEligiblePurchase';
        id: string;
        award: { __typename: 'AwardPointsPer'; points: number; rounding: AwardPointsRoundingStrategy };
      }
    | {
        __typename: 'EarningMechanismTotalEligiblePurchaseOverTime';
        id: string;
        purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            };
      }
    | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
    | {
        __typename: 'EarningMechanismTotalSpendOverTime';
        id: string;
        purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            };
      }
    | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
    | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
    | {
        __typename: 'EarningMechanismVarietyPurchase';
        id: string;
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            };
      }
    | {
        __typename: 'EarningMechanismVarietyPurchaseOverTime';
        id: string;
        varietyMemberProgress: Array<{ quantityPurchased: number; quantityRequired: number }>;
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            };
        products: Array<{
          __typename: 'EarningMechanismProductCriteria';
          countProductsBy: EarningMechanismProductCountingAttribute;
        }>;
      }
    | {
        __typename: 'EarningMechanismVisits';
        id: string;
        visitsMemberProgress: { visits: number; visitsRequired: number } | null;
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherExpirationDays: number | null;
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
              };
            };
      }
    | null;
  vouchers?: { edges: Array<{ node: { id: string; expireAt: any | null; createdAt: any; state: VoucherState } }> };
  displayCategories: Array<{
    id: string;
    name: string;
    rank: number;
    categoryRestrictions: CategoryRestrictions | null;
    bannerIds: Array<string> | null;
  }>;
  limits?: Array<
    | { __typename: 'LimitGlobalActivation'; id: string }
    | { __typename: 'LimitGlobalActivationInTime'; id: string }
    | { __typename: 'LimitGlobalAwardCount'; id: string }
    | { __typename: 'LimitGlobalAwardCountInTime'; id: string }
    | { __typename: 'LimitInTransactionAwardCount'; id: string }
    | { __typename: 'LimitInTransactionProgress'; id: string }
    | { __typename: 'LimitMembershipActivation'; id: string }
    | { __typename: 'LimitMembershipActivationInTime'; id: string }
    | { __typename: 'LimitMembershipAwardCount'; id: string; limit: number; membershipQuantityAvailable: number | null }
    | {
        __typename: 'LimitMembershipAwardCountInTime';
        id: string;
        limit: number;
        membershipQuantityAvailable: number | null;
      }
    | { __typename: 'LimitMembershipProgressInTime'; id: string }
    | { __typename: 'LimitMembershipTransactionCount'; id: string }
    | { __typename: 'LimitMembershipTransactionCountInTime'; id: string }
  >;
  availableAtLocations: Array<{
    uuid: string;
    name?: string | null;
    address?: {
      city: string;
      street1: string;
      street2: string | null;
      state: string;
      zipCode: string;
      geoLocation: { latitude: number; longitude: number } | null;
    } | null;
  }> | null;
  constraints?: Array<
    | { __typename: 'ConstraintDaysOfWeek' }
    | { __typename: 'ConstraintEmailRequired' }
    | { __typename: 'ConstraintInAudience' }
    | { __typename: 'ConstraintLocationInState' }
    | { __typename: 'ConstraintOrderAheadOnly' }
    | { __typename: 'ConstraintPaymentInstrument' }
    | { __typename: 'ConstraintPaymentMethod' }
    | { __typename: 'ConstraintPreAuth' }
    | { __typename: 'ConstraintPurchasableEligibility' }
    | { __typename: 'ConstraintPurchaseThreshold' }
    | { __typename: 'ConstraintRequiresActivation' }
    | { __typename: 'ConstraintRequiresTransactionVoucher' }
    | { __typename: 'ConstraintRequiresVoucher' }
    | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount' }
    | { __typename: 'ConstraintStoreLocation'; id: string }
    | { __typename: 'ConstraintStoreLocationGroup'; id: string }
    | { __typename: 'ConstraintSubBrand' }
    | { __typename: 'ConstraintTimeOfDay' }
  >;
};

export type ConstraintStoreLocationFragment = { id: string };

export type ConstraintStoreLocationGroupFragment = { id: string };

export type OffersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  deleted: Scalars['Boolean']['input'];
  publicationStatusEquals?: InputMaybe<PublicationStatusType>;
  visibleStatusEquals?: InputMaybe<OfferVisibleStatus>;
  presentationTypeIncludes?: InputMaybe<Array<OfferPresentationType> | OfferPresentationType>;
  presentationPriorityIncludes?: InputMaybe<Array<OfferPresentationPriority> | OfferPresentationPriority>;
  engagementTypeEquals?: InputMaybe<OfferEngagementType>;
  engagementTypeExcludes?: InputMaybe<Array<OfferEngagementType> | OfferEngagementType>;
  idEquals?: InputMaybe<Scalars['ID']['input']>;
  offerLimitsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  offerVouchersIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  locationsGeoFilter?: InputMaybe<LocationsGeoFilterInput>;
  availableAtLocationsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  constraintsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type OffersQuery = {
  customer: {
    uuid: string;
    membership: {
      id: string;
      offers: {
        edges: Array<{
          node: {
            __typename: 'Offer';
            id: string;
            expireAt: any | null;
            engagementType: OfferEngagementType | null;
            activationStatus: OfferActivationStatus;
            visibleStatus: OfferVisibleStatus;
            ineligibilityReason: IneligibilityReason | null;
            customData: any | null;
            voucherCount: number;
            presentationPriority: OfferPresentationPriority;
            presentationType: OfferPresentationType;
            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
            marketingContents: Array<{
              id: string;
              imageUrl: any | null;
              title: string | null;
              shortDescription: string | null;
              longDescription: string | null;
              disclaimer: string | null;
              disclaimerUrl: any | null;
              terms: string | null;
              termsUrl: any | null;
              surgeonGeneralsWarning: string | null;
              externalUrl: string | null;
            } | null>;
            earningMechanism:
              | {
                  __typename: 'EarningMechanismExternalFulfillment';
                  id: string;
                  optionalAward:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      }
                    | null;
                }
              | {
                  __typename: 'EarningMechanismLoyaltyEvent';
                  id: string;
                  optionalAward:
                    | { __typename: 'AwardExternalPoints' }
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      }
                    | null;
                }
              | {
                  __typename: 'EarningMechanismMembershipEvent';
                  id: string;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | {
                  __typename: 'EarningMechanismPointSpend';
                  id: string;
                  pointCost: number;
                  award: {
                    __typename: 'AwardVouchers';
                    voucherExpirationDays: number | null;
                    voucherCount: number;
                    voucheredOffer: {
                      id: string;
                      voucherCount: number;
                      trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                    };
                  };
                }
              | { __typename: 'EarningMechanismProductDiscount'; id: string }
              | {
                  __typename: 'EarningMechanismProductPurchase';
                  id: string;
                  award:
                    | { __typename: 'AwardExternal' }
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | { __typename: 'EarningMechanismPromocodes' }
              | {
                  __typename: 'EarningMechanismSpinWheelGame';
                  id: string;
                  awards: Array<{
                    awardType: RandomAwardType;
                    limit: number;
                    sequenceNumber: number;
                    award:
                      | { __typename: 'AwardPoints'; points: number }
                      | {
                          __typename: 'AwardVouchers';
                          voucherExpirationDays: number | null;
                          voucheredOffer: {
                            __typename: 'Offer';
                            id: string;
                            trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                            marketingContents: Array<{
                              id: string;
                              imageUrl: any | null;
                              title: string | null;
                              shortDescription: string | null;
                              longDescription: string | null;
                              disclaimer: string | null;
                              disclaimerUrl: any | null;
                              terms: string | null;
                              termsUrl: any | null;
                              surgeonGeneralsWarning: string | null;
                              externalUrl: string | null;
                            } | null>;
                          };
                        }
                      | null;
                  }>;
                  purchasableOffer: {
                    __typename: 'Offer';
                    id: string;
                    trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                    earningMechanism:
                      | { __typename: 'EarningMechanismExternalFulfillment' }
                      | { __typename: 'EarningMechanismLoyaltyEvent' }
                      | { __typename: 'EarningMechanismMembershipEvent' }
                      | { __typename: 'EarningMechanismPointSpend'; id: string; pointCost: number }
                      | { __typename: 'EarningMechanismProductDiscount' }
                      | { __typename: 'EarningMechanismProductPurchase' }
                      | { __typename: 'EarningMechanismPromocodes' }
                      | { __typename: 'EarningMechanismSpinWheelGame' }
                      | { __typename: 'EarningMechanismTotalEligiblePurchase' }
                      | { __typename: 'EarningMechanismTotalEligiblePurchaseOverTime' }
                      | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
                      | { __typename: 'EarningMechanismTotalSpendOverTime' }
                      | { __typename: 'EarningMechanismTransactionDiscount' }
                      | { __typename: 'EarningMechanismVarietyDiscount' }
                      | { __typename: 'EarningMechanismVarietyPurchase' }
                      | { __typename: 'EarningMechanismVarietyPurchaseOverTime' }
                      | { __typename: 'EarningMechanismVisits' }
                      | null;
                  } | null;
                }
              | {
                  __typename: 'EarningMechanismTotalEligiblePurchase';
                  id: string;
                  award: { __typename: 'AwardPointsPer'; points: number; rounding: AwardPointsRoundingStrategy };
                }
              | {
                  __typename: 'EarningMechanismTotalEligiblePurchaseOverTime';
                  id: string;
                  purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | { __typename: 'EarningMechanismTotalSpendOnTransaction' }
              | {
                  __typename: 'EarningMechanismTotalSpendOverTime';
                  id: string;
                  purchaseMemberProgress: { quantityPurchased: number; quantityRequired: number } | null;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | { __typename: 'EarningMechanismTransactionDiscount'; id: string }
              | { __typename: 'EarningMechanismVarietyDiscount'; id: string }
              | {
                  __typename: 'EarningMechanismVarietyPurchase';
                  id: string;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | {
                  __typename: 'EarningMechanismVarietyPurchaseOverTime';
                  id: string;
                  varietyMemberProgress: Array<{ quantityPurchased: number; quantityRequired: number }>;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                  products: Array<{
                    __typename: 'EarningMechanismProductCriteria';
                    countProductsBy: EarningMechanismProductCountingAttribute;
                  }>;
                }
              | {
                  __typename: 'EarningMechanismVisits';
                  id: string;
                  visitsMemberProgress: { visits: number; visitsRequired: number } | null;
                  award:
                    | { __typename: 'AwardPoints'; points: number }
                    | {
                        __typename: 'AwardVouchers';
                        voucherExpirationDays: number | null;
                        voucherCount: number;
                        voucheredOffer: {
                          id: string;
                          voucherCount: number;
                          trackingConfig: { trackingId: string; isActivityLogIncludedInAltriaDDM: boolean } | null;
                        };
                      };
                }
              | null;
            vouchers?: {
              edges: Array<{ node: { id: string; expireAt: any | null; createdAt: any; state: VoucherState } }>;
            };
            displayCategories: Array<{
              id: string;
              name: string;
              rank: number;
              categoryRestrictions: CategoryRestrictions | null;
              bannerIds: Array<string> | null;
            }>;
            limits?: Array<
              | { __typename: 'LimitGlobalActivation'; id: string }
              | { __typename: 'LimitGlobalActivationInTime'; id: string }
              | { __typename: 'LimitGlobalAwardCount'; id: string }
              | { __typename: 'LimitGlobalAwardCountInTime'; id: string }
              | { __typename: 'LimitInTransactionAwardCount'; id: string }
              | { __typename: 'LimitInTransactionProgress'; id: string }
              | { __typename: 'LimitMembershipActivation'; id: string }
              | { __typename: 'LimitMembershipActivationInTime'; id: string }
              | {
                  __typename: 'LimitMembershipAwardCount';
                  id: string;
                  limit: number;
                  membershipQuantityAvailable: number | null;
                }
              | {
                  __typename: 'LimitMembershipAwardCountInTime';
                  id: string;
                  limit: number;
                  membershipQuantityAvailable: number | null;
                }
              | { __typename: 'LimitMembershipProgressInTime'; id: string }
              | { __typename: 'LimitMembershipTransactionCount'; id: string }
              | { __typename: 'LimitMembershipTransactionCountInTime'; id: string }
            >;
            availableAtLocations: Array<{
              uuid: string;
              name?: string | null;
              address?: {
                city: string;
                street1: string;
                street2: string | null;
                state: string;
                zipCode: string;
                geoLocation: { latitude: number; longitude: number } | null;
              } | null;
            }> | null;
            constraints?: Array<
              | { __typename: 'ConstraintDaysOfWeek' }
              | { __typename: 'ConstraintEmailRequired' }
              | { __typename: 'ConstraintInAudience' }
              | { __typename: 'ConstraintLocationInState' }
              | { __typename: 'ConstraintOrderAheadOnly' }
              | { __typename: 'ConstraintPaymentInstrument' }
              | { __typename: 'ConstraintPaymentMethod' }
              | { __typename: 'ConstraintPreAuth' }
              | { __typename: 'ConstraintPurchasableEligibility' }
              | { __typename: 'ConstraintPurchaseThreshold' }
              | { __typename: 'ConstraintRequiresActivation' }
              | { __typename: 'ConstraintRequiresTransactionVoucher' }
              | { __typename: 'ConstraintRequiresVoucher' }
              | { __typename: 'ConstraintRequiresVoucherAvailableForDiscount' }
              | { __typename: 'ConstraintStoreLocation'; id: string }
              | { __typename: 'ConstraintStoreLocationGroup'; id: string }
              | { __typename: 'ConstraintSubBrand' }
              | { __typename: 'ConstraintTimeOfDay' }
            >;
          };
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type ReturnPurchasedVoucherMutationVariables = Exact<{
  input: OfferPurchaseReturn;
}>;

export type ReturnPurchasedVoucherMutation = { offerPurchaseReturn: { createdAt: any } | null };

export type TotalVouchersCountQueryVariables = Exact<{
  filter?: InputMaybe<VoucherFilter>;
}>;

export type TotalVouchersCountQuery = {
  customer: { uuid: string; membership: { id: string; vouchers: { totalCount: number } } | null } | null;
};

export type CreatePaymentInstrumentMutationVariables = Exact<{
  input: CustomerPaymentInstrumentCreate;
}>;

export type CreatePaymentInstrumentMutation = { customerPaymentInstrumentCreate: { uuid: string } };

export type DeletePaymentInstrumentMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeletePaymentInstrumentMutation = { customerPaymentInstrumentDelete: Array<{ uuid: string } | null> };

export type GetPaymentInstrumentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPaymentInstrumentsQuery = {
  customer: {
    __typename: 'Customer';
    uuid: string;
    hasPasscode: boolean | null;
    paymentWallet: Array<{
      uuid: string;
      alias: string | null;
      providerNickName: string | null;
      accountNumber: string | null;
      accountType: PaymentAccountType;
      paymentType: PaymentInstrumentType | null;
      balance: number | null;
      isDefault: boolean | null;
      displayNumber: string | null;
      status: PaymentInstrumentStatus;
      address: { zipCode: string } | null;
      expiration: { expirationMonth: string | null; expirationYear: string | null } | null;
    } | null> | null;
  } | null;
};

export type PaymentInstrumentFragment = {
  uuid: string;
  alias: string | null;
  providerNickName: string | null;
  accountNumber: string | null;
  accountType: PaymentAccountType;
  paymentType: PaymentInstrumentType | null;
  balance: number | null;
  isDefault: boolean | null;
  displayNumber: string | null;
  status: PaymentInstrumentStatus;
  address: { zipCode: string } | null;
  expiration: { expirationMonth: string | null; expirationYear: string | null } | null;
};

export type CreateApplePaySessionMutationVariables = Exact<{
  input: PaymentApplePaySessionCreateInput;
}>;

export type CreateApplePaySessionMutation = { session: { data: any | null } };

export type CreateParPaySessionMutationVariables = Exact<{ [key: string]: never }>;

export type CreateParPaySessionMutation = {
  session: { iframeUrl: string; rawResponse: any; responseCode: string; responseText: string; sessionId: string };
};

export type ParPaySessionFragment = {
  iframeUrl: string;
  rawResponse: any;
  responseCode: string;
  responseText: string;
  sessionId: string;
};

export type GetFiservClientAccessTokenQueryVariables = Exact<{ [key: string]: never }>;

export type GetFiservClientAccessTokenQuery = {
  getFiservClientAccessToken: {
    fdCustomerId: string;
    publicKey: string;
    algorithm: string;
    issuedOn: any;
    expiresInSeconds: number;
    oAuthToken: string;
    apiKey: string;
    baseUrl: string;
  };
};

export type ExternalIdentityVerificationParamsFragment = {
  clientId: string;
  scope: string;
  grantType: string;
  state: string;
  authorizationUrl: any;
};

export type GenerateExternalIdentityVerificationParamsMutationVariables = Exact<{ [key: string]: never }>;

export type GenerateExternalIdentityVerificationParamsMutation = {
  result: { clientId: string; scope: string; grantType: string; state: string; authorizationUrl: any };
};

export type LocationFragment = { uuid: string };

export type LocationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LocationFilter>;
}>;

export type LocationsQuery = {
  locations: {
    edges: Array<{ node: { uuid: string } }> | null;
    pageInfo: { hasNextPage: boolean; hasPreviousPage: boolean; startCursor: string | null; endCursor: string | null };
  } | null;
};

export type GetTotalPointsEarnedQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalPointsEarnedQuery = {
  customer: { uuid: string; membership: { id: string; lifetimeMetrics: { pointsEarned: number } } | null } | null;
};

export type CreateOrderAheadSessionMutationVariables = Exact<{
  provider: OrderAheadProvider;
}>;

export type CreateOrderAheadSessionMutation = {
  result:
    | { __typename: 'LulaOrderAheadCreateSessionPayload'; iframeUrl: any }
    | { __typename: 'OloOrderAheadCreateSessionPayload'; iframeUrl: any };
};

export type OrderAheadSessionOloFragment = { __typename: 'OloOrderAheadCreateSessionPayload'; iframeUrl: any };

export type OrderAheadSessionLulaFragment = { __typename: 'LulaOrderAheadCreateSessionPayload'; iframeUrl: any };

export type StartTransactionMutationVariables = Exact<{
  input: TransactionStart;
}>;

export type StartTransactionMutation = {
  transaction: { uuid: string; primaryStatus: PrimaryTransactionStatus } | null;
};

export type TransactionFragment = {
  uuid: string;
  primaryStatus: PrimaryTransactionStatus;
  secondaryStatus: SecondaryTransactionStatus;
  completedAt: any | null;
  fuelingPosition: string | null;
  amount: { displayPrice: string; price: number } | null;
  tax: { displayPrice: string; price: number } | null;
  fuelReceipt: {
    priceG: string;
    product: string;
    fuelSale: string;
    tax: string;
    gallons: string;
    carWashCode: string | null;
    carWashName: string | null;
    carWashPrice: string | null;
  } | null;
  receiptLines: Array<{ lineNumber: number | null; value: string | null } | null> | null;
  location: {
    address: {
      city: string;
      street1: string;
      street2: string | null;
      state: string;
      zipCode: string;
      geoLocation: { latitude: number; longitude: number } | null;
    } | null;
  } | null;
  paymentInstrument: {
    uuid: string;
    alias: string | null;
    providerNickName: string | null;
    accountNumber: string | null;
    accountType: PaymentAccountType;
    paymentType: PaymentInstrumentType | null;
    balance: number | null;
    isDefault: boolean | null;
    displayNumber: string | null;
    status: PaymentInstrumentStatus;
    address: { zipCode: string } | null;
    expiration: { expirationMonth: string | null; expirationYear: string | null } | null;
  } | null;
};

export type TransactionQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type TransactionQuery = {
  transaction: {
    uuid: string;
    primaryStatus: PrimaryTransactionStatus;
    secondaryStatus: SecondaryTransactionStatus;
    completedAt: any | null;
    fuelingPosition: string | null;
    amount: { displayPrice: string; price: number } | null;
    tax: { displayPrice: string; price: number } | null;
    fuelReceipt: {
      priceG: string;
      product: string;
      fuelSale: string;
      tax: string;
      gallons: string;
      carWashCode: string | null;
      carWashName: string | null;
      carWashPrice: string | null;
    } | null;
    receiptLines: Array<{ lineNumber: number | null; value: string | null } | null> | null;
    location: {
      address: {
        city: string;
        street1: string;
        street2: string | null;
        state: string;
        zipCode: string;
        geoLocation: { latitude: number; longitude: number } | null;
      } | null;
    } | null;
    paymentInstrument: {
      uuid: string;
      alias: string | null;
      providerNickName: string | null;
      accountNumber: string | null;
      accountType: PaymentAccountType;
      paymentType: PaymentInstrumentType | null;
      balance: number | null;
      isDefault: boolean | null;
      displayNumber: string | null;
      status: PaymentInstrumentStatus;
      address: { zipCode: string } | null;
      expiration: { expirationMonth: string | null; expirationYear: string | null } | null;
    } | null;
  } | null;
};

export type StartPayInsideTransactionMutationVariables = Exact<{
  input: TransactionStart;
}>;

export type StartPayInsideTransactionMutation = {
  transaction: { uuid: string; stac: { id: string; expiration: any | null } | null } | null;
};

export type PointExpirationScheduleFragment = { date: any; points: number };

export type PointExpirationScheduleQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;

export type PointExpirationScheduleQuery = {
  currentCustomer: {
    uuid: string;
    membership: {
      id: string;
      points: number;
      pointExpirationSchedule: {
        pageInfo: {
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor: string | null;
          endCursor: string | null;
        };
        edges: Array<{ cursor: string; node: { date: any; points: number } }>;
      };
    } | null;
  } | null;
};

export type RedeemPromocodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type RedeemPromocodeMutation = {
  result:
    | { __typename: 'RedeemPromocodeResultFail'; reason: string | null }
    | {
        __typename: 'RedeemPromocodeResultSuccess';
        award:
          | { __typename: 'AwardPoints'; points: number }
          | {
              __typename: 'AwardVouchers';
              voucherCount: number;
              voucheredOffer: {
                id: string;
                voucherCount: number;
                marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
              };
            }
          | null;
      };
};

type PromocodeRedeemedAwardAwardPointsFragment = { __typename: 'AwardPoints'; points: number };

type PromocodeRedeemedAwardAwardVouchersFragment = {
  __typename: 'AwardVouchers';
  voucherCount: number;
  voucheredOffer: {
    id: string;
    voucherCount: number;
    marketingContents: Array<{ id: string; title: string | null; imageUrl: any | null } | null>;
  };
};

export type PromocodeRedeemedAwardFragment =
  | PromocodeRedeemedAwardAwardPointsFragment
  | PromocodeRedeemedAwardAwardVouchersFragment;

export type ReferralProgramConfigFragment = {
  __typename: 'ReferralProgramConfiguration';
  referralProgramEnabled: boolean;
  referralCodeManualEntryEnabled: boolean;
  receiverConfiguration: { instructions: string };
};

export type ReferralProgramSenderConfigQueryVariables = Exact<{ [key: string]: never }>;

export type ReferralProgramSenderConfigQuery = {
  appConfig: {
    loyaltyProgram: {
      referralProgramConfiguration: { senderConfiguration: { instructions: string; smsTemplate: string } } | null;
    };
  };
  currentCustomer: { uuid: string; membership: { id: string; referralCode: any; referralUrl: any } | null } | null;
};

export type SubmitReferralCodeSharedEventMutationVariables = Exact<{ [key: string]: never }>;

export type SubmitReferralCodeSharedEventMutation = { submitReferralCodeSharedEvent: { id: string; createdAt: any } };

export type SupportConfigurationFragment = {
  email: string;
  phoneNumber: string | null;
  widget:
    | { __typename: 'DevRevSupportWidgetConfiguration'; enabled: boolean; appId: string }
    | {
        __typename: 'FreshdeskSupportWidgetConfiguration';
        enabled: boolean;
        widgetId: string | null;
        token: string | null;
        host: string | null;
        sdkUrl: string | null;
      }
    | null;
};

type SupportWidgetConfigurationDevRevSupportWidgetConfigurationFragment = {
  __typename: 'DevRevSupportWidgetConfiguration';
  enabled: boolean;
  appId: string;
};

type SupportWidgetConfigurationFreshdeskSupportWidgetConfigurationFragment = {
  __typename: 'FreshdeskSupportWidgetConfiguration';
  enabled: boolean;
  widgetId: string | null;
  token: string | null;
  host: string | null;
  sdkUrl: string | null;
};

export type SupportWidgetConfigurationFragment =
  | SupportWidgetConfigurationDevRevSupportWidgetConfigurationFragment
  | SupportWidgetConfigurationFreshdeskSupportWidgetConfigurationFragment;

export const OfferByLoyaltyEventFragmentDoc = gql`
  fragment OfferByLoyaltyEvent on Offer {
    id
    trackingConfig {
      trackingId
      isActivityLogIncludedInAltriaDDM
    }
    customData
    marketingContents {
      id
      title
      shortDescription
      imageUrl
      terms
      disclaimer
      disclaimerUrl
    }
  }
`;
export const LoyaltyActivitySourceChainFragmentDoc = gql`
  fragment LoyaltyActivitySourceChain on Chain {
    id
  }
`;
export const LoyaltyActivitySourceActivateUserFragmentDoc = gql`
  fragment LoyaltyActivitySourceActivateUser on ActivateUser {
    id
  }
`;
export const LoyaltyActivitySourceLoyaltyEventFragmentDoc = gql`
  fragment LoyaltyActivitySourceLoyaltyEvent on LoyaltyEvent {
    eventType
    createdAt
  }
`;
export const LoyaltyActivitySourceActivateTransactionFragmentDoc = gql`
  fragment LoyaltyActivitySourceActivateTransaction on ActivateTransaction {
    id
  }
`;
export const LoyaltyActivitySourceOfferPurchaseFragmentDoc = gql`
  fragment LoyaltyActivitySourceOfferPurchase on OfferPurchase {
    purchasedWith {
      id
      name
      marketingContents {
        id
        title
      }
    }
  }
`;
export const LoyaltyActivitySourcePointChangeFragmentDoc = gql`
  fragment LoyaltyActivitySourcePointChange on PointChange {
    id
    offer {
      id
      name
      marketingContents {
        id
        title
      }
    }
  }
`;
export const PointChangeFragmentDoc = gql`
  fragment PointChange on PointChange {
    id
    createdAt
    quantity
    type
    notes
    source {
      __typename
      ...LoyaltyActivitySourceChain
      ...LoyaltyActivitySourceActivateUser
      ...LoyaltyActivitySourceLoyaltyEvent
      ...LoyaltyActivitySourceActivateTransaction
      ...LoyaltyActivitySourceOfferPurchase
      ...LoyaltyActivitySourcePointChange
    }
    offer {
      id
      name
      marketingContents {
        id
        title
      }
    }
  }
  ${LoyaltyActivitySourceChainFragmentDoc}
  ${LoyaltyActivitySourceActivateUserFragmentDoc}
  ${LoyaltyActivitySourceLoyaltyEventFragmentDoc}
  ${LoyaltyActivitySourceActivateTransactionFragmentDoc}
  ${LoyaltyActivitySourceOfferPurchaseFragmentDoc}
  ${LoyaltyActivitySourcePointChangeFragmentDoc}
`;
export const ActivateTransactionFragmentDoc = gql`
  fragment ActivateTransaction on ActivateTransaction {
    id
    totalTax
    totalAmount
    subtotalAmount
    totalDiscountAmount
    totalAmountWithoutDiscounts
    totalPointsEarned
    totalPointsRefunded
    totalPointsSpent
    status
    vendorName
    lineItems {
      id
      group
      moneyAmount
      quantity
      sku
      upc
      fuelGradeId
      promotions {
        offer {
          id
          marketingContents {
            id
            title
            shortDescription
          }
        }
        promotionAmount
        promotionReason
        promotionTitle
      }
      externalLineItemPromotions {
        id
        discountAmount
        promotionReason
      }
    }
    createdAt
    location {
      id
      address1
      address2
      state
      city
      name
      zipcode
    }
    paymentInfos {
      tenderType
      tenderSubtype
    }
  }
`;
export const ActivateLineItemPromotionFragmentDoc = gql`
  fragment ActivateLineItemPromotion on ActivateLineItemPromotion {
    offer {
      id
      marketingContents {
        id
        title
        shortDescription
      }
    }
    promotionAmount
    promotionReason
    promotionTitle
  }
`;
export const AwardPointsFragmentDoc = gql`
  fragment AwardPoints on AwardPoints {
    __typename
    points
  }
`;
export const AwardVouchersSurveyFragmentDoc = gql`
  fragment AwardVouchersSurvey on AwardVouchers {
    __typename
    voucheredOffer {
      id
      marketingContents {
        id
        title
        imageUrl
      }
    }
  }
`;
export const BaseSurveyFragmentDoc = gql`
  fragment BaseSurvey on Survey {
    __typename
    uuid
    award {
      ...AwardPoints
      ...AwardVouchersSurvey
    }
  }
  ${AwardPointsFragmentDoc}
  ${AwardVouchersSurveyFragmentDoc}
`;
export const SurveyQuestionFragmentDoc = gql`
  fragment SurveyQuestion on SurveyQuestion {
    __typename
    uuid
    index
    questionText
  }
`;
export const WalletSteeringSurveyFragmentDoc = gql`
  fragment WalletSteeringSurvey on WalletSteeringSurvey {
    ...BaseSurvey
    questions {
      ...SurveyQuestion
      fields {
        uuid
      }
    }
    configuration {
      steeringWalletUuid
      questionText
      steeringWalletUnitOfMeasure
      maxUnits
      minUnits
    }
  }
  ${BaseSurveyFragmentDoc}
  ${SurveyQuestionFragmentDoc}
`;
export const GeneralSurveyFragmentDoc = gql`
  fragment GeneralSurvey on GeneralSurvey {
    ...BaseSurvey
    questions {
      ...SurveyQuestion
      ... on SurveyQuestionIntSlider {
        min
        max
      }
      ... on SurveyQuestionSingleChoice {
        options {
          uuid
          index
          label
        }
      }
      ... on SurveyQuestionMultipleChoice {
        options {
          uuid
          index
          label
        }
      }
    }
    configuration {
      startDate
      endDate
    }
  }
  ${BaseSurveyFragmentDoc}
  ${SurveyQuestionFragmentDoc}
`;
export const SurveyFragmentDoc = gql`
  fragment Survey on Survey {
    ... on WalletSteeringSurvey {
      ...WalletSteeringSurvey
    }
    ... on GeneralSurvey {
      ...GeneralSurvey
    }
  }
  ${WalletSteeringSurveyFragmentDoc}
  ${GeneralSurveyFragmentDoc}
`;
export const FulfilledOfferFragmentDoc = gql`
  fragment FulfilledOffer on Offer {
    id
    earningMechanism {
      __typename
      ... on EarningMechanismProductPurchase {
        id
      }
      ... on EarningMechanismVisits {
        id
      }
      ... on EarningMechanismVarietyPurchaseOverTime {
        id
      }
      ... on EarningMechanismPointSpend {
        id
      }
      ... on EarningMechanismExternalFulfillment {
        id
      }
      ... on EarningMechanismLoyaltyEvent {
        id
      }
      ... on EarningMechanismMembershipEvent {
        id
      }
      ... on EarningMechanismTotalEligiblePurchase {
        id
      }
      ... on EarningMechanismTotalEligiblePurchaseOverTime {
        id
      }
      ... on EarningMechanismTotalSpendOverTime {
        id
      }
      ... on EarningMechanismVarietyPurchase {
        id
      }
      ... on EarningMechanismProductDiscount {
        id
      }
      ... on EarningMechanismTransactionDiscount {
        id
      }
      ... on EarningMechanismVarietyDiscount {
        id
      }
    }
  }
`;
export const OfferFulfillmentFragmentDoc = gql`
  fragment OfferFulfillment on RuleFulfillment {
    id
    fulfillmentCount
    fulfilledOffer {
      ...FulfilledOffer
    }
  }
  ${FulfilledOfferFragmentDoc}
`;
export const TransactionWithOfferFulfillmentFragmentDoc = gql`
  fragment TransactionWithOfferFulfillment on ActivateTransaction {
    id
    createdAt
    offerFulfillments {
      ...OfferFulfillment
    }
  }
  ${OfferFulfillmentFragmentDoc}
`;
export const AuthPayloadFragmentDoc = gql`
  fragment AuthPayload on AuthPayload {
    __typename
    tokens {
      accessToken
      refreshToken
    }
  }
`;
export const CustomerOtpPayloadFragmentDoc = gql`
  fragment CustomerOTPPayload on CustomerOTPPayload {
    __typename
    session
    success
  }
`;
export const SignupWithOtpSuccessFragmentDoc = gql`
  fragment SignupWithOTPSuccess on ExchangeSessionAndOTPToAuthTokenResultSuccess {
    success
    tokens {
      accessToken
      refreshToken
    }
  }
`;
export const SignupWithOtpIncorrectOtpFragmentDoc = gql`
  fragment SignupWithOTPIncorrectOTP on ExchangeSessionAndOTPToAuthTokenResultFailedIncorrectOTP {
    success
  }
`;
export const CommunicationPreferenceFragmentDoc = gql`
  fragment CommunicationPreference on CommunicationPreference {
    smsOptIn
    pushOptIn
    smsOptOutReason
  }
`;
export const OrderAheadConfigurationProviderVroomFragmentDoc = gql`
  fragment OrderAheadConfigurationProviderVroom on OrderAheadConfigurationProviderVroom {
    urlTemplate
    __typename
  }
`;
export const OrderAheadConfigurationProviderOloFragmentDoc = gql`
  fragment OrderAheadConfigurationProviderOlo on OrderAheadConfigurationProviderOlo {
    __typename
  }
`;
export const AgeVerificationRequireAdditionalPromptFragmentDoc = gql`
  fragment AgeVerificationRequireAdditionalPrompt on EaivAgeVerificationRequireAdditionalPrompt {
    prompt
  }
`;
export const IdentityVerificationChoiceQuestionOptionFragmentDoc = gql`
  fragment IdentityVerificationChoiceQuestionOption on EaivIdentityVerificationChoiceQuestionOption {
    id
    text
  }
`;
export const IdentityVerificationChoiceQuestionFragmentDoc = gql`
  fragment IdentityVerificationChoiceQuestion on EaivIdentityVerificationChoiceQuestion {
    id
    text
    helpText
    choices {
      ...IdentityVerificationChoiceQuestionOption
    }
  }
  ${IdentityVerificationChoiceQuestionOptionFragmentDoc}
`;
export const IdentityVerificationQuestionSetFragmentDoc = gql`
  fragment IdentityVerificationQuestionSet on EaivIdentityVerificationQuestionSet {
    id
    questions {
      __typename
      ...IdentityVerificationChoiceQuestion
    }
  }
  ${IdentityVerificationChoiceQuestionFragmentDoc}
`;
export const IdentityVerificationStartResultSuccessFragmentDoc = gql`
  fragment IdentityVerificationStartResultSuccess on EaivIdentityVerificationStartResultSuccess {
    conversationId
    questionSet {
      ...IdentityVerificationQuestionSet
    }
  }
  ${IdentityVerificationQuestionSetFragmentDoc}
`;
export const IdentityVerificationRequireAdditionalPromptFragmentDoc = gql`
  fragment IdentityVerificationRequireAdditionalPrompt on EaivIdentityVerificationRequireAdditionalPrompt {
    prompt
  }
`;
export const IdentityVerificationStartResultContinueFragmentDoc = gql`
  fragment IdentityVerificationStartResultContinue on EaivIdentityVerificationSubmitResultContinue {
    conversationId
    questionSet {
      ...IdentityVerificationQuestionSet
    }
  }
  ${IdentityVerificationQuestionSetFragmentDoc}
`;
export const ProductCategoryFragmentDoc = gql`
  fragment ProductCategory on ProductCategory {
    id
    name
    rank
    categoryRestriction
  }
`;
export const StoreFuelGradeFragmentDoc = gql`
  fragment StoreFuelGrade on FuelGradePrice {
    description
    unitPrice {
      cashPrice
      creditPrice
    }
  }
`;
export const StoreWorkingHoursFragmentDoc = gql`
  fragment StoreWorkingHours on HoursOfOperationGroup {
    hours {
      dayOfWeek
      openTime
      closeTime
    }
  }
`;
export const StorePhoneNumberFragmentDoc = gql`
  fragment StorePhoneNumber on ContactPhoneNumber {
    alias
    phoneNumber
    phoneType
    uuid
  }
`;
export const StoreAttributeFragmentDoc = gql`
  fragment StoreAttribute on LocationAttribute {
    description
    name
    value
  }
`;
export const StoreAddressFragmentDoc = gql`
  fragment StoreAddress on Address {
    city
    street1
    street2
    state
    zipCode
    geoLocation {
      latitude
      longitude
    }
  }
`;
export const StoreCarWashItemFragmentDoc = gql`
  fragment StoreCarWashItem on SiteSystemCarWashItem {
    description
    posCode
    posCodeModifier
    productCode
    unitPrice
  }
`;
export const StorePumpConfigFragmentDoc = gql`
  fragment StorePumpConfig on SiteSystemFuelPumpProduct {
    outdoorPosition
    description
    posCode
    posCodeFormat
    productCode
  }
`;
export const StoreConfigurationFragmentDoc = gql`
  fragment StoreConfiguration on SiteSystemConfiguration {
    uuid
    identifier
    details {
      carWashDetails {
        ...StoreCarWashItem
      }
      fuelConfigDetails {
        ...StorePumpConfig
      }
    }
  }
  ${StoreCarWashItemFragmentDoc}
  ${StorePumpConfigFragmentDoc}
`;
export const StorePumpInfoFragmentDoc = gql`
  fragment StorePumpInfo on Location {
    uuid
    address {
      ...StoreAddress
    }
    siteSystemConfiguration {
      ...StoreConfiguration
    }
  }
  ${StoreAddressFragmentDoc}
  ${StoreConfigurationFragmentDoc}
`;
export const LoyaltyActivateTransactionItemFragmentDoc = gql`
  fragment LoyaltyActivateTransactionItem on ActivateTransaction {
    id
    createdAt
    totalAmount
    totalAmountWithoutDiscounts
    vendorName
    status
  }
`;
export const LoyaltyPointChangeItemFragmentDoc = gql`
  fragment LoyaltyPointChangeItem on PointChange {
    id
    type
    createdAt
    quantity
    notes
    offer {
      id
      name
    }
    source {
      __typename
      ...LoyaltyActivitySourceChain
      ...LoyaltyActivitySourceActivateUser
      ...LoyaltyActivitySourceLoyaltyEvent
      ...LoyaltyActivitySourceActivateTransaction
      ...LoyaltyActivitySourceOfferPurchase
      ...LoyaltyActivitySourcePointChange
    }
  }
  ${LoyaltyActivitySourceChainFragmentDoc}
  ${LoyaltyActivitySourceActivateUserFragmentDoc}
  ${LoyaltyActivitySourceLoyaltyEventFragmentDoc}
  ${LoyaltyActivitySourceActivateTransactionFragmentDoc}
  ${LoyaltyActivitySourceOfferPurchaseFragmentDoc}
  ${LoyaltyActivitySourcePointChangeFragmentDoc}
`;
export const TransactionHistoryItemFragmentDoc = gql`
  fragment TransactionHistoryItem on Transaction {
    uuid
    completedAt
    primaryStatus
    secondaryStatus
    amount {
      displayPrice
      price
    }
  }
`;
export const MembershipAddressFragmentDoc = gql`
  fragment MembershipAddress on MembershipAddress {
    address1
    address2
    city
    state
    zipcode
  }
`;
export const FuelProductGroupFragmentDoc = gql`
  fragment FuelProductGroup on FuelProductGroup {
    id
    productGroup {
      id
      name
    }
  }
`;
export const FuelAndConvenienceProfileFragmentDoc = gql`
  fragment FuelAndConvenienceProfile on FuelAndConvenienceProfile {
    restrictionVerification
    pendingVerification
    memberDataShare
    preferredFuelProductGroup {
      ...FuelProductGroup
    }
    achEnrollmentStatus
  }
  ${FuelProductGroupFragmentDoc}
`;
export const CustomerProfileFragmentDoc = gql`
  fragment CustomerProfile on Membership {
    __typename
    id
    customerUuid
    createdAt
    state
    isCompleted @client
    firstName
    lastName
    birthdate
    phone
    email
    programTermsAcceptanceAt
    primaryAddress {
      ...MembershipAddress
    }
    fuelAndConvenienceProfile {
      ...FuelAndConvenienceProfile
    }
    barcodeIdentifier
  }
  ${MembershipAddressFragmentDoc}
  ${FuelAndConvenienceProfileFragmentDoc}
`;
export const ExternalIdentityVerificationAttributeFragmentDoc = gql`
  fragment ExternalIdentityVerificationAttribute on ExternalIdentityVerificationAttribute {
    handle
    name
  }
`;
export const ExternalIdentityVerificationProfileFragmentDoc = gql`
  fragment ExternalIdentityVerificationProfile on ExternalIdentityVerificationProfile {
    completedAt
    provider
    attributes(filter: { isCoreAttributeOnly: true }) {
      ...ExternalIdentityVerificationAttribute
    }
  }
  ${ExternalIdentityVerificationAttributeFragmentDoc}
`;
export const MembershipFragmentDoc = gql`
  fragment Membership on Membership {
    ...CustomerProfile
    incomingReferral {
      status
    }
    points
    customData
    homeStores {
      locationUuid
    }
    externalIdentityVerificationProfiles {
      ...ExternalIdentityVerificationProfile
    }
  }
  ${CustomerProfileFragmentDoc}
  ${ExternalIdentityVerificationProfileFragmentDoc}
`;
export const AwardPointsPerFragmentDoc = gql`
  fragment AwardPointsPer on AwardPointsPer {
    __typename
    points
    rounding
  }
`;
export const AwardVouchersFragmentDoc = gql`
  fragment AwardVouchers on AwardVouchers {
    __typename
    voucherExpirationDays
    voucheredOffer {
      id
      voucherCount
      trackingConfig {
        trackingId
        isActivityLogIncludedInAltriaDDM
      }
    }
    voucherCount
  }
`;
export const AwardPointsOrVouchersFragmentDoc = gql`
  fragment AwardPointsOrVouchers on AwardPointsOrVouchers {
    __typename
    ...AwardVouchers
    ...AwardPoints
  }
  ${AwardVouchersFragmentDoc}
  ${AwardPointsFragmentDoc}
`;
export const EarningMechanismPromocodesFragmentDoc = gql`
  fragment EarningMechanismPromocodes on EarningMechanismPromocodes {
    id
    award {
      ...AwardPointsOrVouchers
    }
  }
  ${AwardPointsOrVouchersFragmentDoc}
`;
export const ExternalOfferFragmentDoc = gql`
  fragment ExternalOffer on Banner {
    trackingId
    bannerConfigurationUuid
    externalCampaignId
    content {
      title
      title2
      titleMiddle
      imageUrl
      surgeonGeneralWarning
    }
  }
`;
export const MarketingContentFragmentDoc = gql`
  fragment MarketingContent on MarketingContent {
    id
    imageUrl
    title
    shortDescription
    longDescription
    disclaimer
    disclaimerUrl
    terms
    termsUrl
    surgeonGeneralsWarning
    externalUrl
  }
`;
export const EarningMechanismProductPurchaseFragmentDoc = gql`
  fragment EarningMechanismProductPurchase on EarningMechanismProductPurchase {
    id
    award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismVisitsFragmentDoc = gql`
  fragment EarningMechanismVisits on EarningMechanismVisits {
    id
    visitsMemberProgress {
      visits
      visitsRequired
    }
    award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismVarietyPurchaseOverTimeFragmentDoc = gql`
  fragment EarningMechanismVarietyPurchaseOverTime on EarningMechanismVarietyPurchaseOverTime {
    id
    varietyMemberProgress {
      quantityPurchased
      quantityRequired
    }
    award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
    products {
      __typename
      countProductsBy
    }
  }
`;
export const EarningMechanismPointSpendFragmentDoc = gql`
  fragment EarningMechanismPointSpend on EarningMechanismPointSpend {
    __typename
    id
    award {
      __typename
      voucherExpirationDays
      voucheredOffer {
        id
        voucherCount
        trackingConfig {
          trackingId
          isActivityLogIncludedInAltriaDDM
        }
      }
      voucherCount
    }
    pointCost
  }
`;
export const EarningMechanismExternalFulfillmentFragmentDoc = gql`
  fragment EarningMechanismExternalFulfillment on EarningMechanismExternalFulfillment {
    id
    optionalAward: award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismLoyaltyEventFragmentDoc = gql`
  fragment EarningMechanismLoyaltyEvent on EarningMechanismLoyaltyEvent {
    id
    optionalAward: award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismMembershipEventFragmentDoc = gql`
  fragment EarningMechanismMembershipEvent on EarningMechanismMembershipEvent {
    id
    award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismTotalEligiblePurchaseFragmentDoc = gql`
  fragment EarningMechanismTotalEligiblePurchase on EarningMechanismTotalEligiblePurchase {
    id
    award {
      __typename
      points
      rounding
    }
  }
`;
export const EarningMechanismTotalEligiblePurchaseOverTimeFragmentDoc = gql`
  fragment EarningMechanismTotalEligiblePurchaseOverTime on EarningMechanismTotalEligiblePurchaseOverTime {
    id
    purchaseMemberProgress {
      quantityPurchased
      quantityRequired
    }
    award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismTotalSpendOverTimeFragmentDoc = gql`
  fragment EarningMechanismTotalSpendOverTime on EarningMechanismTotalSpendOverTime {
    id
    purchaseMemberProgress {
      quantityPurchased
      quantityRequired
    }
    award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismVarietyPurchaseFragmentDoc = gql`
  fragment EarningMechanismVarietyPurchase on EarningMechanismVarietyPurchase {
    id
    award {
      __typename
      ... on AwardPoints {
        __typename
        points
      }
      ... on AwardVouchers {
        __typename
        voucherExpirationDays
        voucheredOffer {
          id
          voucherCount
          trackingConfig {
            trackingId
            isActivityLogIncludedInAltriaDDM
          }
        }
        voucherCount
      }
    }
  }
`;
export const EarningMechanismProductDiscountFragmentDoc = gql`
  fragment EarningMechanismProductDiscount on EarningMechanismProductDiscount {
    __typename
    id
  }
`;
export const EarningMechanismTransactionDiscountFragmentDoc = gql`
  fragment EarningMechanismTransactionDiscount on EarningMechanismTransactionDiscount {
    __typename
    id
  }
`;
export const EarningMechanismVarietyDiscountFragmentDoc = gql`
  fragment EarningMechanismVarietyDiscount on EarningMechanismVarietyDiscount {
    __typename
    id
  }
`;
export const GameAwardVouchersFragmentDoc = gql`
  fragment GameAwardVouchers on AwardVouchers {
    __typename
    voucherExpirationDays
    voucheredOffer {
      __typename
      id
      trackingConfig {
        trackingId
        isActivityLogIncludedInAltriaDDM
      }
      marketingContents {
        ...MarketingContent
      }
    }
  }
  ${MarketingContentFragmentDoc}
`;
export const GameAwardPointsOrVouchersFragmentDoc = gql`
  fragment GameAwardPointsOrVouchers on AwardPointsOrVouchers {
    __typename
    ...AwardPoints
    ...GameAwardVouchers
  }
  ${AwardPointsFragmentDoc}
  ${GameAwardVouchersFragmentDoc}
`;
export const SpinWheelGamePrizeFragmentDoc = gql`
  fragment SpinWheelGamePrize on RandomAwardConfig {
    award {
      ...GameAwardPointsOrVouchers
    }
    awardType
    limit
    sequenceNumber
  }
  ${GameAwardPointsOrVouchersFragmentDoc}
`;
export const SpinWheelGameVoucherPurchaseFragmentDoc = gql`
  fragment SpinWheelGameVoucherPurchase on Offer {
    __typename
    id
    trackingConfig {
      trackingId
      isActivityLogIncludedInAltriaDDM
    }
    earningMechanism {
      __typename
      ... on EarningMechanismPointSpend {
        id
        pointCost
      }
    }
  }
`;
export const EarningMechanismSpinWheelGameFragmentDoc = gql`
  fragment EarningMechanismSpinWheelGame on EarningMechanismSpinWheelGame {
    __typename
    id
    awards {
      ...SpinWheelGamePrize
    }
    purchasableOffer {
      ...SpinWheelGameVoucherPurchase
    }
  }
  ${SpinWheelGamePrizeFragmentDoc}
  ${SpinWheelGameVoucherPurchaseFragmentDoc}
`;
export const DisplayCategoryFragmentDoc = gql`
  fragment DisplayCategory on DisplayCategory {
    id
    name
    rank
    categoryRestrictions
    bannerIds
  }
`;
export const LimitMembershipAwardCountFragmentDoc = gql`
  fragment LimitMembershipAwardCount on LimitMembershipAwardCount {
    __typename
    id
    limit
    membershipQuantityAvailable
  }
`;
export const LimitMembershipAwardCountInTimeFragmentDoc = gql`
  fragment LimitMembershipAwardCountInTime on LimitMembershipAwardCountInTime {
    __typename
    id
    limit
    membershipQuantityAvailable
  }
`;
export const LimitGlobalActivationFragmentDoc = gql`
  fragment LimitGlobalActivation on LimitGlobalActivation {
    __typename
    id
  }
`;
export const LimitGlobalActivationInTimeFragmentDoc = gql`
  fragment LimitGlobalActivationInTime on LimitGlobalActivationInTime {
    __typename
    id
  }
`;
export const LimitGlobalAwardCountFragmentDoc = gql`
  fragment LimitGlobalAwardCount on LimitGlobalAwardCount {
    __typename
    id
  }
`;
export const LimitGlobalAwardCountInTimeFragmentDoc = gql`
  fragment LimitGlobalAwardCountInTime on LimitGlobalAwardCountInTime {
    __typename
    id
  }
`;
export const LimitMembershipActivationFragmentDoc = gql`
  fragment LimitMembershipActivation on LimitMembershipActivation {
    __typename
    id
  }
`;
export const LimitMembershipActivationInTimeFragmentDoc = gql`
  fragment LimitMembershipActivationInTime on LimitMembershipActivationInTime {
    __typename
    id
  }
`;
export const LimitMembershipProgressInTimeFragmentDoc = gql`
  fragment LimitMembershipProgressInTime on LimitMembershipProgressInTime {
    __typename
    id
  }
`;
export const LimitInTransactionAwardCountFragmentDoc = gql`
  fragment LimitInTransactionAwardCount on LimitInTransactionAwardCount {
    __typename
    id
  }
`;
export const LimitInTransactionProgressFragmentDoc = gql`
  fragment LimitInTransactionProgress on LimitInTransactionProgress {
    __typename
    id
  }
`;
export const LimitMembershipTransactionCountFragmentDoc = gql`
  fragment LimitMembershipTransactionCount on LimitMembershipTransactionCount {
    __typename
    id
  }
`;
export const LimitMembershipTransactionCountInTimeFragmentDoc = gql`
  fragment LimitMembershipTransactionCountInTime on LimitMembershipTransactionCountInTime {
    __typename
    id
  }
`;
export const LimitFragmentDoc = gql`
  fragment Limit on Limit {
    ...LimitMembershipAwardCount
    ...LimitMembershipAwardCountInTime
    ...LimitGlobalActivation
    ...LimitGlobalActivationInTime
    ...LimitGlobalAwardCount
    ...LimitGlobalAwardCountInTime
    ...LimitMembershipActivation
    ...LimitMembershipActivationInTime
    ...LimitMembershipProgressInTime
    ...LimitInTransactionAwardCount
    ...LimitInTransactionProgress
    ...LimitMembershipTransactionCount
    ...LimitMembershipTransactionCountInTime
  }
  ${LimitMembershipAwardCountFragmentDoc}
  ${LimitMembershipAwardCountInTimeFragmentDoc}
  ${LimitGlobalActivationFragmentDoc}
  ${LimitGlobalActivationInTimeFragmentDoc}
  ${LimitGlobalAwardCountFragmentDoc}
  ${LimitGlobalAwardCountInTimeFragmentDoc}
  ${LimitMembershipActivationFragmentDoc}
  ${LimitMembershipActivationInTimeFragmentDoc}
  ${LimitMembershipProgressInTimeFragmentDoc}
  ${LimitInTransactionAwardCountFragmentDoc}
  ${LimitInTransactionProgressFragmentDoc}
  ${LimitMembershipTransactionCountFragmentDoc}
  ${LimitMembershipTransactionCountInTimeFragmentDoc}
`;
export const OfferAvailableAtLocationFragmentDoc = gql`
  fragment OfferAvailableAtLocation on Location {
    address @include(if: $availableAtLocationsIncluded) {
      ...StoreAddress
    }
    name @include(if: $availableAtLocationsIncluded)
  }
  ${StoreAddressFragmentDoc}
`;
export const ConstraintStoreLocationFragmentDoc = gql`
  fragment constraintStoreLocation on ConstraintStoreLocation {
    id
  }
`;
export const ConstraintStoreLocationGroupFragmentDoc = gql`
  fragment constraintStoreLocationGroup on ConstraintStoreLocationGroup {
    id
  }
`;
export const OfferFragmentDoc = gql`
  fragment Offer on Offer {
    __typename
    id
    trackingConfig {
      trackingId
      isActivityLogIncludedInAltriaDDM
    }
    expireAt
    engagementType
    activationStatus
    visibleStatus
    ineligibilityReason
    marketingContents {
      ...MarketingContent
    }
    earningMechanism {
      __typename
      ...EarningMechanismProductPurchase
      ...EarningMechanismVisits
      ...EarningMechanismVarietyPurchaseOverTime
      ...EarningMechanismPointSpend
      ...EarningMechanismExternalFulfillment
      ...EarningMechanismLoyaltyEvent
      ...EarningMechanismMembershipEvent
      ...EarningMechanismTotalEligiblePurchase
      ...EarningMechanismTotalEligiblePurchaseOverTime
      ...EarningMechanismTotalSpendOverTime
      ...EarningMechanismVarietyPurchase
      ...EarningMechanismProductDiscount
      ...EarningMechanismTransactionDiscount
      ...EarningMechanismVarietyDiscount
      ...EarningMechanismSpinWheelGame
    }
    customData
    voucherCount
    vouchers @include(if: $offerVouchersIncluded) {
      edges {
        node {
          id
          expireAt
          createdAt
          state
        }
      }
    }
    presentationPriority
    presentationType
    displayCategories {
      ...DisplayCategory
    }
    limits @include(if: $offerLimitsIncluded) {
      ...Limit
    }
    availableAtLocations {
      uuid
      ...OfferAvailableAtLocation
    }
    constraints @include(if: $constraintsIncluded) {
      __typename
      ...constraintStoreLocation
      ...constraintStoreLocationGroup
    }
  }
  ${MarketingContentFragmentDoc}
  ${EarningMechanismProductPurchaseFragmentDoc}
  ${EarningMechanismVisitsFragmentDoc}
  ${EarningMechanismVarietyPurchaseOverTimeFragmentDoc}
  ${EarningMechanismPointSpendFragmentDoc}
  ${EarningMechanismExternalFulfillmentFragmentDoc}
  ${EarningMechanismLoyaltyEventFragmentDoc}
  ${EarningMechanismMembershipEventFragmentDoc}
  ${EarningMechanismTotalEligiblePurchaseFragmentDoc}
  ${EarningMechanismTotalEligiblePurchaseOverTimeFragmentDoc}
  ${EarningMechanismTotalSpendOverTimeFragmentDoc}
  ${EarningMechanismVarietyPurchaseFragmentDoc}
  ${EarningMechanismProductDiscountFragmentDoc}
  ${EarningMechanismTransactionDiscountFragmentDoc}
  ${EarningMechanismVarietyDiscountFragmentDoc}
  ${EarningMechanismSpinWheelGameFragmentDoc}
  ${DisplayCategoryFragmentDoc}
  ${LimitFragmentDoc}
  ${OfferAvailableAtLocationFragmentDoc}
  ${ConstraintStoreLocationFragmentDoc}
  ${ConstraintStoreLocationGroupFragmentDoc}
`;
export const ParPaySessionFragmentDoc = gql`
  fragment ParPaySession on ParPayTokenizationSession {
    iframeUrl
    rawResponse
    responseCode
    responseText
    sessionId
  }
`;
export const ExternalIdentityVerificationParamsFragmentDoc = gql`
  fragment ExternalIdentityVerificationParams on ExternalIdentityVerificationAuthorizationUrlPayload {
    clientId
    scope
    grantType
    state
    authorizationUrl
  }
`;
export const LocationFragmentDoc = gql`
  fragment Location on Location {
    uuid
  }
`;
export const OrderAheadSessionOloFragmentDoc = gql`
  fragment OrderAheadSessionOlo on OloOrderAheadCreateSessionPayload {
    iframeUrl
    __typename
  }
`;
export const OrderAheadSessionLulaFragmentDoc = gql`
  fragment OrderAheadSessionLula on LulaOrderAheadCreateSessionPayload {
    iframeUrl
    __typename
  }
`;
export const PaymentInstrumentFragmentDoc = gql`
  fragment PaymentInstrument on PaymentInstrument {
    uuid
    alias
    providerNickName
    accountNumber
    accountType
    paymentType
    balance
    isDefault
    displayNumber
    status
    address {
      zipCode
    }
    expiration {
      expirationMonth
      expirationYear
    }
  }
`;
export const TransactionFragmentDoc = gql`
  fragment Transaction on Transaction {
    uuid
    primaryStatus
    secondaryStatus
    completedAt
    amount {
      displayPrice
      price
    }
    tax {
      displayPrice
      price
    }
    fuelReceipt {
      priceG
      product
      fuelSale
      tax
      gallons
      carWashCode
      carWashName
      carWashPrice
    }
    receiptLines {
      lineNumber
      value
    }
    location {
      address {
        ...StoreAddress
      }
    }
    fuelingPosition
    paymentInstrument {
      ...PaymentInstrument
    }
  }
  ${StoreAddressFragmentDoc}
  ${PaymentInstrumentFragmentDoc}
`;
export const PointExpirationScheduleFragmentDoc = gql`
  fragment PointExpirationSchedule on PointExpirationSchedule {
    date
    points
  }
`;
export const PromocodeRedeemedAwardFragmentDoc = gql`
  fragment PromocodeRedeemedAward on AwardPointsOrVouchers {
    __typename
    ... on AwardPoints {
      __typename
      points
    }
    ... on AwardVouchers {
      __typename
      voucheredOffer {
        id
        voucherCount
        marketingContents {
          id
          title
          imageUrl
        }
      }
      voucherCount
    }
  }
`;
export const ReferralProgramConfigFragmentDoc = gql`
  fragment ReferralProgramConfig on ReferralProgramConfiguration {
    __typename
    referralProgramEnabled
    referralCodeManualEntryEnabled
    receiverConfiguration {
      instructions
    }
  }
`;
export const SupportWidgetConfigurationFragmentDoc = gql`
  fragment SupportWidgetConfiguration on SupportWidgetConfiguration {
    __typename
    ... on FreshdeskSupportWidgetConfiguration {
      enabled
      widgetId
      token
      host
      sdkUrl
    }
    ... on DevRevSupportWidgetConfiguration {
      enabled
      appId
    }
  }
`;
export const SupportConfigurationFragmentDoc = gql`
  fragment SupportConfiguration on SupportConfiguration {
    email
    phoneNumber
    widget {
      ...SupportWidgetConfiguration
    }
  }
  ${SupportWidgetConfigurationFragmentDoc}
`;
export const CustomerMakeActiveDocument = gql`
  mutation customerMakeActive {
    membershipStateTransition(input: { state: ACTIVE }) {
      __typename
      id
      customerUuid
      state
    }
  }
`;
export type CustomerMakeActiveMutationFn = Apollo.MutationFunction<
  CustomerMakeActiveMutation,
  CustomerMakeActiveMutationVariables
>;

/**
 * __useCustomerMakeActiveMutation__
 *
 * To run a mutation, you first call `useCustomerMakeActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerMakeActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerMakeActiveMutation, { data, loading, error }] = useCustomerMakeActiveMutation({
 *   variables: {
 *   },
 * });
 */
export function useCustomerMakeActiveMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomerMakeActiveMutation, CustomerMakeActiveMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CustomerMakeActiveMutation, CustomerMakeActiveMutationVariables>(
    CustomerMakeActiveDocument,
    options,
  );
}
export type CustomerMakeActiveMutationHookResult = ReturnType<typeof useCustomerMakeActiveMutation>;
export type CustomerMakeActiveMutationResult = Apollo.MutationResult<CustomerMakeActiveMutation>;
export type CustomerMakeActiveMutationOptions = Apollo.BaseMutationOptions<
  CustomerMakeActiveMutation,
  CustomerMakeActiveMutationVariables
>;
export const CustomerResetPinCodeDocument = gql`
  mutation customerResetPinCode {
    success: customerPinCodeReset
  }
`;
export type CustomerResetPinCodeMutationFn = Apollo.MutationFunction<
  CustomerResetPinCodeMutation,
  CustomerResetPinCodeMutationVariables
>;

/**
 * __useCustomerResetPinCodeMutation__
 *
 * To run a mutation, you first call `useCustomerResetPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerResetPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerResetPinCodeMutation, { data, loading, error }] = useCustomerResetPinCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCustomerResetPinCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomerResetPinCodeMutation, CustomerResetPinCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CustomerResetPinCodeMutation, CustomerResetPinCodeMutationVariables>(
    CustomerResetPinCodeDocument,
    options,
  );
}
export type CustomerResetPinCodeMutationHookResult = ReturnType<typeof useCustomerResetPinCodeMutation>;
export type CustomerResetPinCodeMutationResult = Apollo.MutationResult<CustomerResetPinCodeMutation>;
export type CustomerResetPinCodeMutationOptions = Apollo.BaseMutationOptions<
  CustomerResetPinCodeMutation,
  CustomerResetPinCodeMutationVariables
>;
export const CustomerSetPinCodeDocument = gql`
  mutation customerSetPinCode($pinCode: String!) {
    success: customerPinCodeSet(input: { pinCode: { pinCode: $pinCode } })
  }
`;
export type CustomerSetPinCodeMutationFn = Apollo.MutationFunction<
  CustomerSetPinCodeMutation,
  CustomerSetPinCodeMutationVariables
>;

/**
 * __useCustomerSetPinCodeMutation__
 *
 * To run a mutation, you first call `useCustomerSetPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerSetPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerSetPinCodeMutation, { data, loading, error }] = useCustomerSetPinCodeMutation({
 *   variables: {
 *      pinCode: // value for 'pinCode'
 *   },
 * });
 */
export function useCustomerSetPinCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomerSetPinCodeMutation, CustomerSetPinCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CustomerSetPinCodeMutation, CustomerSetPinCodeMutationVariables>(
    CustomerSetPinCodeDocument,
    options,
  );
}
export type CustomerSetPinCodeMutationHookResult = ReturnType<typeof useCustomerSetPinCodeMutation>;
export type CustomerSetPinCodeMutationResult = Apollo.MutationResult<CustomerSetPinCodeMutation>;
export type CustomerSetPinCodeMutationOptions = Apollo.BaseMutationOptions<
  CustomerSetPinCodeMutation,
  CustomerSetPinCodeMutationVariables
>;
export const CustomerVerifyPinCodeDocument = gql`
  mutation customerVerifyPinCode($pinCode: String!) {
    success: customerPinCodeVerify(input: { pinCode: { pinCode: $pinCode } })
  }
`;
export type CustomerVerifyPinCodeMutationFn = Apollo.MutationFunction<
  CustomerVerifyPinCodeMutation,
  CustomerVerifyPinCodeMutationVariables
>;

/**
 * __useCustomerVerifyPinCodeMutation__
 *
 * To run a mutation, you first call `useCustomerVerifyPinCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerVerifyPinCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerVerifyPinCodeMutation, { data, loading, error }] = useCustomerVerifyPinCodeMutation({
 *   variables: {
 *      pinCode: // value for 'pinCode'
 *   },
 * });
 */
export function useCustomerVerifyPinCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomerVerifyPinCodeMutation, CustomerVerifyPinCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CustomerVerifyPinCodeMutation, CustomerVerifyPinCodeMutationVariables>(
    CustomerVerifyPinCodeDocument,
    options,
  );
}
export type CustomerVerifyPinCodeMutationHookResult = ReturnType<typeof useCustomerVerifyPinCodeMutation>;
export type CustomerVerifyPinCodeMutationResult = Apollo.MutationResult<CustomerVerifyPinCodeMutation>;
export type CustomerVerifyPinCodeMutationOptions = Apollo.BaseMutationOptions<
  CustomerVerifyPinCodeMutation,
  CustomerVerifyPinCodeMutationVariables
>;
export const GetAtTheStoreWithPumpsDocument = gql`
  query getAtTheStoreWithPumps($geoLocation: GeoLocationFilter) {
    store: locations(filter: { geoLocation: $geoLocation, isPayAtPumpEnabled: true }, first: 1) {
      edges {
        node {
          uuid
          siteSystemConfiguration {
            uuid
            details {
              fuelConfigDetails {
                outdoorPosition
              }
            }
            mobileEnabled
          }
        }
      }
    }
  }
`;

/**
 * __useGetAtTheStoreWithPumpsQuery__
 *
 * To run a query within a React component, call `useGetAtTheStoreWithPumpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtTheStoreWithPumpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtTheStoreWithPumpsQuery({
 *   variables: {
 *      geoLocation: // value for 'geoLocation'
 *   },
 * });
 */
export function useGetAtTheStoreWithPumpsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAtTheStoreWithPumpsQuery, GetAtTheStoreWithPumpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAtTheStoreWithPumpsQuery, GetAtTheStoreWithPumpsQueryVariables>(
    GetAtTheStoreWithPumpsDocument,
    options,
  );
}
export function useGetAtTheStoreWithPumpsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAtTheStoreWithPumpsQuery, GetAtTheStoreWithPumpsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAtTheStoreWithPumpsQuery, GetAtTheStoreWithPumpsQueryVariables>(
    GetAtTheStoreWithPumpsDocument,
    options,
  );
}
export function useGetAtTheStoreWithPumpsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAtTheStoreWithPumpsQuery, GetAtTheStoreWithPumpsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAtTheStoreWithPumpsQuery, GetAtTheStoreWithPumpsQueryVariables>(
    GetAtTheStoreWithPumpsDocument,
    options,
  );
}
export type GetAtTheStoreWithPumpsQueryHookResult = ReturnType<typeof useGetAtTheStoreWithPumpsQuery>;
export type GetAtTheStoreWithPumpsLazyQueryHookResult = ReturnType<typeof useGetAtTheStoreWithPumpsLazyQuery>;
export type GetAtTheStoreWithPumpsSuspenseQueryHookResult = ReturnType<typeof useGetAtTheStoreWithPumpsSuspenseQuery>;
export type GetAtTheStoreWithPumpsQueryResult = Apollo.QueryResult<
  GetAtTheStoreWithPumpsQuery,
  GetAtTheStoreWithPumpsQueryVariables
>;
export const GetOffersByLoyaltyEventDocument = gql`
  query getOffersByLoyaltyEvent(
    $loyaltyEventEquals: String!
    $publicationStatusEquals: PUBLICATION_STATUS_TYPE!
    $visibleStatusEquals: OFFER_VISIBLE_STATUS!
  ) {
    currentCustomer {
      uuid
      membership {
        id
        offers(
          first: 1
          filter: {
            loyaltyEventEquals: $loyaltyEventEquals
            deleted: false
            publicationStatusEquals: $publicationStatusEquals
            visibleStatusEquals: $visibleStatusEquals
          }
        ) {
          edges {
            node {
              ...OfferByLoyaltyEvent
            }
          }
        }
      }
    }
  }
  ${OfferByLoyaltyEventFragmentDoc}
`;

/**
 * __useGetOffersByLoyaltyEventQuery__
 *
 * To run a query within a React component, call `useGetOffersByLoyaltyEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffersByLoyaltyEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffersByLoyaltyEventQuery({
 *   variables: {
 *      loyaltyEventEquals: // value for 'loyaltyEventEquals'
 *      publicationStatusEquals: // value for 'publicationStatusEquals'
 *      visibleStatusEquals: // value for 'visibleStatusEquals'
 *   },
 * });
 */
export function useGetOffersByLoyaltyEventQuery(
  baseOptions: Apollo.QueryHookOptions<GetOffersByLoyaltyEventQuery, GetOffersByLoyaltyEventQueryVariables> &
    ({ variables: GetOffersByLoyaltyEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOffersByLoyaltyEventQuery, GetOffersByLoyaltyEventQueryVariables>(
    GetOffersByLoyaltyEventDocument,
    options,
  );
}
export function useGetOffersByLoyaltyEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOffersByLoyaltyEventQuery, GetOffersByLoyaltyEventQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOffersByLoyaltyEventQuery, GetOffersByLoyaltyEventQueryVariables>(
    GetOffersByLoyaltyEventDocument,
    options,
  );
}
export function useGetOffersByLoyaltyEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOffersByLoyaltyEventQuery, GetOffersByLoyaltyEventQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOffersByLoyaltyEventQuery, GetOffersByLoyaltyEventQueryVariables>(
    GetOffersByLoyaltyEventDocument,
    options,
  );
}
export type GetOffersByLoyaltyEventQueryHookResult = ReturnType<typeof useGetOffersByLoyaltyEventQuery>;
export type GetOffersByLoyaltyEventLazyQueryHookResult = ReturnType<typeof useGetOffersByLoyaltyEventLazyQuery>;
export type GetOffersByLoyaltyEventSuspenseQueryHookResult = ReturnType<typeof useGetOffersByLoyaltyEventSuspenseQuery>;
export type GetOffersByLoyaltyEventQueryResult = Apollo.QueryResult<
  GetOffersByLoyaltyEventQuery,
  GetOffersByLoyaltyEventQueryVariables
>;
export const LoyaltyEventCreateDocument = gql`
  mutation loyaltyEventCreate($input: LoyaltyEventCreate!) {
    event: loyaltyEventCreate(input: $input) {
      eventData
      eventType
      createdAt
    }
  }
`;
export type LoyaltyEventCreateMutationFn = Apollo.MutationFunction<
  LoyaltyEventCreateMutation,
  LoyaltyEventCreateMutationVariables
>;

/**
 * __useLoyaltyEventCreateMutation__
 *
 * To run a mutation, you first call `useLoyaltyEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyEventCreateMutation, { data, loading, error }] = useLoyaltyEventCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoyaltyEventCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<LoyaltyEventCreateMutation, LoyaltyEventCreateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoyaltyEventCreateMutation, LoyaltyEventCreateMutationVariables>(
    LoyaltyEventCreateDocument,
    options,
  );
}
export type LoyaltyEventCreateMutationHookResult = ReturnType<typeof useLoyaltyEventCreateMutation>;
export type LoyaltyEventCreateMutationResult = Apollo.MutationResult<LoyaltyEventCreateMutation>;
export type LoyaltyEventCreateMutationOptions = Apollo.BaseMutationOptions<
  LoyaltyEventCreateMutation,
  LoyaltyEventCreateMutationVariables
>;
export const OfferPurchaseDocument = gql`
  mutation offerPurchase($input: OfferPurchaseCreate!) {
    offers: offerPurchaseCreate(input: $input) {
      pointCost
    }
  }
`;
export type OfferPurchaseMutationFn = Apollo.MutationFunction<OfferPurchaseMutation, OfferPurchaseMutationVariables>;

/**
 * __useOfferPurchaseMutation__
 *
 * To run a mutation, you first call `useOfferPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerPurchaseMutation, { data, loading, error }] = useOfferPurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOfferPurchaseMutation(
  baseOptions?: Apollo.MutationHookOptions<OfferPurchaseMutation, OfferPurchaseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OfferPurchaseMutation, OfferPurchaseMutationVariables>(OfferPurchaseDocument, options);
}
export type OfferPurchaseMutationHookResult = ReturnType<typeof useOfferPurchaseMutation>;
export type OfferPurchaseMutationResult = Apollo.MutationResult<OfferPurchaseMutation>;
export type OfferPurchaseMutationOptions = Apollo.BaseMutationOptions<
  OfferPurchaseMutation,
  OfferPurchaseMutationVariables
>;
export const GetPointsChangeDocument = gql`
  query getPointsChange($id: ID!) {
    transactionHistory: currentCustomer {
      uuid
      membership {
        id
        pointChanges(filter: { idEquals: $id }) {
          edges {
            cursor
            node {
              ...PointChange
            }
          }
        }
      }
    }
  }
  ${PointChangeFragmentDoc}
`;

/**
 * __useGetPointsChangeQuery__
 *
 * To run a query within a React component, call `useGetPointsChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsChangeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPointsChangeQuery(
  baseOptions: Apollo.QueryHookOptions<GetPointsChangeQuery, GetPointsChangeQueryVariables> &
    ({ variables: GetPointsChangeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPointsChangeQuery, GetPointsChangeQueryVariables>(GetPointsChangeDocument, options);
}
export function useGetPointsChangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPointsChangeQuery, GetPointsChangeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPointsChangeQuery, GetPointsChangeQueryVariables>(GetPointsChangeDocument, options);
}
export function useGetPointsChangeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointsChangeQuery, GetPointsChangeQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPointsChangeQuery, GetPointsChangeQueryVariables>(GetPointsChangeDocument, options);
}
export type GetPointsChangeQueryHookResult = ReturnType<typeof useGetPointsChangeQuery>;
export type GetPointsChangeLazyQueryHookResult = ReturnType<typeof useGetPointsChangeLazyQuery>;
export type GetPointsChangeSuspenseQueryHookResult = ReturnType<typeof useGetPointsChangeSuspenseQuery>;
export type GetPointsChangeQueryResult = Apollo.QueryResult<GetPointsChangeQuery, GetPointsChangeQueryVariables>;
export const GetActivateTransactionDocument = gql`
  query getActivateTransaction($id: ID!) {
    transactionHistory: currentCustomer {
      uuid
      membership {
        id
        transactions(filter: { idEquals: $id }) {
          edges {
            cursor
            node {
              ...ActivateTransaction
            }
          }
        }
      }
    }
  }
  ${ActivateTransactionFragmentDoc}
`;

/**
 * __useGetActivateTransactionQuery__
 *
 * To run a query within a React component, call `useGetActivateTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivateTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivateTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActivateTransactionQuery(
  baseOptions: Apollo.QueryHookOptions<GetActivateTransactionQuery, GetActivateTransactionQueryVariables> &
    ({ variables: GetActivateTransactionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetActivateTransactionQuery, GetActivateTransactionQueryVariables>(
    GetActivateTransactionDocument,
    options,
  );
}
export function useGetActivateTransactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActivateTransactionQuery, GetActivateTransactionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetActivateTransactionQuery, GetActivateTransactionQueryVariables>(
    GetActivateTransactionDocument,
    options,
  );
}
export function useGetActivateTransactionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetActivateTransactionQuery, GetActivateTransactionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetActivateTransactionQuery, GetActivateTransactionQueryVariables>(
    GetActivateTransactionDocument,
    options,
  );
}
export type GetActivateTransactionQueryHookResult = ReturnType<typeof useGetActivateTransactionQuery>;
export type GetActivateTransactionLazyQueryHookResult = ReturnType<typeof useGetActivateTransactionLazyQuery>;
export type GetActivateTransactionSuspenseQueryHookResult = ReturnType<typeof useGetActivateTransactionSuspenseQuery>;
export type GetActivateTransactionQueryResult = Apollo.QueryResult<
  GetActivateTransactionQuery,
  GetActivateTransactionQueryVariables
>;
export const CreateSurveyViewsDocument = gql`
  mutation createSurveyViews($input: SurveyViewsCreateInput!) {
    createSurveyViews: surveyViewsCreate(input: $input)
  }
`;
export type CreateSurveyViewsMutationFn = Apollo.MutationFunction<
  CreateSurveyViewsMutation,
  CreateSurveyViewsMutationVariables
>;

/**
 * __useCreateSurveyViewsMutation__
 *
 * To run a mutation, you first call `useCreateSurveyViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyViewsMutation, { data, loading, error }] = useCreateSurveyViewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyViewsMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSurveyViewsMutation, CreateSurveyViewsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSurveyViewsMutation, CreateSurveyViewsMutationVariables>(
    CreateSurveyViewsDocument,
    options,
  );
}
export type CreateSurveyViewsMutationHookResult = ReturnType<typeof useCreateSurveyViewsMutation>;
export type CreateSurveyViewsMutationResult = Apollo.MutationResult<CreateSurveyViewsMutation>;
export type CreateSurveyViewsMutationOptions = Apollo.BaseMutationOptions<
  CreateSurveyViewsMutation,
  CreateSurveyViewsMutationVariables
>;
export const DismissSurveyDocument = gql`
  mutation dismissSurvey($input: SurveyDismissInput!) {
    surveyDismiss(input: $input)
  }
`;
export type DismissSurveyMutationFn = Apollo.MutationFunction<DismissSurveyMutation, DismissSurveyMutationVariables>;

/**
 * __useDismissSurveyMutation__
 *
 * To run a mutation, you first call `useDismissSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissSurveyMutation, { data, loading, error }] = useDismissSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissSurveyMutation(
  baseOptions?: Apollo.MutationHookOptions<DismissSurveyMutation, DismissSurveyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DismissSurveyMutation, DismissSurveyMutationVariables>(DismissSurveyDocument, options);
}
export type DismissSurveyMutationHookResult = ReturnType<typeof useDismissSurveyMutation>;
export type DismissSurveyMutationResult = Apollo.MutationResult<DismissSurveyMutation>;
export type DismissSurveyMutationOptions = Apollo.BaseMutationOptions<
  DismissSurveyMutation,
  DismissSurveyMutationVariables
>;
export const GetGuestSurveyDocument = gql`
  query getGuestSurvey($guestSurveyId: String!) {
    guestSurvey(guestSurveyId: $guestSurveyId) {
      ...Survey
    }
  }
  ${SurveyFragmentDoc}
`;

/**
 * __useGetGuestSurveyQuery__
 *
 * To run a query within a React component, call `useGetGuestSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestSurveyQuery({
 *   variables: {
 *      guestSurveyId: // value for 'guestSurveyId'
 *   },
 * });
 */
export function useGetGuestSurveyQuery(
  baseOptions: Apollo.QueryHookOptions<GetGuestSurveyQuery, GetGuestSurveyQueryVariables> &
    ({ variables: GetGuestSurveyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGuestSurveyQuery, GetGuestSurveyQueryVariables>(GetGuestSurveyDocument, options);
}
export function useGetGuestSurveyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGuestSurveyQuery, GetGuestSurveyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGuestSurveyQuery, GetGuestSurveyQueryVariables>(GetGuestSurveyDocument, options);
}
export function useGetGuestSurveySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestSurveyQuery, GetGuestSurveyQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetGuestSurveyQuery, GetGuestSurveyQueryVariables>(GetGuestSurveyDocument, options);
}
export type GetGuestSurveyQueryHookResult = ReturnType<typeof useGetGuestSurveyQuery>;
export type GetGuestSurveyLazyQueryHookResult = ReturnType<typeof useGetGuestSurveyLazyQuery>;
export type GetGuestSurveySuspenseQueryHookResult = ReturnType<typeof useGetGuestSurveySuspenseQuery>;
export type GetGuestSurveyQueryResult = Apollo.QueryResult<GetGuestSurveyQuery, GetGuestSurveyQueryVariables>;
export const GetSurveyDocument = gql`
  query getSurvey($uuid: OCUUID!) {
    survey(uuid: $uuid) {
      ...Survey
    }
  }
  ${SurveyFragmentDoc}
`;

/**
 * __useGetSurveyQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetSurveyQuery(
  baseOptions: Apollo.QueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables> &
    ({ variables: GetSurveyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
}
export function useGetSurveyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
}
export function useGetSurveySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
}
export type GetSurveyQueryHookResult = ReturnType<typeof useGetSurveyQuery>;
export type GetSurveyLazyQueryHookResult = ReturnType<typeof useGetSurveyLazyQuery>;
export type GetSurveySuspenseQueryHookResult = ReturnType<typeof useGetSurveySuspenseQuery>;
export type GetSurveyQueryResult = Apollo.QueryResult<GetSurveyQuery, GetSurveyQueryVariables>;
export const GetSurveysDocument = gql`
  query getSurveys($filter: SurveyFilter) {
    surveys(first: 10, filter: $filter) {
      edges {
        cursor
        node {
          ...Survey
        }
      }
    }
  }
  ${SurveyFragmentDoc}
`;

/**
 * __useGetSurveysQuery__
 *
 * To run a query within a React component, call `useGetSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
}
export function useGetSurveysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
}
export function useGetSurveysSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
}
export type GetSurveysQueryHookResult = ReturnType<typeof useGetSurveysQuery>;
export type GetSurveysLazyQueryHookResult = ReturnType<typeof useGetSurveysLazyQuery>;
export type GetSurveysSuspenseQueryHookResult = ReturnType<typeof useGetSurveysSuspenseQuery>;
export type GetSurveysQueryResult = Apollo.QueryResult<GetSurveysQuery, GetSurveysQueryVariables>;
export const GetSurveysTotalCountDocument = gql`
  query getSurveysTotalCount {
    surveys(filter: { includeDismissed: true }) {
      totalCount
    }
  }
`;

/**
 * __useGetSurveysTotalCountQuery__
 *
 * To run a query within a React component, call `useGetSurveysTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysTotalCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSurveysTotalCountQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSurveysTotalCountQuery, GetSurveysTotalCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSurveysTotalCountQuery, GetSurveysTotalCountQueryVariables>(
    GetSurveysTotalCountDocument,
    options,
  );
}
export function useGetSurveysTotalCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSurveysTotalCountQuery, GetSurveysTotalCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSurveysTotalCountQuery, GetSurveysTotalCountQueryVariables>(
    GetSurveysTotalCountDocument,
    options,
  );
}
export function useGetSurveysTotalCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSurveysTotalCountQuery, GetSurveysTotalCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSurveysTotalCountQuery, GetSurveysTotalCountQueryVariables>(
    GetSurveysTotalCountDocument,
    options,
  );
}
export type GetSurveysTotalCountQueryHookResult = ReturnType<typeof useGetSurveysTotalCountQuery>;
export type GetSurveysTotalCountLazyQueryHookResult = ReturnType<typeof useGetSurveysTotalCountLazyQuery>;
export type GetSurveysTotalCountSuspenseQueryHookResult = ReturnType<typeof useGetSurveysTotalCountSuspenseQuery>;
export type GetSurveysTotalCountQueryResult = Apollo.QueryResult<
  GetSurveysTotalCountQuery,
  GetSurveysTotalCountQueryVariables
>;
export const SubmitGuestSurveyAnswerDocument = gql`
  mutation submitGuestSurveyAnswer($input: GuestSurveyAnswerSendInput!) {
    submitGuestSurveyAnswer: guestSurveyAnswerSend(input: $input)
  }
`;
export type SubmitGuestSurveyAnswerMutationFn = Apollo.MutationFunction<
  SubmitGuestSurveyAnswerMutation,
  SubmitGuestSurveyAnswerMutationVariables
>;

/**
 * __useSubmitGuestSurveyAnswerMutation__
 *
 * To run a mutation, you first call `useSubmitGuestSurveyAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGuestSurveyAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGuestSurveyAnswerMutation, { data, loading, error }] = useSubmitGuestSurveyAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitGuestSurveyAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitGuestSurveyAnswerMutation, SubmitGuestSurveyAnswerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitGuestSurveyAnswerMutation, SubmitGuestSurveyAnswerMutationVariables>(
    SubmitGuestSurveyAnswerDocument,
    options,
  );
}
export type SubmitGuestSurveyAnswerMutationHookResult = ReturnType<typeof useSubmitGuestSurveyAnswerMutation>;
export type SubmitGuestSurveyAnswerMutationResult = Apollo.MutationResult<SubmitGuestSurveyAnswerMutation>;
export type SubmitGuestSurveyAnswerMutationOptions = Apollo.BaseMutationOptions<
  SubmitGuestSurveyAnswerMutation,
  SubmitGuestSurveyAnswerMutationVariables
>;
export const SubmitGuestSurveyAnswersDocument = gql`
  mutation submitGuestSurveyAnswers($input: GuestSurveyAnswersSubmitInput!) {
    submitGuestSurveyAnswers: guestSurveyAnswersSubmit(input: $input)
  }
`;
export type SubmitGuestSurveyAnswersMutationFn = Apollo.MutationFunction<
  SubmitGuestSurveyAnswersMutation,
  SubmitGuestSurveyAnswersMutationVariables
>;

/**
 * __useSubmitGuestSurveyAnswersMutation__
 *
 * To run a mutation, you first call `useSubmitGuestSurveyAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGuestSurveyAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGuestSurveyAnswersMutation, { data, loading, error }] = useSubmitGuestSurveyAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitGuestSurveyAnswersMutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitGuestSurveyAnswersMutation, SubmitGuestSurveyAnswersMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitGuestSurveyAnswersMutation, SubmitGuestSurveyAnswersMutationVariables>(
    SubmitGuestSurveyAnswersDocument,
    options,
  );
}
export type SubmitGuestSurveyAnswersMutationHookResult = ReturnType<typeof useSubmitGuestSurveyAnswersMutation>;
export type SubmitGuestSurveyAnswersMutationResult = Apollo.MutationResult<SubmitGuestSurveyAnswersMutation>;
export type SubmitGuestSurveyAnswersMutationOptions = Apollo.BaseMutationOptions<
  SubmitGuestSurveyAnswersMutation,
  SubmitGuestSurveyAnswersMutationVariables
>;
export const SubmitSurveyAnswerDocument = gql`
  mutation submitSurveyAnswer($input: SurveyAnswerSendInput!) {
    submitSurveyAnswer: surveyAnswerSend(input: $input)
  }
`;
export type SubmitSurveyAnswerMutationFn = Apollo.MutationFunction<
  SubmitSurveyAnswerMutation,
  SubmitSurveyAnswerMutationVariables
>;

/**
 * __useSubmitSurveyAnswerMutation__
 *
 * To run a mutation, you first call `useSubmitSurveyAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSurveyAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSurveyAnswerMutation, { data, loading, error }] = useSubmitSurveyAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSurveyAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitSurveyAnswerMutation, SubmitSurveyAnswerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitSurveyAnswerMutation, SubmitSurveyAnswerMutationVariables>(
    SubmitSurveyAnswerDocument,
    options,
  );
}
export type SubmitSurveyAnswerMutationHookResult = ReturnType<typeof useSubmitSurveyAnswerMutation>;
export type SubmitSurveyAnswerMutationResult = Apollo.MutationResult<SubmitSurveyAnswerMutation>;
export type SubmitSurveyAnswerMutationOptions = Apollo.BaseMutationOptions<
  SubmitSurveyAnswerMutation,
  SubmitSurveyAnswerMutationVariables
>;
export const SubmitSurveyAnswersDocument = gql`
  mutation submitSurveyAnswers($input: SurveyAnswersSubmitInput!) {
    submitSurveyAnswers: surveyAnswersSubmit(input: $input)
  }
`;
export type SubmitSurveyAnswersMutationFn = Apollo.MutationFunction<
  SubmitSurveyAnswersMutation,
  SubmitSurveyAnswersMutationVariables
>;

/**
 * __useSubmitSurveyAnswersMutation__
 *
 * To run a mutation, you first call `useSubmitSurveyAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSurveyAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSurveyAnswersMutation, { data, loading, error }] = useSubmitSurveyAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSurveyAnswersMutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitSurveyAnswersMutation, SubmitSurveyAnswersMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitSurveyAnswersMutation, SubmitSurveyAnswersMutationVariables>(
    SubmitSurveyAnswersDocument,
    options,
  );
}
export type SubmitSurveyAnswersMutationHookResult = ReturnType<typeof useSubmitSurveyAnswersMutation>;
export type SubmitSurveyAnswersMutationResult = Apollo.MutationResult<SubmitSurveyAnswersMutation>;
export type SubmitSurveyAnswersMutationOptions = Apollo.BaseMutationOptions<
  SubmitSurveyAnswersMutation,
  SubmitSurveyAnswersMutationVariables
>;
export const TransactionsWithOfferFulfillmentDocument = gql`
  query transactionsWithOfferFulfillment($size: Int!) {
    customer: currentCustomer {
      uuid
      membership {
        id
        transactions(first: $size) {
          edges {
            node {
              ...TransactionWithOfferFulfillment
            }
          }
        }
      }
    }
  }
  ${TransactionWithOfferFulfillmentFragmentDoc}
`;

/**
 * __useTransactionsWithOfferFulfillmentQuery__
 *
 * To run a query within a React component, call `useTransactionsWithOfferFulfillmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsWithOfferFulfillmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsWithOfferFulfillmentQuery({
 *   variables: {
 *      size: // value for 'size'
 *   },
 * });
 */
export function useTransactionsWithOfferFulfillmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    TransactionsWithOfferFulfillmentQuery,
    TransactionsWithOfferFulfillmentQueryVariables
  > &
    ({ variables: TransactionsWithOfferFulfillmentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TransactionsWithOfferFulfillmentQuery, TransactionsWithOfferFulfillmentQueryVariables>(
    TransactionsWithOfferFulfillmentDocument,
    options,
  );
}
export function useTransactionsWithOfferFulfillmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TransactionsWithOfferFulfillmentQuery,
    TransactionsWithOfferFulfillmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TransactionsWithOfferFulfillmentQuery, TransactionsWithOfferFulfillmentQueryVariables>(
    TransactionsWithOfferFulfillmentDocument,
    options,
  );
}
export function useTransactionsWithOfferFulfillmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TransactionsWithOfferFulfillmentQuery,
        TransactionsWithOfferFulfillmentQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TransactionsWithOfferFulfillmentQuery, TransactionsWithOfferFulfillmentQueryVariables>(
    TransactionsWithOfferFulfillmentDocument,
    options,
  );
}
export type TransactionsWithOfferFulfillmentQueryHookResult = ReturnType<
  typeof useTransactionsWithOfferFulfillmentQuery
>;
export type TransactionsWithOfferFulfillmentLazyQueryHookResult = ReturnType<
  typeof useTransactionsWithOfferFulfillmentLazyQuery
>;
export type TransactionsWithOfferFulfillmentSuspenseQueryHookResult = ReturnType<
  typeof useTransactionsWithOfferFulfillmentSuspenseQuery
>;
export type TransactionsWithOfferFulfillmentQueryResult = Apollo.QueryResult<
  TransactionsWithOfferFulfillmentQuery,
  TransactionsWithOfferFulfillmentQueryVariables
>;
export const CreateOtpSessionByPlatformDocument = gql`
  mutation createOTPSessionByPlatform($input: CreateOTPSessionInput!) {
    createOTPSessionByPlatform(input: $input) {
      session
    }
  }
`;
export type CreateOtpSessionByPlatformMutationFn = Apollo.MutationFunction<
  CreateOtpSessionByPlatformMutation,
  CreateOtpSessionByPlatformMutationVariables
>;

/**
 * __useCreateOtpSessionByPlatformMutation__
 *
 * To run a mutation, you first call `useCreateOtpSessionByPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtpSessionByPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtpSessionByPlatformMutation, { data, loading, error }] = useCreateOtpSessionByPlatformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOtpSessionByPlatformMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOtpSessionByPlatformMutation,
    CreateOtpSessionByPlatformMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOtpSessionByPlatformMutation, CreateOtpSessionByPlatformMutationVariables>(
    CreateOtpSessionByPlatformDocument,
    options,
  );
}
export type CreateOtpSessionByPlatformMutationHookResult = ReturnType<typeof useCreateOtpSessionByPlatformMutation>;
export type CreateOtpSessionByPlatformMutationResult = Apollo.MutationResult<CreateOtpSessionByPlatformMutation>;
export type CreateOtpSessionByPlatformMutationOptions = Apollo.BaseMutationOptions<
  CreateOtpSessionByPlatformMutation,
  CreateOtpSessionByPlatformMutationVariables
>;
export const GetAccessTokenByRefreshTokenDocument = gql`
  mutation getAccessTokenByRefreshToken($input: AccessTokenByRefreshTokenInput!) {
    getAccessTokenByRefreshToken(input: $input) {
      accessToken
      refreshToken
    }
  }
`;
export type GetAccessTokenByRefreshTokenMutationFn = Apollo.MutationFunction<
  GetAccessTokenByRefreshTokenMutation,
  GetAccessTokenByRefreshTokenMutationVariables
>;

/**
 * __useGetAccessTokenByRefreshTokenMutation__
 *
 * To run a mutation, you first call `useGetAccessTokenByRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAccessTokenByRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAccessTokenByRefreshTokenMutation, { data, loading, error }] = useGetAccessTokenByRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAccessTokenByRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetAccessTokenByRefreshTokenMutation,
    GetAccessTokenByRefreshTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GetAccessTokenByRefreshTokenMutation, GetAccessTokenByRefreshTokenMutationVariables>(
    GetAccessTokenByRefreshTokenDocument,
    options,
  );
}
export type GetAccessTokenByRefreshTokenMutationHookResult = ReturnType<typeof useGetAccessTokenByRefreshTokenMutation>;
export type GetAccessTokenByRefreshTokenMutationResult = Apollo.MutationResult<GetAccessTokenByRefreshTokenMutation>;
export type GetAccessTokenByRefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  GetAccessTokenByRefreshTokenMutation,
  GetAccessTokenByRefreshTokenMutationVariables
>;
export const RequestMagicLinkDocument = gql`
  mutation requestMagicLink($input: MagicLinkRequestInput!) {
    requestMagicLink(input: $input)
  }
`;
export type RequestMagicLinkMutationFn = Apollo.MutationFunction<
  RequestMagicLinkMutation,
  RequestMagicLinkMutationVariables
>;

/**
 * __useRequestMagicLinkMutation__
 *
 * To run a mutation, you first call `useRequestMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMagicLinkMutation, { data, loading, error }] = useRequestMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMagicLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>(
    RequestMagicLinkDocument,
    options,
  );
}
export type RequestMagicLinkMutationHookResult = ReturnType<typeof useRequestMagicLinkMutation>;
export type RequestMagicLinkMutationResult = Apollo.MutationResult<RequestMagicLinkMutation>;
export type RequestMagicLinkMutationOptions = Apollo.BaseMutationOptions<
  RequestMagicLinkMutation,
  RequestMagicLinkMutationVariables
>;
export const SignupWithOtpDocument = gql`
  mutation signupWithOTP($input: OTP!) {
    exchangeSessionAndOTPToAuthToken(input: $input) {
      __typename
      ...SignupWithOTPSuccess
      ...SignupWithOTPIncorrectOTP
    }
  }
  ${SignupWithOtpSuccessFragmentDoc}
  ${SignupWithOtpIncorrectOtpFragmentDoc}
`;
export type SignupWithOtpMutationFn = Apollo.MutationFunction<SignupWithOtpMutation, SignupWithOtpMutationVariables>;

/**
 * __useSignupWithOtpMutation__
 *
 * To run a mutation, you first call `useSignupWithOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupWithOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupWithOtpMutation, { data, loading, error }] = useSignupWithOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupWithOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<SignupWithOtpMutation, SignupWithOtpMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignupWithOtpMutation, SignupWithOtpMutationVariables>(SignupWithOtpDocument, options);
}
export type SignupWithOtpMutationHookResult = ReturnType<typeof useSignupWithOtpMutation>;
export type SignupWithOtpMutationResult = Apollo.MutationResult<SignupWithOtpMutation>;
export type SignupWithOtpMutationOptions = Apollo.BaseMutationOptions<
  SignupWithOtpMutation,
  SignupWithOtpMutationVariables
>;
export const SignupWithTokenDocument = gql`
  mutation signupWithToken($input: MagicLinkExchangeSessionIdToAuthTokenInput!) {
    signupWithToken: magicLinkExchangeSessionIdToAuthToken(input: $input) {
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`;
export type SignupWithTokenMutationFn = Apollo.MutationFunction<
  SignupWithTokenMutation,
  SignupWithTokenMutationVariables
>;

/**
 * __useSignupWithTokenMutation__
 *
 * To run a mutation, you first call `useSignupWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupWithTokenMutation, { data, loading, error }] = useSignupWithTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupWithTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<SignupWithTokenMutation, SignupWithTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignupWithTokenMutation, SignupWithTokenMutationVariables>(
    SignupWithTokenDocument,
    options,
  );
}
export type SignupWithTokenMutationHookResult = ReturnType<typeof useSignupWithTokenMutation>;
export type SignupWithTokenMutationResult = Apollo.MutationResult<SignupWithTokenMutation>;
export type SignupWithTokenMutationOptions = Apollo.BaseMutationOptions<
  SignupWithTokenMutation,
  SignupWithTokenMutationVariables
>;
export const CommunicationPreferenceUpdateDocument = gql`
  mutation communicationPreferenceUpdate($input: CommunicationPreferenceUpdateInput!) {
    preference: updateCommunicationPreference(input: $input) {
      ...CommunicationPreference
    }
  }
  ${CommunicationPreferenceFragmentDoc}
`;
export type CommunicationPreferenceUpdateMutationFn = Apollo.MutationFunction<
  CommunicationPreferenceUpdateMutation,
  CommunicationPreferenceUpdateMutationVariables
>;

/**
 * __useCommunicationPreferenceUpdateMutation__
 *
 * To run a mutation, you first call `useCommunicationPreferenceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunicationPreferenceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communicationPreferenceUpdateMutation, { data, loading, error }] = useCommunicationPreferenceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommunicationPreferenceUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommunicationPreferenceUpdateMutation,
    CommunicationPreferenceUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CommunicationPreferenceUpdateMutation, CommunicationPreferenceUpdateMutationVariables>(
    CommunicationPreferenceUpdateDocument,
    options,
  );
}
export type CommunicationPreferenceUpdateMutationHookResult = ReturnType<
  typeof useCommunicationPreferenceUpdateMutation
>;
export type CommunicationPreferenceUpdateMutationResult = Apollo.MutationResult<CommunicationPreferenceUpdateMutation>;
export type CommunicationPreferenceUpdateMutationOptions = Apollo.BaseMutationOptions<
  CommunicationPreferenceUpdateMutation,
  CommunicationPreferenceUpdateMutationVariables
>;
export const GetAppConfigDocument = gql`
  query getAppConfig {
    appConfig {
      brandUuid
      chainId
      userExperience {
        offers {
          gridLocation
          tabNavbarIcon
        }
      }
      termsConditions {
        activeAt
        name
        url
        uuid
      }
      privacyPolicy {
        activeAt
        name
        url
        uuid
      }
      support {
        ...SupportConfiguration
      }
      loyaltyProgram {
        pointsStrategy
        pointExpiration {
          strategy
          notificationDays
        }
        homePageOffersLimit
        redeemOfferWithCompletedProfileOnly
        membershipMinAge
        isExplicitTermsAcceptanceRequired
        isExplicitSmsPromotionAcceptanceEnabled
        isPromocodesEnabled
        referralProgramConfig: referralProgramConfiguration {
          ...ReferralProgramConfig
        }
      }
      payAtPump {
        enabled
      }
      payInside {
        enabled
      }
      applePay {
        merchantId
        supportedNetworks
        allowCreditCards
        merchantName
        allowPrepaidCards
        isBillingZipCodeCollectionEnabled
      }
      googlePay {
        environment
        gateway
        merchantId
        merchantName
        allowedCardNetworks
        allowPrepaidCards
        allowCreditCards
        gatewayMerchantId
        isBillingZipCodeCollectionEnabled
      }
      kount {
        merchantId
        collectorHostname
        environment
      }
      pinCode {
        blockingDuration
        attemptThrottle
        maxAttempts
      }
      wallet {
        enabled
      }
      deleteAccount {
        enabled
        deleteAccountMutation
      }
      paymentProvider {
        __typename
        ... on FiservConfiguration {
          customData
        }
        ... on ParPayConfiguration {
          customData
        }
        ... on WorldpayConfiguration {
          customData
          eProtectPayPageId
          eProtectGooglePayPageId
          eProtectWebSdkApiUrl
          eProtectWebSdkUrl
        }
      }
      paymentWallet {
        maxInstruments
        allowedAccountTypes
      }
      communicationPreference {
        enabled
        isSmsOptInConfigurable
        isPushOptInConfigurable
      }
      eaivAgeVerification {
        enabled
      }
      eaivIdentityVerification {
        enabled
      }
      productInterests {
        enabled
        isEAIVPromotionOnProfileCompletedEnabled
      }
      appRating {
        enabled
        promptIntervalDays
        transactionHistoryLookupDays
      }
      auth {
        primaryMethod
        otp {
          enabled
          channels
        }
      }
      rudderStack {
        enabled
      }
      totalAvailableRollback {
        enabled
      }
      totalPointsEarned {
        enabled
      }
      smsOptIn {
        enabled
        modalAppearanceDelaySeconds
        modalOfferLoyaltyEventName
        optInAcceptedLoyaltyEventName
        optInRejectedLoyaltyEventName
      }
      mobilePaymentsReceiptsView {
        enabled
      }
      storeLocator {
        fuelPricesMode
        googleMapsApiKey
        defaultLocation {
          latitude
          longitude
        }
      }
      smsOptedOutWarning {
        enabled
        smsOptInPhoneNumber
        smsOptInKeyword
      }
      orderAhead {
        enabled
        navbar {
          icon
          text
        }
        provider {
          ...OrderAheadConfigurationProviderVroom
          ...OrderAheadConfigurationProviderOlo
        }
      }
      externalIdentityVerification {
        enabled
        provider
      }
      personalDataShareOptOut {
        enabled
        optOutUrl
      }
      appsFlyer {
        enabled
        appId
        devKey
        webDevKey
      }
      localOffers {
        enabled
        radiusInMeters
      }
      spireEnrollment {
        enabled
        iframeUrl
        partnerId
      }
      cookieConsent {
        __typename
        ... on CookiebotCookieConsentConfiguration {
          enabled
          consentEditingEnabled
          sdkUrl
        }
      }
      loyaltyIdBarcode {
        enabled
      }
    }
  }
  ${SupportConfigurationFragmentDoc}
  ${ReferralProgramConfigFragmentDoc}
  ${OrderAheadConfigurationProviderVroomFragmentDoc}
  ${OrderAheadConfigurationProviderOloFragmentDoc}
`;

/**
 * __useGetAppConfigQuery__
 *
 * To run a query within a React component, call `useGetAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAppConfigQuery, GetAppConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(GetAppConfigDocument, options);
}
export function useGetAppConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAppConfigQuery, GetAppConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(GetAppConfigDocument, options);
}
export function useGetAppConfigSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppConfigQuery, GetAppConfigQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(GetAppConfigDocument, options);
}
export type GetAppConfigQueryHookResult = ReturnType<typeof useGetAppConfigQuery>;
export type GetAppConfigLazyQueryHookResult = ReturnType<typeof useGetAppConfigLazyQuery>;
export type GetAppConfigSuspenseQueryHookResult = ReturnType<typeof useGetAppConfigSuspenseQuery>;
export type GetAppConfigQueryResult = Apollo.QueryResult<GetAppConfigQuery, GetAppConfigQueryVariables>;
export const EaivAgeVerificationStartDocument = gql`
  mutation eaivAgeVerificationStart($input: EaivAgeVerificationStartInput!) {
    result: eaivAgeVerificationStart(input: $input) {
      __typename
      ... on EaivAgeVerificationResultFailed {
        reason
      }
      ... on EaivAgeVerificationStartResultSuccess {
        status
      }
      ...AgeVerificationRequireAdditionalPrompt
    }
  }
  ${AgeVerificationRequireAdditionalPromptFragmentDoc}
`;
export type EaivAgeVerificationStartMutationFn = Apollo.MutationFunction<
  EaivAgeVerificationStartMutation,
  EaivAgeVerificationStartMutationVariables
>;

/**
 * __useEaivAgeVerificationStartMutation__
 *
 * To run a mutation, you first call `useEaivAgeVerificationStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEaivAgeVerificationStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eaivAgeVerificationStartMutation, { data, loading, error }] = useEaivAgeVerificationStartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEaivAgeVerificationStartMutation(
  baseOptions?: Apollo.MutationHookOptions<EaivAgeVerificationStartMutation, EaivAgeVerificationStartMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EaivAgeVerificationStartMutation, EaivAgeVerificationStartMutationVariables>(
    EaivAgeVerificationStartDocument,
    options,
  );
}
export type EaivAgeVerificationStartMutationHookResult = ReturnType<typeof useEaivAgeVerificationStartMutation>;
export type EaivAgeVerificationStartMutationResult = Apollo.MutationResult<EaivAgeVerificationStartMutation>;
export type EaivAgeVerificationStartMutationOptions = Apollo.BaseMutationOptions<
  EaivAgeVerificationStartMutation,
  EaivAgeVerificationStartMutationVariables
>;
export const EaivIdentityVerificationStartDocument = gql`
  mutation eaivIdentityVerificationStart($input: EaivIdentityVerificationStartInput!) {
    result: eaivIdentityVerificationStart(input: $input) {
      __typename
      ... on EaivIdentityVerificationResultFailed {
        reason
      }
      ...IdentityVerificationStartResultSuccess
      ...IdentityVerificationRequireAdditionalPrompt
    }
  }
  ${IdentityVerificationStartResultSuccessFragmentDoc}
  ${IdentityVerificationRequireAdditionalPromptFragmentDoc}
`;
export type EaivIdentityVerificationStartMutationFn = Apollo.MutationFunction<
  EaivIdentityVerificationStartMutation,
  EaivIdentityVerificationStartMutationVariables
>;

/**
 * __useEaivIdentityVerificationStartMutation__
 *
 * To run a mutation, you first call `useEaivIdentityVerificationStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEaivIdentityVerificationStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eaivIdentityVerificationStartMutation, { data, loading, error }] = useEaivIdentityVerificationStartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEaivIdentityVerificationStartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EaivIdentityVerificationStartMutation,
    EaivIdentityVerificationStartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EaivIdentityVerificationStartMutation, EaivIdentityVerificationStartMutationVariables>(
    EaivIdentityVerificationStartDocument,
    options,
  );
}
export type EaivIdentityVerificationStartMutationHookResult = ReturnType<
  typeof useEaivIdentityVerificationStartMutation
>;
export type EaivIdentityVerificationStartMutationResult = Apollo.MutationResult<EaivIdentityVerificationStartMutation>;
export type EaivIdentityVerificationStartMutationOptions = Apollo.BaseMutationOptions<
  EaivIdentityVerificationStartMutation,
  EaivIdentityVerificationStartMutationVariables
>;
export const EaivIdentityVerificationSubmitDocument = gql`
  mutation eaivIdentityVerificationSubmit($input: EaivIdentityVerificationSubmitInput!) {
    result: eaivIdentityVerificationSubmit(input: $input) {
      __typename
      ... on EaivIdentityVerificationResultFailed {
        reason
      }
      ... on EaivIdentityVerificationSubmitResultSuccess {
        status
      }
      ...IdentityVerificationStartResultContinue
    }
  }
  ${IdentityVerificationStartResultContinueFragmentDoc}
`;
export type EaivIdentityVerificationSubmitMutationFn = Apollo.MutationFunction<
  EaivIdentityVerificationSubmitMutation,
  EaivIdentityVerificationSubmitMutationVariables
>;

/**
 * __useEaivIdentityVerificationSubmitMutation__
 *
 * To run a mutation, you first call `useEaivIdentityVerificationSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEaivIdentityVerificationSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eaivIdentityVerificationSubmitMutation, { data, loading, error }] = useEaivIdentityVerificationSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEaivIdentityVerificationSubmitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EaivIdentityVerificationSubmitMutation,
    EaivIdentityVerificationSubmitMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EaivIdentityVerificationSubmitMutation, EaivIdentityVerificationSubmitMutationVariables>(
    EaivIdentityVerificationSubmitDocument,
    options,
  );
}
export type EaivIdentityVerificationSubmitMutationHookResult = ReturnType<
  typeof useEaivIdentityVerificationSubmitMutation
>;
export type EaivIdentityVerificationSubmitMutationResult =
  Apollo.MutationResult<EaivIdentityVerificationSubmitMutation>;
export type EaivIdentityVerificationSubmitMutationOptions = Apollo.BaseMutationOptions<
  EaivIdentityVerificationSubmitMutation,
  EaivIdentityVerificationSubmitMutationVariables
>;
export const FuelProductGroupsDocument = gql`
  query fuelProductGroups($filter: FuelProductGroupFilter) {
    fuelProductGroups(filter: $filter) {
      ...FuelProductGroup
    }
  }
  ${FuelProductGroupFragmentDoc}
`;

/**
 * __useFuelProductGroupsQuery__
 *
 * To run a query within a React component, call `useFuelProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFuelProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFuelProductGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFuelProductGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<FuelProductGroupsQuery, FuelProductGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FuelProductGroupsQuery, FuelProductGroupsQueryVariables>(FuelProductGroupsDocument, options);
}
export function useFuelProductGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FuelProductGroupsQuery, FuelProductGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FuelProductGroupsQuery, FuelProductGroupsQueryVariables>(
    FuelProductGroupsDocument,
    options,
  );
}
export function useFuelProductGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FuelProductGroupsQuery, FuelProductGroupsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FuelProductGroupsQuery, FuelProductGroupsQueryVariables>(
    FuelProductGroupsDocument,
    options,
  );
}
export type FuelProductGroupsQueryHookResult = ReturnType<typeof useFuelProductGroupsQuery>;
export type FuelProductGroupsLazyQueryHookResult = ReturnType<typeof useFuelProductGroupsLazyQuery>;
export type FuelProductGroupsSuspenseQueryHookResult = ReturnType<typeof useFuelProductGroupsSuspenseQuery>;
export type FuelProductGroupsQueryResult = Apollo.QueryResult<FuelProductGroupsQuery, FuelProductGroupsQueryVariables>;
export const ExecuteSpinWheelGameDocument = gql`
  mutation executeSpinWheelGame($offerId: ID!) {
    result: spinWheelGameExecute(input: { offerId: $offerId }) {
      sequenceNumber
      awardType
      award {
        ...GameAwardPointsOrVouchers
      }
    }
  }
  ${GameAwardPointsOrVouchersFragmentDoc}
`;
export type ExecuteSpinWheelGameMutationFn = Apollo.MutationFunction<
  ExecuteSpinWheelGameMutation,
  ExecuteSpinWheelGameMutationVariables
>;

/**
 * __useExecuteSpinWheelGameMutation__
 *
 * To run a mutation, you first call `useExecuteSpinWheelGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteSpinWheelGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeSpinWheelGameMutation, { data, loading, error }] = useExecuteSpinWheelGameMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useExecuteSpinWheelGameMutation(
  baseOptions?: Apollo.MutationHookOptions<ExecuteSpinWheelGameMutation, ExecuteSpinWheelGameMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExecuteSpinWheelGameMutation, ExecuteSpinWheelGameMutationVariables>(
    ExecuteSpinWheelGameDocument,
    options,
  );
}
export type ExecuteSpinWheelGameMutationHookResult = ReturnType<typeof useExecuteSpinWheelGameMutation>;
export type ExecuteSpinWheelGameMutationResult = Apollo.MutationResult<ExecuteSpinWheelGameMutation>;
export type ExecuteSpinWheelGameMutationOptions = Apollo.BaseMutationOptions<
  ExecuteSpinWheelGameMutation,
  ExecuteSpinWheelGameMutationVariables
>;
export const GetDisplayCategoriesDocument = gql`
  query getDisplayCategories($filter: DisplayCategoryFilter) {
    displayCategories(filter: $filter) {
      edges {
        node {
          ...DisplayCategory
        }
      }
    }
  }
  ${DisplayCategoryFragmentDoc}
`;

/**
 * __useGetDisplayCategoriesQuery__
 *
 * To run a query within a React component, call `useGetDisplayCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisplayCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisplayCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDisplayCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDisplayCategoriesQuery, GetDisplayCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDisplayCategoriesQuery, GetDisplayCategoriesQueryVariables>(
    GetDisplayCategoriesDocument,
    options,
  );
}
export function useGetDisplayCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDisplayCategoriesQuery, GetDisplayCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDisplayCategoriesQuery, GetDisplayCategoriesQueryVariables>(
    GetDisplayCategoriesDocument,
    options,
  );
}
export function useGetDisplayCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDisplayCategoriesQuery, GetDisplayCategoriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDisplayCategoriesQuery, GetDisplayCategoriesQueryVariables>(
    GetDisplayCategoriesDocument,
    options,
  );
}
export type GetDisplayCategoriesQueryHookResult = ReturnType<typeof useGetDisplayCategoriesQuery>;
export type GetDisplayCategoriesLazyQueryHookResult = ReturnType<typeof useGetDisplayCategoriesLazyQuery>;
export type GetDisplayCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetDisplayCategoriesSuspenseQuery>;
export type GetDisplayCategoriesQueryResult = Apollo.QueryResult<
  GetDisplayCategoriesQuery,
  GetDisplayCategoriesQueryVariables
>;
export const ProductCategoriesDocument = gql`
  query productCategories($filter: ProductCategoryFilter) {
    productCategories(filter: $filter) {
      edges {
        node {
          ...ProductCategory
        }
      }
    }
  }
  ${ProductCategoryFragmentDoc}
`;

/**
 * __useProductCategoriesQuery__
 *
 * To run a query within a React component, call `useProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
}
export function useProductCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(
    ProductCategoriesDocument,
    options,
  );
}
export function useProductCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(
    ProductCategoriesDocument,
    options,
  );
}
export type ProductCategoriesQueryHookResult = ReturnType<typeof useProductCategoriesQuery>;
export type ProductCategoriesLazyQueryHookResult = ReturnType<typeof useProductCategoriesLazyQuery>;
export type ProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useProductCategoriesSuspenseQuery>;
export type ProductCategoriesQueryResult = Apollo.QueryResult<ProductCategoriesQuery, ProductCategoriesQueryVariables>;
export const DeviceTokenRegisterDocument = gql`
  mutation deviceTokenRegister($input: DeviceTokenRegisterInput!) {
    deviceTokenRegister(input: $input)
  }
`;
export type DeviceTokenRegisterMutationFn = Apollo.MutationFunction<
  DeviceTokenRegisterMutation,
  DeviceTokenRegisterMutationVariables
>;

/**
 * __useDeviceTokenRegisterMutation__
 *
 * To run a mutation, you first call `useDeviceTokenRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeviceTokenRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deviceTokenRegisterMutation, { data, loading, error }] = useDeviceTokenRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeviceTokenRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<DeviceTokenRegisterMutation, DeviceTokenRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeviceTokenRegisterMutation, DeviceTokenRegisterMutationVariables>(
    DeviceTokenRegisterDocument,
    options,
  );
}
export type DeviceTokenRegisterMutationHookResult = ReturnType<typeof useDeviceTokenRegisterMutation>;
export type DeviceTokenRegisterMutationResult = Apollo.MutationResult<DeviceTokenRegisterMutation>;
export type DeviceTokenRegisterMutationOptions = Apollo.BaseMutationOptions<
  DeviceTokenRegisterMutation,
  DeviceTokenRegisterMutationVariables
>;
export const StoreDetailsDocument = gql`
  query storeDetails($id: ID!) {
    stores: locations(filter: { uuidEquals: $id }) {
      edges {
        node {
          uuid
          utcOffset
          openStatus
          fuelPriceState
          address {
            ...StoreAddress
          }
          fuelGradePrices {
            ...StoreFuelGrade
          }
          hoursOfOperationGroup {
            ...StoreWorkingHours
          }
          phoneNumbers {
            ...StorePhoneNumber
          }
          attributes {
            ...StoreAttribute
          }
        }
      }
    }
  }
  ${StoreAddressFragmentDoc}
  ${StoreFuelGradeFragmentDoc}
  ${StoreWorkingHoursFragmentDoc}
  ${StorePhoneNumberFragmentDoc}
  ${StoreAttributeFragmentDoc}
`;

/**
 * __useStoreDetailsQuery__
 *
 * To run a query within a React component, call `useStoreDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStoreDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<StoreDetailsQuery, StoreDetailsQueryVariables> &
    ({ variables: StoreDetailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StoreDetailsQuery, StoreDetailsQueryVariables>(StoreDetailsDocument, options);
}
export function useStoreDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StoreDetailsQuery, StoreDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StoreDetailsQuery, StoreDetailsQueryVariables>(StoreDetailsDocument, options);
}
export function useStoreDetailsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreDetailsQuery, StoreDetailsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StoreDetailsQuery, StoreDetailsQueryVariables>(StoreDetailsDocument, options);
}
export type StoreDetailsQueryHookResult = ReturnType<typeof useStoreDetailsQuery>;
export type StoreDetailsLazyQueryHookResult = ReturnType<typeof useStoreDetailsLazyQuery>;
export type StoreDetailsSuspenseQueryHookResult = ReturnType<typeof useStoreDetailsSuspenseQuery>;
export type StoreDetailsQueryResult = Apollo.QueryResult<StoreDetailsQuery, StoreDetailsQueryVariables>;
export const StoreLocationsDocument = gql`
  query storeLocations($after: String, $before: String, $filter: LocationFilter, $first: Int, $last: Int) {
    stores: locations(after: $after, before: $before, filter: $filter, first: $first, last: $last) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          uuid
          fuelPriceState
          address {
            ...StoreAddress
          }
          fuelGradePrices {
            ...StoreFuelGrade
          }
        }
      }
    }
  }
  ${StoreAddressFragmentDoc}
  ${StoreFuelGradeFragmentDoc}
`;

/**
 * __useStoreLocationsQuery__
 *
 * To run a query within a React component, call `useStoreLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreLocationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useStoreLocationsQuery(
  baseOptions?: Apollo.QueryHookOptions<StoreLocationsQuery, StoreLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StoreLocationsQuery, StoreLocationsQueryVariables>(StoreLocationsDocument, options);
}
export function useStoreLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StoreLocationsQuery, StoreLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StoreLocationsQuery, StoreLocationsQueryVariables>(StoreLocationsDocument, options);
}
export function useStoreLocationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoreLocationsQuery, StoreLocationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StoreLocationsQuery, StoreLocationsQueryVariables>(StoreLocationsDocument, options);
}
export type StoreLocationsQueryHookResult = ReturnType<typeof useStoreLocationsQuery>;
export type StoreLocationsLazyQueryHookResult = ReturnType<typeof useStoreLocationsLazyQuery>;
export type StoreLocationsSuspenseQueryHookResult = ReturnType<typeof useStoreLocationsSuspenseQuery>;
export type StoreLocationsQueryResult = Apollo.QueryResult<StoreLocationsQuery, StoreLocationsQueryVariables>;
export const StorePumpInfoDocument = gql`
  query storePumpInfo($id: ID!) {
    stores: locations(filter: { uuidEquals: $id }) {
      edges {
        node {
          ...StorePumpInfo
        }
      }
    }
  }
  ${StorePumpInfoFragmentDoc}
`;

/**
 * __useStorePumpInfoQuery__
 *
 * To run a query within a React component, call `useStorePumpInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorePumpInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorePumpInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStorePumpInfoQuery(
  baseOptions: Apollo.QueryHookOptions<StorePumpInfoQuery, StorePumpInfoQueryVariables> &
    ({ variables: StorePumpInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StorePumpInfoQuery, StorePumpInfoQueryVariables>(StorePumpInfoDocument, options);
}
export function useStorePumpInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StorePumpInfoQuery, StorePumpInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StorePumpInfoQuery, StorePumpInfoQueryVariables>(StorePumpInfoDocument, options);
}
export function useStorePumpInfoSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorePumpInfoQuery, StorePumpInfoQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StorePumpInfoQuery, StorePumpInfoQueryVariables>(StorePumpInfoDocument, options);
}
export type StorePumpInfoQueryHookResult = ReturnType<typeof useStorePumpInfoQuery>;
export type StorePumpInfoLazyQueryHookResult = ReturnType<typeof useStorePumpInfoLazyQuery>;
export type StorePumpInfoSuspenseQueryHookResult = ReturnType<typeof useStorePumpInfoSuspenseQuery>;
export type StorePumpInfoQueryResult = Apollo.QueryResult<StorePumpInfoQuery, StorePumpInfoQueryVariables>;
export const GetTotalAvailableRollbackMoneyAmountDocument = gql`
  query getTotalAvailableRollbackMoneyAmount {
    customer: currentCustomer {
      uuid
      membership {
        id
        totalAvailableRollback {
          fuelProductGroup {
            id
          }
          locationUuid
          moneyAmount
        }
      }
    }
  }
`;

/**
 * __useGetTotalAvailableRollbackMoneyAmountQuery__
 *
 * To run a query within a React component, call `useGetTotalAvailableRollbackMoneyAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalAvailableRollbackMoneyAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalAvailableRollbackMoneyAmountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalAvailableRollbackMoneyAmountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTotalAvailableRollbackMoneyAmountQuery,
    GetTotalAvailableRollbackMoneyAmountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTotalAvailableRollbackMoneyAmountQuery, GetTotalAvailableRollbackMoneyAmountQueryVariables>(
    GetTotalAvailableRollbackMoneyAmountDocument,
    options,
  );
}
export function useGetTotalAvailableRollbackMoneyAmountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTotalAvailableRollbackMoneyAmountQuery,
    GetTotalAvailableRollbackMoneyAmountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTotalAvailableRollbackMoneyAmountQuery,
    GetTotalAvailableRollbackMoneyAmountQueryVariables
  >(GetTotalAvailableRollbackMoneyAmountDocument, options);
}
export function useGetTotalAvailableRollbackMoneyAmountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTotalAvailableRollbackMoneyAmountQuery,
        GetTotalAvailableRollbackMoneyAmountQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTotalAvailableRollbackMoneyAmountQuery,
    GetTotalAvailableRollbackMoneyAmountQueryVariables
  >(GetTotalAvailableRollbackMoneyAmountDocument, options);
}
export type GetTotalAvailableRollbackMoneyAmountQueryHookResult = ReturnType<
  typeof useGetTotalAvailableRollbackMoneyAmountQuery
>;
export type GetTotalAvailableRollbackMoneyAmountLazyQueryHookResult = ReturnType<
  typeof useGetTotalAvailableRollbackMoneyAmountLazyQuery
>;
export type GetTotalAvailableRollbackMoneyAmountSuspenseQueryHookResult = ReturnType<
  typeof useGetTotalAvailableRollbackMoneyAmountSuspenseQuery
>;
export type GetTotalAvailableRollbackMoneyAmountQueryResult = Apollo.QueryResult<
  GetTotalAvailableRollbackMoneyAmountQuery,
  GetTotalAvailableRollbackMoneyAmountQueryVariables
>;
export const GetTotalAvailableRollbackDocument = gql`
  query getTotalAvailableRollback(
    $offerLimitsIncluded: Boolean = false
    $offerVouchersIncluded: Boolean = false
    $availableAtLocationsIncluded: Boolean = false
    $constraintsIncluded: Boolean = false
  ) {
    customer: currentCustomer {
      uuid
      membership {
        id
        totalAvailableRollback {
          fuelProductGroup {
            ...FuelProductGroup
          }
          locationUuid
          locationName
          moneyAmount
          offers {
            ...Offer
          }
        }
      }
    }
  }
  ${FuelProductGroupFragmentDoc}
  ${OfferFragmentDoc}
`;

/**
 * __useGetTotalAvailableRollbackQuery__
 *
 * To run a query within a React component, call `useGetTotalAvailableRollbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalAvailableRollbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalAvailableRollbackQuery({
 *   variables: {
 *      offerLimitsIncluded: // value for 'offerLimitsIncluded'
 *      offerVouchersIncluded: // value for 'offerVouchersIncluded'
 *      availableAtLocationsIncluded: // value for 'availableAtLocationsIncluded'
 *      constraintsIncluded: // value for 'constraintsIncluded'
 *   },
 * });
 */
export function useGetTotalAvailableRollbackQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTotalAvailableRollbackQuery, GetTotalAvailableRollbackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTotalAvailableRollbackQuery, GetTotalAvailableRollbackQueryVariables>(
    GetTotalAvailableRollbackDocument,
    options,
  );
}
export function useGetTotalAvailableRollbackLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTotalAvailableRollbackQuery, GetTotalAvailableRollbackQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTotalAvailableRollbackQuery, GetTotalAvailableRollbackQueryVariables>(
    GetTotalAvailableRollbackDocument,
    options,
  );
}
export function useGetTotalAvailableRollbackSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTotalAvailableRollbackQuery, GetTotalAvailableRollbackQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTotalAvailableRollbackQuery, GetTotalAvailableRollbackQueryVariables>(
    GetTotalAvailableRollbackDocument,
    options,
  );
}
export type GetTotalAvailableRollbackQueryHookResult = ReturnType<typeof useGetTotalAvailableRollbackQuery>;
export type GetTotalAvailableRollbackLazyQueryHookResult = ReturnType<typeof useGetTotalAvailableRollbackLazyQuery>;
export type GetTotalAvailableRollbackSuspenseQueryHookResult = ReturnType<
  typeof useGetTotalAvailableRollbackSuspenseQuery
>;
export type GetTotalAvailableRollbackQueryResult = Apollo.QueryResult<
  GetTotalAvailableRollbackQuery,
  GetTotalAvailableRollbackQueryVariables
>;
export const LoyaltyActionHistoryDocument = gql`
  query loyaltyActionHistory(
    $size: Int!
    $transactionCursor: String
    $pointChangeCursor: String
    $skipPointChanges: Boolean = false
  ) {
    customer: currentCustomer {
      uuid
      membership {
        id
        transactions(first: $size, after: $transactionCursor) {
          edges {
            cursor
            node {
              ...LoyaltyActivateTransactionItem
            }
          }
        }
        pointChanges(first: $size, after: $pointChangeCursor) @skip(if: $skipPointChanges) {
          edges {
            cursor
            node {
              ...LoyaltyPointChangeItem
            }
          }
        }
      }
    }
  }
  ${LoyaltyActivateTransactionItemFragmentDoc}
  ${LoyaltyPointChangeItemFragmentDoc}
`;

/**
 * __useLoyaltyActionHistoryQuery__
 *
 * To run a query within a React component, call `useLoyaltyActionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyActionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyActionHistoryQuery({
 *   variables: {
 *      size: // value for 'size'
 *      transactionCursor: // value for 'transactionCursor'
 *      pointChangeCursor: // value for 'pointChangeCursor'
 *      skipPointChanges: // value for 'skipPointChanges'
 *   },
 * });
 */
export function useLoyaltyActionHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<LoyaltyActionHistoryQuery, LoyaltyActionHistoryQueryVariables> &
    ({ variables: LoyaltyActionHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoyaltyActionHistoryQuery, LoyaltyActionHistoryQueryVariables>(
    LoyaltyActionHistoryDocument,
    options,
  );
}
export function useLoyaltyActionHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyActionHistoryQuery, LoyaltyActionHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoyaltyActionHistoryQuery, LoyaltyActionHistoryQueryVariables>(
    LoyaltyActionHistoryDocument,
    options,
  );
}
export function useLoyaltyActionHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoyaltyActionHistoryQuery, LoyaltyActionHistoryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoyaltyActionHistoryQuery, LoyaltyActionHistoryQueryVariables>(
    LoyaltyActionHistoryDocument,
    options,
  );
}
export type LoyaltyActionHistoryQueryHookResult = ReturnType<typeof useLoyaltyActionHistoryQuery>;
export type LoyaltyActionHistoryLazyQueryHookResult = ReturnType<typeof useLoyaltyActionHistoryLazyQuery>;
export type LoyaltyActionHistorySuspenseQueryHookResult = ReturnType<typeof useLoyaltyActionHistorySuspenseQuery>;
export type LoyaltyActionHistoryQueryResult = Apollo.QueryResult<
  LoyaltyActionHistoryQuery,
  LoyaltyActionHistoryQueryVariables
>;
export const TransactionHistoryDocument = gql`
  query transactionHistory(
    $size: Int!
    $cursor: String
    $primaryTransactionStatus: PRIMARY_TRANSACTION_STATUS
    $secondaryTransactionStatus: SECONDARY_TRANSACTION_STATUS
  ) {
    customer: currentCustomer {
      uuid
      transactions(
        first: $size
        after: $cursor
        filter: { primaryStatusEquals: $primaryTransactionStatus, secondaryStatusEquals: $secondaryTransactionStatus }
      ) {
        edges {
          cursor
          node {
            ...TransactionHistoryItem
          }
        }
      }
    }
  }
  ${TransactionHistoryItemFragmentDoc}
`;

/**
 * __useTransactionHistoryQuery__
 *
 * To run a query within a React component, call `useTransactionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionHistoryQuery({
 *   variables: {
 *      size: // value for 'size'
 *      cursor: // value for 'cursor'
 *      primaryTransactionStatus: // value for 'primaryTransactionStatus'
 *      secondaryTransactionStatus: // value for 'secondaryTransactionStatus'
 *   },
 * });
 */
export function useTransactionHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<TransactionHistoryQuery, TransactionHistoryQueryVariables> &
    ({ variables: TransactionHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TransactionHistoryQuery, TransactionHistoryQueryVariables>(
    TransactionHistoryDocument,
    options,
  );
}
export function useTransactionHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TransactionHistoryQuery, TransactionHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TransactionHistoryQuery, TransactionHistoryQueryVariables>(
    TransactionHistoryDocument,
    options,
  );
}
export function useTransactionHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TransactionHistoryQuery, TransactionHistoryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TransactionHistoryQuery, TransactionHistoryQueryVariables>(
    TransactionHistoryDocument,
    options,
  );
}
export type TransactionHistoryQueryHookResult = ReturnType<typeof useTransactionHistoryQuery>;
export type TransactionHistoryLazyQueryHookResult = ReturnType<typeof useTransactionHistoryLazyQuery>;
export type TransactionHistorySuspenseQueryHookResult = ReturnType<typeof useTransactionHistorySuspenseQuery>;
export type TransactionHistoryQueryResult = Apollo.QueryResult<
  TransactionHistoryQuery,
  TransactionHistoryQueryVariables
>;
export const CurrentCustomerDocument = gql`
  query currentCustomer($isLoggedIn: Boolean!) {
    customer: currentCustomer @include(if: $isLoggedIn) {
      __typename
      uuid
      hasPasscode
      membership {
        ...Membership
      }
      communicationPreference {
        ...CommunicationPreference
      }
    }
  }
  ${MembershipFragmentDoc}
  ${CommunicationPreferenceFragmentDoc}
`;

/**
 * __useCurrentCustomerQuery__
 *
 * To run a query within a React component, call `useCurrentCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentCustomerQuery({
 *   variables: {
 *      isLoggedIn: // value for 'isLoggedIn'
 *   },
 * });
 */
export function useCurrentCustomerQuery(
  baseOptions: Apollo.QueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables> &
    ({ variables: CurrentCustomerQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, options);
}
export function useCurrentCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, options);
}
export function useCurrentCustomerSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, options);
}
export type CurrentCustomerQueryHookResult = ReturnType<typeof useCurrentCustomerQuery>;
export type CurrentCustomerLazyQueryHookResult = ReturnType<typeof useCurrentCustomerLazyQuery>;
export type CurrentCustomerSuspenseQueryHookResult = ReturnType<typeof useCurrentCustomerSuspenseQuery>;
export type CurrentCustomerQueryResult = Apollo.QueryResult<CurrentCustomerQuery, CurrentCustomerQueryVariables>;
export const CustomerLogoutDocument = gql`
  mutation customerLogout {
    logout
  }
`;
export type CustomerLogoutMutationFn = Apollo.MutationFunction<CustomerLogoutMutation, CustomerLogoutMutationVariables>;

/**
 * __useCustomerLogoutMutation__
 *
 * To run a mutation, you first call `useCustomerLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerLogoutMutation, { data, loading, error }] = useCustomerLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useCustomerLogoutMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomerLogoutMutation, CustomerLogoutMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CustomerLogoutMutation, CustomerLogoutMutationVariables>(CustomerLogoutDocument, options);
}
export type CustomerLogoutMutationHookResult = ReturnType<typeof useCustomerLogoutMutation>;
export type CustomerLogoutMutationResult = Apollo.MutationResult<CustomerLogoutMutation>;
export type CustomerLogoutMutationOptions = Apollo.BaseMutationOptions<
  CustomerLogoutMutation,
  CustomerLogoutMutationVariables
>;
export const CustomerUpdateDocument = gql`
  mutation customerUpdate($customer: CustomerUpdate!) {
    customer: customerUpdate(input: $customer) {
      uuid
      membership {
        ...Membership
      }
    }
  }
  ${MembershipFragmentDoc}
`;
export type CustomerUpdateMutationFn = Apollo.MutationFunction<CustomerUpdateMutation, CustomerUpdateMutationVariables>;

/**
 * __useCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateMutation, { data, loading, error }] = useCustomerUpdateMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<CustomerUpdateMutation, CustomerUpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CustomerUpdateMutation, CustomerUpdateMutationVariables>(CustomerUpdateDocument, options);
}
export type CustomerUpdateMutationHookResult = ReturnType<typeof useCustomerUpdateMutation>;
export type CustomerUpdateMutationResult = Apollo.MutationResult<CustomerUpdateMutation>;
export type CustomerUpdateMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdateMutation,
  CustomerUpdateMutationVariables
>;
export const DeleteMembershipScrubDataDocument = gql`
  mutation deleteMembershipScrubData {
    deleteAccount: scrubData
  }
`;
export type DeleteMembershipScrubDataMutationFn = Apollo.MutationFunction<
  DeleteMembershipScrubDataMutation,
  DeleteMembershipScrubDataMutationVariables
>;

/**
 * __useDeleteMembershipScrubDataMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipScrubDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipScrubDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipScrubDataMutation, { data, loading, error }] = useDeleteMembershipScrubDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMembershipScrubDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMembershipScrubDataMutation,
    DeleteMembershipScrubDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteMembershipScrubDataMutation, DeleteMembershipScrubDataMutationVariables>(
    DeleteMembershipScrubDataDocument,
    options,
  );
}
export type DeleteMembershipScrubDataMutationHookResult = ReturnType<typeof useDeleteMembershipScrubDataMutation>;
export type DeleteMembershipScrubDataMutationResult = Apollo.MutationResult<DeleteMembershipScrubDataMutation>;
export type DeleteMembershipScrubDataMutationOptions = Apollo.BaseMutationOptions<
  DeleteMembershipScrubDataMutation,
  DeleteMembershipScrubDataMutationVariables
>;
export const DeleteMembershipDocument = gql`
  mutation deleteMembership {
    deleteAccount: membershipDelete
  }
`;
export type DeleteMembershipMutationFn = Apollo.MutationFunction<
  DeleteMembershipMutation,
  DeleteMembershipMutationVariables
>;

/**
 * __useDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMembershipMutation, { data, loading, error }] = useDeleteMembershipMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteMembershipMutation, DeleteMembershipMutationVariables>(
    DeleteMembershipDocument,
    options,
  );
}
export type DeleteMembershipMutationHookResult = ReturnType<typeof useDeleteMembershipMutation>;
export type DeleteMembershipMutationResult = Apollo.MutationResult<DeleteMembershipMutation>;
export type DeleteMembershipMutationOptions = Apollo.BaseMutationOptions<
  DeleteMembershipMutation,
  DeleteMembershipMutationVariables
>;
export const FuelAndConvenienceProfileCreateOrUpdateDocument = gql`
  mutation fuelAndConvenienceProfileCreateOrUpdate($input: FuelAndConvenienceProfileCreateOrUpdateInput!) {
    fuelAndConvenienceProfile: fuelAndConvenienceProfileCreateOrUpdate(input: $input) {
      memberDataShare
      preferredFuelProductGroup {
        id
      }
      achEnrollmentStatus
    }
  }
`;
export type FuelAndConvenienceProfileCreateOrUpdateMutationFn = Apollo.MutationFunction<
  FuelAndConvenienceProfileCreateOrUpdateMutation,
  FuelAndConvenienceProfileCreateOrUpdateMutationVariables
>;

/**
 * __useFuelAndConvenienceProfileCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `useFuelAndConvenienceProfileCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFuelAndConvenienceProfileCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fuelAndConvenienceProfileCreateOrUpdateMutation, { data, loading, error }] = useFuelAndConvenienceProfileCreateOrUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFuelAndConvenienceProfileCreateOrUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FuelAndConvenienceProfileCreateOrUpdateMutation,
    FuelAndConvenienceProfileCreateOrUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FuelAndConvenienceProfileCreateOrUpdateMutation,
    FuelAndConvenienceProfileCreateOrUpdateMutationVariables
  >(FuelAndConvenienceProfileCreateOrUpdateDocument, options);
}
export type FuelAndConvenienceProfileCreateOrUpdateMutationHookResult = ReturnType<
  typeof useFuelAndConvenienceProfileCreateOrUpdateMutation
>;
export type FuelAndConvenienceProfileCreateOrUpdateMutationResult =
  Apollo.MutationResult<FuelAndConvenienceProfileCreateOrUpdateMutation>;
export type FuelAndConvenienceProfileCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<
  FuelAndConvenienceProfileCreateOrUpdateMutation,
  FuelAndConvenienceProfileCreateOrUpdateMutationVariables
>;
export const MembershipProductInterestsDocument = gql`
  query membershipProductInterests {
    customer: currentCustomer {
      __typename
      uuid
      membership {
        id
        productInterests {
          ...ProductCategory
        }
      }
    }
  }
  ${ProductCategoryFragmentDoc}
`;

/**
 * __useMembershipProductInterestsQuery__
 *
 * To run a query within a React component, call `useMembershipProductInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipProductInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipProductInterestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipProductInterestsQuery(
  baseOptions?: Apollo.QueryHookOptions<MembershipProductInterestsQuery, MembershipProductInterestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MembershipProductInterestsQuery, MembershipProductInterestsQueryVariables>(
    MembershipProductInterestsDocument,
    options,
  );
}
export function useMembershipProductInterestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MembershipProductInterestsQuery, MembershipProductInterestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MembershipProductInterestsQuery, MembershipProductInterestsQueryVariables>(
    MembershipProductInterestsDocument,
    options,
  );
}
export function useMembershipProductInterestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MembershipProductInterestsQuery, MembershipProductInterestsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MembershipProductInterestsQuery, MembershipProductInterestsQueryVariables>(
    MembershipProductInterestsDocument,
    options,
  );
}
export type MembershipProductInterestsQueryHookResult = ReturnType<typeof useMembershipProductInterestsQuery>;
export type MembershipProductInterestsLazyQueryHookResult = ReturnType<typeof useMembershipProductInterestsLazyQuery>;
export type MembershipProductInterestsSuspenseQueryHookResult = ReturnType<
  typeof useMembershipProductInterestsSuspenseQuery
>;
export type MembershipProductInterestsQueryResult = Apollo.QueryResult<
  MembershipProductInterestsQuery,
  MembershipProductInterestsQueryVariables
>;
export const ProductInterestsReplaceDocument = gql`
  mutation productInterestsReplace($input: ProductInterestsReplaceInput!) {
    membership: productInterestsReplace(input: $input) {
      id
      productInterests {
        ...ProductCategory
      }
      fuelAndConvenienceProfile {
        pendingVerification
      }
    }
  }
  ${ProductCategoryFragmentDoc}
`;
export type ProductInterestsReplaceMutationFn = Apollo.MutationFunction<
  ProductInterestsReplaceMutation,
  ProductInterestsReplaceMutationVariables
>;

/**
 * __useProductInterestsReplaceMutation__
 *
 * To run a mutation, you first call `useProductInterestsReplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductInterestsReplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productInterestsReplaceMutation, { data, loading, error }] = useProductInterestsReplaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductInterestsReplaceMutation(
  baseOptions?: Apollo.MutationHookOptions<ProductInterestsReplaceMutation, ProductInterestsReplaceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ProductInterestsReplaceMutation, ProductInterestsReplaceMutationVariables>(
    ProductInterestsReplaceDocument,
    options,
  );
}
export type ProductInterestsReplaceMutationHookResult = ReturnType<typeof useProductInterestsReplaceMutation>;
export type ProductInterestsReplaceMutationResult = Apollo.MutationResult<ProductInterestsReplaceMutation>;
export type ProductInterestsReplaceMutationOptions = Apollo.BaseMutationOptions<
  ProductInterestsReplaceMutation,
  ProductInterestsReplaceMutationVariables
>;
export const ActivateOfferDocument = gql`
  mutation activateOffer($input: OfferActivate!) {
    offerActivate(input: $input) {
      id
      activationStatus
    }
  }
`;
export type ActivateOfferMutationFn = Apollo.MutationFunction<ActivateOfferMutation, ActivateOfferMutationVariables>;

/**
 * __useActivateOfferMutation__
 *
 * To run a mutation, you first call `useActivateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateOfferMutation, { data, loading, error }] = useActivateOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<ActivateOfferMutation, ActivateOfferMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateOfferMutation, ActivateOfferMutationVariables>(ActivateOfferDocument, options);
}
export type ActivateOfferMutationHookResult = ReturnType<typeof useActivateOfferMutation>;
export type ActivateOfferMutationResult = Apollo.MutationResult<ActivateOfferMutation>;
export type ActivateOfferMutationOptions = Apollo.BaseMutationOptions<
  ActivateOfferMutation,
  ActivateOfferMutationVariables
>;
export const BaseOffersDocument = gql`
  query baseOffers(
    $first: Int!
    $deleted: Boolean!
    $publicationStatusEquals: PUBLICATION_STATUS_TYPE
    $visibleStatusEquals: OFFER_VISIBLE_STATUS
    $presentationTypeIncludes: [OFFER_PRESENTATION_TYPE!]
    $engagementTypeEquals: OFFER_ENGAGEMENT_TYPE!
    $offerLimitsIncluded: Boolean = false
    $offerVouchersIncluded: Boolean = false
    $availableAtLocationsIncluded: Boolean = false
    $constraintsIncluded: Boolean = false
  ) {
    customer: currentCustomer {
      uuid
      membership {
        id
        offers(
          first: $first
          filter: {
            deleted: $deleted
            visibleStatusEquals: $visibleStatusEquals
            publicationStatusEquals: $publicationStatusEquals
            presentationTypeIncludes: $presentationTypeIncludes
            engagementTypeEquals: $engagementTypeEquals
          }
        ) {
          edges {
            node {
              ...Offer
            }
          }
        }
      }
    }
  }
  ${OfferFragmentDoc}
`;

/**
 * __useBaseOffersQuery__
 *
 * To run a query within a React component, call `useBaseOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaseOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaseOffersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      deleted: // value for 'deleted'
 *      publicationStatusEquals: // value for 'publicationStatusEquals'
 *      visibleStatusEquals: // value for 'visibleStatusEquals'
 *      presentationTypeIncludes: // value for 'presentationTypeIncludes'
 *      engagementTypeEquals: // value for 'engagementTypeEquals'
 *      offerLimitsIncluded: // value for 'offerLimitsIncluded'
 *      offerVouchersIncluded: // value for 'offerVouchersIncluded'
 *      availableAtLocationsIncluded: // value for 'availableAtLocationsIncluded'
 *      constraintsIncluded: // value for 'constraintsIncluded'
 *   },
 * });
 */
export function useBaseOffersQuery(
  baseOptions: Apollo.QueryHookOptions<BaseOffersQuery, BaseOffersQueryVariables> &
    ({ variables: BaseOffersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BaseOffersQuery, BaseOffersQueryVariables>(BaseOffersDocument, options);
}
export function useBaseOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BaseOffersQuery, BaseOffersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BaseOffersQuery, BaseOffersQueryVariables>(BaseOffersDocument, options);
}
export function useBaseOffersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BaseOffersQuery, BaseOffersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<BaseOffersQuery, BaseOffersQueryVariables>(BaseOffersDocument, options);
}
export type BaseOffersQueryHookResult = ReturnType<typeof useBaseOffersQuery>;
export type BaseOffersLazyQueryHookResult = ReturnType<typeof useBaseOffersLazyQuery>;
export type BaseOffersSuspenseQueryHookResult = ReturnType<typeof useBaseOffersSuspenseQuery>;
export type BaseOffersQueryResult = Apollo.QueryResult<BaseOffersQuery, BaseOffersQueryVariables>;
export const GetExternalOffersDocument = gql`
  query GetExternalOffers($filter: BannerFilter!) {
    banners(filter: $filter) {
      ...ExternalOffer
    }
  }
  ${ExternalOfferFragmentDoc}
`;

/**
 * __useGetExternalOffersQuery__
 *
 * To run a query within a React component, call `useGetExternalOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalOffersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetExternalOffersQuery(
  baseOptions: Apollo.QueryHookOptions<GetExternalOffersQuery, GetExternalOffersQueryVariables> &
    ({ variables: GetExternalOffersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExternalOffersQuery, GetExternalOffersQueryVariables>(GetExternalOffersDocument, options);
}
export function useGetExternalOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetExternalOffersQuery, GetExternalOffersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExternalOffersQuery, GetExternalOffersQueryVariables>(
    GetExternalOffersDocument,
    options,
  );
}
export function useGetExternalOffersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetExternalOffersQuery, GetExternalOffersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetExternalOffersQuery, GetExternalOffersQueryVariables>(
    GetExternalOffersDocument,
    options,
  );
}
export type GetExternalOffersQueryHookResult = ReturnType<typeof useGetExternalOffersQuery>;
export type GetExternalOffersLazyQueryHookResult = ReturnType<typeof useGetExternalOffersLazyQuery>;
export type GetExternalOffersSuspenseQueryHookResult = ReturnType<typeof useGetExternalOffersSuspenseQuery>;
export type GetExternalOffersQueryResult = Apollo.QueryResult<GetExternalOffersQuery, GetExternalOffersQueryVariables>;
export const GetOfferVoucherDocument = gql`
  query getOfferVoucher($offerId: ID!, $voucherFilter: VoucherFilter!) {
    customer: currentCustomer {
      uuid
      membership {
        id
        offers(filter: { idEquals: $offerId }) {
          edges {
            node {
              id
              vouchers(first: 1, filter: $voucherFilter) {
                edges {
                  node {
                    id
                    source {
                      __typename
                      ... on OfferPurchase {
                        purchasedWith {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOfferVoucherQuery__
 *
 * To run a query within a React component, call `useGetOfferVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferVoucherQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      voucherFilter: // value for 'voucherFilter'
 *   },
 * });
 */
export function useGetOfferVoucherQuery(
  baseOptions: Apollo.QueryHookOptions<GetOfferVoucherQuery, GetOfferVoucherQueryVariables> &
    ({ variables: GetOfferVoucherQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOfferVoucherQuery, GetOfferVoucherQueryVariables>(GetOfferVoucherDocument, options);
}
export function useGetOfferVoucherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOfferVoucherQuery, GetOfferVoucherQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOfferVoucherQuery, GetOfferVoucherQueryVariables>(GetOfferVoucherDocument, options);
}
export function useGetOfferVoucherSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferVoucherQuery, GetOfferVoucherQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOfferVoucherQuery, GetOfferVoucherQueryVariables>(GetOfferVoucherDocument, options);
}
export type GetOfferVoucherQueryHookResult = ReturnType<typeof useGetOfferVoucherQuery>;
export type GetOfferVoucherLazyQueryHookResult = ReturnType<typeof useGetOfferVoucherLazyQuery>;
export type GetOfferVoucherSuspenseQueryHookResult = ReturnType<typeof useGetOfferVoucherSuspenseQuery>;
export type GetOfferVoucherQueryResult = Apollo.QueryResult<GetOfferVoucherQuery, GetOfferVoucherQueryVariables>;
export const LogOfferActivityBatchDocument = gql`
  mutation LogOfferActivityBatch($input: [OfferActivityLogInput!]!) {
    offerActivityLogBatch(input: $input)
  }
`;
export type LogOfferActivityBatchMutationFn = Apollo.MutationFunction<
  LogOfferActivityBatchMutation,
  LogOfferActivityBatchMutationVariables
>;

/**
 * __useLogOfferActivityBatchMutation__
 *
 * To run a mutation, you first call `useLogOfferActivityBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOfferActivityBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOfferActivityBatchMutation, { data, loading, error }] = useLogOfferActivityBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogOfferActivityBatchMutation(
  baseOptions?: Apollo.MutationHookOptions<LogOfferActivityBatchMutation, LogOfferActivityBatchMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogOfferActivityBatchMutation, LogOfferActivityBatchMutationVariables>(
    LogOfferActivityBatchDocument,
    options,
  );
}
export type LogOfferActivityBatchMutationHookResult = ReturnType<typeof useLogOfferActivityBatchMutation>;
export type LogOfferActivityBatchMutationResult = Apollo.MutationResult<LogOfferActivityBatchMutation>;
export type LogOfferActivityBatchMutationOptions = Apollo.BaseMutationOptions<
  LogOfferActivityBatchMutation,
  LogOfferActivityBatchMutationVariables
>;
export const LogOfferActivityDocument = gql`
  mutation LogOfferActivity($input: OfferActivityLogInput!) {
    offerActivityLog(input: $input)
  }
`;
export type LogOfferActivityMutationFn = Apollo.MutationFunction<
  LogOfferActivityMutation,
  LogOfferActivityMutationVariables
>;

/**
 * __useLogOfferActivityMutation__
 *
 * To run a mutation, you first call `useLogOfferActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOfferActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOfferActivityMutation, { data, loading, error }] = useLogOfferActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogOfferActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<LogOfferActivityMutation, LogOfferActivityMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogOfferActivityMutation, LogOfferActivityMutationVariables>(
    LogOfferActivityDocument,
    options,
  );
}
export type LogOfferActivityMutationHookResult = ReturnType<typeof useLogOfferActivityMutation>;
export type LogOfferActivityMutationResult = Apollo.MutationResult<LogOfferActivityMutation>;
export type LogOfferActivityMutationOptions = Apollo.BaseMutationOptions<
  LogOfferActivityMutation,
  LogOfferActivityMutationVariables
>;
export const OffersDocument = gql`
  query offers(
    $first: Int!
    $deleted: Boolean!
    $publicationStatusEquals: PUBLICATION_STATUS_TYPE
    $visibleStatusEquals: OFFER_VISIBLE_STATUS
    $presentationTypeIncludes: [OFFER_PRESENTATION_TYPE!]
    $presentationPriorityIncludes: [OFFER_PRESENTATION_PRIORITY!] = null
    $engagementTypeEquals: OFFER_ENGAGEMENT_TYPE
    $engagementTypeExcludes: [OFFER_ENGAGEMENT_TYPE!]
    $idEquals: ID = null
    $offerLimitsIncluded: Boolean = false
    $offerVouchersIncluded: Boolean = false
    $locationsGeoFilter: LocationsGeoFilterInput = null
    $availableAtLocationsIncluded: Boolean = false
    $constraintsIncluded: Boolean = false
  ) {
    customer: currentCustomer {
      uuid
      membership {
        id
        offers(
          first: $first
          filter: {
            deleted: $deleted
            visibleStatusEquals: $visibleStatusEquals
            publicationStatusEquals: $publicationStatusEquals
            presentationTypeIncludes: $presentationTypeIncludes
            presentationPriorityIncludes: $presentationPriorityIncludes
            engagementTypeEquals: $engagementTypeEquals
            engagementTypeExcludes: $engagementTypeExcludes
            idEquals: $idEquals
            locationsGeoFilter: $locationsGeoFilter
          }
        ) {
          edges {
            node {
              ...Offer
            }
          }
        }
      }
    }
  }
  ${OfferFragmentDoc}
`;

/**
 * __useOffersQuery__
 *
 * To run a query within a React component, call `useOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      deleted: // value for 'deleted'
 *      publicationStatusEquals: // value for 'publicationStatusEquals'
 *      visibleStatusEquals: // value for 'visibleStatusEquals'
 *      presentationTypeIncludes: // value for 'presentationTypeIncludes'
 *      presentationPriorityIncludes: // value for 'presentationPriorityIncludes'
 *      engagementTypeEquals: // value for 'engagementTypeEquals'
 *      engagementTypeExcludes: // value for 'engagementTypeExcludes'
 *      idEquals: // value for 'idEquals'
 *      offerLimitsIncluded: // value for 'offerLimitsIncluded'
 *      offerVouchersIncluded: // value for 'offerVouchersIncluded'
 *      locationsGeoFilter: // value for 'locationsGeoFilter'
 *      availableAtLocationsIncluded: // value for 'availableAtLocationsIncluded'
 *      constraintsIncluded: // value for 'constraintsIncluded'
 *   },
 * });
 */
export function useOffersQuery(
  baseOptions: Apollo.QueryHookOptions<OffersQuery, OffersQueryVariables> &
    ({ variables: OffersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export function useOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersQuery, OffersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export function useOffersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersQuery, OffersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
}
export type OffersQueryHookResult = ReturnType<typeof useOffersQuery>;
export type OffersLazyQueryHookResult = ReturnType<typeof useOffersLazyQuery>;
export type OffersSuspenseQueryHookResult = ReturnType<typeof useOffersSuspenseQuery>;
export type OffersQueryResult = Apollo.QueryResult<OffersQuery, OffersQueryVariables>;
export const ReturnPurchasedVoucherDocument = gql`
  mutation returnPurchasedVoucher($input: OfferPurchaseReturn!) {
    offerPurchaseReturn(input: $input) {
      createdAt
    }
  }
`;
export type ReturnPurchasedVoucherMutationFn = Apollo.MutationFunction<
  ReturnPurchasedVoucherMutation,
  ReturnPurchasedVoucherMutationVariables
>;

/**
 * __useReturnPurchasedVoucherMutation__
 *
 * To run a mutation, you first call `useReturnPurchasedVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnPurchasedVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnPurchasedVoucherMutation, { data, loading, error }] = useReturnPurchasedVoucherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReturnPurchasedVoucherMutation(
  baseOptions?: Apollo.MutationHookOptions<ReturnPurchasedVoucherMutation, ReturnPurchasedVoucherMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReturnPurchasedVoucherMutation, ReturnPurchasedVoucherMutationVariables>(
    ReturnPurchasedVoucherDocument,
    options,
  );
}
export type ReturnPurchasedVoucherMutationHookResult = ReturnType<typeof useReturnPurchasedVoucherMutation>;
export type ReturnPurchasedVoucherMutationResult = Apollo.MutationResult<ReturnPurchasedVoucherMutation>;
export type ReturnPurchasedVoucherMutationOptions = Apollo.BaseMutationOptions<
  ReturnPurchasedVoucherMutation,
  ReturnPurchasedVoucherMutationVariables
>;
export const TotalVouchersCountDocument = gql`
  query totalVouchersCount($filter: VoucherFilter = null) {
    customer: currentCustomer {
      uuid
      membership {
        id
        vouchers(filter: $filter) {
          totalCount
        }
      }
    }
  }
`;

/**
 * __useTotalVouchersCountQuery__
 *
 * To run a query within a React component, call `useTotalVouchersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalVouchersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalVouchersCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTotalVouchersCountQuery(
  baseOptions?: Apollo.QueryHookOptions<TotalVouchersCountQuery, TotalVouchersCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalVouchersCountQuery, TotalVouchersCountQueryVariables>(
    TotalVouchersCountDocument,
    options,
  );
}
export function useTotalVouchersCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TotalVouchersCountQuery, TotalVouchersCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TotalVouchersCountQuery, TotalVouchersCountQueryVariables>(
    TotalVouchersCountDocument,
    options,
  );
}
export function useTotalVouchersCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TotalVouchersCountQuery, TotalVouchersCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TotalVouchersCountQuery, TotalVouchersCountQueryVariables>(
    TotalVouchersCountDocument,
    options,
  );
}
export type TotalVouchersCountQueryHookResult = ReturnType<typeof useTotalVouchersCountQuery>;
export type TotalVouchersCountLazyQueryHookResult = ReturnType<typeof useTotalVouchersCountLazyQuery>;
export type TotalVouchersCountSuspenseQueryHookResult = ReturnType<typeof useTotalVouchersCountSuspenseQuery>;
export type TotalVouchersCountQueryResult = Apollo.QueryResult<
  TotalVouchersCountQuery,
  TotalVouchersCountQueryVariables
>;
export const CreatePaymentInstrumentDocument = gql`
  mutation createPaymentInstrument($input: CustomerPaymentInstrumentCreate!) {
    customerPaymentInstrumentCreate(input: $input) {
      uuid
    }
  }
`;
export type CreatePaymentInstrumentMutationFn = Apollo.MutationFunction<
  CreatePaymentInstrumentMutation,
  CreatePaymentInstrumentMutationVariables
>;

/**
 * __useCreatePaymentInstrumentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentInstrumentMutation, { data, loading, error }] = useCreatePaymentInstrumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentInstrumentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>(
    CreatePaymentInstrumentDocument,
    options,
  );
}
export type CreatePaymentInstrumentMutationHookResult = ReturnType<typeof useCreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationResult = Apollo.MutationResult<CreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationOptions = Apollo.BaseMutationOptions<
  CreatePaymentInstrumentMutation,
  CreatePaymentInstrumentMutationVariables
>;
export const DeletePaymentInstrumentDocument = gql`
  mutation deletePaymentInstrument($uuid: ID!) {
    customerPaymentInstrumentDelete(uuid: $uuid) {
      uuid
    }
  }
`;
export type DeletePaymentInstrumentMutationFn = Apollo.MutationFunction<
  DeletePaymentInstrumentMutation,
  DeletePaymentInstrumentMutationVariables
>;

/**
 * __useDeletePaymentInstrumentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentInstrumentMutation, { data, loading, error }] = useDeletePaymentInstrumentMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeletePaymentInstrumentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePaymentInstrumentMutation, DeletePaymentInstrumentMutationVariables>(
    DeletePaymentInstrumentDocument,
    options,
  );
}
export type DeletePaymentInstrumentMutationHookResult = ReturnType<typeof useDeletePaymentInstrumentMutation>;
export type DeletePaymentInstrumentMutationResult = Apollo.MutationResult<DeletePaymentInstrumentMutation>;
export type DeletePaymentInstrumentMutationOptions = Apollo.BaseMutationOptions<
  DeletePaymentInstrumentMutation,
  DeletePaymentInstrumentMutationVariables
>;
export const GetPaymentInstrumentsDocument = gql`
  query getPaymentInstruments {
    customer: currentCustomer {
      __typename
      uuid
      hasPasscode
      paymentWallet {
        ...PaymentInstrument
      }
    }
  }
  ${PaymentInstrumentFragmentDoc}
`;

/**
 * __useGetPaymentInstrumentsQuery__
 *
 * To run a query within a React component, call `useGetPaymentInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentInstrumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentInstrumentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPaymentInstrumentsQuery, GetPaymentInstrumentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPaymentInstrumentsQuery, GetPaymentInstrumentsQueryVariables>(
    GetPaymentInstrumentsDocument,
    options,
  );
}
export function useGetPaymentInstrumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentInstrumentsQuery, GetPaymentInstrumentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPaymentInstrumentsQuery, GetPaymentInstrumentsQueryVariables>(
    GetPaymentInstrumentsDocument,
    options,
  );
}
export function useGetPaymentInstrumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPaymentInstrumentsQuery, GetPaymentInstrumentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPaymentInstrumentsQuery, GetPaymentInstrumentsQueryVariables>(
    GetPaymentInstrumentsDocument,
    options,
  );
}
export type GetPaymentInstrumentsQueryHookResult = ReturnType<typeof useGetPaymentInstrumentsQuery>;
export type GetPaymentInstrumentsLazyQueryHookResult = ReturnType<typeof useGetPaymentInstrumentsLazyQuery>;
export type GetPaymentInstrumentsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentInstrumentsSuspenseQuery>;
export type GetPaymentInstrumentsQueryResult = Apollo.QueryResult<
  GetPaymentInstrumentsQuery,
  GetPaymentInstrumentsQueryVariables
>;
export const CreateApplePaySessionDocument = gql`
  mutation createApplePaySession($input: PaymentApplePaySessionCreateInput!) {
    session: applePaySessionCreate(input: $input) {
      data
    }
  }
`;
export type CreateApplePaySessionMutationFn = Apollo.MutationFunction<
  CreateApplePaySessionMutation,
  CreateApplePaySessionMutationVariables
>;

/**
 * __useCreateApplePaySessionMutation__
 *
 * To run a mutation, you first call `useCreateApplePaySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplePaySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplePaySessionMutation, { data, loading, error }] = useCreateApplePaySessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplePaySessionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateApplePaySessionMutation, CreateApplePaySessionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateApplePaySessionMutation, CreateApplePaySessionMutationVariables>(
    CreateApplePaySessionDocument,
    options,
  );
}
export type CreateApplePaySessionMutationHookResult = ReturnType<typeof useCreateApplePaySessionMutation>;
export type CreateApplePaySessionMutationResult = Apollo.MutationResult<CreateApplePaySessionMutation>;
export type CreateApplePaySessionMutationOptions = Apollo.BaseMutationOptions<
  CreateApplePaySessionMutation,
  CreateApplePaySessionMutationVariables
>;
export const CreateParPaySessionDocument = gql`
  mutation createParPaySession {
    session: customerInitiateTokenizationSession {
      ...ParPaySession
    }
  }
  ${ParPaySessionFragmentDoc}
`;
export type CreateParPaySessionMutationFn = Apollo.MutationFunction<
  CreateParPaySessionMutation,
  CreateParPaySessionMutationVariables
>;

/**
 * __useCreateParPaySessionMutation__
 *
 * To run a mutation, you first call `useCreateParPaySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParPaySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParPaySessionMutation, { data, loading, error }] = useCreateParPaySessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateParPaySessionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateParPaySessionMutation, CreateParPaySessionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateParPaySessionMutation, CreateParPaySessionMutationVariables>(
    CreateParPaySessionDocument,
    options,
  );
}
export type CreateParPaySessionMutationHookResult = ReturnType<typeof useCreateParPaySessionMutation>;
export type CreateParPaySessionMutationResult = Apollo.MutationResult<CreateParPaySessionMutation>;
export type CreateParPaySessionMutationOptions = Apollo.BaseMutationOptions<
  CreateParPaySessionMutation,
  CreateParPaySessionMutationVariables
>;
export const GetFiservClientAccessTokenDocument = gql`
  query getFiservClientAccessToken {
    getFiservClientAccessToken {
      fdCustomerId
      publicKey
      algorithm
      issuedOn
      expiresInSeconds
      oAuthToken
      apiKey
      baseUrl
    }
  }
`;

/**
 * __useGetFiservClientAccessTokenQuery__
 *
 * To run a query within a React component, call `useGetFiservClientAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiservClientAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiservClientAccessTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFiservClientAccessTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFiservClientAccessTokenQuery, GetFiservClientAccessTokenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFiservClientAccessTokenQuery, GetFiservClientAccessTokenQueryVariables>(
    GetFiservClientAccessTokenDocument,
    options,
  );
}
export function useGetFiservClientAccessTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFiservClientAccessTokenQuery, GetFiservClientAccessTokenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFiservClientAccessTokenQuery, GetFiservClientAccessTokenQueryVariables>(
    GetFiservClientAccessTokenDocument,
    options,
  );
}
export function useGetFiservClientAccessTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetFiservClientAccessTokenQuery, GetFiservClientAccessTokenQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFiservClientAccessTokenQuery, GetFiservClientAccessTokenQueryVariables>(
    GetFiservClientAccessTokenDocument,
    options,
  );
}
export type GetFiservClientAccessTokenQueryHookResult = ReturnType<typeof useGetFiservClientAccessTokenQuery>;
export type GetFiservClientAccessTokenLazyQueryHookResult = ReturnType<typeof useGetFiservClientAccessTokenLazyQuery>;
export type GetFiservClientAccessTokenSuspenseQueryHookResult = ReturnType<
  typeof useGetFiservClientAccessTokenSuspenseQuery
>;
export type GetFiservClientAccessTokenQueryResult = Apollo.QueryResult<
  GetFiservClientAccessTokenQuery,
  GetFiservClientAccessTokenQueryVariables
>;
export const GenerateExternalIdentityVerificationParamsDocument = gql`
  mutation generateExternalIdentityVerificationParams {
    result: createExternalIdentityVerificationAuthorizationUrl(input: {}) {
      ...ExternalIdentityVerificationParams
    }
  }
  ${ExternalIdentityVerificationParamsFragmentDoc}
`;
export type GenerateExternalIdentityVerificationParamsMutationFn = Apollo.MutationFunction<
  GenerateExternalIdentityVerificationParamsMutation,
  GenerateExternalIdentityVerificationParamsMutationVariables
>;

/**
 * __useGenerateExternalIdentityVerificationParamsMutation__
 *
 * To run a mutation, you first call `useGenerateExternalIdentityVerificationParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateExternalIdentityVerificationParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateExternalIdentityVerificationParamsMutation, { data, loading, error }] = useGenerateExternalIdentityVerificationParamsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateExternalIdentityVerificationParamsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateExternalIdentityVerificationParamsMutation,
    GenerateExternalIdentityVerificationParamsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateExternalIdentityVerificationParamsMutation,
    GenerateExternalIdentityVerificationParamsMutationVariables
  >(GenerateExternalIdentityVerificationParamsDocument, options);
}
export type GenerateExternalIdentityVerificationParamsMutationHookResult = ReturnType<
  typeof useGenerateExternalIdentityVerificationParamsMutation
>;
export type GenerateExternalIdentityVerificationParamsMutationResult =
  Apollo.MutationResult<GenerateExternalIdentityVerificationParamsMutation>;
export type GenerateExternalIdentityVerificationParamsMutationOptions = Apollo.BaseMutationOptions<
  GenerateExternalIdentityVerificationParamsMutation,
  GenerateExternalIdentityVerificationParamsMutationVariables
>;
export const LocationsDocument = gql`
  query locations($after: String, $before: String, $first: Int, $last: Int, $filter: LocationFilter) {
    locations(after: $after, before: $before, first: $first, last: $last, filter: $filter) {
      edges {
        node {
          ...Location
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${LocationFragmentDoc}
`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
}
export function useLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
}
export function useLocationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
}
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsSuspenseQueryHookResult = ReturnType<typeof useLocationsSuspenseQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const GetTotalPointsEarnedDocument = gql`
  query getTotalPointsEarned {
    customer: currentCustomer {
      uuid
      membership {
        id
        lifetimeMetrics {
          pointsEarned
        }
      }
    }
  }
`;

/**
 * __useGetTotalPointsEarnedQuery__
 *
 * To run a query within a React component, call `useGetTotalPointsEarnedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalPointsEarnedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalPointsEarnedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalPointsEarnedQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTotalPointsEarnedQuery, GetTotalPointsEarnedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTotalPointsEarnedQuery, GetTotalPointsEarnedQueryVariables>(
    GetTotalPointsEarnedDocument,
    options,
  );
}
export function useGetTotalPointsEarnedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTotalPointsEarnedQuery, GetTotalPointsEarnedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTotalPointsEarnedQuery, GetTotalPointsEarnedQueryVariables>(
    GetTotalPointsEarnedDocument,
    options,
  );
}
export function useGetTotalPointsEarnedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTotalPointsEarnedQuery, GetTotalPointsEarnedQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTotalPointsEarnedQuery, GetTotalPointsEarnedQueryVariables>(
    GetTotalPointsEarnedDocument,
    options,
  );
}
export type GetTotalPointsEarnedQueryHookResult = ReturnType<typeof useGetTotalPointsEarnedQuery>;
export type GetTotalPointsEarnedLazyQueryHookResult = ReturnType<typeof useGetTotalPointsEarnedLazyQuery>;
export type GetTotalPointsEarnedSuspenseQueryHookResult = ReturnType<typeof useGetTotalPointsEarnedSuspenseQuery>;
export type GetTotalPointsEarnedQueryResult = Apollo.QueryResult<
  GetTotalPointsEarnedQuery,
  GetTotalPointsEarnedQueryVariables
>;
export const CreateOrderAheadSessionDocument = gql`
  mutation createOrderAheadSession($provider: OrderAheadProvider!) {
    result: createOrderAheadSession(input: { provider: $provider }) {
      ...OrderAheadSessionOlo
      ...OrderAheadSessionLula
    }
  }
  ${OrderAheadSessionOloFragmentDoc}
  ${OrderAheadSessionLulaFragmentDoc}
`;
export type CreateOrderAheadSessionMutationFn = Apollo.MutationFunction<
  CreateOrderAheadSessionMutation,
  CreateOrderAheadSessionMutationVariables
>;

/**
 * __useCreateOrderAheadSessionMutation__
 *
 * To run a mutation, you first call `useCreateOrderAheadSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderAheadSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderAheadSessionMutation, { data, loading, error }] = useCreateOrderAheadSessionMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useCreateOrderAheadSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateOrderAheadSessionMutation, CreateOrderAheadSessionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOrderAheadSessionMutation, CreateOrderAheadSessionMutationVariables>(
    CreateOrderAheadSessionDocument,
    options,
  );
}
export type CreateOrderAheadSessionMutationHookResult = ReturnType<typeof useCreateOrderAheadSessionMutation>;
export type CreateOrderAheadSessionMutationResult = Apollo.MutationResult<CreateOrderAheadSessionMutation>;
export type CreateOrderAheadSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateOrderAheadSessionMutation,
  CreateOrderAheadSessionMutationVariables
>;
export const StartTransactionDocument = gql`
  mutation startTransaction($input: TransactionStart!) {
    transaction: transactionStart(input: $input) {
      uuid
      primaryStatus
    }
  }
`;
export type StartTransactionMutationFn = Apollo.MutationFunction<
  StartTransactionMutation,
  StartTransactionMutationVariables
>;

/**
 * __useStartTransactionMutation__
 *
 * To run a mutation, you first call `useStartTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTransactionMutation, { data, loading, error }] = useStartTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<StartTransactionMutation, StartTransactionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartTransactionMutation, StartTransactionMutationVariables>(
    StartTransactionDocument,
    options,
  );
}
export type StartTransactionMutationHookResult = ReturnType<typeof useStartTransactionMutation>;
export type StartTransactionMutationResult = Apollo.MutationResult<StartTransactionMutation>;
export type StartTransactionMutationOptions = Apollo.BaseMutationOptions<
  StartTransactionMutation,
  StartTransactionMutationVariables
>;
export const TransactionDocument = gql`
  query transaction($uuid: ID!) {
    transaction(uuid: $uuid) {
      ...Transaction
    }
  }
  ${TransactionFragmentDoc}
`;

/**
 * __useTransactionQuery__
 *
 * To run a query within a React component, call `useTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTransactionQuery(
  baseOptions: Apollo.QueryHookOptions<TransactionQuery, TransactionQueryVariables> &
    ({ variables: TransactionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
}
export function useTransactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TransactionQuery, TransactionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
}
export function useTransactionSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionQuery, TransactionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
}
export type TransactionQueryHookResult = ReturnType<typeof useTransactionQuery>;
export type TransactionLazyQueryHookResult = ReturnType<typeof useTransactionLazyQuery>;
export type TransactionSuspenseQueryHookResult = ReturnType<typeof useTransactionSuspenseQuery>;
export type TransactionQueryResult = Apollo.QueryResult<TransactionQuery, TransactionQueryVariables>;
export const StartPayInsideTransactionDocument = gql`
  mutation startPayInsideTransaction($input: TransactionStart!) {
    transaction: transactionStart(input: $input) {
      uuid
      stac {
        id
        expiration
      }
    }
  }
`;
export type StartPayInsideTransactionMutationFn = Apollo.MutationFunction<
  StartPayInsideTransactionMutation,
  StartPayInsideTransactionMutationVariables
>;

/**
 * __useStartPayInsideTransactionMutation__
 *
 * To run a mutation, you first call `useStartPayInsideTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPayInsideTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPayInsideTransactionMutation, { data, loading, error }] = useStartPayInsideTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartPayInsideTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartPayInsideTransactionMutation,
    StartPayInsideTransactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartPayInsideTransactionMutation, StartPayInsideTransactionMutationVariables>(
    StartPayInsideTransactionDocument,
    options,
  );
}
export type StartPayInsideTransactionMutationHookResult = ReturnType<typeof useStartPayInsideTransactionMutation>;
export type StartPayInsideTransactionMutationResult = Apollo.MutationResult<StartPayInsideTransactionMutation>;
export type StartPayInsideTransactionMutationOptions = Apollo.BaseMutationOptions<
  StartPayInsideTransactionMutation,
  StartPayInsideTransactionMutationVariables
>;
export const PointExpirationScheduleDocument = gql`
  query PointExpirationSchedule($first: Int!) {
    currentCustomer {
      uuid
      membership {
        id
        points
        pointExpirationSchedule(first: $first) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            cursor
            node {
              date
              points
            }
          }
        }
      }
    }
  }
`;

/**
 * __usePointExpirationScheduleQuery__
 *
 * To run a query within a React component, call `usePointExpirationScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointExpirationScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointExpirationScheduleQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePointExpirationScheduleQuery(
  baseOptions: Apollo.QueryHookOptions<PointExpirationScheduleQuery, PointExpirationScheduleQueryVariables> &
    ({ variables: PointExpirationScheduleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PointExpirationScheduleQuery, PointExpirationScheduleQueryVariables>(
    PointExpirationScheduleDocument,
    options,
  );
}
export function usePointExpirationScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PointExpirationScheduleQuery, PointExpirationScheduleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PointExpirationScheduleQuery, PointExpirationScheduleQueryVariables>(
    PointExpirationScheduleDocument,
    options,
  );
}
export function usePointExpirationScheduleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PointExpirationScheduleQuery, PointExpirationScheduleQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PointExpirationScheduleQuery, PointExpirationScheduleQueryVariables>(
    PointExpirationScheduleDocument,
    options,
  );
}
export type PointExpirationScheduleQueryHookResult = ReturnType<typeof usePointExpirationScheduleQuery>;
export type PointExpirationScheduleLazyQueryHookResult = ReturnType<typeof usePointExpirationScheduleLazyQuery>;
export type PointExpirationScheduleSuspenseQueryHookResult = ReturnType<typeof usePointExpirationScheduleSuspenseQuery>;
export type PointExpirationScheduleQueryResult = Apollo.QueryResult<
  PointExpirationScheduleQuery,
  PointExpirationScheduleQueryVariables
>;
export const RedeemPromocodeDocument = gql`
  mutation redeemPromocode($code: String!) {
    result: redeemPromocode(promocode: $code) {
      ... on RedeemPromocodeResultSuccess {
        __typename
        award {
          ...PromocodeRedeemedAward
        }
      }
      ... on RedeemPromocodeResultFail {
        __typename
        reason
      }
    }
  }
  ${PromocodeRedeemedAwardFragmentDoc}
`;
export type RedeemPromocodeMutationFn = Apollo.MutationFunction<
  RedeemPromocodeMutation,
  RedeemPromocodeMutationVariables
>;

/**
 * __useRedeemPromocodeMutation__
 *
 * To run a mutation, you first call `useRedeemPromocodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemPromocodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemPromocodeMutation, { data, loading, error }] = useRedeemPromocodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRedeemPromocodeMutation(
  baseOptions?: Apollo.MutationHookOptions<RedeemPromocodeMutation, RedeemPromocodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RedeemPromocodeMutation, RedeemPromocodeMutationVariables>(
    RedeemPromocodeDocument,
    options,
  );
}
export type RedeemPromocodeMutationHookResult = ReturnType<typeof useRedeemPromocodeMutation>;
export type RedeemPromocodeMutationResult = Apollo.MutationResult<RedeemPromocodeMutation>;
export type RedeemPromocodeMutationOptions = Apollo.BaseMutationOptions<
  RedeemPromocodeMutation,
  RedeemPromocodeMutationVariables
>;
export const ReferralProgramSenderConfigDocument = gql`
  query ReferralProgramSenderConfig {
    appConfig {
      loyaltyProgram {
        referralProgramConfiguration {
          senderConfiguration {
            instructions
            smsTemplate
          }
        }
      }
    }
    currentCustomer {
      uuid
      membership {
        id
        referralCode
        referralUrl
      }
    }
  }
`;

/**
 * __useReferralProgramSenderConfigQuery__
 *
 * To run a query within a React component, call `useReferralProgramSenderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralProgramSenderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralProgramSenderConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralProgramSenderConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<ReferralProgramSenderConfigQuery, ReferralProgramSenderConfigQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReferralProgramSenderConfigQuery, ReferralProgramSenderConfigQueryVariables>(
    ReferralProgramSenderConfigDocument,
    options,
  );
}
export function useReferralProgramSenderConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReferralProgramSenderConfigQuery,
    ReferralProgramSenderConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReferralProgramSenderConfigQuery, ReferralProgramSenderConfigQueryVariables>(
    ReferralProgramSenderConfigDocument,
    options,
  );
}
export function useReferralProgramSenderConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReferralProgramSenderConfigQuery, ReferralProgramSenderConfigQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReferralProgramSenderConfigQuery, ReferralProgramSenderConfigQueryVariables>(
    ReferralProgramSenderConfigDocument,
    options,
  );
}
export type ReferralProgramSenderConfigQueryHookResult = ReturnType<typeof useReferralProgramSenderConfigQuery>;
export type ReferralProgramSenderConfigLazyQueryHookResult = ReturnType<typeof useReferralProgramSenderConfigLazyQuery>;
export type ReferralProgramSenderConfigSuspenseQueryHookResult = ReturnType<
  typeof useReferralProgramSenderConfigSuspenseQuery
>;
export type ReferralProgramSenderConfigQueryResult = Apollo.QueryResult<
  ReferralProgramSenderConfigQuery,
  ReferralProgramSenderConfigQueryVariables
>;
export const SubmitReferralCodeSharedEventDocument = gql`
  mutation submitReferralCodeSharedEvent {
    submitReferralCodeSharedEvent {
      id
      createdAt
    }
  }
`;
export type SubmitReferralCodeSharedEventMutationFn = Apollo.MutationFunction<
  SubmitReferralCodeSharedEventMutation,
  SubmitReferralCodeSharedEventMutationVariables
>;

/**
 * __useSubmitReferralCodeSharedEventMutation__
 *
 * To run a mutation, you first call `useSubmitReferralCodeSharedEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReferralCodeSharedEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReferralCodeSharedEventMutation, { data, loading, error }] = useSubmitReferralCodeSharedEventMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitReferralCodeSharedEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitReferralCodeSharedEventMutation,
    SubmitReferralCodeSharedEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitReferralCodeSharedEventMutation, SubmitReferralCodeSharedEventMutationVariables>(
    SubmitReferralCodeSharedEventDocument,
    options,
  );
}
export type SubmitReferralCodeSharedEventMutationHookResult = ReturnType<
  typeof useSubmitReferralCodeSharedEventMutation
>;
export type SubmitReferralCodeSharedEventMutationResult = Apollo.MutationResult<SubmitReferralCodeSharedEventMutation>;
export type SubmitReferralCodeSharedEventMutationOptions = Apollo.BaseMutationOptions<
  SubmitReferralCodeSharedEventMutation,
  SubmitReferralCodeSharedEventMutationVariables
>;
